
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire09fa"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire09fa"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1KfxD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kuyKG"));

});
parcelRegister("kuyKG", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $eeb19103ef40cfa2$export$ffb0004e005737fa; }, function (v) { return $eeb19103ef40cfa2$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $eeb19103ef40cfa2$export$34b9dba7ce09269b; }, function (v) { return $eeb19103ef40cfa2$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $eeb19103ef40cfa2$export$25062201e9e25d76; }, function (v) { return $eeb19103ef40cfa2$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eeb19103ef40cfa2$export$ffb0004e005737fa;
var $eeb19103ef40cfa2$export$34b9dba7ce09269b;
var $eeb19103ef40cfa2$export$25062201e9e25d76;
"use strict";
var $eeb19103ef40cfa2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $eeb19103ef40cfa2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $eeb19103ef40cfa2$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $eeb19103ef40cfa2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$eeb19103ef40cfa2$export$ffb0004e005737fa = $eeb19103ef40cfa2$var$REACT_FRAGMENT_TYPE;
$eeb19103ef40cfa2$export$34b9dba7ce09269b = $eeb19103ef40cfa2$var$jsxProd;
$eeb19103ef40cfa2$export$25062201e9e25d76 = $eeb19103ef40cfa2$var$jsxProd;

});


parcelRegister("ejTrU", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $a6cdda187280cdb0$export$882461b6382ed46c; }, function (v) { return $a6cdda187280cdb0$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $a6cdda187280cdb0$export$757ceba2d55c277e; }, function (v) { return $a6cdda187280cdb0$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $a6cdda187280cdb0$export$83d89fbfd8236492; }, function (v) { return $a6cdda187280cdb0$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $a6cdda187280cdb0$export$882461b6382ed46c;
var $a6cdda187280cdb0$export$757ceba2d55c277e;
var $a6cdda187280cdb0$export$83d89fbfd8236492;
"use strict";

var $a7qGw = parcelRequire("a7qGw");

var $dSwpL = parcelRequire("dSwpL");

var $jZ3UM = parcelRequire("jZ3UM");
function $a6cdda187280cdb0$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $a6cdda187280cdb0$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $a6cdda187280cdb0$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $a6cdda187280cdb0$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $a6cdda187280cdb0$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $a6cdda187280cdb0$var$assertIsMounted(fiber) {
    if ($a6cdda187280cdb0$var$getNearestMountedFiber(fiber) !== fiber) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(188));
}
function $a6cdda187280cdb0$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $a6cdda187280cdb0$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $a6cdda187280cdb0$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $a6cdda187280cdb0$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $a6cdda187280cdb0$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $a6cdda187280cdb0$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $a6cdda187280cdb0$var$assign = Object.assign, $a6cdda187280cdb0$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $a6cdda187280cdb0$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $a6cdda187280cdb0$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $a6cdda187280cdb0$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $a6cdda187280cdb0$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $a6cdda187280cdb0$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $a6cdda187280cdb0$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $a6cdda187280cdb0$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $a6cdda187280cdb0$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $a6cdda187280cdb0$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $a6cdda187280cdb0$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $a6cdda187280cdb0$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $a6cdda187280cdb0$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $a6cdda187280cdb0$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $a6cdda187280cdb0$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $a6cdda187280cdb0$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $a6cdda187280cdb0$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $a6cdda187280cdb0$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$a6cdda187280cdb0$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $a6cdda187280cdb0$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $a6cdda187280cdb0$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $a6cdda187280cdb0$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $a6cdda187280cdb0$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $a6cdda187280cdb0$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $a6cdda187280cdb0$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $a6cdda187280cdb0$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $a6cdda187280cdb0$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $a6cdda187280cdb0$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $a6cdda187280cdb0$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $a6cdda187280cdb0$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $a6cdda187280cdb0$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $a6cdda187280cdb0$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $a6cdda187280cdb0$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $a6cdda187280cdb0$var$getComponentNameFromType(type.type) || "Memo";
        case $a6cdda187280cdb0$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $a6cdda187280cdb0$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $a6cdda187280cdb0$var$isArrayImpl = Array.isArray, $a6cdda187280cdb0$var$ReactSharedInternals = $dSwpL.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $a6cdda187280cdb0$var$ReactDOMSharedInternals = $jZ3UM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $a6cdda187280cdb0$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $a6cdda187280cdb0$var$valueStack = [], $a6cdda187280cdb0$var$index = -1;
function $a6cdda187280cdb0$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $a6cdda187280cdb0$var$pop(cursor) {
    0 > $a6cdda187280cdb0$var$index || (cursor.current = $a6cdda187280cdb0$var$valueStack[$a6cdda187280cdb0$var$index], $a6cdda187280cdb0$var$valueStack[$a6cdda187280cdb0$var$index] = null, $a6cdda187280cdb0$var$index--);
}
function $a6cdda187280cdb0$var$push(cursor, value) {
    $a6cdda187280cdb0$var$index++;
    $a6cdda187280cdb0$var$valueStack[$a6cdda187280cdb0$var$index] = cursor.current;
    cursor.current = value;
}
var $a6cdda187280cdb0$var$contextStackCursor = $a6cdda187280cdb0$var$createCursor(null), $a6cdda187280cdb0$var$contextFiberStackCursor = $a6cdda187280cdb0$var$createCursor(null), $a6cdda187280cdb0$var$rootInstanceStackCursor = $a6cdda187280cdb0$var$createCursor(null), $a6cdda187280cdb0$var$hostTransitionProviderCursor = $a6cdda187280cdb0$var$createCursor(null);
function $a6cdda187280cdb0$var$pushHostContainer(fiber, nextRootInstance) {
    $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$rootInstanceStackCursor, nextRootInstance);
    $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$contextFiberStackCursor, fiber);
    $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $a6cdda187280cdb0$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $a6cdda187280cdb0$var$getOwnHostContext(nextRootInstance), fiber = $a6cdda187280cdb0$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$contextStackCursor);
    $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$contextStackCursor, fiber);
}
function $a6cdda187280cdb0$var$popHostContainer() {
    $a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$contextStackCursor);
    $a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$contextFiberStackCursor);
    $a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$rootInstanceStackCursor);
}
function $a6cdda187280cdb0$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$hostTransitionProviderCursor, fiber);
    var context = $a6cdda187280cdb0$var$contextStackCursor.current;
    var JSCompiler_inline_result = $a6cdda187280cdb0$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$contextFiberStackCursor, fiber), $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$contextStackCursor, JSCompiler_inline_result));
}
function $a6cdda187280cdb0$var$popHostContext(fiber) {
    $a6cdda187280cdb0$var$contextFiberStackCursor.current === fiber && ($a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$contextStackCursor), $a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$contextFiberStackCursor));
    $a6cdda187280cdb0$var$hostTransitionProviderCursor.current === fiber && ($a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$hostTransitionProviderCursor), $a6cdda187280cdb0$var$HostTransitionContext._currentValue = $a6cdda187280cdb0$var$sharedNotPendingObject);
}
var $a6cdda187280cdb0$var$prefix, $a6cdda187280cdb0$var$suffix;
function $a6cdda187280cdb0$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $a6cdda187280cdb0$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $a6cdda187280cdb0$var$prefix = match && match[1] || "";
        $a6cdda187280cdb0$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $a6cdda187280cdb0$var$prefix + name + $a6cdda187280cdb0$var$suffix;
}
var $a6cdda187280cdb0$var$reentry = !1;
function $a6cdda187280cdb0$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $a6cdda187280cdb0$var$reentry) return "";
    $a6cdda187280cdb0$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $a6cdda187280cdb0$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $a6cdda187280cdb0$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $a6cdda187280cdb0$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $a6cdda187280cdb0$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $a6cdda187280cdb0$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $a6cdda187280cdb0$var$describeBuiltInComponentFrame("Suspense Fallback") : $a6cdda187280cdb0$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $a6cdda187280cdb0$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $a6cdda187280cdb0$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $a6cdda187280cdb0$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $a6cdda187280cdb0$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $a6cdda187280cdb0$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $a6cdda187280cdb0$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $a6cdda187280cdb0$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $a6cdda187280cdb0$var$hasOwnProperty = Object.prototype.hasOwnProperty, $a6cdda187280cdb0$var$scheduleCallback$3 = $a7qGw.unstable_scheduleCallback, $a6cdda187280cdb0$var$cancelCallback$1 = $a7qGw.unstable_cancelCallback, $a6cdda187280cdb0$var$shouldYield = $a7qGw.unstable_shouldYield, $a6cdda187280cdb0$var$requestPaint = $a7qGw.unstable_requestPaint, $a6cdda187280cdb0$var$now = $a7qGw.unstable_now, $a6cdda187280cdb0$var$getCurrentPriorityLevel = $a7qGw.unstable_getCurrentPriorityLevel, $a6cdda187280cdb0$var$ImmediatePriority = $a7qGw.unstable_ImmediatePriority, $a6cdda187280cdb0$var$UserBlockingPriority = $a7qGw.unstable_UserBlockingPriority, $a6cdda187280cdb0$var$NormalPriority$1 = $a7qGw.unstable_NormalPriority, $a6cdda187280cdb0$var$LowPriority = $a7qGw.unstable_LowPriority, $a6cdda187280cdb0$var$IdlePriority = $a7qGw.unstable_IdlePriority, $a6cdda187280cdb0$var$log$1 = $a7qGw.log, $a6cdda187280cdb0$var$unstable_setDisableYieldValue = $a7qGw.unstable_setDisableYieldValue, $a6cdda187280cdb0$var$rendererID = null, $a6cdda187280cdb0$var$injectedHook = null;
function $a6cdda187280cdb0$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $a6cdda187280cdb0$var$log$1 && $a6cdda187280cdb0$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($a6cdda187280cdb0$var$injectedHook && "function" === typeof $a6cdda187280cdb0$var$injectedHook.setStrictMode) try {
        $a6cdda187280cdb0$var$injectedHook.setStrictMode($a6cdda187280cdb0$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $a6cdda187280cdb0$var$clz32 = Math.clz32 ? Math.clz32 : $a6cdda187280cdb0$var$clz32Fallback, $a6cdda187280cdb0$var$log = Math.log, $a6cdda187280cdb0$var$LN2 = Math.LN2;
function $a6cdda187280cdb0$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($a6cdda187280cdb0$var$log(x) / $a6cdda187280cdb0$var$LN2 | 0) | 0;
}
var $a6cdda187280cdb0$var$nextTransitionUpdateLane = 256, $a6cdda187280cdb0$var$nextTransitionDeferredLane = 262144, $a6cdda187280cdb0$var$nextRetryLane = 4194304;
function $a6cdda187280cdb0$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $a6cdda187280cdb0$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $a6cdda187280cdb0$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $a6cdda187280cdb0$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $a6cdda187280cdb0$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $a6cdda187280cdb0$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $a6cdda187280cdb0$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $a6cdda187280cdb0$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $a6cdda187280cdb0$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $a6cdda187280cdb0$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $a6cdda187280cdb0$var$claimNextRetryLane() {
    var lane = $a6cdda187280cdb0$var$nextRetryLane;
    $a6cdda187280cdb0$var$nextRetryLane <<= 1;
    0 === ($a6cdda187280cdb0$var$nextRetryLane & 62914560) && ($a6cdda187280cdb0$var$nextRetryLane = 4194304);
    return lane;
}
function $a6cdda187280cdb0$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $a6cdda187280cdb0$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $a6cdda187280cdb0$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $a6cdda187280cdb0$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $a6cdda187280cdb0$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $a6cdda187280cdb0$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $a6cdda187280cdb0$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $a6cdda187280cdb0$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $a6cdda187280cdb0$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $a6cdda187280cdb0$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $a6cdda187280cdb0$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $a6cdda187280cdb0$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $a6cdda187280cdb0$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $a6cdda187280cdb0$var$resolveUpdatePriority() {
    var updatePriority = $a6cdda187280cdb0$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $a6cdda187280cdb0$var$getEventPriority(updatePriority.type);
}
function $a6cdda187280cdb0$var$runWithPriority(priority, fn) {
    var previousPriority = $a6cdda187280cdb0$var$ReactDOMSharedInternals.p;
    try {
        return $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $a6cdda187280cdb0$var$randomKey = Math.random().toString(36).slice(2), $a6cdda187280cdb0$var$internalInstanceKey = "__reactFiber$" + $a6cdda187280cdb0$var$randomKey, $a6cdda187280cdb0$var$internalPropsKey = "__reactProps$" + $a6cdda187280cdb0$var$randomKey, $a6cdda187280cdb0$var$internalContainerInstanceKey = "__reactContainer$" + $a6cdda187280cdb0$var$randomKey, $a6cdda187280cdb0$var$internalEventHandlersKey = "__reactEvents$" + $a6cdda187280cdb0$var$randomKey, $a6cdda187280cdb0$var$internalEventHandlerListenersKey = "__reactListeners$" + $a6cdda187280cdb0$var$randomKey, $a6cdda187280cdb0$var$internalEventHandlesSetKey = "__reactHandles$" + $a6cdda187280cdb0$var$randomKey, $a6cdda187280cdb0$var$internalRootNodeResourcesKey = "__reactResources$" + $a6cdda187280cdb0$var$randomKey, $a6cdda187280cdb0$var$internalHoistableMarker = "__reactMarker$" + $a6cdda187280cdb0$var$randomKey;
function $a6cdda187280cdb0$var$detachDeletedInstance(node) {
    delete node[$a6cdda187280cdb0$var$internalInstanceKey];
    delete node[$a6cdda187280cdb0$var$internalPropsKey];
    delete node[$a6cdda187280cdb0$var$internalEventHandlersKey];
    delete node[$a6cdda187280cdb0$var$internalEventHandlerListenersKey];
    delete node[$a6cdda187280cdb0$var$internalEventHandlesSetKey];
}
function $a6cdda187280cdb0$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$a6cdda187280cdb0$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$a6cdda187280cdb0$var$internalContainerInstanceKey] || parentNode[$a6cdda187280cdb0$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $a6cdda187280cdb0$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$a6cdda187280cdb0$var$internalInstanceKey]) return parentNode;
                targetNode = $a6cdda187280cdb0$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $a6cdda187280cdb0$var$getInstanceFromNode(node) {
    if (node = node[$a6cdda187280cdb0$var$internalInstanceKey] || node[$a6cdda187280cdb0$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $a6cdda187280cdb0$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(33));
}
function $a6cdda187280cdb0$var$getResourcesFromRoot(root) {
    var resources = root[$a6cdda187280cdb0$var$internalRootNodeResourcesKey];
    resources || (resources = root[$a6cdda187280cdb0$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $a6cdda187280cdb0$var$markNodeAsHoistable(node) {
    node[$a6cdda187280cdb0$var$internalHoistableMarker] = !0;
}
var $a6cdda187280cdb0$var$allNativeEvents = new Set(), $a6cdda187280cdb0$var$registrationNameDependencies = {};
function $a6cdda187280cdb0$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $a6cdda187280cdb0$var$registerDirectEvent(registrationName, dependencies);
    $a6cdda187280cdb0$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $a6cdda187280cdb0$var$registerDirectEvent(registrationName, dependencies) {
    $a6cdda187280cdb0$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$a6cdda187280cdb0$var$allNativeEvents.add(dependencies[registrationName]);
}
var $a6cdda187280cdb0$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $a6cdda187280cdb0$var$illegalAttributeNameCache = {}, $a6cdda187280cdb0$var$validatedAttributeNameCache = {};
function $a6cdda187280cdb0$var$isAttributeNameSafe(attributeName) {
    if ($a6cdda187280cdb0$var$hasOwnProperty.call($a6cdda187280cdb0$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($a6cdda187280cdb0$var$hasOwnProperty.call($a6cdda187280cdb0$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($a6cdda187280cdb0$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $a6cdda187280cdb0$var$validatedAttributeNameCache[attributeName] = !0;
    $a6cdda187280cdb0$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $a6cdda187280cdb0$var$setValueForAttribute(node, name, value) {
    if ($a6cdda187280cdb0$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $a6cdda187280cdb0$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $a6cdda187280cdb0$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $a6cdda187280cdb0$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $a6cdda187280cdb0$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $a6cdda187280cdb0$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $a6cdda187280cdb0$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $a6cdda187280cdb0$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $a6cdda187280cdb0$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $a6cdda187280cdb0$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $a6cdda187280cdb0$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $a6cdda187280cdb0$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $a6cdda187280cdb0$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $a6cdda187280cdb0$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($a6cdda187280cdb0$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $a6cdda187280cdb0$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $a6cdda187280cdb0$var$getToStringValue(value);
        } else element.value !== "" + $a6cdda187280cdb0$var$getToStringValue(value) && (element.value = "" + $a6cdda187280cdb0$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $a6cdda187280cdb0$var$setDefaultValue(element, type, $a6cdda187280cdb0$var$getToStringValue(value)) : null != defaultValue ? $a6cdda187280cdb0$var$setDefaultValue(element, type, $a6cdda187280cdb0$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $a6cdda187280cdb0$var$getToStringValue(name) : element.removeAttribute("name");
}
function $a6cdda187280cdb0$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $a6cdda187280cdb0$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $a6cdda187280cdb0$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $a6cdda187280cdb0$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $a6cdda187280cdb0$var$track(element);
}
function $a6cdda187280cdb0$var$setDefaultValue(node, type, value) {
    "number" === type && $a6cdda187280cdb0$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $a6cdda187280cdb0$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $a6cdda187280cdb0$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $a6cdda187280cdb0$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $a6cdda187280cdb0$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $a6cdda187280cdb0$var$getToStringValue(defaultValue) : "";
}
function $a6cdda187280cdb0$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(92));
            if ($a6cdda187280cdb0$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $a6cdda187280cdb0$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $a6cdda187280cdb0$var$track(element);
}
function $a6cdda187280cdb0$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $a6cdda187280cdb0$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $a6cdda187280cdb0$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $a6cdda187280cdb0$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $a6cdda187280cdb0$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $a6cdda187280cdb0$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $a6cdda187280cdb0$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $a6cdda187280cdb0$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $a6cdda187280cdb0$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $a6cdda187280cdb0$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $a6cdda187280cdb0$var$sanitizeURL(url) {
    return $a6cdda187280cdb0$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $a6cdda187280cdb0$var$noop$1() {}
var $a6cdda187280cdb0$var$currentReplayingEvent = null;
function $a6cdda187280cdb0$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $a6cdda187280cdb0$var$restoreTarget = null, $a6cdda187280cdb0$var$restoreQueue = null;
function $a6cdda187280cdb0$var$restoreStateOfTarget(target) {
    var internalInstance = $a6cdda187280cdb0$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$a6cdda187280cdb0$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $a6cdda187280cdb0$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $a6cdda187280cdb0$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$a6cdda187280cdb0$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(90));
                            $a6cdda187280cdb0$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $a6cdda187280cdb0$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $a6cdda187280cdb0$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $a6cdda187280cdb0$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $a6cdda187280cdb0$var$isInsideEventHandler = !1;
function $a6cdda187280cdb0$var$batchedUpdates$1(fn, a, b) {
    if ($a6cdda187280cdb0$var$isInsideEventHandler) return fn(a, b);
    $a6cdda187280cdb0$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($a6cdda187280cdb0$var$isInsideEventHandler = !1, null !== $a6cdda187280cdb0$var$restoreTarget || null !== $a6cdda187280cdb0$var$restoreQueue) {
            if ($a6cdda187280cdb0$var$flushSyncWork$1(), $a6cdda187280cdb0$var$restoreTarget && (a = $a6cdda187280cdb0$var$restoreTarget, fn = $a6cdda187280cdb0$var$restoreQueue, $a6cdda187280cdb0$var$restoreQueue = $a6cdda187280cdb0$var$restoreTarget = null, $a6cdda187280cdb0$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$a6cdda187280cdb0$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $a6cdda187280cdb0$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$a6cdda187280cdb0$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $a6cdda187280cdb0$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $a6cdda187280cdb0$var$passiveBrowserEventsSupported = !1;
if ($a6cdda187280cdb0$var$canUseDOM) try {
    var $a6cdda187280cdb0$var$options = {};
    Object.defineProperty($a6cdda187280cdb0$var$options, "passive", {
        get: function() {
            $a6cdda187280cdb0$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $a6cdda187280cdb0$var$options, $a6cdda187280cdb0$var$options);
    window.removeEventListener("test", $a6cdda187280cdb0$var$options, $a6cdda187280cdb0$var$options);
} catch (e) {
    $a6cdda187280cdb0$var$passiveBrowserEventsSupported = !1;
}
var $a6cdda187280cdb0$var$root = null, $a6cdda187280cdb0$var$startText = null, $a6cdda187280cdb0$var$fallbackText = null;
function $a6cdda187280cdb0$var$getData() {
    if ($a6cdda187280cdb0$var$fallbackText) return $a6cdda187280cdb0$var$fallbackText;
    var start, startValue = $a6cdda187280cdb0$var$startText, startLength = startValue.length, end, endValue = "value" in $a6cdda187280cdb0$var$root ? $a6cdda187280cdb0$var$root.value : $a6cdda187280cdb0$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $a6cdda187280cdb0$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $a6cdda187280cdb0$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $a6cdda187280cdb0$var$functionThatReturnsTrue() {
    return !0;
}
function $a6cdda187280cdb0$var$functionThatReturnsFalse() {
    return !1;
}
function $a6cdda187280cdb0$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $a6cdda187280cdb0$var$functionThatReturnsTrue : $a6cdda187280cdb0$var$functionThatReturnsFalse;
        this.isPropagationStopped = $a6cdda187280cdb0$var$functionThatReturnsFalse;
        return this;
    }
    $a6cdda187280cdb0$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $a6cdda187280cdb0$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $a6cdda187280cdb0$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $a6cdda187280cdb0$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $a6cdda187280cdb0$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $a6cdda187280cdb0$var$SyntheticEvent = $a6cdda187280cdb0$var$createSyntheticEvent($a6cdda187280cdb0$var$EventInterface), $a6cdda187280cdb0$var$UIEventInterface = $a6cdda187280cdb0$var$assign({}, $a6cdda187280cdb0$var$EventInterface, {
    view: 0,
    detail: 0
}), $a6cdda187280cdb0$var$SyntheticUIEvent = $a6cdda187280cdb0$var$createSyntheticEvent($a6cdda187280cdb0$var$UIEventInterface), $a6cdda187280cdb0$var$lastMovementX, $a6cdda187280cdb0$var$lastMovementY, $a6cdda187280cdb0$var$lastMouseEvent, $a6cdda187280cdb0$var$MouseEventInterface = $a6cdda187280cdb0$var$assign({}, $a6cdda187280cdb0$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $a6cdda187280cdb0$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $a6cdda187280cdb0$var$lastMouseEvent && ($a6cdda187280cdb0$var$lastMouseEvent && "mousemove" === event.type ? ($a6cdda187280cdb0$var$lastMovementX = event.screenX - $a6cdda187280cdb0$var$lastMouseEvent.screenX, $a6cdda187280cdb0$var$lastMovementY = event.screenY - $a6cdda187280cdb0$var$lastMouseEvent.screenY) : $a6cdda187280cdb0$var$lastMovementY = $a6cdda187280cdb0$var$lastMovementX = 0, $a6cdda187280cdb0$var$lastMouseEvent = event);
        return $a6cdda187280cdb0$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $a6cdda187280cdb0$var$lastMovementY;
    }
}), $a6cdda187280cdb0$var$SyntheticMouseEvent = $a6cdda187280cdb0$var$createSyntheticEvent($a6cdda187280cdb0$var$MouseEventInterface), $a6cdda187280cdb0$var$DragEventInterface = $a6cdda187280cdb0$var$assign({}, $a6cdda187280cdb0$var$MouseEventInterface, {
    dataTransfer: 0
}), $a6cdda187280cdb0$var$SyntheticDragEvent = $a6cdda187280cdb0$var$createSyntheticEvent($a6cdda187280cdb0$var$DragEventInterface), $a6cdda187280cdb0$var$FocusEventInterface = $a6cdda187280cdb0$var$assign({}, $a6cdda187280cdb0$var$UIEventInterface, {
    relatedTarget: 0
}), $a6cdda187280cdb0$var$SyntheticFocusEvent = $a6cdda187280cdb0$var$createSyntheticEvent($a6cdda187280cdb0$var$FocusEventInterface), $a6cdda187280cdb0$var$AnimationEventInterface = $a6cdda187280cdb0$var$assign({}, $a6cdda187280cdb0$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a6cdda187280cdb0$var$SyntheticAnimationEvent = $a6cdda187280cdb0$var$createSyntheticEvent($a6cdda187280cdb0$var$AnimationEventInterface), $a6cdda187280cdb0$var$ClipboardEventInterface = $a6cdda187280cdb0$var$assign({}, $a6cdda187280cdb0$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $a6cdda187280cdb0$var$SyntheticClipboardEvent = $a6cdda187280cdb0$var$createSyntheticEvent($a6cdda187280cdb0$var$ClipboardEventInterface), $a6cdda187280cdb0$var$CompositionEventInterface = $a6cdda187280cdb0$var$assign({}, $a6cdda187280cdb0$var$EventInterface, {
    data: 0
}), $a6cdda187280cdb0$var$SyntheticCompositionEvent = $a6cdda187280cdb0$var$createSyntheticEvent($a6cdda187280cdb0$var$CompositionEventInterface), $a6cdda187280cdb0$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $a6cdda187280cdb0$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $a6cdda187280cdb0$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $a6cdda187280cdb0$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $a6cdda187280cdb0$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $a6cdda187280cdb0$var$getEventModifierState() {
    return $a6cdda187280cdb0$var$modifierStateGetter;
}
var $a6cdda187280cdb0$var$KeyboardEventInterface = $a6cdda187280cdb0$var$assign({}, $a6cdda187280cdb0$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $a6cdda187280cdb0$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $a6cdda187280cdb0$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $a6cdda187280cdb0$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $a6cdda187280cdb0$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $a6cdda187280cdb0$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $a6cdda187280cdb0$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $a6cdda187280cdb0$var$SyntheticKeyboardEvent = $a6cdda187280cdb0$var$createSyntheticEvent($a6cdda187280cdb0$var$KeyboardEventInterface), $a6cdda187280cdb0$var$PointerEventInterface = $a6cdda187280cdb0$var$assign({}, $a6cdda187280cdb0$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $a6cdda187280cdb0$var$SyntheticPointerEvent = $a6cdda187280cdb0$var$createSyntheticEvent($a6cdda187280cdb0$var$PointerEventInterface), $a6cdda187280cdb0$var$TouchEventInterface = $a6cdda187280cdb0$var$assign({}, $a6cdda187280cdb0$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $a6cdda187280cdb0$var$getEventModifierState
}), $a6cdda187280cdb0$var$SyntheticTouchEvent = $a6cdda187280cdb0$var$createSyntheticEvent($a6cdda187280cdb0$var$TouchEventInterface), $a6cdda187280cdb0$var$TransitionEventInterface = $a6cdda187280cdb0$var$assign({}, $a6cdda187280cdb0$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a6cdda187280cdb0$var$SyntheticTransitionEvent = $a6cdda187280cdb0$var$createSyntheticEvent($a6cdda187280cdb0$var$TransitionEventInterface), $a6cdda187280cdb0$var$WheelEventInterface = $a6cdda187280cdb0$var$assign({}, $a6cdda187280cdb0$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $a6cdda187280cdb0$var$SyntheticWheelEvent = $a6cdda187280cdb0$var$createSyntheticEvent($a6cdda187280cdb0$var$WheelEventInterface), $a6cdda187280cdb0$var$ToggleEventInterface = $a6cdda187280cdb0$var$assign({}, $a6cdda187280cdb0$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $a6cdda187280cdb0$var$SyntheticToggleEvent = $a6cdda187280cdb0$var$createSyntheticEvent($a6cdda187280cdb0$var$ToggleEventInterface), $a6cdda187280cdb0$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $a6cdda187280cdb0$var$canUseCompositionEvent = $a6cdda187280cdb0$var$canUseDOM && "CompositionEvent" in window, $a6cdda187280cdb0$var$documentMode = null;
$a6cdda187280cdb0$var$canUseDOM && "documentMode" in document && ($a6cdda187280cdb0$var$documentMode = document.documentMode);
var $a6cdda187280cdb0$var$canUseTextInputEvent = $a6cdda187280cdb0$var$canUseDOM && "TextEvent" in window && !$a6cdda187280cdb0$var$documentMode, $a6cdda187280cdb0$var$useFallbackCompositionData = $a6cdda187280cdb0$var$canUseDOM && (!$a6cdda187280cdb0$var$canUseCompositionEvent || $a6cdda187280cdb0$var$documentMode && 8 < $a6cdda187280cdb0$var$documentMode && 11 >= $a6cdda187280cdb0$var$documentMode), $a6cdda187280cdb0$var$SPACEBAR_CHAR = String.fromCharCode(32), $a6cdda187280cdb0$var$hasSpaceKeypress = !1;
function $a6cdda187280cdb0$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $a6cdda187280cdb0$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $a6cdda187280cdb0$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $a6cdda187280cdb0$var$isComposing = !1;
function $a6cdda187280cdb0$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $a6cdda187280cdb0$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $a6cdda187280cdb0$var$hasSpaceKeypress = !0;
            return $a6cdda187280cdb0$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $a6cdda187280cdb0$var$SPACEBAR_CHAR && $a6cdda187280cdb0$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $a6cdda187280cdb0$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($a6cdda187280cdb0$var$isComposing) return "compositionend" === domEventName || !$a6cdda187280cdb0$var$canUseCompositionEvent && $a6cdda187280cdb0$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $a6cdda187280cdb0$var$getData(), $a6cdda187280cdb0$var$fallbackText = $a6cdda187280cdb0$var$startText = $a6cdda187280cdb0$var$root = null, $a6cdda187280cdb0$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $a6cdda187280cdb0$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $a6cdda187280cdb0$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $a6cdda187280cdb0$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$a6cdda187280cdb0$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $a6cdda187280cdb0$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $a6cdda187280cdb0$var$restoreTarget ? $a6cdda187280cdb0$var$restoreQueue ? $a6cdda187280cdb0$var$restoreQueue.push(target) : $a6cdda187280cdb0$var$restoreQueue = [
        target
    ] : $a6cdda187280cdb0$var$restoreTarget = target;
    inst = $a6cdda187280cdb0$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $a6cdda187280cdb0$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $a6cdda187280cdb0$var$activeElement$1 = null, $a6cdda187280cdb0$var$activeElementInst$1 = null;
function $a6cdda187280cdb0$var$runEventInBatch(dispatchQueue) {
    $a6cdda187280cdb0$var$processDispatchQueue(dispatchQueue, 0);
}
function $a6cdda187280cdb0$var$getInstIfValueChanged(targetInst) {
    var targetNode = $a6cdda187280cdb0$var$getNodeFromInstance(targetInst);
    if ($a6cdda187280cdb0$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $a6cdda187280cdb0$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $a6cdda187280cdb0$var$isInputEventSupported = !1;
if ($a6cdda187280cdb0$var$canUseDOM) {
    var $a6cdda187280cdb0$var$JSCompiler_inline_result$jscomp$286;
    if ($a6cdda187280cdb0$var$canUseDOM) {
        var $a6cdda187280cdb0$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$a6cdda187280cdb0$var$isSupported$jscomp$inline_427) {
            var $a6cdda187280cdb0$var$element$jscomp$inline_428 = document.createElement("div");
            $a6cdda187280cdb0$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $a6cdda187280cdb0$var$isSupported$jscomp$inline_427 = "function" === typeof $a6cdda187280cdb0$var$element$jscomp$inline_428.oninput;
        }
        $a6cdda187280cdb0$var$JSCompiler_inline_result$jscomp$286 = $a6cdda187280cdb0$var$isSupported$jscomp$inline_427;
    } else $a6cdda187280cdb0$var$JSCompiler_inline_result$jscomp$286 = !1;
    $a6cdda187280cdb0$var$isInputEventSupported = $a6cdda187280cdb0$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $a6cdda187280cdb0$var$stopWatchingForValueChange() {
    $a6cdda187280cdb0$var$activeElement$1 && ($a6cdda187280cdb0$var$activeElement$1.detachEvent("onpropertychange", $a6cdda187280cdb0$var$handlePropertyChange), $a6cdda187280cdb0$var$activeElementInst$1 = $a6cdda187280cdb0$var$activeElement$1 = null);
}
function $a6cdda187280cdb0$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $a6cdda187280cdb0$var$getInstIfValueChanged($a6cdda187280cdb0$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $a6cdda187280cdb0$var$createAndAccumulateChangeEvent(dispatchQueue, $a6cdda187280cdb0$var$activeElementInst$1, nativeEvent, $a6cdda187280cdb0$var$getEventTarget(nativeEvent));
        $a6cdda187280cdb0$var$batchedUpdates$1($a6cdda187280cdb0$var$runEventInBatch, dispatchQueue);
    }
}
function $a6cdda187280cdb0$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($a6cdda187280cdb0$var$stopWatchingForValueChange(), $a6cdda187280cdb0$var$activeElement$1 = target, $a6cdda187280cdb0$var$activeElementInst$1 = targetInst, $a6cdda187280cdb0$var$activeElement$1.attachEvent("onpropertychange", $a6cdda187280cdb0$var$handlePropertyChange)) : "focusout" === domEventName && $a6cdda187280cdb0$var$stopWatchingForValueChange();
}
function $a6cdda187280cdb0$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $a6cdda187280cdb0$var$getInstIfValueChanged($a6cdda187280cdb0$var$activeElementInst$1);
}
function $a6cdda187280cdb0$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $a6cdda187280cdb0$var$getInstIfValueChanged(targetInst);
}
function $a6cdda187280cdb0$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $a6cdda187280cdb0$var$getInstIfValueChanged(targetInst);
}
function $a6cdda187280cdb0$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $a6cdda187280cdb0$var$objectIs = "function" === typeof Object.is ? Object.is : $a6cdda187280cdb0$var$is;
function $a6cdda187280cdb0$var$shallowEqual(objA, objB) {
    if ($a6cdda187280cdb0$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$a6cdda187280cdb0$var$hasOwnProperty.call(objB, currentKey) || !$a6cdda187280cdb0$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $a6cdda187280cdb0$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $a6cdda187280cdb0$var$getNodeForCharacterOffset(root, offset) {
    var node = $a6cdda187280cdb0$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $a6cdda187280cdb0$var$getLeafNode(node);
    }
}
function $a6cdda187280cdb0$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $a6cdda187280cdb0$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $a6cdda187280cdb0$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $a6cdda187280cdb0$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $a6cdda187280cdb0$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $a6cdda187280cdb0$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $a6cdda187280cdb0$var$skipSelectionChangeEvent = $a6cdda187280cdb0$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $a6cdda187280cdb0$var$activeElement = null, $a6cdda187280cdb0$var$activeElementInst = null, $a6cdda187280cdb0$var$lastSelection = null, $a6cdda187280cdb0$var$mouseDown = !1;
function $a6cdda187280cdb0$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $a6cdda187280cdb0$var$mouseDown || null == $a6cdda187280cdb0$var$activeElement || $a6cdda187280cdb0$var$activeElement !== $a6cdda187280cdb0$var$getActiveElement(doc) || (doc = $a6cdda187280cdb0$var$activeElement, "selectionStart" in doc && $a6cdda187280cdb0$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $a6cdda187280cdb0$var$lastSelection && $a6cdda187280cdb0$var$shallowEqual($a6cdda187280cdb0$var$lastSelection, doc) || ($a6cdda187280cdb0$var$lastSelection = doc, doc = $a6cdda187280cdb0$var$accumulateTwoPhaseListeners($a6cdda187280cdb0$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $a6cdda187280cdb0$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $a6cdda187280cdb0$var$activeElement)));
}
function $a6cdda187280cdb0$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $a6cdda187280cdb0$var$vendorPrefixes = {
    animationend: $a6cdda187280cdb0$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $a6cdda187280cdb0$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $a6cdda187280cdb0$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $a6cdda187280cdb0$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $a6cdda187280cdb0$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $a6cdda187280cdb0$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $a6cdda187280cdb0$var$makePrefixMap("Transition", "TransitionEnd")
}, $a6cdda187280cdb0$var$prefixedEventNames = {}, $a6cdda187280cdb0$var$style = {};
$a6cdda187280cdb0$var$canUseDOM && ($a6cdda187280cdb0$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $a6cdda187280cdb0$var$vendorPrefixes.animationend.animation, delete $a6cdda187280cdb0$var$vendorPrefixes.animationiteration.animation, delete $a6cdda187280cdb0$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $a6cdda187280cdb0$var$vendorPrefixes.transitionend.transition);
function $a6cdda187280cdb0$var$getVendorPrefixedEventName(eventName) {
    if ($a6cdda187280cdb0$var$prefixedEventNames[eventName]) return $a6cdda187280cdb0$var$prefixedEventNames[eventName];
    if (!$a6cdda187280cdb0$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $a6cdda187280cdb0$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $a6cdda187280cdb0$var$style) return $a6cdda187280cdb0$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $a6cdda187280cdb0$var$ANIMATION_END = $a6cdda187280cdb0$var$getVendorPrefixedEventName("animationend"), $a6cdda187280cdb0$var$ANIMATION_ITERATION = $a6cdda187280cdb0$var$getVendorPrefixedEventName("animationiteration"), $a6cdda187280cdb0$var$ANIMATION_START = $a6cdda187280cdb0$var$getVendorPrefixedEventName("animationstart"), $a6cdda187280cdb0$var$TRANSITION_RUN = $a6cdda187280cdb0$var$getVendorPrefixedEventName("transitionrun"), $a6cdda187280cdb0$var$TRANSITION_START = $a6cdda187280cdb0$var$getVendorPrefixedEventName("transitionstart"), $a6cdda187280cdb0$var$TRANSITION_CANCEL = $a6cdda187280cdb0$var$getVendorPrefixedEventName("transitioncancel"), $a6cdda187280cdb0$var$TRANSITION_END = $a6cdda187280cdb0$var$getVendorPrefixedEventName("transitionend"), $a6cdda187280cdb0$var$topLevelEventsToReactNames = new Map(), $a6cdda187280cdb0$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$a6cdda187280cdb0$var$simpleEventPluginEvents.push("scrollEnd");
function $a6cdda187280cdb0$var$registerSimpleEvent(domEventName, reactName) {
    $a6cdda187280cdb0$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $a6cdda187280cdb0$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $a6cdda187280cdb0$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $a6cdda187280cdb0$var$concurrentQueues = [], $a6cdda187280cdb0$var$concurrentQueuesIndex = 0, $a6cdda187280cdb0$var$concurrentlyUpdatedLanes = 0;
function $a6cdda187280cdb0$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $a6cdda187280cdb0$var$concurrentQueuesIndex, i = $a6cdda187280cdb0$var$concurrentlyUpdatedLanes = $a6cdda187280cdb0$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $a6cdda187280cdb0$var$concurrentQueues[i];
        $a6cdda187280cdb0$var$concurrentQueues[i++] = null;
        var queue = $a6cdda187280cdb0$var$concurrentQueues[i];
        $a6cdda187280cdb0$var$concurrentQueues[i++] = null;
        var update = $a6cdda187280cdb0$var$concurrentQueues[i];
        $a6cdda187280cdb0$var$concurrentQueues[i++] = null;
        var lane = $a6cdda187280cdb0$var$concurrentQueues[i];
        $a6cdda187280cdb0$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $a6cdda187280cdb0$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $a6cdda187280cdb0$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $a6cdda187280cdb0$var$concurrentQueues[$a6cdda187280cdb0$var$concurrentQueuesIndex++] = fiber;
    $a6cdda187280cdb0$var$concurrentQueues[$a6cdda187280cdb0$var$concurrentQueuesIndex++] = queue;
    $a6cdda187280cdb0$var$concurrentQueues[$a6cdda187280cdb0$var$concurrentQueuesIndex++] = update;
    $a6cdda187280cdb0$var$concurrentQueues[$a6cdda187280cdb0$var$concurrentQueuesIndex++] = lane;
    $a6cdda187280cdb0$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $a6cdda187280cdb0$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $a6cdda187280cdb0$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $a6cdda187280cdb0$var$getRootForUpdatedFiber(fiber);
}
function $a6cdda187280cdb0$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $a6cdda187280cdb0$var$enqueueUpdate$1(fiber, null, null, lane);
    return $a6cdda187280cdb0$var$getRootForUpdatedFiber(fiber);
}
function $a6cdda187280cdb0$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $a6cdda187280cdb0$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $a6cdda187280cdb0$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $a6cdda187280cdb0$var$nestedUpdateCount) throw $a6cdda187280cdb0$var$nestedUpdateCount = 0, $a6cdda187280cdb0$var$rootWithNestedUpdates = null, Error($a6cdda187280cdb0$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $a6cdda187280cdb0$var$emptyContextObject = {};
function $a6cdda187280cdb0$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $a6cdda187280cdb0$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $a6cdda187280cdb0$var$FiberNode(tag, pendingProps, key, mode);
}
function $a6cdda187280cdb0$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $a6cdda187280cdb0$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $a6cdda187280cdb0$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $a6cdda187280cdb0$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $a6cdda187280cdb0$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $a6cdda187280cdb0$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $a6cdda187280cdb0$var$isHostHoistableType(type, pendingProps, $a6cdda187280cdb0$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $a6cdda187280cdb0$var$REACT_ACTIVITY_TYPE:
            return type = $a6cdda187280cdb0$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $a6cdda187280cdb0$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $a6cdda187280cdb0$var$REACT_FRAGMENT_TYPE:
            return $a6cdda187280cdb0$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $a6cdda187280cdb0$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $a6cdda187280cdb0$var$REACT_PROFILER_TYPE:
            return type = $a6cdda187280cdb0$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $a6cdda187280cdb0$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $a6cdda187280cdb0$var$REACT_SUSPENSE_TYPE:
            return type = $a6cdda187280cdb0$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $a6cdda187280cdb0$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $a6cdda187280cdb0$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $a6cdda187280cdb0$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $a6cdda187280cdb0$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $a6cdda187280cdb0$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $a6cdda187280cdb0$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $a6cdda187280cdb0$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $a6cdda187280cdb0$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $a6cdda187280cdb0$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($a6cdda187280cdb0$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $a6cdda187280cdb0$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $a6cdda187280cdb0$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $a6cdda187280cdb0$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $a6cdda187280cdb0$var$createFiberFromText(content, mode, lanes) {
    content = $a6cdda187280cdb0$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $a6cdda187280cdb0$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $a6cdda187280cdb0$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $a6cdda187280cdb0$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $a6cdda187280cdb0$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $a6cdda187280cdb0$var$CapturedStacks = new WeakMap();
function $a6cdda187280cdb0$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $a6cdda187280cdb0$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $a6cdda187280cdb0$var$getStackByFiberInDevAndProd(source)
        };
        $a6cdda187280cdb0$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $a6cdda187280cdb0$var$getStackByFiberInDevAndProd(source)
    };
}
var $a6cdda187280cdb0$var$forkStack = [], $a6cdda187280cdb0$var$forkStackIndex = 0, $a6cdda187280cdb0$var$treeForkProvider = null, $a6cdda187280cdb0$var$treeForkCount = 0, $a6cdda187280cdb0$var$idStack = [], $a6cdda187280cdb0$var$idStackIndex = 0, $a6cdda187280cdb0$var$treeContextProvider = null, $a6cdda187280cdb0$var$treeContextId = 1, $a6cdda187280cdb0$var$treeContextOverflow = "";
function $a6cdda187280cdb0$var$pushTreeFork(workInProgress, totalChildren) {
    $a6cdda187280cdb0$var$forkStack[$a6cdda187280cdb0$var$forkStackIndex++] = $a6cdda187280cdb0$var$treeForkCount;
    $a6cdda187280cdb0$var$forkStack[$a6cdda187280cdb0$var$forkStackIndex++] = $a6cdda187280cdb0$var$treeForkProvider;
    $a6cdda187280cdb0$var$treeForkProvider = workInProgress;
    $a6cdda187280cdb0$var$treeForkCount = totalChildren;
}
function $a6cdda187280cdb0$var$pushTreeId(workInProgress, totalChildren, index) {
    $a6cdda187280cdb0$var$idStack[$a6cdda187280cdb0$var$idStackIndex++] = $a6cdda187280cdb0$var$treeContextId;
    $a6cdda187280cdb0$var$idStack[$a6cdda187280cdb0$var$idStackIndex++] = $a6cdda187280cdb0$var$treeContextOverflow;
    $a6cdda187280cdb0$var$idStack[$a6cdda187280cdb0$var$idStackIndex++] = $a6cdda187280cdb0$var$treeContextProvider;
    $a6cdda187280cdb0$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $a6cdda187280cdb0$var$treeContextId;
    workInProgress = $a6cdda187280cdb0$var$treeContextOverflow;
    var baseLength = 32 - $a6cdda187280cdb0$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $a6cdda187280cdb0$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $a6cdda187280cdb0$var$treeContextId = 1 << 32 - $a6cdda187280cdb0$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $a6cdda187280cdb0$var$treeContextOverflow = length + workInProgress;
    } else $a6cdda187280cdb0$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $a6cdda187280cdb0$var$treeContextOverflow = workInProgress;
}
function $a6cdda187280cdb0$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($a6cdda187280cdb0$var$pushTreeFork(workInProgress, 1), $a6cdda187280cdb0$var$pushTreeId(workInProgress, 1, 0));
}
function $a6cdda187280cdb0$var$popTreeContext(workInProgress) {
    for(; workInProgress === $a6cdda187280cdb0$var$treeForkProvider;)$a6cdda187280cdb0$var$treeForkProvider = $a6cdda187280cdb0$var$forkStack[--$a6cdda187280cdb0$var$forkStackIndex], $a6cdda187280cdb0$var$forkStack[$a6cdda187280cdb0$var$forkStackIndex] = null, $a6cdda187280cdb0$var$treeForkCount = $a6cdda187280cdb0$var$forkStack[--$a6cdda187280cdb0$var$forkStackIndex], $a6cdda187280cdb0$var$forkStack[$a6cdda187280cdb0$var$forkStackIndex] = null;
    for(; workInProgress === $a6cdda187280cdb0$var$treeContextProvider;)$a6cdda187280cdb0$var$treeContextProvider = $a6cdda187280cdb0$var$idStack[--$a6cdda187280cdb0$var$idStackIndex], $a6cdda187280cdb0$var$idStack[$a6cdda187280cdb0$var$idStackIndex] = null, $a6cdda187280cdb0$var$treeContextOverflow = $a6cdda187280cdb0$var$idStack[--$a6cdda187280cdb0$var$idStackIndex], $a6cdda187280cdb0$var$idStack[$a6cdda187280cdb0$var$idStackIndex] = null, $a6cdda187280cdb0$var$treeContextId = $a6cdda187280cdb0$var$idStack[--$a6cdda187280cdb0$var$idStackIndex], $a6cdda187280cdb0$var$idStack[$a6cdda187280cdb0$var$idStackIndex] = null;
}
function $a6cdda187280cdb0$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $a6cdda187280cdb0$var$idStack[$a6cdda187280cdb0$var$idStackIndex++] = $a6cdda187280cdb0$var$treeContextId;
    $a6cdda187280cdb0$var$idStack[$a6cdda187280cdb0$var$idStackIndex++] = $a6cdda187280cdb0$var$treeContextOverflow;
    $a6cdda187280cdb0$var$idStack[$a6cdda187280cdb0$var$idStackIndex++] = $a6cdda187280cdb0$var$treeContextProvider;
    $a6cdda187280cdb0$var$treeContextId = suspendedContext.id;
    $a6cdda187280cdb0$var$treeContextOverflow = suspendedContext.overflow;
    $a6cdda187280cdb0$var$treeContextProvider = workInProgress;
}
var $a6cdda187280cdb0$var$hydrationParentFiber = null, $a6cdda187280cdb0$var$nextHydratableInstance = null, $a6cdda187280cdb0$var$isHydrating = !1, $a6cdda187280cdb0$var$hydrationErrors = null, $a6cdda187280cdb0$var$rootOrSingletonContext = !1, $a6cdda187280cdb0$var$HydrationMismatchException = Error($a6cdda187280cdb0$var$formatProdErrorMessage(519));
function $a6cdda187280cdb0$var$throwOnHydrationMismatch(fiber) {
    var error = Error($a6cdda187280cdb0$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $a6cdda187280cdb0$var$queueHydrationError($a6cdda187280cdb0$var$createCapturedValueAtFiber(error, fiber));
    throw $a6cdda187280cdb0$var$HydrationMismatchException;
}
function $a6cdda187280cdb0$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$a6cdda187280cdb0$var$internalInstanceKey] = fiber;
    instance[$a6cdda187280cdb0$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("cancel", instance);
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $a6cdda187280cdb0$var$mediaEventTypes.length; type++)$a6cdda187280cdb0$var$listenToNonDelegatedEvent($a6cdda187280cdb0$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("error", instance);
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("invalid", instance);
            $a6cdda187280cdb0$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("invalid", instance), $a6cdda187280cdb0$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $a6cdda187280cdb0$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($a6cdda187280cdb0$var$listenToNonDelegatedEvent("beforetoggle", instance), $a6cdda187280cdb0$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $a6cdda187280cdb0$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $a6cdda187280cdb0$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $a6cdda187280cdb0$var$noop$1), instance = !0) : instance = !1;
    instance || $a6cdda187280cdb0$var$throwOnHydrationMismatch(fiber, !0);
}
function $a6cdda187280cdb0$var$popToNextHostParent(fiber) {
    for($a6cdda187280cdb0$var$hydrationParentFiber = fiber.return; $a6cdda187280cdb0$var$hydrationParentFiber;)switch($a6cdda187280cdb0$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $a6cdda187280cdb0$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $a6cdda187280cdb0$var$rootOrSingletonContext = !0;
            return;
        default:
            $a6cdda187280cdb0$var$hydrationParentFiber = $a6cdda187280cdb0$var$hydrationParentFiber.return;
    }
}
function $a6cdda187280cdb0$var$popHydrationState(fiber) {
    if (fiber !== $a6cdda187280cdb0$var$hydrationParentFiber) return !1;
    if (!$a6cdda187280cdb0$var$isHydrating) return $a6cdda187280cdb0$var$popToNextHostParent(fiber), $a6cdda187280cdb0$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $a6cdda187280cdb0$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $a6cdda187280cdb0$var$nextHydratableInstance && $a6cdda187280cdb0$var$throwOnHydrationMismatch(fiber);
    $a6cdda187280cdb0$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(317));
        $a6cdda187280cdb0$var$nextHydratableInstance = $a6cdda187280cdb0$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(317));
        $a6cdda187280cdb0$var$nextHydratableInstance = $a6cdda187280cdb0$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $a6cdda187280cdb0$var$nextHydratableInstance, $a6cdda187280cdb0$var$isSingletonScope(fiber.type) ? (fiber = $a6cdda187280cdb0$var$previousHydratableOnEnteringScopedSingleton, $a6cdda187280cdb0$var$previousHydratableOnEnteringScopedSingleton = null, $a6cdda187280cdb0$var$nextHydratableInstance = fiber) : $a6cdda187280cdb0$var$nextHydratableInstance = tag) : $a6cdda187280cdb0$var$nextHydratableInstance = $a6cdda187280cdb0$var$hydrationParentFiber ? $a6cdda187280cdb0$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $a6cdda187280cdb0$var$resetHydrationState() {
    $a6cdda187280cdb0$var$nextHydratableInstance = $a6cdda187280cdb0$var$hydrationParentFiber = null;
    $a6cdda187280cdb0$var$isHydrating = !1;
}
function $a6cdda187280cdb0$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $a6cdda187280cdb0$var$hydrationErrors;
    null !== queuedErrors && (null === $a6cdda187280cdb0$var$workInProgressRootRecoverableErrors ? $a6cdda187280cdb0$var$workInProgressRootRecoverableErrors = queuedErrors : $a6cdda187280cdb0$var$workInProgressRootRecoverableErrors.push.apply($a6cdda187280cdb0$var$workInProgressRootRecoverableErrors, queuedErrors), $a6cdda187280cdb0$var$hydrationErrors = null);
    return queuedErrors;
}
function $a6cdda187280cdb0$var$queueHydrationError(error) {
    null === $a6cdda187280cdb0$var$hydrationErrors ? $a6cdda187280cdb0$var$hydrationErrors = [
        error
    ] : $a6cdda187280cdb0$var$hydrationErrors.push(error);
}
var $a6cdda187280cdb0$var$valueCursor = $a6cdda187280cdb0$var$createCursor(null), $a6cdda187280cdb0$var$currentlyRenderingFiber$1 = null, $a6cdda187280cdb0$var$lastContextDependency = null;
function $a6cdda187280cdb0$var$pushProvider(providerFiber, context, nextValue) {
    $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $a6cdda187280cdb0$var$popProvider(context) {
    context._currentValue = $a6cdda187280cdb0$var$valueCursor.current;
    $a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$valueCursor);
}
function $a6cdda187280cdb0$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $a6cdda187280cdb0$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $a6cdda187280cdb0$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $a6cdda187280cdb0$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $a6cdda187280cdb0$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $a6cdda187280cdb0$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $a6cdda187280cdb0$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($a6cdda187280cdb0$var$HostTransitionContext) : current = [
                $a6cdda187280cdb0$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $a6cdda187280cdb0$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $a6cdda187280cdb0$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$a6cdda187280cdb0$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $a6cdda187280cdb0$var$prepareToReadContext(workInProgress) {
    $a6cdda187280cdb0$var$currentlyRenderingFiber$1 = workInProgress;
    $a6cdda187280cdb0$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $a6cdda187280cdb0$var$readContext(context) {
    return $a6cdda187280cdb0$var$readContextForConsumer($a6cdda187280cdb0$var$currentlyRenderingFiber$1, context);
}
function $a6cdda187280cdb0$var$readContextDuringReconciliation(consumer, context) {
    null === $a6cdda187280cdb0$var$currentlyRenderingFiber$1 && $a6cdda187280cdb0$var$prepareToReadContext(consumer);
    return $a6cdda187280cdb0$var$readContextForConsumer(consumer, context);
}
function $a6cdda187280cdb0$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $a6cdda187280cdb0$var$lastContextDependency) {
        if (null === consumer) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(308));
        $a6cdda187280cdb0$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $a6cdda187280cdb0$var$lastContextDependency = $a6cdda187280cdb0$var$lastContextDependency.next = context;
    return value;
}
var $a6cdda187280cdb0$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $a6cdda187280cdb0$var$scheduleCallback$2 = $a7qGw.unstable_scheduleCallback, $a6cdda187280cdb0$var$NormalPriority = $a7qGw.unstable_NormalPriority, $a6cdda187280cdb0$var$CacheContext = {
    $$typeof: $a6cdda187280cdb0$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $a6cdda187280cdb0$var$createCache() {
    return {
        controller: new $a6cdda187280cdb0$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $a6cdda187280cdb0$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $a6cdda187280cdb0$var$scheduleCallback$2($a6cdda187280cdb0$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $a6cdda187280cdb0$var$currentEntangledListeners = null, $a6cdda187280cdb0$var$currentEntangledPendingCount = 0, $a6cdda187280cdb0$var$currentEntangledLane = 0, $a6cdda187280cdb0$var$currentEntangledActionThenable = null;
function $a6cdda187280cdb0$var$entangleAsyncAction(transition, thenable) {
    if (null === $a6cdda187280cdb0$var$currentEntangledListeners) {
        var entangledListeners = $a6cdda187280cdb0$var$currentEntangledListeners = [];
        $a6cdda187280cdb0$var$currentEntangledPendingCount = 0;
        $a6cdda187280cdb0$var$currentEntangledLane = $a6cdda187280cdb0$var$requestTransitionLane();
        $a6cdda187280cdb0$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $a6cdda187280cdb0$var$currentEntangledPendingCount++;
    thenable.then($a6cdda187280cdb0$var$pingEngtangledActionScope, $a6cdda187280cdb0$var$pingEngtangledActionScope);
    return thenable;
}
function $a6cdda187280cdb0$var$pingEngtangledActionScope() {
    if (0 === --$a6cdda187280cdb0$var$currentEntangledPendingCount && null !== $a6cdda187280cdb0$var$currentEntangledListeners) {
        null !== $a6cdda187280cdb0$var$currentEntangledActionThenable && ($a6cdda187280cdb0$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $a6cdda187280cdb0$var$currentEntangledListeners;
        $a6cdda187280cdb0$var$currentEntangledListeners = null;
        $a6cdda187280cdb0$var$currentEntangledLane = 0;
        $a6cdda187280cdb0$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $a6cdda187280cdb0$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $a6cdda187280cdb0$var$prevOnStartTransitionFinish = $a6cdda187280cdb0$var$ReactSharedInternals.S;
$a6cdda187280cdb0$var$ReactSharedInternals.S = function(transition, returnValue) {
    $a6cdda187280cdb0$var$globalMostRecentTransitionTime = $a6cdda187280cdb0$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $a6cdda187280cdb0$var$entangleAsyncAction(transition, returnValue);
    null !== $a6cdda187280cdb0$var$prevOnStartTransitionFinish && $a6cdda187280cdb0$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $a6cdda187280cdb0$var$resumedCache = $a6cdda187280cdb0$var$createCursor(null);
function $a6cdda187280cdb0$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $a6cdda187280cdb0$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $a6cdda187280cdb0$var$workInProgressRoot.pooledCache;
}
function $a6cdda187280cdb0$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$resumedCache, $a6cdda187280cdb0$var$resumedCache.current) : $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$resumedCache, prevCachePool.pool);
}
function $a6cdda187280cdb0$var$getSuspendedCache() {
    var cacheFromPool = $a6cdda187280cdb0$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $a6cdda187280cdb0$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $a6cdda187280cdb0$var$SuspenseException = Error($a6cdda187280cdb0$var$formatProdErrorMessage(460)), $a6cdda187280cdb0$var$SuspenseyCommitException = Error($a6cdda187280cdb0$var$formatProdErrorMessage(474)), $a6cdda187280cdb0$var$SuspenseActionException = Error($a6cdda187280cdb0$var$formatProdErrorMessage(542)), $a6cdda187280cdb0$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $a6cdda187280cdb0$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $a6cdda187280cdb0$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($a6cdda187280cdb0$var$noop$1, $a6cdda187280cdb0$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $a6cdda187280cdb0$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($a6cdda187280cdb0$var$noop$1, $a6cdda187280cdb0$var$noop$1);
            else {
                thenableState = $a6cdda187280cdb0$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $a6cdda187280cdb0$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $a6cdda187280cdb0$var$suspendedThenable = thenable;
            throw $a6cdda187280cdb0$var$SuspenseException;
    }
}
function $a6cdda187280cdb0$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $a6cdda187280cdb0$var$suspendedThenable = x, $a6cdda187280cdb0$var$SuspenseException;
        throw x;
    }
}
var $a6cdda187280cdb0$var$suspendedThenable = null;
function $a6cdda187280cdb0$var$getSuspendedThenable() {
    if (null === $a6cdda187280cdb0$var$suspendedThenable) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(459));
    var thenable = $a6cdda187280cdb0$var$suspendedThenable;
    $a6cdda187280cdb0$var$suspendedThenable = null;
    return thenable;
}
function $a6cdda187280cdb0$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $a6cdda187280cdb0$var$SuspenseException || rejectedReason === $a6cdda187280cdb0$var$SuspenseActionException) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(483));
}
var $a6cdda187280cdb0$var$thenableState$1 = null, $a6cdda187280cdb0$var$thenableIndexCounter$1 = 0;
function $a6cdda187280cdb0$var$unwrapThenable(thenable) {
    var index = $a6cdda187280cdb0$var$thenableIndexCounter$1;
    $a6cdda187280cdb0$var$thenableIndexCounter$1 += 1;
    null === $a6cdda187280cdb0$var$thenableState$1 && ($a6cdda187280cdb0$var$thenableState$1 = []);
    return $a6cdda187280cdb0$var$trackUsedThenable($a6cdda187280cdb0$var$thenableState$1, thenable, index);
}
function $a6cdda187280cdb0$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $a6cdda187280cdb0$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $a6cdda187280cdb0$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $a6cdda187280cdb0$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $a6cdda187280cdb0$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $a6cdda187280cdb0$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $a6cdda187280cdb0$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $a6cdda187280cdb0$var$REACT_LAZY_TYPE && $a6cdda187280cdb0$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $a6cdda187280cdb0$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $a6cdda187280cdb0$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $a6cdda187280cdb0$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $a6cdda187280cdb0$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $a6cdda187280cdb0$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $a6cdda187280cdb0$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $a6cdda187280cdb0$var$REACT_ELEMENT_TYPE:
                    return lanes = $a6cdda187280cdb0$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $a6cdda187280cdb0$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $a6cdda187280cdb0$var$REACT_PORTAL_TYPE:
                    return newChild = $a6cdda187280cdb0$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $a6cdda187280cdb0$var$REACT_LAZY_TYPE:
                    return newChild = $a6cdda187280cdb0$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($a6cdda187280cdb0$var$isArrayImpl(newChild) || $a6cdda187280cdb0$var$getIteratorFn(newChild)) return newChild = $a6cdda187280cdb0$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $a6cdda187280cdb0$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $a6cdda187280cdb0$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $a6cdda187280cdb0$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $a6cdda187280cdb0$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $a6cdda187280cdb0$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $a6cdda187280cdb0$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $a6cdda187280cdb0$var$REACT_LAZY_TYPE:
                    return newChild = $a6cdda187280cdb0$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($a6cdda187280cdb0$var$isArrayImpl(newChild) || $a6cdda187280cdb0$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $a6cdda187280cdb0$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $a6cdda187280cdb0$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $a6cdda187280cdb0$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $a6cdda187280cdb0$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $a6cdda187280cdb0$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $a6cdda187280cdb0$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $a6cdda187280cdb0$var$REACT_LAZY_TYPE:
                    return newChild = $a6cdda187280cdb0$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($a6cdda187280cdb0$var$isArrayImpl(newChild) || $a6cdda187280cdb0$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $a6cdda187280cdb0$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $a6cdda187280cdb0$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $a6cdda187280cdb0$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $a6cdda187280cdb0$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $a6cdda187280cdb0$var$isHydrating && $a6cdda187280cdb0$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $a6cdda187280cdb0$var$isHydrating && $a6cdda187280cdb0$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $a6cdda187280cdb0$var$isHydrating && $a6cdda187280cdb0$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $a6cdda187280cdb0$var$isHydrating && $a6cdda187280cdb0$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $a6cdda187280cdb0$var$isHydrating && $a6cdda187280cdb0$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $a6cdda187280cdb0$var$isHydrating && $a6cdda187280cdb0$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $a6cdda187280cdb0$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $a6cdda187280cdb0$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $a6cdda187280cdb0$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $a6cdda187280cdb0$var$REACT_LAZY_TYPE && $a6cdda187280cdb0$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $a6cdda187280cdb0$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $a6cdda187280cdb0$var$REACT_FRAGMENT_TYPE ? (lanes = $a6cdda187280cdb0$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $a6cdda187280cdb0$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $a6cdda187280cdb0$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $a6cdda187280cdb0$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $a6cdda187280cdb0$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $a6cdda187280cdb0$var$REACT_LAZY_TYPE:
                    return newChild = $a6cdda187280cdb0$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($a6cdda187280cdb0$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($a6cdda187280cdb0$var$getIteratorFn(newChild)) {
                key = $a6cdda187280cdb0$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $a6cdda187280cdb0$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $a6cdda187280cdb0$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $a6cdda187280cdb0$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $a6cdda187280cdb0$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $a6cdda187280cdb0$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $a6cdda187280cdb0$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $a6cdda187280cdb0$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $a6cdda187280cdb0$var$SuspenseException || x === $a6cdda187280cdb0$var$SuspenseActionException) throw x;
            var fiber = $a6cdda187280cdb0$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $a6cdda187280cdb0$var$reconcileChildFibers = $a6cdda187280cdb0$var$createChildReconciler(!0), $a6cdda187280cdb0$var$mountChildFibers = $a6cdda187280cdb0$var$createChildReconciler(!1), $a6cdda187280cdb0$var$hasForceUpdate = !1;
function $a6cdda187280cdb0$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $a6cdda187280cdb0$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $a6cdda187280cdb0$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $a6cdda187280cdb0$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($a6cdda187280cdb0$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $a6cdda187280cdb0$var$getRootForUpdatedFiber(fiber);
        $a6cdda187280cdb0$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $a6cdda187280cdb0$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $a6cdda187280cdb0$var$getRootForUpdatedFiber(fiber);
}
function $a6cdda187280cdb0$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $a6cdda187280cdb0$var$markRootEntangled(root, lane);
    }
}
function $a6cdda187280cdb0$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $a6cdda187280cdb0$var$didReadFromEntangledAsyncAction = !1;
function $a6cdda187280cdb0$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($a6cdda187280cdb0$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $a6cdda187280cdb0$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $a6cdda187280cdb0$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $a6cdda187280cdb0$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $a6cdda187280cdb0$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($a6cdda187280cdb0$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $a6cdda187280cdb0$var$currentEntangledLane && ($a6cdda187280cdb0$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $a6cdda187280cdb0$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $a6cdda187280cdb0$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $a6cdda187280cdb0$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $a6cdda187280cdb0$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $a6cdda187280cdb0$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$a6cdda187280cdb0$var$callCallback(callbacks[updateQueue], context);
}
var $a6cdda187280cdb0$var$currentTreeHiddenStackCursor = $a6cdda187280cdb0$var$createCursor(null), $a6cdda187280cdb0$var$prevEntangledRenderLanesCursor = $a6cdda187280cdb0$var$createCursor(0);
function $a6cdda187280cdb0$var$pushHiddenContext(fiber, context) {
    fiber = $a6cdda187280cdb0$var$entangledRenderLanes;
    $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$prevEntangledRenderLanesCursor, fiber);
    $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$currentTreeHiddenStackCursor, context);
    $a6cdda187280cdb0$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $a6cdda187280cdb0$var$reuseHiddenContextOnStack() {
    $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$prevEntangledRenderLanesCursor, $a6cdda187280cdb0$var$entangledRenderLanes);
    $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$currentTreeHiddenStackCursor, $a6cdda187280cdb0$var$currentTreeHiddenStackCursor.current);
}
function $a6cdda187280cdb0$var$popHiddenContext() {
    $a6cdda187280cdb0$var$entangledRenderLanes = $a6cdda187280cdb0$var$prevEntangledRenderLanesCursor.current;
    $a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$currentTreeHiddenStackCursor);
    $a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$prevEntangledRenderLanesCursor);
}
var $a6cdda187280cdb0$var$suspenseHandlerStackCursor = $a6cdda187280cdb0$var$createCursor(null), $a6cdda187280cdb0$var$shellBoundary = null;
function $a6cdda187280cdb0$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$suspenseStackCursor, $a6cdda187280cdb0$var$suspenseStackCursor.current & 1);
    $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$suspenseHandlerStackCursor, handler);
    null === $a6cdda187280cdb0$var$shellBoundary && (null === current || null !== $a6cdda187280cdb0$var$currentTreeHiddenStackCursor.current ? $a6cdda187280cdb0$var$shellBoundary = handler : null !== current.memoizedState && ($a6cdda187280cdb0$var$shellBoundary = handler));
}
function $a6cdda187280cdb0$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$suspenseStackCursor, $a6cdda187280cdb0$var$suspenseStackCursor.current);
    $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$suspenseHandlerStackCursor, fiber);
    null === $a6cdda187280cdb0$var$shellBoundary && ($a6cdda187280cdb0$var$shellBoundary = fiber);
}
function $a6cdda187280cdb0$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$suspenseStackCursor, $a6cdda187280cdb0$var$suspenseStackCursor.current), $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$suspenseHandlerStackCursor, fiber), null === $a6cdda187280cdb0$var$shellBoundary && ($a6cdda187280cdb0$var$shellBoundary = fiber)) : $a6cdda187280cdb0$var$reuseSuspenseHandlerOnStack(fiber);
}
function $a6cdda187280cdb0$var$reuseSuspenseHandlerOnStack() {
    $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$suspenseStackCursor, $a6cdda187280cdb0$var$suspenseStackCursor.current);
    $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$suspenseHandlerStackCursor, $a6cdda187280cdb0$var$suspenseHandlerStackCursor.current);
}
function $a6cdda187280cdb0$var$popSuspenseHandler(fiber) {
    $a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$suspenseHandlerStackCursor);
    $a6cdda187280cdb0$var$shellBoundary === fiber && ($a6cdda187280cdb0$var$shellBoundary = null);
    $a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$suspenseStackCursor);
}
var $a6cdda187280cdb0$var$suspenseStackCursor = $a6cdda187280cdb0$var$createCursor(0);
function $a6cdda187280cdb0$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $a6cdda187280cdb0$var$isSuspenseInstancePending(state) || $a6cdda187280cdb0$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $a6cdda187280cdb0$var$renderLanes = 0, $a6cdda187280cdb0$var$currentlyRenderingFiber = null, $a6cdda187280cdb0$var$currentHook = null, $a6cdda187280cdb0$var$workInProgressHook = null, $a6cdda187280cdb0$var$didScheduleRenderPhaseUpdate = !1, $a6cdda187280cdb0$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $a6cdda187280cdb0$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $a6cdda187280cdb0$var$localIdCounter = 0, $a6cdda187280cdb0$var$thenableIndexCounter = 0, $a6cdda187280cdb0$var$thenableState = null, $a6cdda187280cdb0$var$globalClientIdCounter = 0;
function $a6cdda187280cdb0$var$throwInvalidHookError() {
    throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(321));
}
function $a6cdda187280cdb0$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$a6cdda187280cdb0$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $a6cdda187280cdb0$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $a6cdda187280cdb0$var$renderLanes = nextRenderLanes;
    $a6cdda187280cdb0$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $a6cdda187280cdb0$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $a6cdda187280cdb0$var$HooksDispatcherOnMount : $a6cdda187280cdb0$var$HooksDispatcherOnUpdate;
    $a6cdda187280cdb0$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $a6cdda187280cdb0$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $a6cdda187280cdb0$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $a6cdda187280cdb0$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $a6cdda187280cdb0$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $a6cdda187280cdb0$var$finishRenderingHooks(current) {
    $a6cdda187280cdb0$var$ReactSharedInternals.H = $a6cdda187280cdb0$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $a6cdda187280cdb0$var$currentHook && null !== $a6cdda187280cdb0$var$currentHook.next;
    $a6cdda187280cdb0$var$renderLanes = 0;
    $a6cdda187280cdb0$var$workInProgressHook = $a6cdda187280cdb0$var$currentHook = $a6cdda187280cdb0$var$currentlyRenderingFiber = null;
    $a6cdda187280cdb0$var$didScheduleRenderPhaseUpdate = !1;
    $a6cdda187280cdb0$var$thenableIndexCounter = 0;
    $a6cdda187280cdb0$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(300));
    null === current || $a6cdda187280cdb0$var$didReceiveUpdate || (current = current.dependencies, null !== current && $a6cdda187280cdb0$var$checkIfContextChanged(current) && ($a6cdda187280cdb0$var$didReceiveUpdate = !0));
}
function $a6cdda187280cdb0$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $a6cdda187280cdb0$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $a6cdda187280cdb0$var$didScheduleRenderPhaseUpdateDuringThisPass && ($a6cdda187280cdb0$var$thenableState = null);
        $a6cdda187280cdb0$var$thenableIndexCounter = 0;
        $a6cdda187280cdb0$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $a6cdda187280cdb0$var$workInProgressHook = $a6cdda187280cdb0$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $a6cdda187280cdb0$var$ReactSharedInternals.H = $a6cdda187280cdb0$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($a6cdda187280cdb0$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $a6cdda187280cdb0$var$TransitionAwareHostComponent() {
    var dispatcher = $a6cdda187280cdb0$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $a6cdda187280cdb0$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $a6cdda187280cdb0$var$currentHook ? $a6cdda187280cdb0$var$currentHook.memoizedState : null) !== dispatcher && ($a6cdda187280cdb0$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $a6cdda187280cdb0$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $a6cdda187280cdb0$var$localIdCounter;
    $a6cdda187280cdb0$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $a6cdda187280cdb0$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $a6cdda187280cdb0$var$resetHooksOnUnwind(workInProgress) {
    if ($a6cdda187280cdb0$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $a6cdda187280cdb0$var$didScheduleRenderPhaseUpdate = !1;
    }
    $a6cdda187280cdb0$var$renderLanes = 0;
    $a6cdda187280cdb0$var$workInProgressHook = $a6cdda187280cdb0$var$currentHook = $a6cdda187280cdb0$var$currentlyRenderingFiber = null;
    $a6cdda187280cdb0$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $a6cdda187280cdb0$var$thenableIndexCounter = $a6cdda187280cdb0$var$localIdCounter = 0;
    $a6cdda187280cdb0$var$thenableState = null;
}
function $a6cdda187280cdb0$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $a6cdda187280cdb0$var$workInProgressHook ? $a6cdda187280cdb0$var$currentlyRenderingFiber.memoizedState = $a6cdda187280cdb0$var$workInProgressHook = hook : $a6cdda187280cdb0$var$workInProgressHook = $a6cdda187280cdb0$var$workInProgressHook.next = hook;
    return $a6cdda187280cdb0$var$workInProgressHook;
}
function $a6cdda187280cdb0$var$updateWorkInProgressHook() {
    if (null === $a6cdda187280cdb0$var$currentHook) {
        var nextCurrentHook = $a6cdda187280cdb0$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $a6cdda187280cdb0$var$currentHook.next;
    var nextWorkInProgressHook = null === $a6cdda187280cdb0$var$workInProgressHook ? $a6cdda187280cdb0$var$currentlyRenderingFiber.memoizedState : $a6cdda187280cdb0$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $a6cdda187280cdb0$var$workInProgressHook = nextWorkInProgressHook, $a6cdda187280cdb0$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $a6cdda187280cdb0$var$currentlyRenderingFiber.alternate) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(467));
            throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(310));
        }
        $a6cdda187280cdb0$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $a6cdda187280cdb0$var$currentHook.memoizedState,
            baseState: $a6cdda187280cdb0$var$currentHook.baseState,
            baseQueue: $a6cdda187280cdb0$var$currentHook.baseQueue,
            queue: $a6cdda187280cdb0$var$currentHook.queue,
            next: null
        };
        null === $a6cdda187280cdb0$var$workInProgressHook ? $a6cdda187280cdb0$var$currentlyRenderingFiber.memoizedState = $a6cdda187280cdb0$var$workInProgressHook = nextCurrentHook : $a6cdda187280cdb0$var$workInProgressHook = $a6cdda187280cdb0$var$workInProgressHook.next = nextCurrentHook;
    }
    return $a6cdda187280cdb0$var$workInProgressHook;
}
function $a6cdda187280cdb0$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $a6cdda187280cdb0$var$useThenable(thenable) {
    var index = $a6cdda187280cdb0$var$thenableIndexCounter;
    $a6cdda187280cdb0$var$thenableIndexCounter += 1;
    null === $a6cdda187280cdb0$var$thenableState && ($a6cdda187280cdb0$var$thenableState = []);
    thenable = $a6cdda187280cdb0$var$trackUsedThenable($a6cdda187280cdb0$var$thenableState, thenable, index);
    index = $a6cdda187280cdb0$var$currentlyRenderingFiber;
    null === (null === $a6cdda187280cdb0$var$workInProgressHook ? index.memoizedState : $a6cdda187280cdb0$var$workInProgressHook.next) && (index = index.alternate, $a6cdda187280cdb0$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $a6cdda187280cdb0$var$HooksDispatcherOnMount : $a6cdda187280cdb0$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $a6cdda187280cdb0$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $a6cdda187280cdb0$var$useThenable(usable);
        if (usable.$$typeof === $a6cdda187280cdb0$var$REACT_CONTEXT_TYPE) return $a6cdda187280cdb0$var$readContext(usable);
    }
    throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(438, String(usable)));
}
function $a6cdda187280cdb0$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $a6cdda187280cdb0$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $a6cdda187280cdb0$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $a6cdda187280cdb0$var$createFunctionComponentUpdateQueue(), $a6cdda187280cdb0$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $a6cdda187280cdb0$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $a6cdda187280cdb0$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $a6cdda187280cdb0$var$updateReducer(reducer) {
    var hook = $a6cdda187280cdb0$var$updateWorkInProgressHook();
    return $a6cdda187280cdb0$var$updateReducerImpl(hook, $a6cdda187280cdb0$var$currentHook, reducer);
}
function $a6cdda187280cdb0$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($a6cdda187280cdb0$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($a6cdda187280cdb0$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $a6cdda187280cdb0$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($a6cdda187280cdb0$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $a6cdda187280cdb0$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $a6cdda187280cdb0$var$currentlyRenderingFiber.lanes |= revertLane, $a6cdda187280cdb0$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $a6cdda187280cdb0$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $a6cdda187280cdb0$var$currentlyRenderingFiber.lanes |= updateLane, $a6cdda187280cdb0$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$a6cdda187280cdb0$var$objectIs(pendingQueue, hook.memoizedState) && ($a6cdda187280cdb0$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $a6cdda187280cdb0$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $a6cdda187280cdb0$var$rerenderReducer(reducer) {
    var hook = $a6cdda187280cdb0$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $a6cdda187280cdb0$var$objectIs(newState, hook.memoizedState) || ($a6cdda187280cdb0$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $a6cdda187280cdb0$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $a6cdda187280cdb0$var$currentlyRenderingFiber, hook = $a6cdda187280cdb0$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $a6cdda187280cdb0$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$a6cdda187280cdb0$var$objectIs(($a6cdda187280cdb0$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $a6cdda187280cdb0$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $a6cdda187280cdb0$var$updateEffect($a6cdda187280cdb0$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $a6cdda187280cdb0$var$workInProgressHook && $a6cdda187280cdb0$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $a6cdda187280cdb0$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $a6cdda187280cdb0$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $a6cdda187280cdb0$var$workInProgressRoot) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($a6cdda187280cdb0$var$renderLanes & 127) || $a6cdda187280cdb0$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $a6cdda187280cdb0$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $a6cdda187280cdb0$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $a6cdda187280cdb0$var$createFunctionComponentUpdateQueue(), $a6cdda187280cdb0$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $a6cdda187280cdb0$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $a6cdda187280cdb0$var$checkIfSnapshotChanged(inst) && $a6cdda187280cdb0$var$forceStoreRerender(fiber);
}
function $a6cdda187280cdb0$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $a6cdda187280cdb0$var$checkIfSnapshotChanged(inst) && $a6cdda187280cdb0$var$forceStoreRerender(fiber);
    });
}
function $a6cdda187280cdb0$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$a6cdda187280cdb0$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $a6cdda187280cdb0$var$forceStoreRerender(fiber) {
    var root = $a6cdda187280cdb0$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $a6cdda187280cdb0$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $a6cdda187280cdb0$var$mountStateImpl(initialState) {
    var hook = $a6cdda187280cdb0$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($a6cdda187280cdb0$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $a6cdda187280cdb0$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $a6cdda187280cdb0$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $a6cdda187280cdb0$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $a6cdda187280cdb0$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $a6cdda187280cdb0$var$updateReducerImpl(hook, $a6cdda187280cdb0$var$currentHook, "function" === typeof reducer ? reducer : $a6cdda187280cdb0$var$basicStateReducer);
}
function $a6cdda187280cdb0$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($a6cdda187280cdb0$var$isRenderPhaseUpdate(fiber)) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $a6cdda187280cdb0$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $a6cdda187280cdb0$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $a6cdda187280cdb0$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $a6cdda187280cdb0$var$ReactSharedInternals.T, currentTransition = {};
        $a6cdda187280cdb0$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $a6cdda187280cdb0$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $a6cdda187280cdb0$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $a6cdda187280cdb0$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $a6cdda187280cdb0$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $a6cdda187280cdb0$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $a6cdda187280cdb0$var$onActionError(actionQueue, node, error$66);
    }
}
function $a6cdda187280cdb0$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $a6cdda187280cdb0$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $a6cdda187280cdb0$var$onActionError(actionQueue, node, error);
    }) : $a6cdda187280cdb0$var$onActionSuccess(actionQueue, node, returnValue);
}
function $a6cdda187280cdb0$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $a6cdda187280cdb0$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $a6cdda187280cdb0$var$runActionStateAction(actionQueue, nextState)));
}
function $a6cdda187280cdb0$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $a6cdda187280cdb0$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $a6cdda187280cdb0$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $a6cdda187280cdb0$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $a6cdda187280cdb0$var$mountActionState(action, initialStateProp) {
    if ($a6cdda187280cdb0$var$isHydrating) {
        var ssrFormState = $a6cdda187280cdb0$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $a6cdda187280cdb0$var$currentlyRenderingFiber;
                if ($a6cdda187280cdb0$var$isHydrating) {
                    if ($a6cdda187280cdb0$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $a6cdda187280cdb0$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $a6cdda187280cdb0$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $a6cdda187280cdb0$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $a6cdda187280cdb0$var$nextHydratableInstance = $a6cdda187280cdb0$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $a6cdda187280cdb0$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $a6cdda187280cdb0$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $a6cdda187280cdb0$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $a6cdda187280cdb0$var$dispatchSetState.bind(null, $a6cdda187280cdb0$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $a6cdda187280cdb0$var$mountStateImpl(!1);
    inRootOrSingleton = $a6cdda187280cdb0$var$dispatchOptimisticSetState.bind(null, $a6cdda187280cdb0$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $a6cdda187280cdb0$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $a6cdda187280cdb0$var$dispatchActionState.bind(null, $a6cdda187280cdb0$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $a6cdda187280cdb0$var$updateActionState(action) {
    var stateHook = $a6cdda187280cdb0$var$updateWorkInProgressHook();
    return $a6cdda187280cdb0$var$updateActionStateImpl(stateHook, $a6cdda187280cdb0$var$currentHook, action);
}
function $a6cdda187280cdb0$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $a6cdda187280cdb0$var$updateReducerImpl(stateHook, currentStateHook, $a6cdda187280cdb0$var$actionStateReducer)[0];
    stateHook = $a6cdda187280cdb0$var$updateReducer($a6cdda187280cdb0$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $a6cdda187280cdb0$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $a6cdda187280cdb0$var$SuspenseException) throw $a6cdda187280cdb0$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $a6cdda187280cdb0$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($a6cdda187280cdb0$var$currentlyRenderingFiber.flags |= 2048, $a6cdda187280cdb0$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $a6cdda187280cdb0$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $a6cdda187280cdb0$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $a6cdda187280cdb0$var$rerenderActionState(action) {
    var stateHook = $a6cdda187280cdb0$var$updateWorkInProgressHook(), currentStateHook = $a6cdda187280cdb0$var$currentHook;
    if (null !== currentStateHook) return $a6cdda187280cdb0$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $a6cdda187280cdb0$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $a6cdda187280cdb0$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $a6cdda187280cdb0$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $a6cdda187280cdb0$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $a6cdda187280cdb0$var$createFunctionComponentUpdateQueue(), $a6cdda187280cdb0$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $a6cdda187280cdb0$var$updateRef() {
    return $a6cdda187280cdb0$var$updateWorkInProgressHook().memoizedState;
}
function $a6cdda187280cdb0$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $a6cdda187280cdb0$var$mountWorkInProgressHook();
    $a6cdda187280cdb0$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $a6cdda187280cdb0$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $a6cdda187280cdb0$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $a6cdda187280cdb0$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $a6cdda187280cdb0$var$currentHook && null !== deps && $a6cdda187280cdb0$var$areHookInputsEqual(deps, $a6cdda187280cdb0$var$currentHook.memoizedState.deps) ? hook.memoizedState = $a6cdda187280cdb0$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($a6cdda187280cdb0$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $a6cdda187280cdb0$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $a6cdda187280cdb0$var$mountEffect(create, deps) {
    $a6cdda187280cdb0$var$mountEffectImpl(8390656, 8, create, deps);
}
function $a6cdda187280cdb0$var$updateEffect(create, deps) {
    $a6cdda187280cdb0$var$updateEffectImpl(2048, 8, create, deps);
}
function $a6cdda187280cdb0$var$useEffectEventImpl(payload) {
    $a6cdda187280cdb0$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $a6cdda187280cdb0$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $a6cdda187280cdb0$var$createFunctionComponentUpdateQueue(), $a6cdda187280cdb0$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $a6cdda187280cdb0$var$updateEvent(callback) {
    var ref = $a6cdda187280cdb0$var$updateWorkInProgressHook().memoizedState;
    $a6cdda187280cdb0$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($a6cdda187280cdb0$var$executionContext & 2)) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $a6cdda187280cdb0$var$updateInsertionEffect(create, deps) {
    return $a6cdda187280cdb0$var$updateEffectImpl(4, 2, create, deps);
}
function $a6cdda187280cdb0$var$updateLayoutEffect(create, deps) {
    return $a6cdda187280cdb0$var$updateEffectImpl(4, 4, create, deps);
}
function $a6cdda187280cdb0$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $a6cdda187280cdb0$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $a6cdda187280cdb0$var$updateEffectImpl(4, 4, $a6cdda187280cdb0$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $a6cdda187280cdb0$var$mountDebugValue() {}
function $a6cdda187280cdb0$var$updateCallback(callback, deps) {
    var hook = $a6cdda187280cdb0$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $a6cdda187280cdb0$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $a6cdda187280cdb0$var$updateMemo(nextCreate, deps) {
    var hook = $a6cdda187280cdb0$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $a6cdda187280cdb0$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($a6cdda187280cdb0$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $a6cdda187280cdb0$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $a6cdda187280cdb0$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $a6cdda187280cdb0$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($a6cdda187280cdb0$var$renderLanes & 1073741824) && 0 === ($a6cdda187280cdb0$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $a6cdda187280cdb0$var$requestDeferredLane();
    $a6cdda187280cdb0$var$currentlyRenderingFiber.lanes |= hook;
    $a6cdda187280cdb0$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $a6cdda187280cdb0$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($a6cdda187280cdb0$var$objectIs(value, prevValue)) return value;
    if (null !== $a6cdda187280cdb0$var$currentTreeHiddenStackCursor.current) return hook = $a6cdda187280cdb0$var$mountDeferredValueImpl(hook, value, initialValue), $a6cdda187280cdb0$var$objectIs(hook, prevValue) || ($a6cdda187280cdb0$var$didReceiveUpdate = !0), hook;
    if (0 === ($a6cdda187280cdb0$var$renderLanes & 42) || 0 !== ($a6cdda187280cdb0$var$renderLanes & 1073741824) && 0 === ($a6cdda187280cdb0$var$workInProgressRootRenderLanes & 261930)) return $a6cdda187280cdb0$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $a6cdda187280cdb0$var$requestDeferredLane();
    $a6cdda187280cdb0$var$currentlyRenderingFiber.lanes |= hook;
    $a6cdda187280cdb0$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $a6cdda187280cdb0$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $a6cdda187280cdb0$var$ReactDOMSharedInternals.p;
    $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $a6cdda187280cdb0$var$ReactSharedInternals.T, currentTransition = {};
    $a6cdda187280cdb0$var$ReactSharedInternals.T = currentTransition;
    $a6cdda187280cdb0$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $a6cdda187280cdb0$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $a6cdda187280cdb0$var$chainThenableValue(returnValue, finishedState);
            $a6cdda187280cdb0$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $a6cdda187280cdb0$var$requestUpdateLane(fiber));
        } else $a6cdda187280cdb0$var$dispatchSetStateInternal(fiber, queue, finishedState, $a6cdda187280cdb0$var$requestUpdateLane(fiber));
    } catch (error) {
        $a6cdda187280cdb0$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $a6cdda187280cdb0$var$requestUpdateLane());
    } finally{
        $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $a6cdda187280cdb0$var$ReactSharedInternals.T = prevTransition;
    }
}
function $a6cdda187280cdb0$var$noop() {}
function $a6cdda187280cdb0$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(476));
    var queue = $a6cdda187280cdb0$var$ensureFormComponentIsStateful(formFiber).queue;
    $a6cdda187280cdb0$var$startTransition(formFiber, queue, pendingState, $a6cdda187280cdb0$var$sharedNotPendingObject, null === action ? $a6cdda187280cdb0$var$noop : function() {
        $a6cdda187280cdb0$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $a6cdda187280cdb0$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $a6cdda187280cdb0$var$sharedNotPendingObject,
        baseState: $a6cdda187280cdb0$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $a6cdda187280cdb0$var$basicStateReducer,
            lastRenderedState: $a6cdda187280cdb0$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $a6cdda187280cdb0$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $a6cdda187280cdb0$var$requestFormReset$1(formFiber) {
    var stateHook = $a6cdda187280cdb0$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $a6cdda187280cdb0$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $a6cdda187280cdb0$var$requestUpdateLane());
}
function $a6cdda187280cdb0$var$useHostTransitionStatus() {
    return $a6cdda187280cdb0$var$readContext($a6cdda187280cdb0$var$HostTransitionContext);
}
function $a6cdda187280cdb0$var$updateId() {
    return $a6cdda187280cdb0$var$updateWorkInProgressHook().memoizedState;
}
function $a6cdda187280cdb0$var$updateRefresh() {
    return $a6cdda187280cdb0$var$updateWorkInProgressHook().memoizedState;
}
function $a6cdda187280cdb0$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $a6cdda187280cdb0$var$requestUpdateLane();
                fiber = $a6cdda187280cdb0$var$createUpdate(lane);
                var root$69 = $a6cdda187280cdb0$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($a6cdda187280cdb0$var$scheduleUpdateOnFiber(root$69, provider, lane), $a6cdda187280cdb0$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $a6cdda187280cdb0$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $a6cdda187280cdb0$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $a6cdda187280cdb0$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $a6cdda187280cdb0$var$isRenderPhaseUpdate(fiber) ? $a6cdda187280cdb0$var$enqueueRenderPhaseUpdate(queue, action) : (action = $a6cdda187280cdb0$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($a6cdda187280cdb0$var$scheduleUpdateOnFiber(action, fiber, lane), $a6cdda187280cdb0$var$entangleTransitionUpdate(action, queue, lane)));
}
function $a6cdda187280cdb0$var$dispatchSetState(fiber, queue, action) {
    var lane = $a6cdda187280cdb0$var$requestUpdateLane();
    $a6cdda187280cdb0$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $a6cdda187280cdb0$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a6cdda187280cdb0$var$isRenderPhaseUpdate(fiber)) $a6cdda187280cdb0$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($a6cdda187280cdb0$var$objectIs(eagerState, currentState)) return $a6cdda187280cdb0$var$enqueueUpdate$1(fiber, queue, update, 0), null === $a6cdda187280cdb0$var$workInProgressRoot && $a6cdda187280cdb0$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $a6cdda187280cdb0$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $a6cdda187280cdb0$var$scheduleUpdateOnFiber(action, fiber, lane), $a6cdda187280cdb0$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $a6cdda187280cdb0$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $a6cdda187280cdb0$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a6cdda187280cdb0$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $a6cdda187280cdb0$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $a6cdda187280cdb0$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $a6cdda187280cdb0$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $a6cdda187280cdb0$var$currentlyRenderingFiber || null !== alternate && alternate === $a6cdda187280cdb0$var$currentlyRenderingFiber;
}
function $a6cdda187280cdb0$var$enqueueRenderPhaseUpdate(queue, update) {
    $a6cdda187280cdb0$var$didScheduleRenderPhaseUpdateDuringThisPass = $a6cdda187280cdb0$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $a6cdda187280cdb0$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $a6cdda187280cdb0$var$markRootEntangled(root, lane);
    }
}
var $a6cdda187280cdb0$var$ContextOnlyDispatcher = {
    readContext: $a6cdda187280cdb0$var$readContext,
    use: $a6cdda187280cdb0$var$use,
    useCallback: $a6cdda187280cdb0$var$throwInvalidHookError,
    useContext: $a6cdda187280cdb0$var$throwInvalidHookError,
    useEffect: $a6cdda187280cdb0$var$throwInvalidHookError,
    useImperativeHandle: $a6cdda187280cdb0$var$throwInvalidHookError,
    useLayoutEffect: $a6cdda187280cdb0$var$throwInvalidHookError,
    useInsertionEffect: $a6cdda187280cdb0$var$throwInvalidHookError,
    useMemo: $a6cdda187280cdb0$var$throwInvalidHookError,
    useReducer: $a6cdda187280cdb0$var$throwInvalidHookError,
    useRef: $a6cdda187280cdb0$var$throwInvalidHookError,
    useState: $a6cdda187280cdb0$var$throwInvalidHookError,
    useDebugValue: $a6cdda187280cdb0$var$throwInvalidHookError,
    useDeferredValue: $a6cdda187280cdb0$var$throwInvalidHookError,
    useTransition: $a6cdda187280cdb0$var$throwInvalidHookError,
    useSyncExternalStore: $a6cdda187280cdb0$var$throwInvalidHookError,
    useId: $a6cdda187280cdb0$var$throwInvalidHookError,
    useHostTransitionStatus: $a6cdda187280cdb0$var$throwInvalidHookError,
    useFormState: $a6cdda187280cdb0$var$throwInvalidHookError,
    useActionState: $a6cdda187280cdb0$var$throwInvalidHookError,
    useOptimistic: $a6cdda187280cdb0$var$throwInvalidHookError,
    useMemoCache: $a6cdda187280cdb0$var$throwInvalidHookError,
    useCacheRefresh: $a6cdda187280cdb0$var$throwInvalidHookError
};
$a6cdda187280cdb0$var$ContextOnlyDispatcher.useEffectEvent = $a6cdda187280cdb0$var$throwInvalidHookError;
var $a6cdda187280cdb0$var$HooksDispatcherOnMount = {
    readContext: $a6cdda187280cdb0$var$readContext,
    use: $a6cdda187280cdb0$var$use,
    useCallback: function(callback, deps) {
        $a6cdda187280cdb0$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $a6cdda187280cdb0$var$readContext,
    useEffect: $a6cdda187280cdb0$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $a6cdda187280cdb0$var$mountEffectImpl(4194308, 4, $a6cdda187280cdb0$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $a6cdda187280cdb0$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $a6cdda187280cdb0$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $a6cdda187280cdb0$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($a6cdda187280cdb0$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $a6cdda187280cdb0$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $a6cdda187280cdb0$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $a6cdda187280cdb0$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($a6cdda187280cdb0$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $a6cdda187280cdb0$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $a6cdda187280cdb0$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $a6cdda187280cdb0$var$dispatchReducerAction.bind(null, $a6cdda187280cdb0$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $a6cdda187280cdb0$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $a6cdda187280cdb0$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $a6cdda187280cdb0$var$dispatchSetState.bind(null, $a6cdda187280cdb0$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $a6cdda187280cdb0$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $a6cdda187280cdb0$var$mountWorkInProgressHook();
        return $a6cdda187280cdb0$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $a6cdda187280cdb0$var$mountStateImpl(!1);
        stateHook = $a6cdda187280cdb0$var$startTransition.bind(null, $a6cdda187280cdb0$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $a6cdda187280cdb0$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $a6cdda187280cdb0$var$currentlyRenderingFiber, hook = $a6cdda187280cdb0$var$mountWorkInProgressHook();
        if ($a6cdda187280cdb0$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $a6cdda187280cdb0$var$workInProgressRoot) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(349));
            0 !== ($a6cdda187280cdb0$var$workInProgressRootRenderLanes & 127) || $a6cdda187280cdb0$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $a6cdda187280cdb0$var$mountEffect($a6cdda187280cdb0$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $a6cdda187280cdb0$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $a6cdda187280cdb0$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $a6cdda187280cdb0$var$mountWorkInProgressHook(), identifierPrefix = $a6cdda187280cdb0$var$workInProgressRoot.identifierPrefix;
        if ($a6cdda187280cdb0$var$isHydrating) {
            var JSCompiler_inline_result = $a6cdda187280cdb0$var$treeContextOverflow;
            var idWithLeadingBit = $a6cdda187280cdb0$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $a6cdda187280cdb0$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $a6cdda187280cdb0$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $a6cdda187280cdb0$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $a6cdda187280cdb0$var$useHostTransitionStatus,
    useFormState: $a6cdda187280cdb0$var$mountActionState,
    useActionState: $a6cdda187280cdb0$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $a6cdda187280cdb0$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $a6cdda187280cdb0$var$dispatchOptimisticSetState.bind(null, $a6cdda187280cdb0$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $a6cdda187280cdb0$var$useMemoCache,
    useCacheRefresh: function() {
        return $a6cdda187280cdb0$var$mountWorkInProgressHook().memoizedState = $a6cdda187280cdb0$var$refreshCache.bind(null, $a6cdda187280cdb0$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $a6cdda187280cdb0$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($a6cdda187280cdb0$var$executionContext & 2)) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $a6cdda187280cdb0$var$HooksDispatcherOnUpdate = {
    readContext: $a6cdda187280cdb0$var$readContext,
    use: $a6cdda187280cdb0$var$use,
    useCallback: $a6cdda187280cdb0$var$updateCallback,
    useContext: $a6cdda187280cdb0$var$readContext,
    useEffect: $a6cdda187280cdb0$var$updateEffect,
    useImperativeHandle: $a6cdda187280cdb0$var$updateImperativeHandle,
    useInsertionEffect: $a6cdda187280cdb0$var$updateInsertionEffect,
    useLayoutEffect: $a6cdda187280cdb0$var$updateLayoutEffect,
    useMemo: $a6cdda187280cdb0$var$updateMemo,
    useReducer: $a6cdda187280cdb0$var$updateReducer,
    useRef: $a6cdda187280cdb0$var$updateRef,
    useState: function() {
        return $a6cdda187280cdb0$var$updateReducer($a6cdda187280cdb0$var$basicStateReducer);
    },
    useDebugValue: $a6cdda187280cdb0$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $a6cdda187280cdb0$var$updateWorkInProgressHook();
        return $a6cdda187280cdb0$var$updateDeferredValueImpl(hook, $a6cdda187280cdb0$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $a6cdda187280cdb0$var$updateReducer($a6cdda187280cdb0$var$basicStateReducer)[0], start = $a6cdda187280cdb0$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $a6cdda187280cdb0$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $a6cdda187280cdb0$var$updateSyncExternalStore,
    useId: $a6cdda187280cdb0$var$updateId,
    useHostTransitionStatus: $a6cdda187280cdb0$var$useHostTransitionStatus,
    useFormState: $a6cdda187280cdb0$var$updateActionState,
    useActionState: $a6cdda187280cdb0$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $a6cdda187280cdb0$var$updateWorkInProgressHook();
        return $a6cdda187280cdb0$var$updateOptimisticImpl(hook, $a6cdda187280cdb0$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $a6cdda187280cdb0$var$useMemoCache,
    useCacheRefresh: $a6cdda187280cdb0$var$updateRefresh
};
$a6cdda187280cdb0$var$HooksDispatcherOnUpdate.useEffectEvent = $a6cdda187280cdb0$var$updateEvent;
var $a6cdda187280cdb0$var$HooksDispatcherOnRerender = {
    readContext: $a6cdda187280cdb0$var$readContext,
    use: $a6cdda187280cdb0$var$use,
    useCallback: $a6cdda187280cdb0$var$updateCallback,
    useContext: $a6cdda187280cdb0$var$readContext,
    useEffect: $a6cdda187280cdb0$var$updateEffect,
    useImperativeHandle: $a6cdda187280cdb0$var$updateImperativeHandle,
    useInsertionEffect: $a6cdda187280cdb0$var$updateInsertionEffect,
    useLayoutEffect: $a6cdda187280cdb0$var$updateLayoutEffect,
    useMemo: $a6cdda187280cdb0$var$updateMemo,
    useReducer: $a6cdda187280cdb0$var$rerenderReducer,
    useRef: $a6cdda187280cdb0$var$updateRef,
    useState: function() {
        return $a6cdda187280cdb0$var$rerenderReducer($a6cdda187280cdb0$var$basicStateReducer);
    },
    useDebugValue: $a6cdda187280cdb0$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $a6cdda187280cdb0$var$updateWorkInProgressHook();
        return null === $a6cdda187280cdb0$var$currentHook ? $a6cdda187280cdb0$var$mountDeferredValueImpl(hook, value, initialValue) : $a6cdda187280cdb0$var$updateDeferredValueImpl(hook, $a6cdda187280cdb0$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $a6cdda187280cdb0$var$rerenderReducer($a6cdda187280cdb0$var$basicStateReducer)[0], start = $a6cdda187280cdb0$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $a6cdda187280cdb0$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $a6cdda187280cdb0$var$updateSyncExternalStore,
    useId: $a6cdda187280cdb0$var$updateId,
    useHostTransitionStatus: $a6cdda187280cdb0$var$useHostTransitionStatus,
    useFormState: $a6cdda187280cdb0$var$rerenderActionState,
    useActionState: $a6cdda187280cdb0$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $a6cdda187280cdb0$var$updateWorkInProgressHook();
        if (null !== $a6cdda187280cdb0$var$currentHook) return $a6cdda187280cdb0$var$updateOptimisticImpl(hook, $a6cdda187280cdb0$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $a6cdda187280cdb0$var$useMemoCache,
    useCacheRefresh: $a6cdda187280cdb0$var$updateRefresh
};
$a6cdda187280cdb0$var$HooksDispatcherOnRerender.useEffectEvent = $a6cdda187280cdb0$var$updateEvent;
function $a6cdda187280cdb0$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $a6cdda187280cdb0$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $a6cdda187280cdb0$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $a6cdda187280cdb0$var$requestUpdateLane(), update = $a6cdda187280cdb0$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $a6cdda187280cdb0$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($a6cdda187280cdb0$var$scheduleUpdateOnFiber(payload, inst, lane), $a6cdda187280cdb0$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $a6cdda187280cdb0$var$requestUpdateLane(), update = $a6cdda187280cdb0$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $a6cdda187280cdb0$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($a6cdda187280cdb0$var$scheduleUpdateOnFiber(payload, inst, lane), $a6cdda187280cdb0$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $a6cdda187280cdb0$var$requestUpdateLane(), update = $a6cdda187280cdb0$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $a6cdda187280cdb0$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($a6cdda187280cdb0$var$scheduleUpdateOnFiber(callback, inst, lane), $a6cdda187280cdb0$var$entangleTransitions(callback, inst, lane));
    }
};
function $a6cdda187280cdb0$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$a6cdda187280cdb0$var$shallowEqual(oldProps, newProps) || !$a6cdda187280cdb0$var$shallowEqual(oldState, newState) : !0;
}
function $a6cdda187280cdb0$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $a6cdda187280cdb0$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $a6cdda187280cdb0$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $a6cdda187280cdb0$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $a6cdda187280cdb0$var$defaultOnUncaughtError(error) {
    $a6cdda187280cdb0$var$reportGlobalError(error);
}
function $a6cdda187280cdb0$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $a6cdda187280cdb0$var$defaultOnRecoverableError(error) {
    $a6cdda187280cdb0$var$reportGlobalError(error);
}
function $a6cdda187280cdb0$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $a6cdda187280cdb0$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $a6cdda187280cdb0$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $a6cdda187280cdb0$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $a6cdda187280cdb0$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $a6cdda187280cdb0$var$createClassErrorUpdate(lane) {
    lane = $a6cdda187280cdb0$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $a6cdda187280cdb0$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $a6cdda187280cdb0$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $a6cdda187280cdb0$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $a6cdda187280cdb0$var$legacyErrorBoundariesThatAlreadyFailed ? $a6cdda187280cdb0$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $a6cdda187280cdb0$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $a6cdda187280cdb0$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $a6cdda187280cdb0$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $a6cdda187280cdb0$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $a6cdda187280cdb0$var$shellBoundary ? $a6cdda187280cdb0$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $a6cdda187280cdb0$var$workInProgressRootExitStatus && ($a6cdda187280cdb0$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $a6cdda187280cdb0$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $a6cdda187280cdb0$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $a6cdda187280cdb0$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $a6cdda187280cdb0$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $a6cdda187280cdb0$var$attachPingListener(root, value, rootRenderLanes);
        $a6cdda187280cdb0$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($a6cdda187280cdb0$var$isHydrating) return returnFiber = $a6cdda187280cdb0$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $a6cdda187280cdb0$var$HydrationMismatchException && (root = Error($a6cdda187280cdb0$var$formatProdErrorMessage(422), {
        cause: value
    }), $a6cdda187280cdb0$var$queueHydrationError($a6cdda187280cdb0$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $a6cdda187280cdb0$var$HydrationMismatchException && (returnFiber = Error($a6cdda187280cdb0$var$formatProdErrorMessage(423), {
        cause: value
    }), $a6cdda187280cdb0$var$queueHydrationError($a6cdda187280cdb0$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $a6cdda187280cdb0$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $a6cdda187280cdb0$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $a6cdda187280cdb0$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $a6cdda187280cdb0$var$workInProgressRootExitStatus && ($a6cdda187280cdb0$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($a6cdda187280cdb0$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $a6cdda187280cdb0$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $a6cdda187280cdb0$var$workInProgressRootConcurrentErrors ? $a6cdda187280cdb0$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $a6cdda187280cdb0$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $a6cdda187280cdb0$var$workInProgressRootExitStatus && ($a6cdda187280cdb0$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $a6cdda187280cdb0$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $a6cdda187280cdb0$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $a6cdda187280cdb0$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $a6cdda187280cdb0$var$legacyErrorBoundariesThatAlreadyFailed || !$a6cdda187280cdb0$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $a6cdda187280cdb0$var$createClassErrorUpdate(rootRenderLanes), $a6cdda187280cdb0$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $a6cdda187280cdb0$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $a6cdda187280cdb0$var$SelectiveHydrationException = Error($a6cdda187280cdb0$var$formatProdErrorMessage(461)), $a6cdda187280cdb0$var$didReceiveUpdate = !1;
function $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $a6cdda187280cdb0$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $a6cdda187280cdb0$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $a6cdda187280cdb0$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $a6cdda187280cdb0$var$prepareToReadContext(workInProgress);
    nextProps = $a6cdda187280cdb0$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $a6cdda187280cdb0$var$checkDidRenderIdHook();
    if (null !== current && !$a6cdda187280cdb0$var$didReceiveUpdate) return $a6cdda187280cdb0$var$bailoutHooks(current, workInProgress, renderLanes), $a6cdda187280cdb0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $a6cdda187280cdb0$var$isHydrating && key && $a6cdda187280cdb0$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $a6cdda187280cdb0$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$a6cdda187280cdb0$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $a6cdda187280cdb0$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $a6cdda187280cdb0$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$a6cdda187280cdb0$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $a6cdda187280cdb0$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $a6cdda187280cdb0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $a6cdda187280cdb0$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $a6cdda187280cdb0$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($a6cdda187280cdb0$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($a6cdda187280cdb0$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $a6cdda187280cdb0$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($a6cdda187280cdb0$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $a6cdda187280cdb0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $a6cdda187280cdb0$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $a6cdda187280cdb0$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $a6cdda187280cdb0$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $a6cdda187280cdb0$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $a6cdda187280cdb0$var$pushHiddenContext(workInProgress, prevState) : $a6cdda187280cdb0$var$reuseHiddenContextOnStack(), $a6cdda187280cdb0$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $a6cdda187280cdb0$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($a6cdda187280cdb0$var$pushTransition(workInProgress, prevState.cachePool), $a6cdda187280cdb0$var$pushHiddenContext(workInProgress, prevState), $a6cdda187280cdb0$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $a6cdda187280cdb0$var$pushTransition(workInProgress, null), $a6cdda187280cdb0$var$reuseHiddenContextOnStack(), $a6cdda187280cdb0$var$reuseSuspenseHandlerOnStack(workInProgress));
    $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $a6cdda187280cdb0$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $a6cdda187280cdb0$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $a6cdda187280cdb0$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $a6cdda187280cdb0$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $a6cdda187280cdb0$var$pushTransition(workInProgress, null);
    $a6cdda187280cdb0$var$reuseHiddenContextOnStack();
    $a6cdda187280cdb0$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $a6cdda187280cdb0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $a6cdda187280cdb0$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $a6cdda187280cdb0$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $a6cdda187280cdb0$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $a6cdda187280cdb0$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $a6cdda187280cdb0$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $a6cdda187280cdb0$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $a6cdda187280cdb0$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($a6cdda187280cdb0$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $a6cdda187280cdb0$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $a6cdda187280cdb0$var$bailoutOffscreenComponent(null, current);
            $a6cdda187280cdb0$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $a6cdda187280cdb0$var$nextHydratableInstance) ? (current = $a6cdda187280cdb0$var$canHydrateHydrationBoundary(current, $a6cdda187280cdb0$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $a6cdda187280cdb0$var$treeContextProvider ? {
                    id: $a6cdda187280cdb0$var$treeContextId,
                    overflow: $a6cdda187280cdb0$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $a6cdda187280cdb0$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $a6cdda187280cdb0$var$hydrationParentFiber = workInProgress, $a6cdda187280cdb0$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $a6cdda187280cdb0$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $a6cdda187280cdb0$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $a6cdda187280cdb0$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $a6cdda187280cdb0$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(558));
        } else if ($a6cdda187280cdb0$var$didReceiveUpdate || $a6cdda187280cdb0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $a6cdda187280cdb0$var$didReceiveUpdate || didSuspend) {
            nextProps = $a6cdda187280cdb0$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $a6cdda187280cdb0$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $a6cdda187280cdb0$var$enqueueConcurrentRenderForLane(current, dehydrated), $a6cdda187280cdb0$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $a6cdda187280cdb0$var$SelectiveHydrationException;
            $a6cdda187280cdb0$var$renderDidSuspendDelayIfPossible();
            workInProgress = $a6cdda187280cdb0$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $a6cdda187280cdb0$var$nextHydratableInstance = $a6cdda187280cdb0$var$getNextHydratable(dehydrated.nextSibling), $a6cdda187280cdb0$var$hydrationParentFiber = workInProgress, $a6cdda187280cdb0$var$isHydrating = !0, $a6cdda187280cdb0$var$hydrationErrors = null, $a6cdda187280cdb0$var$rootOrSingletonContext = !1, null !== current && $a6cdda187280cdb0$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $a6cdda187280cdb0$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $a6cdda187280cdb0$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $a6cdda187280cdb0$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $a6cdda187280cdb0$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $a6cdda187280cdb0$var$prepareToReadContext(workInProgress);
    Component = $a6cdda187280cdb0$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $a6cdda187280cdb0$var$checkDidRenderIdHook();
    if (null !== current && !$a6cdda187280cdb0$var$didReceiveUpdate) return $a6cdda187280cdb0$var$bailoutHooks(current, workInProgress, renderLanes), $a6cdda187280cdb0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $a6cdda187280cdb0$var$isHydrating && nextProps && $a6cdda187280cdb0$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $a6cdda187280cdb0$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $a6cdda187280cdb0$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $a6cdda187280cdb0$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $a6cdda187280cdb0$var$finishRenderingHooks(current);
    Component = $a6cdda187280cdb0$var$checkDidRenderIdHook();
    if (null !== current && !$a6cdda187280cdb0$var$didReceiveUpdate) return $a6cdda187280cdb0$var$bailoutHooks(current, workInProgress, renderLanes), $a6cdda187280cdb0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $a6cdda187280cdb0$var$isHydrating && Component && $a6cdda187280cdb0$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $a6cdda187280cdb0$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $a6cdda187280cdb0$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $a6cdda187280cdb0$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $a6cdda187280cdb0$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $a6cdda187280cdb0$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $a6cdda187280cdb0$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $a6cdda187280cdb0$var$readContext(contextType) : $a6cdda187280cdb0$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($a6cdda187280cdb0$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $a6cdda187280cdb0$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $a6cdda187280cdb0$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $a6cdda187280cdb0$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $a6cdda187280cdb0$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $a6cdda187280cdb0$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $a6cdda187280cdb0$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $a6cdda187280cdb0$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $a6cdda187280cdb0$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $a6cdda187280cdb0$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $a6cdda187280cdb0$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $a6cdda187280cdb0$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($a6cdda187280cdb0$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $a6cdda187280cdb0$var$hasForceUpdate || $a6cdda187280cdb0$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $a6cdda187280cdb0$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $a6cdda187280cdb0$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $a6cdda187280cdb0$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $a6cdda187280cdb0$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $a6cdda187280cdb0$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $a6cdda187280cdb0$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $a6cdda187280cdb0$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $a6cdda187280cdb0$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $a6cdda187280cdb0$var$hasForceUpdate || null !== current && null !== current.dependencies && $a6cdda187280cdb0$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($a6cdda187280cdb0$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $a6cdda187280cdb0$var$hasForceUpdate || $a6cdda187280cdb0$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $a6cdda187280cdb0$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $a6cdda187280cdb0$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $a6cdda187280cdb0$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $a6cdda187280cdb0$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $a6cdda187280cdb0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $a6cdda187280cdb0$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $a6cdda187280cdb0$var$resetHydrationState();
    workInProgress.flags |= 256;
    $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $a6cdda187280cdb0$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $a6cdda187280cdb0$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $a6cdda187280cdb0$var$getSuspendedCache()
    };
}
function $a6cdda187280cdb0$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $a6cdda187280cdb0$var$workInProgressDeferredLane);
    return current;
}
function $a6cdda187280cdb0$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($a6cdda187280cdb0$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($a6cdda187280cdb0$var$isHydrating) {
            showFallback ? $a6cdda187280cdb0$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $a6cdda187280cdb0$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $a6cdda187280cdb0$var$nextHydratableInstance) ? (current = $a6cdda187280cdb0$var$canHydrateHydrationBoundary(current, $a6cdda187280cdb0$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $a6cdda187280cdb0$var$treeContextProvider ? {
                    id: $a6cdda187280cdb0$var$treeContextId,
                    overflow: $a6cdda187280cdb0$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $a6cdda187280cdb0$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $a6cdda187280cdb0$var$hydrationParentFiber = workInProgress, $a6cdda187280cdb0$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $a6cdda187280cdb0$var$throwOnHydrationMismatch(workInProgress);
            $a6cdda187280cdb0$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $a6cdda187280cdb0$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $a6cdda187280cdb0$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $a6cdda187280cdb0$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $a6cdda187280cdb0$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $a6cdda187280cdb0$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $a6cdda187280cdb0$var$SUSPENDED_MARKER, $a6cdda187280cdb0$var$bailoutOffscreenComponent(null, nextProps);
        $a6cdda187280cdb0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $a6cdda187280cdb0$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($a6cdda187280cdb0$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $a6cdda187280cdb0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($a6cdda187280cdb0$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($a6cdda187280cdb0$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $a6cdda187280cdb0$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $a6cdda187280cdb0$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $a6cdda187280cdb0$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $a6cdda187280cdb0$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $a6cdda187280cdb0$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $a6cdda187280cdb0$var$SUSPENDED_MARKER, workInProgress = $a6cdda187280cdb0$var$bailoutOffscreenComponent(null, nextProps));
        else if ($a6cdda187280cdb0$var$pushPrimaryTreeSuspenseHandler(workInProgress), $a6cdda187280cdb0$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($a6cdda187280cdb0$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $a6cdda187280cdb0$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $a6cdda187280cdb0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($a6cdda187280cdb0$var$didReceiveUpdate || $a6cdda187280cdb0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $a6cdda187280cdb0$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $a6cdda187280cdb0$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $a6cdda187280cdb0$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $a6cdda187280cdb0$var$enqueueConcurrentRenderForLane(current, nextProps), $a6cdda187280cdb0$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $a6cdda187280cdb0$var$SelectiveHydrationException;
            $a6cdda187280cdb0$var$isSuspenseInstancePending(nextPrimaryChildren) || $a6cdda187280cdb0$var$renderDidSuspendDelayIfPossible();
            workInProgress = $a6cdda187280cdb0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $a6cdda187280cdb0$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $a6cdda187280cdb0$var$nextHydratableInstance = $a6cdda187280cdb0$var$getNextHydratable(nextPrimaryChildren.nextSibling), $a6cdda187280cdb0$var$hydrationParentFiber = workInProgress, $a6cdda187280cdb0$var$isHydrating = !0, $a6cdda187280cdb0$var$hydrationErrors = null, $a6cdda187280cdb0$var$rootOrSingletonContext = !1, null !== current && $a6cdda187280cdb0$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $a6cdda187280cdb0$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $a6cdda187280cdb0$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $a6cdda187280cdb0$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $a6cdda187280cdb0$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $a6cdda187280cdb0$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $a6cdda187280cdb0$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $a6cdda187280cdb0$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $a6cdda187280cdb0$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $a6cdda187280cdb0$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $a6cdda187280cdb0$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $a6cdda187280cdb0$var$SUSPENDED_MARKER, $a6cdda187280cdb0$var$bailoutOffscreenComponent(current.child, nextProps);
    $a6cdda187280cdb0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $a6cdda187280cdb0$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $a6cdda187280cdb0$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $a6cdda187280cdb0$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $a6cdda187280cdb0$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $a6cdda187280cdb0$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $a6cdda187280cdb0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $a6cdda187280cdb0$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $a6cdda187280cdb0$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $a6cdda187280cdb0$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $a6cdda187280cdb0$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $a6cdda187280cdb0$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $a6cdda187280cdb0$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $a6cdda187280cdb0$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$suspenseStackCursor, suspenseContext);
    $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $a6cdda187280cdb0$var$isHydrating ? $a6cdda187280cdb0$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $a6cdda187280cdb0$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $a6cdda187280cdb0$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $a6cdda187280cdb0$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $a6cdda187280cdb0$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $a6cdda187280cdb0$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $a6cdda187280cdb0$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $a6cdda187280cdb0$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $a6cdda187280cdb0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $a6cdda187280cdb0$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($a6cdda187280cdb0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $a6cdda187280cdb0$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $a6cdda187280cdb0$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $a6cdda187280cdb0$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $a6cdda187280cdb0$var$checkIfContextChanged(current) ? !0 : !1;
}
function $a6cdda187280cdb0$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $a6cdda187280cdb0$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $a6cdda187280cdb0$var$pushProvider(workInProgress, $a6cdda187280cdb0$var$CacheContext, current.memoizedState.cache);
            $a6cdda187280cdb0$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $a6cdda187280cdb0$var$pushHostContext(workInProgress);
            break;
        case 4:
            $a6cdda187280cdb0$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $a6cdda187280cdb0$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $a6cdda187280cdb0$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $a6cdda187280cdb0$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $a6cdda187280cdb0$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $a6cdda187280cdb0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $a6cdda187280cdb0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $a6cdda187280cdb0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($a6cdda187280cdb0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $a6cdda187280cdb0$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$suspenseStackCursor, $a6cdda187280cdb0$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $a6cdda187280cdb0$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $a6cdda187280cdb0$var$pushProvider(workInProgress, $a6cdda187280cdb0$var$CacheContext, current.memoizedState.cache);
    }
    return $a6cdda187280cdb0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $a6cdda187280cdb0$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $a6cdda187280cdb0$var$didReceiveUpdate = !0;
        else {
            if (!$a6cdda187280cdb0$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $a6cdda187280cdb0$var$didReceiveUpdate = !1, $a6cdda187280cdb0$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $a6cdda187280cdb0$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $a6cdda187280cdb0$var$didReceiveUpdate = !1, $a6cdda187280cdb0$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $a6cdda187280cdb0$var$pushTreeId(workInProgress, $a6cdda187280cdb0$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $a6cdda187280cdb0$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $a6cdda187280cdb0$var$shouldConstruct(current) ? (props = $a6cdda187280cdb0$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $a6cdda187280cdb0$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $a6cdda187280cdb0$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $a6cdda187280cdb0$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $a6cdda187280cdb0$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $a6cdda187280cdb0$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $a6cdda187280cdb0$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $a6cdda187280cdb0$var$getComponentNameFromType(current) || current;
                    throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $a6cdda187280cdb0$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $a6cdda187280cdb0$var$resolveClassComponentProps(props, workInProgress.pendingProps), $a6cdda187280cdb0$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $a6cdda187280cdb0$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $a6cdda187280cdb0$var$cloneUpdateQueue(current, workInProgress);
                $a6cdda187280cdb0$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $a6cdda187280cdb0$var$pushProvider(workInProgress, $a6cdda187280cdb0$var$CacheContext, props);
                props !== prevState.cache && $a6cdda187280cdb0$var$propagateContextChanges(workInProgress, [
                    $a6cdda187280cdb0$var$CacheContext
                ], renderLanes, !0);
                $a6cdda187280cdb0$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $a6cdda187280cdb0$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $a6cdda187280cdb0$var$createCapturedValueAtFiber(Error($a6cdda187280cdb0$var$formatProdErrorMessage(424)), workInProgress);
                        $a6cdda187280cdb0$var$queueHydrationError($$typeof);
                        workInProgress = $a6cdda187280cdb0$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $a6cdda187280cdb0$var$nextHydratableInstance = $a6cdda187280cdb0$var$getNextHydratable(current.firstChild);
                        $a6cdda187280cdb0$var$hydrationParentFiber = workInProgress;
                        $a6cdda187280cdb0$var$isHydrating = !0;
                        $a6cdda187280cdb0$var$hydrationErrors = null;
                        $a6cdda187280cdb0$var$rootOrSingletonContext = !0;
                        renderLanes = $a6cdda187280cdb0$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $a6cdda187280cdb0$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $a6cdda187280cdb0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $a6cdda187280cdb0$var$markRef(current, workInProgress), null === current ? (renderLanes = $a6cdda187280cdb0$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $a6cdda187280cdb0$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $a6cdda187280cdb0$var$getOwnerDocumentFromRootContainer($a6cdda187280cdb0$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$a6cdda187280cdb0$var$internalInstanceKey] = workInProgress, props[$a6cdda187280cdb0$var$internalPropsKey] = current, $a6cdda187280cdb0$var$setInitialProperties(props, renderLanes, current), $a6cdda187280cdb0$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $a6cdda187280cdb0$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $a6cdda187280cdb0$var$pushHostContext(workInProgress), null === current && $a6cdda187280cdb0$var$isHydrating && (props = workInProgress.stateNode = $a6cdda187280cdb0$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $a6cdda187280cdb0$var$rootInstanceStackCursor.current), $a6cdda187280cdb0$var$hydrationParentFiber = workInProgress, $a6cdda187280cdb0$var$rootOrSingletonContext = !0, $$typeof = $a6cdda187280cdb0$var$nextHydratableInstance, $a6cdda187280cdb0$var$isSingletonScope(workInProgress.type) ? ($a6cdda187280cdb0$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $a6cdda187280cdb0$var$nextHydratableInstance = $a6cdda187280cdb0$var$getNextHydratable(props.firstChild)) : $a6cdda187280cdb0$var$nextHydratableInstance = $$typeof), $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $a6cdda187280cdb0$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $a6cdda187280cdb0$var$isHydrating) {
                if ($$typeof = props = $a6cdda187280cdb0$var$nextHydratableInstance) props = $a6cdda187280cdb0$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $a6cdda187280cdb0$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $a6cdda187280cdb0$var$hydrationParentFiber = workInProgress, $a6cdda187280cdb0$var$nextHydratableInstance = $a6cdda187280cdb0$var$getNextHydratable(props.firstChild), $a6cdda187280cdb0$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $a6cdda187280cdb0$var$throwOnHydrationMismatch(workInProgress);
            }
            $a6cdda187280cdb0$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $a6cdda187280cdb0$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $a6cdda187280cdb0$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $a6cdda187280cdb0$var$renderWithHooks(current, workInProgress, $a6cdda187280cdb0$var$TransitionAwareHostComponent, null, null, renderLanes), $a6cdda187280cdb0$var$HostTransitionContext._currentValue = $$typeof);
            $a6cdda187280cdb0$var$markRef(current, workInProgress);
            $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $a6cdda187280cdb0$var$isHydrating) {
                if (current = renderLanes = $a6cdda187280cdb0$var$nextHydratableInstance) renderLanes = $a6cdda187280cdb0$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $a6cdda187280cdb0$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $a6cdda187280cdb0$var$hydrationParentFiber = workInProgress, $a6cdda187280cdb0$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $a6cdda187280cdb0$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $a6cdda187280cdb0$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $a6cdda187280cdb0$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $a6cdda187280cdb0$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $a6cdda187280cdb0$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $a6cdda187280cdb0$var$pushProvider(workInProgress, workInProgress.type, props.value), $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $a6cdda187280cdb0$var$prepareToReadContext(workInProgress), $$typeof = $a6cdda187280cdb0$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $a6cdda187280cdb0$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $a6cdda187280cdb0$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $a6cdda187280cdb0$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $a6cdda187280cdb0$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $a6cdda187280cdb0$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $a6cdda187280cdb0$var$prepareToReadContext(workInProgress), props = $a6cdda187280cdb0$var$readContext($a6cdda187280cdb0$var$CacheContext), null === current ? ($$typeof = $a6cdda187280cdb0$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $a6cdda187280cdb0$var$workInProgressRoot, prevState = $a6cdda187280cdb0$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $a6cdda187280cdb0$var$initializeUpdateQueue(workInProgress), $a6cdda187280cdb0$var$pushProvider(workInProgress, $a6cdda187280cdb0$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($a6cdda187280cdb0$var$cloneUpdateQueue(current, workInProgress), $a6cdda187280cdb0$var$processUpdateQueue(workInProgress, null, null, renderLanes), $a6cdda187280cdb0$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $a6cdda187280cdb0$var$pushProvider(workInProgress, $a6cdda187280cdb0$var$CacheContext, props)) : (props = prevState.cache, $a6cdda187280cdb0$var$pushProvider(workInProgress, $a6cdda187280cdb0$var$CacheContext, props), props !== $$typeof.cache && $a6cdda187280cdb0$var$propagateContextChanges(workInProgress, [
                $a6cdda187280cdb0$var$CacheContext
            ], renderLanes, !0))), $a6cdda187280cdb0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $a6cdda187280cdb0$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $a6cdda187280cdb0$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($a6cdda187280cdb0$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $a6cdda187280cdb0$var$suspendedThenable = $a6cdda187280cdb0$var$noopSuspenseyCommitThenable, $a6cdda187280cdb0$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $a6cdda187280cdb0$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$a6cdda187280cdb0$var$preloadResource(resource)) {
        if ($a6cdda187280cdb0$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $a6cdda187280cdb0$var$suspendedThenable = $a6cdda187280cdb0$var$noopSuspenseyCommitThenable, $a6cdda187280cdb0$var$SuspenseyCommitException;
    }
}
function $a6cdda187280cdb0$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $a6cdda187280cdb0$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $a6cdda187280cdb0$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $a6cdda187280cdb0$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$a6cdda187280cdb0$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $a6cdda187280cdb0$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $a6cdda187280cdb0$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $a6cdda187280cdb0$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $a6cdda187280cdb0$var$bubbleProperties(workInProgress), null;
        case 1:
            return $a6cdda187280cdb0$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $a6cdda187280cdb0$var$popProvider($a6cdda187280cdb0$var$CacheContext);
            $a6cdda187280cdb0$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $a6cdda187280cdb0$var$popHydrationState(workInProgress) ? $a6cdda187280cdb0$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $a6cdda187280cdb0$var$upgradeHydrationErrorsToRecoverable());
            $a6cdda187280cdb0$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($a6cdda187280cdb0$var$markUpdate(workInProgress), null !== nextResource ? ($a6cdda187280cdb0$var$bubbleProperties(workInProgress), $a6cdda187280cdb0$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($a6cdda187280cdb0$var$bubbleProperties(workInProgress), $a6cdda187280cdb0$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($a6cdda187280cdb0$var$markUpdate(workInProgress), $a6cdda187280cdb0$var$bubbleProperties(workInProgress), $a6cdda187280cdb0$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($a6cdda187280cdb0$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $a6cdda187280cdb0$var$markUpdate(workInProgress), $a6cdda187280cdb0$var$bubbleProperties(workInProgress), $a6cdda187280cdb0$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $a6cdda187280cdb0$var$popHostContext(workInProgress);
            renderLanes = $a6cdda187280cdb0$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $a6cdda187280cdb0$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(166));
                    $a6cdda187280cdb0$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $a6cdda187280cdb0$var$contextStackCursor.current;
                $a6cdda187280cdb0$var$popHydrationState(workInProgress) ? $a6cdda187280cdb0$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $a6cdda187280cdb0$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $a6cdda187280cdb0$var$markUpdate(workInProgress));
            }
            $a6cdda187280cdb0$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $a6cdda187280cdb0$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $a6cdda187280cdb0$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(166));
                    $a6cdda187280cdb0$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $a6cdda187280cdb0$var$contextStackCursor.current;
                if ($a6cdda187280cdb0$var$popHydrationState(workInProgress)) $a6cdda187280cdb0$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $a6cdda187280cdb0$var$getOwnerDocumentFromRootContainer($a6cdda187280cdb0$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$a6cdda187280cdb0$var$internalInstanceKey] = workInProgress;
                    nextResource[$a6cdda187280cdb0$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($a6cdda187280cdb0$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $a6cdda187280cdb0$var$markUpdate(workInProgress);
                }
            }
            $a6cdda187280cdb0$var$bubbleProperties(workInProgress);
            $a6cdda187280cdb0$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $a6cdda187280cdb0$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(166));
                current = $a6cdda187280cdb0$var$rootInstanceStackCursor.current;
                if ($a6cdda187280cdb0$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $a6cdda187280cdb0$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$a6cdda187280cdb0$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $a6cdda187280cdb0$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $a6cdda187280cdb0$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $a6cdda187280cdb0$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$a6cdda187280cdb0$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $a6cdda187280cdb0$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $a6cdda187280cdb0$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(557));
                        current[$a6cdda187280cdb0$var$internalInstanceKey] = workInProgress;
                    } else $a6cdda187280cdb0$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $a6cdda187280cdb0$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $a6cdda187280cdb0$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $a6cdda187280cdb0$var$popSuspenseHandler(workInProgress), workInProgress;
                    $a6cdda187280cdb0$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(558));
            }
            $a6cdda187280cdb0$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $a6cdda187280cdb0$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(317));
                        type[$a6cdda187280cdb0$var$internalInstanceKey] = workInProgress;
                    } else $a6cdda187280cdb0$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $a6cdda187280cdb0$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $a6cdda187280cdb0$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $a6cdda187280cdb0$var$popSuspenseHandler(workInProgress), workInProgress;
                    $a6cdda187280cdb0$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $a6cdda187280cdb0$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $a6cdda187280cdb0$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $a6cdda187280cdb0$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $a6cdda187280cdb0$var$popHostContainer(), null === current && $a6cdda187280cdb0$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $a6cdda187280cdb0$var$bubbleProperties(workInProgress), null;
        case 10:
            return $a6cdda187280cdb0$var$popProvider(workInProgress.type), $a6cdda187280cdb0$var$bubbleProperties(workInProgress), null;
        case 19:
            $a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $a6cdda187280cdb0$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $a6cdda187280cdb0$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $a6cdda187280cdb0$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $a6cdda187280cdb0$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $a6cdda187280cdb0$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $a6cdda187280cdb0$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$a6cdda187280cdb0$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$suspenseStackCursor, $a6cdda187280cdb0$var$suspenseStackCursor.current & 1 | 2);
                            $a6cdda187280cdb0$var$isHydrating && $a6cdda187280cdb0$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $a6cdda187280cdb0$var$now() > $a6cdda187280cdb0$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $a6cdda187280cdb0$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $a6cdda187280cdb0$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $a6cdda187280cdb0$var$scheduleRetryEffect(workInProgress, current), $a6cdda187280cdb0$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$a6cdda187280cdb0$var$isHydrating) return $a6cdda187280cdb0$var$bubbleProperties(workInProgress), null;
                    } else 2 * $a6cdda187280cdb0$var$now() - newProps.renderingStartTime > $a6cdda187280cdb0$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $a6cdda187280cdb0$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $a6cdda187280cdb0$var$now(), current.sibling = null, renderLanes = $a6cdda187280cdb0$var$suspenseStackCursor.current, $a6cdda187280cdb0$var$push($a6cdda187280cdb0$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $a6cdda187280cdb0$var$isHydrating && $a6cdda187280cdb0$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $a6cdda187280cdb0$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $a6cdda187280cdb0$var$popSuspenseHandler(workInProgress), $a6cdda187280cdb0$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($a6cdda187280cdb0$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $a6cdda187280cdb0$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $a6cdda187280cdb0$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $a6cdda187280cdb0$var$popProvider($a6cdda187280cdb0$var$CacheContext), $a6cdda187280cdb0$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $a6cdda187280cdb0$var$unwindWork(current, workInProgress) {
    $a6cdda187280cdb0$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $a6cdda187280cdb0$var$popProvider($a6cdda187280cdb0$var$CacheContext), $a6cdda187280cdb0$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $a6cdda187280cdb0$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $a6cdda187280cdb0$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(340));
                $a6cdda187280cdb0$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $a6cdda187280cdb0$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(340));
                $a6cdda187280cdb0$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$suspenseStackCursor), null;
        case 4:
            return $a6cdda187280cdb0$var$popHostContainer(), null;
        case 10:
            return $a6cdda187280cdb0$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $a6cdda187280cdb0$var$popSuspenseHandler(workInProgress), $a6cdda187280cdb0$var$popHiddenContext(), null !== current && $a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $a6cdda187280cdb0$var$popProvider($a6cdda187280cdb0$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $a6cdda187280cdb0$var$unwindInterruptedWork(current, interruptedWork) {
    $a6cdda187280cdb0$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $a6cdda187280cdb0$var$popProvider($a6cdda187280cdb0$var$CacheContext);
            $a6cdda187280cdb0$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $a6cdda187280cdb0$var$popHostContext(interruptedWork);
            break;
        case 4:
            $a6cdda187280cdb0$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $a6cdda187280cdb0$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $a6cdda187280cdb0$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$suspenseStackCursor);
            break;
        case 10:
            $a6cdda187280cdb0$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $a6cdda187280cdb0$var$popSuspenseHandler(interruptedWork);
            $a6cdda187280cdb0$var$popHiddenContext();
            null !== current && $a6cdda187280cdb0$var$pop($a6cdda187280cdb0$var$resumedCache);
            break;
        case 24:
            $a6cdda187280cdb0$var$popProvider($a6cdda187280cdb0$var$CacheContext);
    }
}
function $a6cdda187280cdb0$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $a6cdda187280cdb0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $a6cdda187280cdb0$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $a6cdda187280cdb0$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $a6cdda187280cdb0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $a6cdda187280cdb0$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $a6cdda187280cdb0$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $a6cdda187280cdb0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $a6cdda187280cdb0$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $a6cdda187280cdb0$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $a6cdda187280cdb0$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $a6cdda187280cdb0$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $a6cdda187280cdb0$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $a6cdda187280cdb0$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $a6cdda187280cdb0$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $a6cdda187280cdb0$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $a6cdda187280cdb0$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $a6cdda187280cdb0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $a6cdda187280cdb0$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $a6cdda187280cdb0$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$a6cdda187280cdb0$var$internalPropsKey] = newProps;
    } catch (error) {
        $a6cdda187280cdb0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $a6cdda187280cdb0$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $a6cdda187280cdb0$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $a6cdda187280cdb0$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $a6cdda187280cdb0$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $a6cdda187280cdb0$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $a6cdda187280cdb0$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $a6cdda187280cdb0$var$noop$1));
    else if (4 !== tag && (27 === tag && $a6cdda187280cdb0$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($a6cdda187280cdb0$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$a6cdda187280cdb0$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $a6cdda187280cdb0$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $a6cdda187280cdb0$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($a6cdda187280cdb0$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$a6cdda187280cdb0$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $a6cdda187280cdb0$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $a6cdda187280cdb0$var$setInitialProperties(singleton, type, props);
        singleton[$a6cdda187280cdb0$var$internalInstanceKey] = finishedWork;
        singleton[$a6cdda187280cdb0$var$internalPropsKey] = props;
    } catch (error) {
        $a6cdda187280cdb0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $a6cdda187280cdb0$var$offscreenSubtreeIsHidden = !1, $a6cdda187280cdb0$var$offscreenSubtreeWasHidden = !1, $a6cdda187280cdb0$var$needsFormReset = !1, $a6cdda187280cdb0$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $a6cdda187280cdb0$var$nextEffect = null;
function $a6cdda187280cdb0$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $a6cdda187280cdb0$var$eventsEnabled = $a6cdda187280cdb0$var$_enabled;
    root = $a6cdda187280cdb0$var$getActiveElementDeep(root);
    if ($a6cdda187280cdb0$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $a6cdda187280cdb0$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $a6cdda187280cdb0$var$_enabled = !1;
    for($a6cdda187280cdb0$var$nextEffect = firstChild; null !== $a6cdda187280cdb0$var$nextEffect;)if (firstChild = $a6cdda187280cdb0$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $a6cdda187280cdb0$var$nextEffect = root;
    else for(; null !== $a6cdda187280cdb0$var$nextEffect;){
        firstChild = $a6cdda187280cdb0$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $a6cdda187280cdb0$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $a6cdda187280cdb0$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $a6cdda187280cdb0$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $a6cdda187280cdb0$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $a6cdda187280cdb0$var$nextEffect = root;
            break;
        }
        $a6cdda187280cdb0$var$nextEffect = firstChild.return;
    }
}
function $a6cdda187280cdb0$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $a6cdda187280cdb0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $a6cdda187280cdb0$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $a6cdda187280cdb0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $a6cdda187280cdb0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $a6cdda187280cdb0$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $a6cdda187280cdb0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $a6cdda187280cdb0$var$commitClassCallbacks(finishedWork);
            flags & 512 && $a6cdda187280cdb0$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $a6cdda187280cdb0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $a6cdda187280cdb0$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $a6cdda187280cdb0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $a6cdda187280cdb0$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $a6cdda187280cdb0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $a6cdda187280cdb0$var$commitHostMount(finishedWork);
            flags & 512 && $a6cdda187280cdb0$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $a6cdda187280cdb0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $a6cdda187280cdb0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $a6cdda187280cdb0$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $a6cdda187280cdb0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $a6cdda187280cdb0$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $a6cdda187280cdb0$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $a6cdda187280cdb0$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $a6cdda187280cdb0$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $a6cdda187280cdb0$var$offscreenSubtreeWasHidden;
                prevProps = $a6cdda187280cdb0$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $a6cdda187280cdb0$var$offscreenSubtreeWasHidden;
                $a6cdda187280cdb0$var$offscreenSubtreeIsHidden = flags;
                ($a6cdda187280cdb0$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $a6cdda187280cdb0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $a6cdda187280cdb0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $a6cdda187280cdb0$var$offscreenSubtreeIsHidden = prevProps;
                $a6cdda187280cdb0$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $a6cdda187280cdb0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $a6cdda187280cdb0$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $a6cdda187280cdb0$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $a6cdda187280cdb0$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $a6cdda187280cdb0$var$hostParent = null, $a6cdda187280cdb0$var$hostParentIsContainer = !1;
function $a6cdda187280cdb0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$a6cdda187280cdb0$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $a6cdda187280cdb0$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($a6cdda187280cdb0$var$injectedHook && "function" === typeof $a6cdda187280cdb0$var$injectedHook.onCommitFiberUnmount) try {
        $a6cdda187280cdb0$var$injectedHook.onCommitFiberUnmount($a6cdda187280cdb0$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $a6cdda187280cdb0$var$offscreenSubtreeWasHidden || $a6cdda187280cdb0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $a6cdda187280cdb0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $a6cdda187280cdb0$var$offscreenSubtreeWasHidden || $a6cdda187280cdb0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $a6cdda187280cdb0$var$hostParent, prevHostParentIsContainer = $a6cdda187280cdb0$var$hostParentIsContainer;
            $a6cdda187280cdb0$var$isSingletonScope(deletedFiber.type) && ($a6cdda187280cdb0$var$hostParent = deletedFiber.stateNode, $a6cdda187280cdb0$var$hostParentIsContainer = !1);
            $a6cdda187280cdb0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $a6cdda187280cdb0$var$releaseSingletonInstance(deletedFiber.stateNode);
            $a6cdda187280cdb0$var$hostParent = prevHostParent;
            $a6cdda187280cdb0$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $a6cdda187280cdb0$var$offscreenSubtreeWasHidden || $a6cdda187280cdb0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $a6cdda187280cdb0$var$hostParent;
            prevHostParentIsContainer = $a6cdda187280cdb0$var$hostParentIsContainer;
            $a6cdda187280cdb0$var$hostParent = null;
            $a6cdda187280cdb0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $a6cdda187280cdb0$var$hostParent = prevHostParent;
            $a6cdda187280cdb0$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $a6cdda187280cdb0$var$hostParent) {
                if ($a6cdda187280cdb0$var$hostParentIsContainer) try {
                    (9 === $a6cdda187280cdb0$var$hostParent.nodeType ? $a6cdda187280cdb0$var$hostParent.body : "HTML" === $a6cdda187280cdb0$var$hostParent.nodeName ? $a6cdda187280cdb0$var$hostParent.ownerDocument.body : $a6cdda187280cdb0$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $a6cdda187280cdb0$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $a6cdda187280cdb0$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $a6cdda187280cdb0$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $a6cdda187280cdb0$var$hostParent && ($a6cdda187280cdb0$var$hostParentIsContainer ? (finishedRoot = $a6cdda187280cdb0$var$hostParent, $a6cdda187280cdb0$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $a6cdda187280cdb0$var$retryIfBlockedOn(finishedRoot)) : $a6cdda187280cdb0$var$clearHydrationBoundary($a6cdda187280cdb0$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $a6cdda187280cdb0$var$hostParent;
            prevHostParentIsContainer = $a6cdda187280cdb0$var$hostParentIsContainer;
            $a6cdda187280cdb0$var$hostParent = deletedFiber.stateNode.containerInfo;
            $a6cdda187280cdb0$var$hostParentIsContainer = !0;
            $a6cdda187280cdb0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $a6cdda187280cdb0$var$hostParent = prevHostParent;
            $a6cdda187280cdb0$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $a6cdda187280cdb0$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $a6cdda187280cdb0$var$offscreenSubtreeWasHidden || $a6cdda187280cdb0$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $a6cdda187280cdb0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $a6cdda187280cdb0$var$offscreenSubtreeWasHidden || ($a6cdda187280cdb0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $a6cdda187280cdb0$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $a6cdda187280cdb0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $a6cdda187280cdb0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $a6cdda187280cdb0$var$offscreenSubtreeWasHidden = (prevHostParent = $a6cdda187280cdb0$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $a6cdda187280cdb0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $a6cdda187280cdb0$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $a6cdda187280cdb0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $a6cdda187280cdb0$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $a6cdda187280cdb0$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $a6cdda187280cdb0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $a6cdda187280cdb0$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $a6cdda187280cdb0$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $a6cdda187280cdb0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $a6cdda187280cdb0$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $a6cdda187280cdb0$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $a6cdda187280cdb0$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $a6cdda187280cdb0$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $a6cdda187280cdb0$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $a6cdda187280cdb0$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $a6cdda187280cdb0$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($a6cdda187280cdb0$var$isSingletonScope(parent.type)) {
                        $a6cdda187280cdb0$var$hostParent = parent.stateNode;
                        $a6cdda187280cdb0$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $a6cdda187280cdb0$var$hostParent = parent.stateNode;
                    $a6cdda187280cdb0$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $a6cdda187280cdb0$var$hostParent = parent.stateNode.containerInfo;
                    $a6cdda187280cdb0$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $a6cdda187280cdb0$var$hostParent) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(160));
        $a6cdda187280cdb0$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $a6cdda187280cdb0$var$hostParent = null;
        $a6cdda187280cdb0$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$a6cdda187280cdb0$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $a6cdda187280cdb0$var$currentHoistableRoot = null;
function $a6cdda187280cdb0$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $a6cdda187280cdb0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a6cdda187280cdb0$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($a6cdda187280cdb0$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $a6cdda187280cdb0$var$commitHookEffectListMount(3, finishedWork), $a6cdda187280cdb0$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $a6cdda187280cdb0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a6cdda187280cdb0$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($a6cdda187280cdb0$var$offscreenSubtreeWasHidden || null === current || $a6cdda187280cdb0$var$safelyDetachRef(current, current.return));
            flags & 64 && $a6cdda187280cdb0$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $a6cdda187280cdb0$var$currentHoistableRoot;
            $a6cdda187280cdb0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a6cdda187280cdb0$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($a6cdda187280cdb0$var$offscreenSubtreeWasHidden || null === current || $a6cdda187280cdb0$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$a6cdda187280cdb0$var$internalHoistableMarker] || currentResource[$a6cdda187280cdb0$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $a6cdda187280cdb0$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$a6cdda187280cdb0$var$internalInstanceKey] = finishedWork;
                                        $a6cdda187280cdb0$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $a6cdda187280cdb0$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $a6cdda187280cdb0$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $a6cdda187280cdb0$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $a6cdda187280cdb0$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$a6cdda187280cdb0$var$internalInstanceKey] = finishedWork;
                                $a6cdda187280cdb0$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $a6cdda187280cdb0$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $a6cdda187280cdb0$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $a6cdda187280cdb0$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $a6cdda187280cdb0$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $a6cdda187280cdb0$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $a6cdda187280cdb0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a6cdda187280cdb0$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($a6cdda187280cdb0$var$offscreenSubtreeWasHidden || null === current || $a6cdda187280cdb0$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $a6cdda187280cdb0$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $a6cdda187280cdb0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a6cdda187280cdb0$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($a6cdda187280cdb0$var$offscreenSubtreeWasHidden || null === current || $a6cdda187280cdb0$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $a6cdda187280cdb0$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $a6cdda187280cdb0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $a6cdda187280cdb0$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($a6cdda187280cdb0$var$needsFormReset = !0);
            break;
        case 6:
            $a6cdda187280cdb0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a6cdda187280cdb0$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $a6cdda187280cdb0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $a6cdda187280cdb0$var$tagCaches = null;
            hoistableRoot = $a6cdda187280cdb0$var$currentHoistableRoot;
            $a6cdda187280cdb0$var$currentHoistableRoot = $a6cdda187280cdb0$var$getHoistableRoot(root.containerInfo);
            $a6cdda187280cdb0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a6cdda187280cdb0$var$currentHoistableRoot = hoistableRoot;
            $a6cdda187280cdb0$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $a6cdda187280cdb0$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $a6cdda187280cdb0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $a6cdda187280cdb0$var$needsFormReset && ($a6cdda187280cdb0$var$needsFormReset = !1, $a6cdda187280cdb0$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $a6cdda187280cdb0$var$currentHoistableRoot;
            $a6cdda187280cdb0$var$currentHoistableRoot = $a6cdda187280cdb0$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $a6cdda187280cdb0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a6cdda187280cdb0$var$commitReconciliationEffects(finishedWork);
            $a6cdda187280cdb0$var$currentHoistableRoot = flags;
            break;
        case 12:
            $a6cdda187280cdb0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a6cdda187280cdb0$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $a6cdda187280cdb0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a6cdda187280cdb0$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $a6cdda187280cdb0$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $a6cdda187280cdb0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a6cdda187280cdb0$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($a6cdda187280cdb0$var$globalMostRecentFallbackTime = $a6cdda187280cdb0$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $a6cdda187280cdb0$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $a6cdda187280cdb0$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $a6cdda187280cdb0$var$offscreenSubtreeWasHidden;
            $a6cdda187280cdb0$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $a6cdda187280cdb0$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $a6cdda187280cdb0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a6cdda187280cdb0$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $a6cdda187280cdb0$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $a6cdda187280cdb0$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $a6cdda187280cdb0$var$offscreenSubtreeIsHidden || $a6cdda187280cdb0$var$offscreenSubtreeWasHidden || $a6cdda187280cdb0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $a6cdda187280cdb0$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $a6cdda187280cdb0$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $a6cdda187280cdb0$var$hideOrUnhideDehydratedBoundary(instance, !0) : $a6cdda187280cdb0$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $a6cdda187280cdb0$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $a6cdda187280cdb0$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $a6cdda187280cdb0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a6cdda187280cdb0$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $a6cdda187280cdb0$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $a6cdda187280cdb0$var$recursivelyTraverseMutationEffects(root, finishedWork), $a6cdda187280cdb0$var$commitReconciliationEffects(finishedWork);
    }
}
function $a6cdda187280cdb0$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($a6cdda187280cdb0$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $a6cdda187280cdb0$var$getHostSibling(finishedWork);
                    $a6cdda187280cdb0$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($a6cdda187280cdb0$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $a6cdda187280cdb0$var$getHostSibling(finishedWork);
                    $a6cdda187280cdb0$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $a6cdda187280cdb0$var$getHostSibling(finishedWork);
                    $a6cdda187280cdb0$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $a6cdda187280cdb0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $a6cdda187280cdb0$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $a6cdda187280cdb0$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $a6cdda187280cdb0$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$a6cdda187280cdb0$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $a6cdda187280cdb0$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $a6cdda187280cdb0$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $a6cdda187280cdb0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $a6cdda187280cdb0$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $a6cdda187280cdb0$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $a6cdda187280cdb0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $a6cdda187280cdb0$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $a6cdda187280cdb0$var$safelyDetachRef(finishedWork, finishedWork.return);
                $a6cdda187280cdb0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $a6cdda187280cdb0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $a6cdda187280cdb0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $a6cdda187280cdb0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $a6cdda187280cdb0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $a6cdda187280cdb0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $a6cdda187280cdb0$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $a6cdda187280cdb0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $a6cdda187280cdb0$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$a6cdda187280cdb0$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $a6cdda187280cdb0$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $a6cdda187280cdb0$var$commitClassCallbacks(finishedWork);
                $a6cdda187280cdb0$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $a6cdda187280cdb0$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $a6cdda187280cdb0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $a6cdda187280cdb0$var$commitHostMount(finishedWork);
                $a6cdda187280cdb0$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $a6cdda187280cdb0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $a6cdda187280cdb0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $a6cdda187280cdb0$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $a6cdda187280cdb0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $a6cdda187280cdb0$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $a6cdda187280cdb0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $a6cdda187280cdb0$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $a6cdda187280cdb0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $a6cdda187280cdb0$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $a6cdda187280cdb0$var$releaseCache(previousCache));
}
function $a6cdda187280cdb0$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $a6cdda187280cdb0$var$releaseCache(current));
}
function $a6cdda187280cdb0$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$a6cdda187280cdb0$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $a6cdda187280cdb0$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $a6cdda187280cdb0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $a6cdda187280cdb0$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $a6cdda187280cdb0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $a6cdda187280cdb0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $a6cdda187280cdb0$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $a6cdda187280cdb0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $a6cdda187280cdb0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $a6cdda187280cdb0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $a6cdda187280cdb0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $a6cdda187280cdb0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $a6cdda187280cdb0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $a6cdda187280cdb0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $a6cdda187280cdb0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $a6cdda187280cdb0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $a6cdda187280cdb0$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $a6cdda187280cdb0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $a6cdda187280cdb0$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $a6cdda187280cdb0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $a6cdda187280cdb0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $a6cdda187280cdb0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $a6cdda187280cdb0$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $a6cdda187280cdb0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $a6cdda187280cdb0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $a6cdda187280cdb0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $a6cdda187280cdb0$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $a6cdda187280cdb0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $a6cdda187280cdb0$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $a6cdda187280cdb0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $a6cdda187280cdb0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $a6cdda187280cdb0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $a6cdda187280cdb0$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $a6cdda187280cdb0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $a6cdda187280cdb0$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $a6cdda187280cdb0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $a6cdda187280cdb0$var$suspenseyCommitFlag = 8192;
function $a6cdda187280cdb0$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $a6cdda187280cdb0$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$a6cdda187280cdb0$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $a6cdda187280cdb0$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $a6cdda187280cdb0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $a6cdda187280cdb0$var$suspenseyCommitFlag && null !== fiber.memoizedState && $a6cdda187280cdb0$var$suspendResource(suspendedState, $a6cdda187280cdb0$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $a6cdda187280cdb0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $a6cdda187280cdb0$var$currentHoistableRoot;
            $a6cdda187280cdb0$var$currentHoistableRoot = $a6cdda187280cdb0$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $a6cdda187280cdb0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $a6cdda187280cdb0$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $a6cdda187280cdb0$var$suspenseyCommitFlag, $a6cdda187280cdb0$var$suspenseyCommitFlag = 16777216, $a6cdda187280cdb0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $a6cdda187280cdb0$var$suspenseyCommitFlag = previousHoistableRoot) : $a6cdda187280cdb0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $a6cdda187280cdb0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $a6cdda187280cdb0$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $a6cdda187280cdb0$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $a6cdda187280cdb0$var$nextEffect = childToDelete;
            $a6cdda187280cdb0$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $a6cdda187280cdb0$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$a6cdda187280cdb0$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $a6cdda187280cdb0$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $a6cdda187280cdb0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $a6cdda187280cdb0$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $a6cdda187280cdb0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $a6cdda187280cdb0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $a6cdda187280cdb0$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $a6cdda187280cdb0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $a6cdda187280cdb0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $a6cdda187280cdb0$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $a6cdda187280cdb0$var$nextEffect = childToDelete;
            $a6cdda187280cdb0$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $a6cdda187280cdb0$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $a6cdda187280cdb0$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $a6cdda187280cdb0$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $a6cdda187280cdb0$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $a6cdda187280cdb0$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $a6cdda187280cdb0$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $a6cdda187280cdb0$var$nextEffect;){
        var fiber = $a6cdda187280cdb0$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $a6cdda187280cdb0$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $a6cdda187280cdb0$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $a6cdda187280cdb0$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $a6cdda187280cdb0$var$nextEffect;){
            cache = $a6cdda187280cdb0$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $a6cdda187280cdb0$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $a6cdda187280cdb0$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $a6cdda187280cdb0$var$nextEffect = sibling;
                break a;
            }
            $a6cdda187280cdb0$var$nextEffect = returnFiber;
        }
    }
}
var $a6cdda187280cdb0$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $a6cdda187280cdb0$var$readContext($a6cdda187280cdb0$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $a6cdda187280cdb0$var$readContext($a6cdda187280cdb0$var$CacheContext).controller.signal;
    }
}, $a6cdda187280cdb0$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $a6cdda187280cdb0$var$executionContext = 0, $a6cdda187280cdb0$var$workInProgressRoot = null, $a6cdda187280cdb0$var$workInProgress = null, $a6cdda187280cdb0$var$workInProgressRootRenderLanes = 0, $a6cdda187280cdb0$var$workInProgressSuspendedReason = 0, $a6cdda187280cdb0$var$workInProgressThrownValue = null, $a6cdda187280cdb0$var$workInProgressRootDidSkipSuspendedSiblings = !1, $a6cdda187280cdb0$var$workInProgressRootIsPrerendering = !1, $a6cdda187280cdb0$var$workInProgressRootDidAttachPingListener = !1, $a6cdda187280cdb0$var$entangledRenderLanes = 0, $a6cdda187280cdb0$var$workInProgressRootExitStatus = 0, $a6cdda187280cdb0$var$workInProgressRootSkippedLanes = 0, $a6cdda187280cdb0$var$workInProgressRootInterleavedUpdatedLanes = 0, $a6cdda187280cdb0$var$workInProgressRootPingedLanes = 0, $a6cdda187280cdb0$var$workInProgressDeferredLane = 0, $a6cdda187280cdb0$var$workInProgressSuspendedRetryLanes = 0, $a6cdda187280cdb0$var$workInProgressRootConcurrentErrors = null, $a6cdda187280cdb0$var$workInProgressRootRecoverableErrors = null, $a6cdda187280cdb0$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $a6cdda187280cdb0$var$globalMostRecentFallbackTime = 0, $a6cdda187280cdb0$var$globalMostRecentTransitionTime = 0, $a6cdda187280cdb0$var$workInProgressRootRenderTargetTime = Infinity, $a6cdda187280cdb0$var$workInProgressTransitions = null, $a6cdda187280cdb0$var$legacyErrorBoundariesThatAlreadyFailed = null, $a6cdda187280cdb0$var$pendingEffectsStatus = 0, $a6cdda187280cdb0$var$pendingEffectsRoot = null, $a6cdda187280cdb0$var$pendingFinishedWork = null, $a6cdda187280cdb0$var$pendingEffectsLanes = 0, $a6cdda187280cdb0$var$pendingEffectsRemainingLanes = 0, $a6cdda187280cdb0$var$pendingPassiveTransitions = null, $a6cdda187280cdb0$var$pendingRecoverableErrors = null, $a6cdda187280cdb0$var$nestedUpdateCount = 0, $a6cdda187280cdb0$var$rootWithNestedUpdates = null;
function $a6cdda187280cdb0$var$requestUpdateLane() {
    return 0 !== ($a6cdda187280cdb0$var$executionContext & 2) && 0 !== $a6cdda187280cdb0$var$workInProgressRootRenderLanes ? $a6cdda187280cdb0$var$workInProgressRootRenderLanes & -$a6cdda187280cdb0$var$workInProgressRootRenderLanes : null !== $a6cdda187280cdb0$var$ReactSharedInternals.T ? $a6cdda187280cdb0$var$requestTransitionLane() : $a6cdda187280cdb0$var$resolveUpdatePriority();
}
function $a6cdda187280cdb0$var$requestDeferredLane() {
    if (0 === $a6cdda187280cdb0$var$workInProgressDeferredLane) {
        if (0 === ($a6cdda187280cdb0$var$workInProgressRootRenderLanes & 536870912) || $a6cdda187280cdb0$var$isHydrating) {
            var lane = $a6cdda187280cdb0$var$nextTransitionDeferredLane;
            $a6cdda187280cdb0$var$nextTransitionDeferredLane <<= 1;
            0 === ($a6cdda187280cdb0$var$nextTransitionDeferredLane & 3932160) && ($a6cdda187280cdb0$var$nextTransitionDeferredLane = 262144);
            $a6cdda187280cdb0$var$workInProgressDeferredLane = lane;
        } else $a6cdda187280cdb0$var$workInProgressDeferredLane = 536870912;
    }
    lane = $a6cdda187280cdb0$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $a6cdda187280cdb0$var$workInProgressDeferredLane;
}
function $a6cdda187280cdb0$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $a6cdda187280cdb0$var$workInProgressRoot && (2 === $a6cdda187280cdb0$var$workInProgressSuspendedReason || 9 === $a6cdda187280cdb0$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $a6cdda187280cdb0$var$prepareFreshStack(root, 0), $a6cdda187280cdb0$var$markRootSuspended(root, $a6cdda187280cdb0$var$workInProgressRootRenderLanes, $a6cdda187280cdb0$var$workInProgressDeferredLane, !1);
    $a6cdda187280cdb0$var$markRootUpdated$1(root, lane);
    if (0 === ($a6cdda187280cdb0$var$executionContext & 2) || root !== $a6cdda187280cdb0$var$workInProgressRoot) root === $a6cdda187280cdb0$var$workInProgressRoot && (0 === ($a6cdda187280cdb0$var$executionContext & 2) && ($a6cdda187280cdb0$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $a6cdda187280cdb0$var$workInProgressRootExitStatus && $a6cdda187280cdb0$var$markRootSuspended(root, $a6cdda187280cdb0$var$workInProgressRootRenderLanes, $a6cdda187280cdb0$var$workInProgressDeferredLane, !1)), $a6cdda187280cdb0$var$ensureRootIsScheduled(root);
}
function $a6cdda187280cdb0$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($a6cdda187280cdb0$var$executionContext & 6)) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $a6cdda187280cdb0$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $a6cdda187280cdb0$var$renderRootConcurrent(root$jscomp$0, lanes) : $a6cdda187280cdb0$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $a6cdda187280cdb0$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $a6cdda187280cdb0$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$a6cdda187280cdb0$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $a6cdda187280cdb0$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $a6cdda187280cdb0$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($a6cdda187280cdb0$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $a6cdda187280cdb0$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($a6cdda187280cdb0$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $a6cdda187280cdb0$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $a6cdda187280cdb0$var$workInProgressRootRecoverableErrors;
                            $a6cdda187280cdb0$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $a6cdda187280cdb0$var$workInProgressRootRecoverableErrors ? $a6cdda187280cdb0$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $a6cdda187280cdb0$var$workInProgressRootRecoverableErrors.push.apply($a6cdda187280cdb0$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $a6cdda187280cdb0$var$prepareFreshStack(root$jscomp$0, 0);
                $a6cdda187280cdb0$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $a6cdda187280cdb0$var$markRootSuspended(shouldTimeSlice, lanes, $a6cdda187280cdb0$var$workInProgressDeferredLane, !$a6cdda187280cdb0$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $a6cdda187280cdb0$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $a6cdda187280cdb0$var$globalMostRecentFallbackTime + 300 - $a6cdda187280cdb0$var$now(), 10 < exitStatus)) {
                    $a6cdda187280cdb0$var$markRootSuspended(shouldTimeSlice, lanes, $a6cdda187280cdb0$var$workInProgressDeferredLane, !$a6cdda187280cdb0$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $a6cdda187280cdb0$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $a6cdda187280cdb0$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $a6cdda187280cdb0$var$scheduleTimeout($a6cdda187280cdb0$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $a6cdda187280cdb0$var$workInProgressRootRecoverableErrors, $a6cdda187280cdb0$var$workInProgressTransitions, $a6cdda187280cdb0$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $a6cdda187280cdb0$var$workInProgressDeferredLane, $a6cdda187280cdb0$var$workInProgressRootInterleavedUpdatedLanes, $a6cdda187280cdb0$var$workInProgressSuspendedRetryLanes, $a6cdda187280cdb0$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $a6cdda187280cdb0$var$commitRootWhenReady(shouldTimeSlice, forceSync, $a6cdda187280cdb0$var$workInProgressRootRecoverableErrors, $a6cdda187280cdb0$var$workInProgressTransitions, $a6cdda187280cdb0$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $a6cdda187280cdb0$var$workInProgressDeferredLane, $a6cdda187280cdb0$var$workInProgressRootInterleavedUpdatedLanes, $a6cdda187280cdb0$var$workInProgressSuspendedRetryLanes, $a6cdda187280cdb0$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $a6cdda187280cdb0$var$ensureRootIsScheduled(root$jscomp$0);
}
function $a6cdda187280cdb0$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $a6cdda187280cdb0$var$noop$1
        };
        $a6cdda187280cdb0$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $a6cdda187280cdb0$var$globalMostRecentFallbackTime - $a6cdda187280cdb0$var$now() : (lanes & 4194048) === lanes ? $a6cdda187280cdb0$var$globalMostRecentTransitionTime - $a6cdda187280cdb0$var$now() : 0;
        timeoutOffset = $a6cdda187280cdb0$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $a6cdda187280cdb0$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($a6cdda187280cdb0$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $a6cdda187280cdb0$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $a6cdda187280cdb0$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $a6cdda187280cdb0$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$a6cdda187280cdb0$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $a6cdda187280cdb0$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$a6cdda187280cdb0$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$a6cdda187280cdb0$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $a6cdda187280cdb0$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $a6cdda187280cdb0$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $a6cdda187280cdb0$var$flushSyncWork$1() {
    return 0 === ($a6cdda187280cdb0$var$executionContext & 6) ? ($a6cdda187280cdb0$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $a6cdda187280cdb0$var$resetWorkInProgressStack() {
    if (null !== $a6cdda187280cdb0$var$workInProgress) {
        if (0 === $a6cdda187280cdb0$var$workInProgressSuspendedReason) var interruptedWork = $a6cdda187280cdb0$var$workInProgress.return;
        else interruptedWork = $a6cdda187280cdb0$var$workInProgress, $a6cdda187280cdb0$var$lastContextDependency = $a6cdda187280cdb0$var$currentlyRenderingFiber$1 = null, $a6cdda187280cdb0$var$resetHooksOnUnwind(interruptedWork), $a6cdda187280cdb0$var$thenableState$1 = null, $a6cdda187280cdb0$var$thenableIndexCounter$1 = 0, interruptedWork = $a6cdda187280cdb0$var$workInProgress;
        for(; null !== interruptedWork;)$a6cdda187280cdb0$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $a6cdda187280cdb0$var$workInProgress = null;
    }
}
function $a6cdda187280cdb0$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $a6cdda187280cdb0$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $a6cdda187280cdb0$var$pendingEffectsLanes = 0;
    $a6cdda187280cdb0$var$resetWorkInProgressStack();
    $a6cdda187280cdb0$var$workInProgressRoot = root;
    $a6cdda187280cdb0$var$workInProgress = timeoutHandle = $a6cdda187280cdb0$var$createWorkInProgress(root.current, null);
    $a6cdda187280cdb0$var$workInProgressRootRenderLanes = lanes;
    $a6cdda187280cdb0$var$workInProgressSuspendedReason = 0;
    $a6cdda187280cdb0$var$workInProgressThrownValue = null;
    $a6cdda187280cdb0$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $a6cdda187280cdb0$var$workInProgressRootIsPrerendering = $a6cdda187280cdb0$var$checkIfRootIsPrerendering(root, lanes);
    $a6cdda187280cdb0$var$workInProgressRootDidAttachPingListener = !1;
    $a6cdda187280cdb0$var$workInProgressSuspendedRetryLanes = $a6cdda187280cdb0$var$workInProgressDeferredLane = $a6cdda187280cdb0$var$workInProgressRootPingedLanes = $a6cdda187280cdb0$var$workInProgressRootInterleavedUpdatedLanes = $a6cdda187280cdb0$var$workInProgressRootSkippedLanes = $a6cdda187280cdb0$var$workInProgressRootExitStatus = 0;
    $a6cdda187280cdb0$var$workInProgressRootRecoverableErrors = $a6cdda187280cdb0$var$workInProgressRootConcurrentErrors = null;
    $a6cdda187280cdb0$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $a6cdda187280cdb0$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $a6cdda187280cdb0$var$entangledRenderLanes = lanes;
    $a6cdda187280cdb0$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $a6cdda187280cdb0$var$handleThrow(root, thrownValue) {
    $a6cdda187280cdb0$var$currentlyRenderingFiber = null;
    $a6cdda187280cdb0$var$ReactSharedInternals.H = $a6cdda187280cdb0$var$ContextOnlyDispatcher;
    thrownValue === $a6cdda187280cdb0$var$SuspenseException || thrownValue === $a6cdda187280cdb0$var$SuspenseActionException ? (thrownValue = $a6cdda187280cdb0$var$getSuspendedThenable(), $a6cdda187280cdb0$var$workInProgressSuspendedReason = 3) : thrownValue === $a6cdda187280cdb0$var$SuspenseyCommitException ? (thrownValue = $a6cdda187280cdb0$var$getSuspendedThenable(), $a6cdda187280cdb0$var$workInProgressSuspendedReason = 4) : $a6cdda187280cdb0$var$workInProgressSuspendedReason = thrownValue === $a6cdda187280cdb0$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $a6cdda187280cdb0$var$workInProgressThrownValue = thrownValue;
    null === $a6cdda187280cdb0$var$workInProgress && ($a6cdda187280cdb0$var$workInProgressRootExitStatus = 1, $a6cdda187280cdb0$var$logUncaughtError(root, $a6cdda187280cdb0$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $a6cdda187280cdb0$var$shouldRemainOnPreviousScreen() {
    var handler = $a6cdda187280cdb0$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($a6cdda187280cdb0$var$workInProgressRootRenderLanes & 4194048) === $a6cdda187280cdb0$var$workInProgressRootRenderLanes ? null === $a6cdda187280cdb0$var$shellBoundary ? !0 : !1 : ($a6cdda187280cdb0$var$workInProgressRootRenderLanes & 62914560) === $a6cdda187280cdb0$var$workInProgressRootRenderLanes || 0 !== ($a6cdda187280cdb0$var$workInProgressRootRenderLanes & 536870912) ? handler === $a6cdda187280cdb0$var$shellBoundary : !1;
}
function $a6cdda187280cdb0$var$pushDispatcher() {
    var prevDispatcher = $a6cdda187280cdb0$var$ReactSharedInternals.H;
    $a6cdda187280cdb0$var$ReactSharedInternals.H = $a6cdda187280cdb0$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $a6cdda187280cdb0$var$ContextOnlyDispatcher : prevDispatcher;
}
function $a6cdda187280cdb0$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $a6cdda187280cdb0$var$ReactSharedInternals.A;
    $a6cdda187280cdb0$var$ReactSharedInternals.A = $a6cdda187280cdb0$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $a6cdda187280cdb0$var$renderDidSuspendDelayIfPossible() {
    $a6cdda187280cdb0$var$workInProgressRootExitStatus = 4;
    $a6cdda187280cdb0$var$workInProgressRootDidSkipSuspendedSiblings || ($a6cdda187280cdb0$var$workInProgressRootRenderLanes & 4194048) !== $a6cdda187280cdb0$var$workInProgressRootRenderLanes && null !== $a6cdda187280cdb0$var$suspenseHandlerStackCursor.current || ($a6cdda187280cdb0$var$workInProgressRootIsPrerendering = !0);
    0 === ($a6cdda187280cdb0$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($a6cdda187280cdb0$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $a6cdda187280cdb0$var$workInProgressRoot || $a6cdda187280cdb0$var$markRootSuspended($a6cdda187280cdb0$var$workInProgressRoot, $a6cdda187280cdb0$var$workInProgressRootRenderLanes, $a6cdda187280cdb0$var$workInProgressDeferredLane, !1);
}
function $a6cdda187280cdb0$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $a6cdda187280cdb0$var$executionContext;
    $a6cdda187280cdb0$var$executionContext |= 2;
    var prevDispatcher = $a6cdda187280cdb0$var$pushDispatcher(), prevAsyncDispatcher = $a6cdda187280cdb0$var$pushAsyncDispatcher();
    if ($a6cdda187280cdb0$var$workInProgressRoot !== root || $a6cdda187280cdb0$var$workInProgressRootRenderLanes !== lanes) $a6cdda187280cdb0$var$workInProgressTransitions = null, $a6cdda187280cdb0$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $a6cdda187280cdb0$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $a6cdda187280cdb0$var$workInProgressSuspendedReason && null !== $a6cdda187280cdb0$var$workInProgress) {
            var unitOfWork = $a6cdda187280cdb0$var$workInProgress, thrownValue = $a6cdda187280cdb0$var$workInProgressThrownValue;
            switch($a6cdda187280cdb0$var$workInProgressSuspendedReason){
                case 8:
                    $a6cdda187280cdb0$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $a6cdda187280cdb0$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $a6cdda187280cdb0$var$workInProgressSuspendedReason;
                    $a6cdda187280cdb0$var$workInProgressSuspendedReason = 0;
                    $a6cdda187280cdb0$var$workInProgressThrownValue = null;
                    $a6cdda187280cdb0$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $a6cdda187280cdb0$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $a6cdda187280cdb0$var$workInProgressSuspendedReason, $a6cdda187280cdb0$var$workInProgressSuspendedReason = 0, $a6cdda187280cdb0$var$workInProgressThrownValue = null, $a6cdda187280cdb0$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $a6cdda187280cdb0$var$workLoopSync();
        exitStatus = $a6cdda187280cdb0$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $a6cdda187280cdb0$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $a6cdda187280cdb0$var$lastContextDependency = $a6cdda187280cdb0$var$currentlyRenderingFiber$1 = null;
    $a6cdda187280cdb0$var$executionContext = prevExecutionContext;
    $a6cdda187280cdb0$var$ReactSharedInternals.H = prevDispatcher;
    $a6cdda187280cdb0$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $a6cdda187280cdb0$var$workInProgress && ($a6cdda187280cdb0$var$workInProgressRoot = null, $a6cdda187280cdb0$var$workInProgressRootRenderLanes = 0, $a6cdda187280cdb0$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $a6cdda187280cdb0$var$workLoopSync() {
    for(; null !== $a6cdda187280cdb0$var$workInProgress;)$a6cdda187280cdb0$var$performUnitOfWork($a6cdda187280cdb0$var$workInProgress);
}
function $a6cdda187280cdb0$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $a6cdda187280cdb0$var$executionContext;
    $a6cdda187280cdb0$var$executionContext |= 2;
    var prevDispatcher = $a6cdda187280cdb0$var$pushDispatcher(), prevAsyncDispatcher = $a6cdda187280cdb0$var$pushAsyncDispatcher();
    $a6cdda187280cdb0$var$workInProgressRoot !== root || $a6cdda187280cdb0$var$workInProgressRootRenderLanes !== lanes ? ($a6cdda187280cdb0$var$workInProgressTransitions = null, $a6cdda187280cdb0$var$workInProgressRootRenderTargetTime = $a6cdda187280cdb0$var$now() + 500, $a6cdda187280cdb0$var$prepareFreshStack(root, lanes)) : $a6cdda187280cdb0$var$workInProgressRootIsPrerendering = $a6cdda187280cdb0$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $a6cdda187280cdb0$var$workInProgressSuspendedReason && null !== $a6cdda187280cdb0$var$workInProgress) {
            lanes = $a6cdda187280cdb0$var$workInProgress;
            var thrownValue = $a6cdda187280cdb0$var$workInProgressThrownValue;
            b: switch($a6cdda187280cdb0$var$workInProgressSuspendedReason){
                case 1:
                    $a6cdda187280cdb0$var$workInProgressSuspendedReason = 0;
                    $a6cdda187280cdb0$var$workInProgressThrownValue = null;
                    $a6cdda187280cdb0$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($a6cdda187280cdb0$var$isThenableResolved(thrownValue)) {
                        $a6cdda187280cdb0$var$workInProgressSuspendedReason = 0;
                        $a6cdda187280cdb0$var$workInProgressThrownValue = null;
                        $a6cdda187280cdb0$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $a6cdda187280cdb0$var$workInProgressSuspendedReason && 9 !== $a6cdda187280cdb0$var$workInProgressSuspendedReason || $a6cdda187280cdb0$var$workInProgressRoot !== root || ($a6cdda187280cdb0$var$workInProgressSuspendedReason = 7);
                        $a6cdda187280cdb0$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $a6cdda187280cdb0$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $a6cdda187280cdb0$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $a6cdda187280cdb0$var$isThenableResolved(thrownValue) ? ($a6cdda187280cdb0$var$workInProgressSuspendedReason = 0, $a6cdda187280cdb0$var$workInProgressThrownValue = null, $a6cdda187280cdb0$var$replaySuspendedUnitOfWork(lanes)) : ($a6cdda187280cdb0$var$workInProgressSuspendedReason = 0, $a6cdda187280cdb0$var$workInProgressThrownValue = null, $a6cdda187280cdb0$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($a6cdda187280cdb0$var$workInProgress.tag){
                        case 26:
                            resource = $a6cdda187280cdb0$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $a6cdda187280cdb0$var$workInProgress;
                            if (resource ? $a6cdda187280cdb0$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $a6cdda187280cdb0$var$workInProgressSuspendedReason = 0;
                                $a6cdda187280cdb0$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $a6cdda187280cdb0$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($a6cdda187280cdb0$var$workInProgress = returnFiber, $a6cdda187280cdb0$var$completeUnitOfWork(returnFiber)) : $a6cdda187280cdb0$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $a6cdda187280cdb0$var$workInProgressSuspendedReason = 0;
                    $a6cdda187280cdb0$var$workInProgressThrownValue = null;
                    $a6cdda187280cdb0$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $a6cdda187280cdb0$var$workInProgressSuspendedReason = 0;
                    $a6cdda187280cdb0$var$workInProgressThrownValue = null;
                    $a6cdda187280cdb0$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $a6cdda187280cdb0$var$resetWorkInProgressStack();
                    $a6cdda187280cdb0$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(462));
            }
        }
        $a6cdda187280cdb0$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $a6cdda187280cdb0$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $a6cdda187280cdb0$var$lastContextDependency = $a6cdda187280cdb0$var$currentlyRenderingFiber$1 = null;
    $a6cdda187280cdb0$var$ReactSharedInternals.H = prevDispatcher;
    $a6cdda187280cdb0$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $a6cdda187280cdb0$var$executionContext = prevExecutionContext;
    if (null !== $a6cdda187280cdb0$var$workInProgress) return 0;
    $a6cdda187280cdb0$var$workInProgressRoot = null;
    $a6cdda187280cdb0$var$workInProgressRootRenderLanes = 0;
    $a6cdda187280cdb0$var$finishQueueingConcurrentUpdates();
    return $a6cdda187280cdb0$var$workInProgressRootExitStatus;
}
function $a6cdda187280cdb0$var$workLoopConcurrentByScheduler() {
    for(; null !== $a6cdda187280cdb0$var$workInProgress && !$a6cdda187280cdb0$var$shouldYield();)$a6cdda187280cdb0$var$performUnitOfWork($a6cdda187280cdb0$var$workInProgress);
}
function $a6cdda187280cdb0$var$performUnitOfWork(unitOfWork) {
    var next = $a6cdda187280cdb0$var$beginWork(unitOfWork.alternate, unitOfWork, $a6cdda187280cdb0$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $a6cdda187280cdb0$var$completeUnitOfWork(unitOfWork) : $a6cdda187280cdb0$var$workInProgress = next;
}
function $a6cdda187280cdb0$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $a6cdda187280cdb0$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $a6cdda187280cdb0$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $a6cdda187280cdb0$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $a6cdda187280cdb0$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $a6cdda187280cdb0$var$resetHooksOnUnwind(next);
        default:
            $a6cdda187280cdb0$var$unwindInterruptedWork(current, next), next = $a6cdda187280cdb0$var$workInProgress = $a6cdda187280cdb0$var$resetWorkInProgress(next, $a6cdda187280cdb0$var$entangledRenderLanes), next = $a6cdda187280cdb0$var$beginWork(current, next, $a6cdda187280cdb0$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $a6cdda187280cdb0$var$completeUnitOfWork(unitOfWork) : $a6cdda187280cdb0$var$workInProgress = next;
}
function $a6cdda187280cdb0$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $a6cdda187280cdb0$var$lastContextDependency = $a6cdda187280cdb0$var$currentlyRenderingFiber$1 = null;
    $a6cdda187280cdb0$var$resetHooksOnUnwind(unitOfWork);
    $a6cdda187280cdb0$var$thenableState$1 = null;
    $a6cdda187280cdb0$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($a6cdda187280cdb0$var$throwException(root, returnFiber, unitOfWork, thrownValue, $a6cdda187280cdb0$var$workInProgressRootRenderLanes)) {
            $a6cdda187280cdb0$var$workInProgressRootExitStatus = 1;
            $a6cdda187280cdb0$var$logUncaughtError(root, $a6cdda187280cdb0$var$createCapturedValueAtFiber(thrownValue, root.current));
            $a6cdda187280cdb0$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $a6cdda187280cdb0$var$workInProgress = returnFiber, error;
        $a6cdda187280cdb0$var$workInProgressRootExitStatus = 1;
        $a6cdda187280cdb0$var$logUncaughtError(root, $a6cdda187280cdb0$var$createCapturedValueAtFiber(thrownValue, root.current));
        $a6cdda187280cdb0$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($a6cdda187280cdb0$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($a6cdda187280cdb0$var$workInProgressRootIsPrerendering || 0 !== ($a6cdda187280cdb0$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($a6cdda187280cdb0$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $a6cdda187280cdb0$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $a6cdda187280cdb0$var$unwindUnitOfWork(unitOfWork, root);
    } else $a6cdda187280cdb0$var$completeUnitOfWork(unitOfWork);
}
function $a6cdda187280cdb0$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $a6cdda187280cdb0$var$unwindUnitOfWork(completedWork, $a6cdda187280cdb0$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $a6cdda187280cdb0$var$completeWork(completedWork.alternate, completedWork, $a6cdda187280cdb0$var$entangledRenderLanes);
        if (null !== next) {
            $a6cdda187280cdb0$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $a6cdda187280cdb0$var$workInProgress = completedWork;
            return;
        }
        $a6cdda187280cdb0$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $a6cdda187280cdb0$var$workInProgressRootExitStatus && ($a6cdda187280cdb0$var$workInProgressRootExitStatus = 5);
}
function $a6cdda187280cdb0$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $a6cdda187280cdb0$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $a6cdda187280cdb0$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $a6cdda187280cdb0$var$workInProgress = unitOfWork;
            return;
        }
        $a6cdda187280cdb0$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $a6cdda187280cdb0$var$workInProgressRootExitStatus = 6;
    $a6cdda187280cdb0$var$workInProgress = null;
}
function $a6cdda187280cdb0$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $a6cdda187280cdb0$var$flushPendingEffects();
    while (0 !== $a6cdda187280cdb0$var$pendingEffectsStatus);
    if (0 !== ($a6cdda187280cdb0$var$executionContext & 6)) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $a6cdda187280cdb0$var$concurrentlyUpdatedLanes;
        $a6cdda187280cdb0$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $a6cdda187280cdb0$var$workInProgressRoot && ($a6cdda187280cdb0$var$workInProgress = $a6cdda187280cdb0$var$workInProgressRoot = null, $a6cdda187280cdb0$var$workInProgressRootRenderLanes = 0);
        $a6cdda187280cdb0$var$pendingFinishedWork = finishedWork;
        $a6cdda187280cdb0$var$pendingEffectsRoot = root;
        $a6cdda187280cdb0$var$pendingEffectsLanes = lanes;
        $a6cdda187280cdb0$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $a6cdda187280cdb0$var$pendingPassiveTransitions = transitions;
        $a6cdda187280cdb0$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $a6cdda187280cdb0$var$scheduleCallback$1($a6cdda187280cdb0$var$NormalPriority$1, function() {
            $a6cdda187280cdb0$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $a6cdda187280cdb0$var$ReactSharedInternals.T;
            $a6cdda187280cdb0$var$ReactSharedInternals.T = null;
            transitions = $a6cdda187280cdb0$var$ReactDOMSharedInternals.p;
            $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $a6cdda187280cdb0$var$executionContext;
            $a6cdda187280cdb0$var$executionContext |= 4;
            try {
                $a6cdda187280cdb0$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $a6cdda187280cdb0$var$executionContext = spawnedLane, $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = transitions, $a6cdda187280cdb0$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $a6cdda187280cdb0$var$pendingEffectsStatus = 1;
        $a6cdda187280cdb0$var$flushMutationEffects();
        $a6cdda187280cdb0$var$flushLayoutEffects();
        $a6cdda187280cdb0$var$flushSpawnedWork();
    }
}
function $a6cdda187280cdb0$var$flushMutationEffects() {
    if (1 === $a6cdda187280cdb0$var$pendingEffectsStatus) {
        $a6cdda187280cdb0$var$pendingEffectsStatus = 0;
        var root = $a6cdda187280cdb0$var$pendingEffectsRoot, finishedWork = $a6cdda187280cdb0$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $a6cdda187280cdb0$var$ReactSharedInternals.T;
            $a6cdda187280cdb0$var$ReactSharedInternals.T = null;
            var previousPriority = $a6cdda187280cdb0$var$ReactDOMSharedInternals.p;
            $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $a6cdda187280cdb0$var$executionContext;
            $a6cdda187280cdb0$var$executionContext |= 4;
            try {
                $a6cdda187280cdb0$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $a6cdda187280cdb0$var$selectionInformation, curFocusedElem = $a6cdda187280cdb0$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $a6cdda187280cdb0$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $a6cdda187280cdb0$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $a6cdda187280cdb0$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $a6cdda187280cdb0$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $a6cdda187280cdb0$var$_enabled = !!$a6cdda187280cdb0$var$eventsEnabled;
                $a6cdda187280cdb0$var$selectionInformation = $a6cdda187280cdb0$var$eventsEnabled = null;
            } finally{
                $a6cdda187280cdb0$var$executionContext = prevExecutionContext, $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = previousPriority, $a6cdda187280cdb0$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $a6cdda187280cdb0$var$pendingEffectsStatus = 2;
    }
}
function $a6cdda187280cdb0$var$flushLayoutEffects() {
    if (2 === $a6cdda187280cdb0$var$pendingEffectsStatus) {
        $a6cdda187280cdb0$var$pendingEffectsStatus = 0;
        var root = $a6cdda187280cdb0$var$pendingEffectsRoot, finishedWork = $a6cdda187280cdb0$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $a6cdda187280cdb0$var$ReactSharedInternals.T;
            $a6cdda187280cdb0$var$ReactSharedInternals.T = null;
            var previousPriority = $a6cdda187280cdb0$var$ReactDOMSharedInternals.p;
            $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $a6cdda187280cdb0$var$executionContext;
            $a6cdda187280cdb0$var$executionContext |= 4;
            try {
                $a6cdda187280cdb0$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $a6cdda187280cdb0$var$executionContext = prevExecutionContext, $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = previousPriority, $a6cdda187280cdb0$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $a6cdda187280cdb0$var$pendingEffectsStatus = 3;
    }
}
function $a6cdda187280cdb0$var$flushSpawnedWork() {
    if (4 === $a6cdda187280cdb0$var$pendingEffectsStatus || 3 === $a6cdda187280cdb0$var$pendingEffectsStatus) {
        $a6cdda187280cdb0$var$pendingEffectsStatus = 0;
        $a6cdda187280cdb0$var$requestPaint();
        var root = $a6cdda187280cdb0$var$pendingEffectsRoot, finishedWork = $a6cdda187280cdb0$var$pendingFinishedWork, lanes = $a6cdda187280cdb0$var$pendingEffectsLanes, recoverableErrors = $a6cdda187280cdb0$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $a6cdda187280cdb0$var$pendingEffectsStatus = 5 : ($a6cdda187280cdb0$var$pendingEffectsStatus = 0, $a6cdda187280cdb0$var$pendingFinishedWork = $a6cdda187280cdb0$var$pendingEffectsRoot = null, $a6cdda187280cdb0$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($a6cdda187280cdb0$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $a6cdda187280cdb0$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($a6cdda187280cdb0$var$injectedHook && "function" === typeof $a6cdda187280cdb0$var$injectedHook.onCommitFiberRoot) try {
            $a6cdda187280cdb0$var$injectedHook.onCommitFiberRoot($a6cdda187280cdb0$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $a6cdda187280cdb0$var$ReactSharedInternals.T;
            remainingLanes = $a6cdda187280cdb0$var$ReactDOMSharedInternals.p;
            $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = 2;
            $a6cdda187280cdb0$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $a6cdda187280cdb0$var$ReactSharedInternals.T = finishedWork, $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($a6cdda187280cdb0$var$pendingEffectsLanes & 3) && $a6cdda187280cdb0$var$flushPendingEffects();
        $a6cdda187280cdb0$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $a6cdda187280cdb0$var$rootWithNestedUpdates ? $a6cdda187280cdb0$var$nestedUpdateCount++ : ($a6cdda187280cdb0$var$nestedUpdateCount = 0, $a6cdda187280cdb0$var$rootWithNestedUpdates = root) : $a6cdda187280cdb0$var$nestedUpdateCount = 0;
        $a6cdda187280cdb0$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $a6cdda187280cdb0$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $a6cdda187280cdb0$var$releaseCache(remainingLanes)));
}
function $a6cdda187280cdb0$var$flushPendingEffects() {
    $a6cdda187280cdb0$var$flushMutationEffects();
    $a6cdda187280cdb0$var$flushLayoutEffects();
    $a6cdda187280cdb0$var$flushSpawnedWork();
    return $a6cdda187280cdb0$var$flushPassiveEffects();
}
function $a6cdda187280cdb0$var$flushPassiveEffects() {
    if (5 !== $a6cdda187280cdb0$var$pendingEffectsStatus) return !1;
    var root = $a6cdda187280cdb0$var$pendingEffectsRoot, remainingLanes = $a6cdda187280cdb0$var$pendingEffectsRemainingLanes;
    $a6cdda187280cdb0$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $a6cdda187280cdb0$var$lanesToEventPriority($a6cdda187280cdb0$var$pendingEffectsLanes), prevTransition = $a6cdda187280cdb0$var$ReactSharedInternals.T, previousPriority = $a6cdda187280cdb0$var$ReactDOMSharedInternals.p;
    try {
        $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $a6cdda187280cdb0$var$ReactSharedInternals.T = null;
        renderPriority = $a6cdda187280cdb0$var$pendingPassiveTransitions;
        $a6cdda187280cdb0$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $a6cdda187280cdb0$var$pendingEffectsRoot, lanes = $a6cdda187280cdb0$var$pendingEffectsLanes;
        $a6cdda187280cdb0$var$pendingEffectsStatus = 0;
        $a6cdda187280cdb0$var$pendingFinishedWork = $a6cdda187280cdb0$var$pendingEffectsRoot = null;
        $a6cdda187280cdb0$var$pendingEffectsLanes = 0;
        if (0 !== ($a6cdda187280cdb0$var$executionContext & 6)) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(331));
        var prevExecutionContext = $a6cdda187280cdb0$var$executionContext;
        $a6cdda187280cdb0$var$executionContext |= 4;
        $a6cdda187280cdb0$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $a6cdda187280cdb0$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $a6cdda187280cdb0$var$executionContext = prevExecutionContext;
        $a6cdda187280cdb0$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($a6cdda187280cdb0$var$injectedHook && "function" === typeof $a6cdda187280cdb0$var$injectedHook.onPostCommitFiberRoot) try {
            $a6cdda187280cdb0$var$injectedHook.onPostCommitFiberRoot($a6cdda187280cdb0$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = previousPriority, $a6cdda187280cdb0$var$ReactSharedInternals.T = prevTransition, $a6cdda187280cdb0$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $a6cdda187280cdb0$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $a6cdda187280cdb0$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $a6cdda187280cdb0$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $a6cdda187280cdb0$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($a6cdda187280cdb0$var$markRootUpdated$1(rootFiber, 2), $a6cdda187280cdb0$var$ensureRootIsScheduled(rootFiber));
}
function $a6cdda187280cdb0$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $a6cdda187280cdb0$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $a6cdda187280cdb0$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $a6cdda187280cdb0$var$legacyErrorBoundariesThatAlreadyFailed || !$a6cdda187280cdb0$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $a6cdda187280cdb0$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $a6cdda187280cdb0$var$createClassErrorUpdate(2);
                instance = $a6cdda187280cdb0$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($a6cdda187280cdb0$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $a6cdda187280cdb0$var$markRootUpdated$1(instance, 2), $a6cdda187280cdb0$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $a6cdda187280cdb0$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $a6cdda187280cdb0$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($a6cdda187280cdb0$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $a6cdda187280cdb0$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $a6cdda187280cdb0$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $a6cdda187280cdb0$var$workInProgressRoot === root && ($a6cdda187280cdb0$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $a6cdda187280cdb0$var$workInProgressRootExitStatus || 3 === $a6cdda187280cdb0$var$workInProgressRootExitStatus && ($a6cdda187280cdb0$var$workInProgressRootRenderLanes & 62914560) === $a6cdda187280cdb0$var$workInProgressRootRenderLanes && 300 > $a6cdda187280cdb0$var$now() - $a6cdda187280cdb0$var$globalMostRecentFallbackTime ? 0 === ($a6cdda187280cdb0$var$executionContext & 2) && $a6cdda187280cdb0$var$prepareFreshStack(root, 0) : $a6cdda187280cdb0$var$workInProgressRootPingedLanes |= pingedLanes, $a6cdda187280cdb0$var$workInProgressSuspendedRetryLanes === $a6cdda187280cdb0$var$workInProgressRootRenderLanes && ($a6cdda187280cdb0$var$workInProgressSuspendedRetryLanes = 0));
    $a6cdda187280cdb0$var$ensureRootIsScheduled(root);
}
function $a6cdda187280cdb0$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $a6cdda187280cdb0$var$claimNextRetryLane());
    boundaryFiber = $a6cdda187280cdb0$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($a6cdda187280cdb0$var$markRootUpdated$1(boundaryFiber, retryLane), $a6cdda187280cdb0$var$ensureRootIsScheduled(boundaryFiber));
}
function $a6cdda187280cdb0$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $a6cdda187280cdb0$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $a6cdda187280cdb0$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $a6cdda187280cdb0$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $a6cdda187280cdb0$var$scheduleCallback$1(priorityLevel, callback) {
    return $a6cdda187280cdb0$var$scheduleCallback$3(priorityLevel, callback);
}
var $a6cdda187280cdb0$var$firstScheduledRoot = null, $a6cdda187280cdb0$var$lastScheduledRoot = null, $a6cdda187280cdb0$var$didScheduleMicrotask = !1, $a6cdda187280cdb0$var$mightHavePendingSyncWork = !1, $a6cdda187280cdb0$var$isFlushingWork = !1, $a6cdda187280cdb0$var$currentEventTransitionLane = 0;
function $a6cdda187280cdb0$var$ensureRootIsScheduled(root) {
    root !== $a6cdda187280cdb0$var$lastScheduledRoot && null === root.next && (null === $a6cdda187280cdb0$var$lastScheduledRoot ? $a6cdda187280cdb0$var$firstScheduledRoot = $a6cdda187280cdb0$var$lastScheduledRoot = root : $a6cdda187280cdb0$var$lastScheduledRoot = $a6cdda187280cdb0$var$lastScheduledRoot.next = root);
    $a6cdda187280cdb0$var$mightHavePendingSyncWork = !0;
    $a6cdda187280cdb0$var$didScheduleMicrotask || ($a6cdda187280cdb0$var$didScheduleMicrotask = !0, $a6cdda187280cdb0$var$scheduleImmediateRootScheduleTask());
}
function $a6cdda187280cdb0$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$a6cdda187280cdb0$var$isFlushingWork && $a6cdda187280cdb0$var$mightHavePendingSyncWork) {
        $a6cdda187280cdb0$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $a6cdda187280cdb0$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $a6cdda187280cdb0$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $a6cdda187280cdb0$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $a6cdda187280cdb0$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $a6cdda187280cdb0$var$getNextLanes(root$170, root$170 === $a6cdda187280cdb0$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $a6cdda187280cdb0$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $a6cdda187280cdb0$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $a6cdda187280cdb0$var$isFlushingWork = !1;
    }
}
function $a6cdda187280cdb0$var$processRootScheduleInImmediateTask() {
    $a6cdda187280cdb0$var$processRootScheduleInMicrotask();
}
function $a6cdda187280cdb0$var$processRootScheduleInMicrotask() {
    $a6cdda187280cdb0$var$mightHavePendingSyncWork = $a6cdda187280cdb0$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $a6cdda187280cdb0$var$currentEventTransitionLane && $a6cdda187280cdb0$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $a6cdda187280cdb0$var$currentEventTransitionLane);
    for(var currentTime = $a6cdda187280cdb0$var$now(), prev = null, root = $a6cdda187280cdb0$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $a6cdda187280cdb0$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $a6cdda187280cdb0$var$firstScheduledRoot = next : prev.next = next, null === next && ($a6cdda187280cdb0$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $a6cdda187280cdb0$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $a6cdda187280cdb0$var$pendingEffectsStatus && 5 !== $a6cdda187280cdb0$var$pendingEffectsStatus || $a6cdda187280cdb0$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $a6cdda187280cdb0$var$currentEventTransitionLane && ($a6cdda187280cdb0$var$currentEventTransitionLane = 0);
}
function $a6cdda187280cdb0$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $a6cdda187280cdb0$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $a6cdda187280cdb0$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $a6cdda187280cdb0$var$workInProgressRoot;
    suspendedLanes = $a6cdda187280cdb0$var$workInProgressRootRenderLanes;
    suspendedLanes = $a6cdda187280cdb0$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $a6cdda187280cdb0$var$workInProgressSuspendedReason || 9 === $a6cdda187280cdb0$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $a6cdda187280cdb0$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $a6cdda187280cdb0$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $a6cdda187280cdb0$var$cancelCallback$1(pingedLanes);
        switch($a6cdda187280cdb0$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $a6cdda187280cdb0$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $a6cdda187280cdb0$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $a6cdda187280cdb0$var$IdlePriority;
                break;
            default:
                suspendedLanes = $a6cdda187280cdb0$var$NormalPriority$1;
        }
        pingedLanes = $a6cdda187280cdb0$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $a6cdda187280cdb0$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $a6cdda187280cdb0$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $a6cdda187280cdb0$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $a6cdda187280cdb0$var$pendingEffectsStatus && 5 !== $a6cdda187280cdb0$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($a6cdda187280cdb0$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $a6cdda187280cdb0$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $a6cdda187280cdb0$var$getNextLanes(root, root === $a6cdda187280cdb0$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $a6cdda187280cdb0$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $a6cdda187280cdb0$var$scheduleTaskForRootDuringMicrotask(root, $a6cdda187280cdb0$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $a6cdda187280cdb0$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $a6cdda187280cdb0$var$performSyncWorkOnRoot(root, lanes) {
    if ($a6cdda187280cdb0$var$flushPendingEffects()) return null;
    $a6cdda187280cdb0$var$performWorkOnRoot(root, lanes, !0);
}
function $a6cdda187280cdb0$var$scheduleImmediateRootScheduleTask() {
    $a6cdda187280cdb0$var$scheduleMicrotask(function() {
        0 !== ($a6cdda187280cdb0$var$executionContext & 6) ? $a6cdda187280cdb0$var$scheduleCallback$3($a6cdda187280cdb0$var$ImmediatePriority, $a6cdda187280cdb0$var$processRootScheduleInImmediateTask) : $a6cdda187280cdb0$var$processRootScheduleInMicrotask();
    });
}
function $a6cdda187280cdb0$var$requestTransitionLane() {
    if (0 === $a6cdda187280cdb0$var$currentEventTransitionLane) {
        var actionScopeLane = $a6cdda187280cdb0$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $a6cdda187280cdb0$var$nextTransitionUpdateLane, $a6cdda187280cdb0$var$nextTransitionUpdateLane <<= 1, 0 === ($a6cdda187280cdb0$var$nextTransitionUpdateLane & 261888) && ($a6cdda187280cdb0$var$nextTransitionUpdateLane = 256));
        $a6cdda187280cdb0$var$currentEventTransitionLane = actionScopeLane;
    }
    return $a6cdda187280cdb0$var$currentEventTransitionLane;
}
function $a6cdda187280cdb0$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $a6cdda187280cdb0$var$sanitizeURL("" + actionProp);
}
function $a6cdda187280cdb0$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $a6cdda187280cdb0$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $a6cdda187280cdb0$var$coerceFormActionProp((nativeEventTarget[$a6cdda187280cdb0$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$a6cdda187280cdb0$var$internalPropsKey] || null) ? $a6cdda187280cdb0$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $a6cdda187280cdb0$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $a6cdda187280cdb0$var$currentEventTransitionLane) {
                                var formData = submitter ? $a6cdda187280cdb0$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $a6cdda187280cdb0$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $a6cdda187280cdb0$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $a6cdda187280cdb0$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $a6cdda187280cdb0$var$i$jscomp$inline_1577 = 0; $a6cdda187280cdb0$var$i$jscomp$inline_1577 < $a6cdda187280cdb0$var$simpleEventPluginEvents.length; $a6cdda187280cdb0$var$i$jscomp$inline_1577++){
    var $a6cdda187280cdb0$var$eventName$jscomp$inline_1578 = $a6cdda187280cdb0$var$simpleEventPluginEvents[$a6cdda187280cdb0$var$i$jscomp$inline_1577], $a6cdda187280cdb0$var$domEventName$jscomp$inline_1579 = $a6cdda187280cdb0$var$eventName$jscomp$inline_1578.toLowerCase(), $a6cdda187280cdb0$var$capitalizedEvent$jscomp$inline_1580 = $a6cdda187280cdb0$var$eventName$jscomp$inline_1578[0].toUpperCase() + $a6cdda187280cdb0$var$eventName$jscomp$inline_1578.slice(1);
    $a6cdda187280cdb0$var$registerSimpleEvent($a6cdda187280cdb0$var$domEventName$jscomp$inline_1579, "on" + $a6cdda187280cdb0$var$capitalizedEvent$jscomp$inline_1580);
}
$a6cdda187280cdb0$var$registerSimpleEvent($a6cdda187280cdb0$var$ANIMATION_END, "onAnimationEnd");
$a6cdda187280cdb0$var$registerSimpleEvent($a6cdda187280cdb0$var$ANIMATION_ITERATION, "onAnimationIteration");
$a6cdda187280cdb0$var$registerSimpleEvent($a6cdda187280cdb0$var$ANIMATION_START, "onAnimationStart");
$a6cdda187280cdb0$var$registerSimpleEvent("dblclick", "onDoubleClick");
$a6cdda187280cdb0$var$registerSimpleEvent("focusin", "onFocus");
$a6cdda187280cdb0$var$registerSimpleEvent("focusout", "onBlur");
$a6cdda187280cdb0$var$registerSimpleEvent($a6cdda187280cdb0$var$TRANSITION_RUN, "onTransitionRun");
$a6cdda187280cdb0$var$registerSimpleEvent($a6cdda187280cdb0$var$TRANSITION_START, "onTransitionStart");
$a6cdda187280cdb0$var$registerSimpleEvent($a6cdda187280cdb0$var$TRANSITION_CANCEL, "onTransitionCancel");
$a6cdda187280cdb0$var$registerSimpleEvent($a6cdda187280cdb0$var$TRANSITION_END, "onTransitionEnd");
$a6cdda187280cdb0$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$a6cdda187280cdb0$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$a6cdda187280cdb0$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$a6cdda187280cdb0$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$a6cdda187280cdb0$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$a6cdda187280cdb0$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$a6cdda187280cdb0$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$a6cdda187280cdb0$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$a6cdda187280cdb0$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$a6cdda187280cdb0$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $a6cdda187280cdb0$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $a6cdda187280cdb0$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($a6cdda187280cdb0$var$mediaEventTypes));
function $a6cdda187280cdb0$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $a6cdda187280cdb0$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $a6cdda187280cdb0$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $a6cdda187280cdb0$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$a6cdda187280cdb0$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$a6cdda187280cdb0$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($a6cdda187280cdb0$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $a6cdda187280cdb0$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $a6cdda187280cdb0$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $a6cdda187280cdb0$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $a6cdda187280cdb0$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$a6cdda187280cdb0$var$listeningMarker]) {
        rootContainerElement[$a6cdda187280cdb0$var$listeningMarker] = !0;
        $a6cdda187280cdb0$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($a6cdda187280cdb0$var$nonDelegatedEvents.has(domEventName) || $a6cdda187280cdb0$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $a6cdda187280cdb0$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$a6cdda187280cdb0$var$listeningMarker] || (ownerDocument[$a6cdda187280cdb0$var$listeningMarker] = !0, $a6cdda187280cdb0$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $a6cdda187280cdb0$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($a6cdda187280cdb0$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $a6cdda187280cdb0$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $a6cdda187280cdb0$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $a6cdda187280cdb0$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$a6cdda187280cdb0$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $a6cdda187280cdb0$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $a6cdda187280cdb0$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $a6cdda187280cdb0$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $a6cdda187280cdb0$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $a6cdda187280cdb0$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $a6cdda187280cdb0$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $a6cdda187280cdb0$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $a6cdda187280cdb0$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $a6cdda187280cdb0$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $a6cdda187280cdb0$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $a6cdda187280cdb0$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $a6cdda187280cdb0$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $a6cdda187280cdb0$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $a6cdda187280cdb0$var$SyntheticTouchEvent;
                        break;
                    case $a6cdda187280cdb0$var$ANIMATION_END:
                    case $a6cdda187280cdb0$var$ANIMATION_ITERATION:
                    case $a6cdda187280cdb0$var$ANIMATION_START:
                        SyntheticEventCtor = $a6cdda187280cdb0$var$SyntheticAnimationEvent;
                        break;
                    case $a6cdda187280cdb0$var$TRANSITION_END:
                        SyntheticEventCtor = $a6cdda187280cdb0$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $a6cdda187280cdb0$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $a6cdda187280cdb0$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $a6cdda187280cdb0$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $a6cdda187280cdb0$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $a6cdda187280cdb0$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $a6cdda187280cdb0$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($a6cdda187280cdb0$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $a6cdda187280cdb0$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($a6cdda187280cdb0$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$a6cdda187280cdb0$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $a6cdda187280cdb0$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $a6cdda187280cdb0$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $a6cdda187280cdb0$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $a6cdda187280cdb0$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $a6cdda187280cdb0$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $a6cdda187280cdb0$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $a6cdda187280cdb0$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $a6cdda187280cdb0$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $a6cdda187280cdb0$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $a6cdda187280cdb0$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $a6cdda187280cdb0$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $a6cdda187280cdb0$var$getTargetInstForChangeEvent;
                else if ($a6cdda187280cdb0$var$isTextInputElement(reactName)) {
                    if ($a6cdda187280cdb0$var$isInputEventSupported) getTargetInstFunc = $a6cdda187280cdb0$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $a6cdda187280cdb0$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $a6cdda187280cdb0$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $a6cdda187280cdb0$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $a6cdda187280cdb0$var$getTargetInstForChangeEvent) : getTargetInstFunc = $a6cdda187280cdb0$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $a6cdda187280cdb0$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $a6cdda187280cdb0$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $a6cdda187280cdb0$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($a6cdda187280cdb0$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $a6cdda187280cdb0$var$activeElement = handleEventFunc, $a6cdda187280cdb0$var$activeElementInst = targetInst, $a6cdda187280cdb0$var$lastSelection = null;
                    break;
                case "focusout":
                    $a6cdda187280cdb0$var$lastSelection = $a6cdda187280cdb0$var$activeElementInst = $a6cdda187280cdb0$var$activeElement = null;
                    break;
                case "mousedown":
                    $a6cdda187280cdb0$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $a6cdda187280cdb0$var$mouseDown = !1;
                    $a6cdda187280cdb0$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($a6cdda187280cdb0$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $a6cdda187280cdb0$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($a6cdda187280cdb0$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $a6cdda187280cdb0$var$isComposing ? $a6cdda187280cdb0$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($a6cdda187280cdb0$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($a6cdda187280cdb0$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $a6cdda187280cdb0$var$isComposing && (fallbackData = $a6cdda187280cdb0$var$getData()) : ($a6cdda187280cdb0$var$root = nativeEventTarget, $a6cdda187280cdb0$var$startText = "value" in $a6cdda187280cdb0$var$root ? $a6cdda187280cdb0$var$root.value : $a6cdda187280cdb0$var$root.textContent, $a6cdda187280cdb0$var$isComposing = !0)), handleEventFunc = $a6cdda187280cdb0$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $a6cdda187280cdb0$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $a6cdda187280cdb0$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $a6cdda187280cdb0$var$canUseTextInputEvent ? $a6cdda187280cdb0$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $a6cdda187280cdb0$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $a6cdda187280cdb0$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $a6cdda187280cdb0$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $a6cdda187280cdb0$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $a6cdda187280cdb0$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $a6cdda187280cdb0$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $a6cdda187280cdb0$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $a6cdda187280cdb0$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($a6cdda187280cdb0$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $a6cdda187280cdb0$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($a6cdda187280cdb0$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $a6cdda187280cdb0$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $a6cdda187280cdb0$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $a6cdda187280cdb0$var$getListener(target, registrationName), null != stateNode && listeners.unshift($a6cdda187280cdb0$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $a6cdda187280cdb0$var$getListener(target, registrationName), null != stateNode && listeners.push($a6cdda187280cdb0$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $a6cdda187280cdb0$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $a6cdda187280cdb0$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $a6cdda187280cdb0$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($a6cdda187280cdb0$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($a6cdda187280cdb0$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $a6cdda187280cdb0$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $a6cdda187280cdb0$var$normalizeMarkupForTextOrAttribute(clientText);
    return $a6cdda187280cdb0$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $a6cdda187280cdb0$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $a6cdda187280cdb0$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $a6cdda187280cdb0$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $a6cdda187280cdb0$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $a6cdda187280cdb0$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $a6cdda187280cdb0$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $a6cdda187280cdb0$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $a6cdda187280cdb0$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $a6cdda187280cdb0$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $a6cdda187280cdb0$var$setProp(domElement, tag, "name", props.name, props, null), $a6cdda187280cdb0$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $a6cdda187280cdb0$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $a6cdda187280cdb0$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($a6cdda187280cdb0$var$setProp(domElement, tag, "encType", props.encType, props, null), $a6cdda187280cdb0$var$setProp(domElement, tag, "method", props.method, props, null), $a6cdda187280cdb0$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $a6cdda187280cdb0$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $a6cdda187280cdb0$var$noop$1);
            break;
        case "onScroll":
            null != value && $a6cdda187280cdb0$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $a6cdda187280cdb0$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $a6cdda187280cdb0$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("toggle", domElement);
            $a6cdda187280cdb0$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $a6cdda187280cdb0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $a6cdda187280cdb0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $a6cdda187280cdb0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $a6cdda187280cdb0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $a6cdda187280cdb0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $a6cdda187280cdb0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $a6cdda187280cdb0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $a6cdda187280cdb0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $a6cdda187280cdb0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $a6cdda187280cdb0$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $a6cdda187280cdb0$var$aliases.get(key) || key, $a6cdda187280cdb0$var$setValueForAttribute(domElement, key, value);
    }
}
function $a6cdda187280cdb0$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $a6cdda187280cdb0$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $a6cdda187280cdb0$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $a6cdda187280cdb0$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $a6cdda187280cdb0$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $a6cdda187280cdb0$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $a6cdda187280cdb0$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$a6cdda187280cdb0$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$a6cdda187280cdb0$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $a6cdda187280cdb0$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $a6cdda187280cdb0$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("error", domElement);
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(137, tag));
                    default:
                        $a6cdda187280cdb0$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $a6cdda187280cdb0$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $a6cdda187280cdb0$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $a6cdda187280cdb0$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $a6cdda187280cdb0$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $a6cdda187280cdb0$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $a6cdda187280cdb0$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $a6cdda187280cdb0$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(91));
                    break;
                default:
                    $a6cdda187280cdb0$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $a6cdda187280cdb0$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $a6cdda187280cdb0$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("toggle", domElement);
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("cancel", domElement);
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $a6cdda187280cdb0$var$mediaEventTypes.length; hasSrc++)$a6cdda187280cdb0$var$listenToNonDelegatedEvent($a6cdda187280cdb0$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("error", domElement);
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $a6cdda187280cdb0$var$listenToNonDelegatedEvent("error", domElement), $a6cdda187280cdb0$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(137, tag));
                default:
                    $a6cdda187280cdb0$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($a6cdda187280cdb0$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $a6cdda187280cdb0$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $a6cdda187280cdb0$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $a6cdda187280cdb0$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $a6cdda187280cdb0$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $a6cdda187280cdb0$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $a6cdda187280cdb0$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $a6cdda187280cdb0$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $a6cdda187280cdb0$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $a6cdda187280cdb0$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $a6cdda187280cdb0$var$updateOptions(domElement, !!lastProps, tag, !0) : $a6cdda187280cdb0$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $a6cdda187280cdb0$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $a6cdda187280cdb0$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $a6cdda187280cdb0$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $a6cdda187280cdb0$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $a6cdda187280cdb0$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $a6cdda187280cdb0$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $a6cdda187280cdb0$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($a6cdda187280cdb0$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $a6cdda187280cdb0$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $a6cdda187280cdb0$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $a6cdda187280cdb0$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $a6cdda187280cdb0$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $a6cdda187280cdb0$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $a6cdda187280cdb0$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $a6cdda187280cdb0$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $a6cdda187280cdb0$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $a6cdda187280cdb0$var$eventsEnabled = null, $a6cdda187280cdb0$var$selectionInformation = null;
function $a6cdda187280cdb0$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $a6cdda187280cdb0$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $a6cdda187280cdb0$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $a6cdda187280cdb0$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $a6cdda187280cdb0$var$currentPopstateTransitionEvent = null;
function $a6cdda187280cdb0$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $a6cdda187280cdb0$var$currentPopstateTransitionEvent) return !1;
        $a6cdda187280cdb0$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $a6cdda187280cdb0$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $a6cdda187280cdb0$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $a6cdda187280cdb0$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $a6cdda187280cdb0$var$localPromise = "function" === typeof Promise ? Promise : void 0, $a6cdda187280cdb0$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $a6cdda187280cdb0$var$localPromise ? function(callback) {
    return $a6cdda187280cdb0$var$localPromise.resolve(null).then(callback).catch($a6cdda187280cdb0$var$handleErrorInNextTick);
} : $a6cdda187280cdb0$var$scheduleTimeout;
function $a6cdda187280cdb0$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $a6cdda187280cdb0$var$isSingletonScope(type) {
    return "head" === type;
}
function $a6cdda187280cdb0$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $a6cdda187280cdb0$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $a6cdda187280cdb0$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $a6cdda187280cdb0$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$a6cdda187280cdb0$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $a6cdda187280cdb0$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $a6cdda187280cdb0$var$retryIfBlockedOn(hydrationInstance);
}
function $a6cdda187280cdb0$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $a6cdda187280cdb0$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $a6cdda187280cdb0$var$clearContainerSparingly(node);
                $a6cdda187280cdb0$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $a6cdda187280cdb0$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$a6cdda187280cdb0$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $a6cdda187280cdb0$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $a6cdda187280cdb0$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $a6cdda187280cdb0$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $a6cdda187280cdb0$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $a6cdda187280cdb0$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $a6cdda187280cdb0$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $a6cdda187280cdb0$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $a6cdda187280cdb0$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $a6cdda187280cdb0$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $a6cdda187280cdb0$var$previousHydratableOnEnteringScopedSingleton = null;
function $a6cdda187280cdb0$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $a6cdda187280cdb0$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $a6cdda187280cdb0$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $a6cdda187280cdb0$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $a6cdda187280cdb0$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(451));
    }
}
function $a6cdda187280cdb0$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $a6cdda187280cdb0$var$detachDeletedInstance(instance);
}
var $a6cdda187280cdb0$var$preloadPropsMap = new Map(), $a6cdda187280cdb0$var$preconnectsSet = new Set();
function $a6cdda187280cdb0$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $a6cdda187280cdb0$var$previousDispatcher = $a6cdda187280cdb0$var$ReactDOMSharedInternals.d;
$a6cdda187280cdb0$var$ReactDOMSharedInternals.d = {
    f: $a6cdda187280cdb0$var$flushSyncWork,
    r: $a6cdda187280cdb0$var$requestFormReset,
    D: $a6cdda187280cdb0$var$prefetchDNS,
    C: $a6cdda187280cdb0$var$preconnect,
    L: $a6cdda187280cdb0$var$preload,
    m: $a6cdda187280cdb0$var$preloadModule,
    X: $a6cdda187280cdb0$var$preinitScript,
    S: $a6cdda187280cdb0$var$preinitStyle,
    M: $a6cdda187280cdb0$var$preinitModuleScript
};
function $a6cdda187280cdb0$var$flushSyncWork() {
    var previousWasRendering = $a6cdda187280cdb0$var$previousDispatcher.f(), wasRendering = $a6cdda187280cdb0$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $a6cdda187280cdb0$var$requestFormReset(form) {
    var formInst = $a6cdda187280cdb0$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $a6cdda187280cdb0$var$requestFormReset$1(formInst) : $a6cdda187280cdb0$var$previousDispatcher.r(form);
}
var $a6cdda187280cdb0$var$globalDocument = "undefined" === typeof document ? null : document;
function $a6cdda187280cdb0$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $a6cdda187280cdb0$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $a6cdda187280cdb0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $a6cdda187280cdb0$var$preconnectsSet.has(limitedEscapedHref) || ($a6cdda187280cdb0$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $a6cdda187280cdb0$var$setInitialProperties(href, "link", rel), $a6cdda187280cdb0$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $a6cdda187280cdb0$var$prefetchDNS(href) {
    $a6cdda187280cdb0$var$previousDispatcher.D(href);
    $a6cdda187280cdb0$var$preconnectAs("dns-prefetch", href, null);
}
function $a6cdda187280cdb0$var$preconnect(href, crossOrigin) {
    $a6cdda187280cdb0$var$previousDispatcher.C(href, crossOrigin);
    $a6cdda187280cdb0$var$preconnectAs("preconnect", href, crossOrigin);
}
function $a6cdda187280cdb0$var$preload(href, as, options) {
    $a6cdda187280cdb0$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $a6cdda187280cdb0$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $a6cdda187280cdb0$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $a6cdda187280cdb0$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $a6cdda187280cdb0$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $a6cdda187280cdb0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $a6cdda187280cdb0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $a6cdda187280cdb0$var$getStyleKey(href);
                break;
            case "script":
                key = $a6cdda187280cdb0$var$getScriptKey(href);
        }
        $a6cdda187280cdb0$var$preloadPropsMap.has(key) || (href = $a6cdda187280cdb0$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $a6cdda187280cdb0$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($a6cdda187280cdb0$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($a6cdda187280cdb0$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $a6cdda187280cdb0$var$setInitialProperties(as, "link", href), $a6cdda187280cdb0$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $a6cdda187280cdb0$var$preloadModule(href, options) {
    $a6cdda187280cdb0$var$previousDispatcher.m(href, options);
    var ownerDocument = $a6cdda187280cdb0$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $a6cdda187280cdb0$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $a6cdda187280cdb0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $a6cdda187280cdb0$var$getScriptKey(href);
        }
        if (!$a6cdda187280cdb0$var$preloadPropsMap.has(key) && (href = $a6cdda187280cdb0$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $a6cdda187280cdb0$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($a6cdda187280cdb0$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $a6cdda187280cdb0$var$setInitialProperties(as, "link", href);
            $a6cdda187280cdb0$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $a6cdda187280cdb0$var$preinitStyle(href, precedence, options) {
    $a6cdda187280cdb0$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $a6cdda187280cdb0$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $a6cdda187280cdb0$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $a6cdda187280cdb0$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($a6cdda187280cdb0$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $a6cdda187280cdb0$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $a6cdda187280cdb0$var$preloadPropsMap.get(key)) && $a6cdda187280cdb0$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $a6cdda187280cdb0$var$markNodeAsHoistable(link);
                $a6cdda187280cdb0$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $a6cdda187280cdb0$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $a6cdda187280cdb0$var$preinitScript(src, options) {
    $a6cdda187280cdb0$var$previousDispatcher.X(src, options);
    var ownerDocument = $a6cdda187280cdb0$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $a6cdda187280cdb0$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $a6cdda187280cdb0$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($a6cdda187280cdb0$var$getScriptSelectorFromKey(key)), resource || (src = $a6cdda187280cdb0$var$assign({
            src: src,
            async: !0
        }, options), (options = $a6cdda187280cdb0$var$preloadPropsMap.get(key)) && $a6cdda187280cdb0$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $a6cdda187280cdb0$var$markNodeAsHoistable(resource), $a6cdda187280cdb0$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $a6cdda187280cdb0$var$preinitModuleScript(src, options) {
    $a6cdda187280cdb0$var$previousDispatcher.M(src, options);
    var ownerDocument = $a6cdda187280cdb0$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $a6cdda187280cdb0$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $a6cdda187280cdb0$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($a6cdda187280cdb0$var$getScriptSelectorFromKey(key)), resource || (src = $a6cdda187280cdb0$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $a6cdda187280cdb0$var$preloadPropsMap.get(key)) && $a6cdda187280cdb0$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $a6cdda187280cdb0$var$markNodeAsHoistable(resource), $a6cdda187280cdb0$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $a6cdda187280cdb0$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $a6cdda187280cdb0$var$rootInstanceStackCursor.current) ? $a6cdda187280cdb0$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $a6cdda187280cdb0$var$getStyleKey(pendingProps.href), pendingProps = $a6cdda187280cdb0$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $a6cdda187280cdb0$var$getStyleKey(pendingProps.href);
                var styles$243 = $a6cdda187280cdb0$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($a6cdda187280cdb0$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $a6cdda187280cdb0$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $a6cdda187280cdb0$var$preloadPropsMap.set(type, pendingProps), styles$243 || $a6cdda187280cdb0$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $a6cdda187280cdb0$var$getScriptKey(pendingProps), pendingProps = $a6cdda187280cdb0$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(444, type));
    }
}
function $a6cdda187280cdb0$var$getStyleKey(href) {
    return 'href="' + $a6cdda187280cdb0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $a6cdda187280cdb0$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $a6cdda187280cdb0$var$stylesheetPropsFromRawProps(rawProps) {
    return $a6cdda187280cdb0$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $a6cdda187280cdb0$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $a6cdda187280cdb0$var$setInitialProperties(key, "link", preloadProps), $a6cdda187280cdb0$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $a6cdda187280cdb0$var$getScriptKey(src) {
    return '[src="' + $a6cdda187280cdb0$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $a6cdda187280cdb0$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $a6cdda187280cdb0$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $a6cdda187280cdb0$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $a6cdda187280cdb0$var$markNodeAsHoistable(instance), instance;
            var styleProps = $a6cdda187280cdb0$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $a6cdda187280cdb0$var$markNodeAsHoistable(instance);
            $a6cdda187280cdb0$var$setInitialProperties(instance, "style", styleProps);
            $a6cdda187280cdb0$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $a6cdda187280cdb0$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($a6cdda187280cdb0$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $a6cdda187280cdb0$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $a6cdda187280cdb0$var$stylesheetPropsFromRawProps(props);
            (styleProps = $a6cdda187280cdb0$var$preloadPropsMap.get(styleProps)) && $a6cdda187280cdb0$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $a6cdda187280cdb0$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $a6cdda187280cdb0$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $a6cdda187280cdb0$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $a6cdda187280cdb0$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($a6cdda187280cdb0$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $a6cdda187280cdb0$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $a6cdda187280cdb0$var$preloadPropsMap.get(instance$249)) instance = $a6cdda187280cdb0$var$assign({}, props), $a6cdda187280cdb0$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $a6cdda187280cdb0$var$markNodeAsHoistable(styleProps);
            $a6cdda187280cdb0$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $a6cdda187280cdb0$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $a6cdda187280cdb0$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $a6cdda187280cdb0$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $a6cdda187280cdb0$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $a6cdda187280cdb0$var$tagCaches = null;
function $a6cdda187280cdb0$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $a6cdda187280cdb0$var$tagCaches) {
        var cache = new Map();
        var caches = $a6cdda187280cdb0$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $a6cdda187280cdb0$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$a6cdda187280cdb0$var$internalHoistableMarker] || node[$a6cdda187280cdb0$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $a6cdda187280cdb0$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $a6cdda187280cdb0$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $a6cdda187280cdb0$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $a6cdda187280cdb0$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $a6cdda187280cdb0$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($a6cdda187280cdb0$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $a6cdda187280cdb0$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $a6cdda187280cdb0$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $a6cdda187280cdb0$var$stylesheetPropsFromRawProps(props);
            (key = $a6cdda187280cdb0$var$preloadPropsMap.get(key)) && $a6cdda187280cdb0$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $a6cdda187280cdb0$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $a6cdda187280cdb0$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $a6cdda187280cdb0$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $a6cdda187280cdb0$var$estimatedBytesWithinLimit = 0;
function $a6cdda187280cdb0$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $a6cdda187280cdb0$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $a6cdda187280cdb0$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $a6cdda187280cdb0$var$estimatedBytesWithinLimit && ($a6cdda187280cdb0$var$estimatedBytesWithinLimit = 62500 * $a6cdda187280cdb0$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $a6cdda187280cdb0$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $a6cdda187280cdb0$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $a6cdda187280cdb0$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $a6cdda187280cdb0$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $a6cdda187280cdb0$var$precedencesByRoot = null;
function $a6cdda187280cdb0$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $a6cdda187280cdb0$var$precedencesByRoot = new Map(), resources.forEach($a6cdda187280cdb0$var$insertStylesheetIntoRoot, state), $a6cdda187280cdb0$var$precedencesByRoot = null, $a6cdda187280cdb0$var$onUnsuspend.call(state));
}
function $a6cdda187280cdb0$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $a6cdda187280cdb0$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $a6cdda187280cdb0$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $a6cdda187280cdb0$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $a6cdda187280cdb0$var$HostTransitionContext = {
    $$typeof: $a6cdda187280cdb0$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $a6cdda187280cdb0$var$sharedNotPendingObject,
    _currentValue2: $a6cdda187280cdb0$var$sharedNotPendingObject,
    _threadCount: 0
};
function $a6cdda187280cdb0$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $a6cdda187280cdb0$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $a6cdda187280cdb0$var$createLaneMap(0);
    this.hiddenUpdates = $a6cdda187280cdb0$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $a6cdda187280cdb0$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $a6cdda187280cdb0$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $a6cdda187280cdb0$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $a6cdda187280cdb0$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $a6cdda187280cdb0$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $a6cdda187280cdb0$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $a6cdda187280cdb0$var$emptyContextObject;
    parentComponent = $a6cdda187280cdb0$var$emptyContextObject;
    return parentComponent;
}
function $a6cdda187280cdb0$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $a6cdda187280cdb0$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $a6cdda187280cdb0$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $a6cdda187280cdb0$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($a6cdda187280cdb0$var$scheduleUpdateOnFiber(element, rootFiber, lane), $a6cdda187280cdb0$var$entangleTransitions(element, rootFiber, lane));
}
function $a6cdda187280cdb0$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $a6cdda187280cdb0$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $a6cdda187280cdb0$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $a6cdda187280cdb0$var$markRetryLaneImpl(fiber, retryLane);
}
function $a6cdda187280cdb0$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $a6cdda187280cdb0$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $a6cdda187280cdb0$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $a6cdda187280cdb0$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $a6cdda187280cdb0$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $a6cdda187280cdb0$var$requestUpdateLane();
        lane = $a6cdda187280cdb0$var$getBumpedLaneForHydrationByLane(lane);
        var root = $a6cdda187280cdb0$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $a6cdda187280cdb0$var$scheduleUpdateOnFiber(root, fiber, lane);
        $a6cdda187280cdb0$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $a6cdda187280cdb0$var$_enabled = !0;
function $a6cdda187280cdb0$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $a6cdda187280cdb0$var$ReactSharedInternals.T;
    $a6cdda187280cdb0$var$ReactSharedInternals.T = null;
    var previousPriority = $a6cdda187280cdb0$var$ReactDOMSharedInternals.p;
    try {
        $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = 2, $a6cdda187280cdb0$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = previousPriority, $a6cdda187280cdb0$var$ReactSharedInternals.T = prevTransition;
    }
}
function $a6cdda187280cdb0$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $a6cdda187280cdb0$var$ReactSharedInternals.T;
    $a6cdda187280cdb0$var$ReactSharedInternals.T = null;
    var previousPriority = $a6cdda187280cdb0$var$ReactDOMSharedInternals.p;
    try {
        $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = 8, $a6cdda187280cdb0$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $a6cdda187280cdb0$var$ReactDOMSharedInternals.p = previousPriority, $a6cdda187280cdb0$var$ReactSharedInternals.T = prevTransition;
    }
}
function $a6cdda187280cdb0$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($a6cdda187280cdb0$var$_enabled) {
        var blockedOn = $a6cdda187280cdb0$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $a6cdda187280cdb0$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $a6cdda187280cdb0$var$return_targetInst, targetContainer), $a6cdda187280cdb0$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($a6cdda187280cdb0$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($a6cdda187280cdb0$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $a6cdda187280cdb0$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $a6cdda187280cdb0$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $a6cdda187280cdb0$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $a6cdda187280cdb0$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $a6cdda187280cdb0$var$ensureRootIsScheduled(fiber);
                                0 === ($a6cdda187280cdb0$var$executionContext & 6) && ($a6cdda187280cdb0$var$workInProgressRootRenderTargetTime = $a6cdda187280cdb0$var$now() + 500, $a6cdda187280cdb0$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $a6cdda187280cdb0$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $a6cdda187280cdb0$var$scheduleUpdateOnFiber(root, fiber, 2), $a6cdda187280cdb0$var$flushSyncWork$1(), $a6cdda187280cdb0$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $a6cdda187280cdb0$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $a6cdda187280cdb0$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $a6cdda187280cdb0$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $a6cdda187280cdb0$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $a6cdda187280cdb0$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $a6cdda187280cdb0$var$getEventTarget(nativeEvent);
    return $a6cdda187280cdb0$var$findInstanceBlockingTarget(nativeEvent);
}
var $a6cdda187280cdb0$var$return_targetInst = null;
function $a6cdda187280cdb0$var$findInstanceBlockingTarget(targetNode) {
    $a6cdda187280cdb0$var$return_targetInst = null;
    targetNode = $a6cdda187280cdb0$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $a6cdda187280cdb0$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $a6cdda187280cdb0$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $a6cdda187280cdb0$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $a6cdda187280cdb0$var$return_targetInst = targetNode;
    return null;
}
function $a6cdda187280cdb0$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($a6cdda187280cdb0$var$getCurrentPriorityLevel()){
                case $a6cdda187280cdb0$var$ImmediatePriority:
                    return 2;
                case $a6cdda187280cdb0$var$UserBlockingPriority:
                    return 8;
                case $a6cdda187280cdb0$var$NormalPriority$1:
                case $a6cdda187280cdb0$var$LowPriority:
                    return 32;
                case $a6cdda187280cdb0$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $a6cdda187280cdb0$var$hasScheduledReplayAttempt = !1, $a6cdda187280cdb0$var$queuedFocus = null, $a6cdda187280cdb0$var$queuedDrag = null, $a6cdda187280cdb0$var$queuedMouse = null, $a6cdda187280cdb0$var$queuedPointers = new Map(), $a6cdda187280cdb0$var$queuedPointerCaptures = new Map(), $a6cdda187280cdb0$var$queuedExplicitHydrationTargets = [], $a6cdda187280cdb0$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $a6cdda187280cdb0$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $a6cdda187280cdb0$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $a6cdda187280cdb0$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $a6cdda187280cdb0$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $a6cdda187280cdb0$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $a6cdda187280cdb0$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $a6cdda187280cdb0$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $a6cdda187280cdb0$var$getInstanceFromNode(blockedOn), null !== blockedOn && $a6cdda187280cdb0$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $a6cdda187280cdb0$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $a6cdda187280cdb0$var$queuedFocus = $a6cdda187280cdb0$var$accumulateOrCreateContinuousQueuedReplayableEvent($a6cdda187280cdb0$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $a6cdda187280cdb0$var$queuedDrag = $a6cdda187280cdb0$var$accumulateOrCreateContinuousQueuedReplayableEvent($a6cdda187280cdb0$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $a6cdda187280cdb0$var$queuedMouse = $a6cdda187280cdb0$var$accumulateOrCreateContinuousQueuedReplayableEvent($a6cdda187280cdb0$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $a6cdda187280cdb0$var$queuedPointers.set(pointerId, $a6cdda187280cdb0$var$accumulateOrCreateContinuousQueuedReplayableEvent($a6cdda187280cdb0$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $a6cdda187280cdb0$var$queuedPointerCaptures.set(pointerId, $a6cdda187280cdb0$var$accumulateOrCreateContinuousQueuedReplayableEvent($a6cdda187280cdb0$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $a6cdda187280cdb0$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $a6cdda187280cdb0$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $a6cdda187280cdb0$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $a6cdda187280cdb0$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $a6cdda187280cdb0$var$runWithPriority(queuedTarget.priority, function() {
                        $a6cdda187280cdb0$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $a6cdda187280cdb0$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $a6cdda187280cdb0$var$runWithPriority(queuedTarget.priority, function() {
                        $a6cdda187280cdb0$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $a6cdda187280cdb0$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $a6cdda187280cdb0$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $a6cdda187280cdb0$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $a6cdda187280cdb0$var$currentReplayingEvent = null;
        } else return targetContainers = $a6cdda187280cdb0$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $a6cdda187280cdb0$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $a6cdda187280cdb0$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $a6cdda187280cdb0$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $a6cdda187280cdb0$var$replayUnblockedEvents() {
    $a6cdda187280cdb0$var$hasScheduledReplayAttempt = !1;
    null !== $a6cdda187280cdb0$var$queuedFocus && $a6cdda187280cdb0$var$attemptReplayContinuousQueuedEvent($a6cdda187280cdb0$var$queuedFocus) && ($a6cdda187280cdb0$var$queuedFocus = null);
    null !== $a6cdda187280cdb0$var$queuedDrag && $a6cdda187280cdb0$var$attemptReplayContinuousQueuedEvent($a6cdda187280cdb0$var$queuedDrag) && ($a6cdda187280cdb0$var$queuedDrag = null);
    null !== $a6cdda187280cdb0$var$queuedMouse && $a6cdda187280cdb0$var$attemptReplayContinuousQueuedEvent($a6cdda187280cdb0$var$queuedMouse) && ($a6cdda187280cdb0$var$queuedMouse = null);
    $a6cdda187280cdb0$var$queuedPointers.forEach($a6cdda187280cdb0$var$attemptReplayContinuousQueuedEventInMap);
    $a6cdda187280cdb0$var$queuedPointerCaptures.forEach($a6cdda187280cdb0$var$attemptReplayContinuousQueuedEventInMap);
}
function $a6cdda187280cdb0$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $a6cdda187280cdb0$var$hasScheduledReplayAttempt || ($a6cdda187280cdb0$var$hasScheduledReplayAttempt = !0, $a7qGw.unstable_scheduleCallback($a7qGw.unstable_NormalPriority, $a6cdda187280cdb0$var$replayUnblockedEvents)));
}
var $a6cdda187280cdb0$var$lastScheduledReplayQueue = null;
function $a6cdda187280cdb0$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $a6cdda187280cdb0$var$lastScheduledReplayQueue !== formReplayingQueue && ($a6cdda187280cdb0$var$lastScheduledReplayQueue = formReplayingQueue, $a7qGw.unstable_scheduleCallback($a7qGw.unstable_NormalPriority, function() {
        $a6cdda187280cdb0$var$lastScheduledReplayQueue === formReplayingQueue && ($a6cdda187280cdb0$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $a6cdda187280cdb0$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $a6cdda187280cdb0$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $a6cdda187280cdb0$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $a6cdda187280cdb0$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $a6cdda187280cdb0$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $a6cdda187280cdb0$var$queuedFocus && $a6cdda187280cdb0$var$scheduleCallbackIfUnblocked($a6cdda187280cdb0$var$queuedFocus, unblocked);
    null !== $a6cdda187280cdb0$var$queuedDrag && $a6cdda187280cdb0$var$scheduleCallbackIfUnblocked($a6cdda187280cdb0$var$queuedDrag, unblocked);
    null !== $a6cdda187280cdb0$var$queuedMouse && $a6cdda187280cdb0$var$scheduleCallbackIfUnblocked($a6cdda187280cdb0$var$queuedMouse, unblocked);
    $a6cdda187280cdb0$var$queuedPointers.forEach(unblock);
    $a6cdda187280cdb0$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $a6cdda187280cdb0$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $a6cdda187280cdb0$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $a6cdda187280cdb0$var$queuedExplicitHydrationTargets.length && (i = $a6cdda187280cdb0$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$a6cdda187280cdb0$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $a6cdda187280cdb0$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$a6cdda187280cdb0$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $a6cdda187280cdb0$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$a6cdda187280cdb0$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $a6cdda187280cdb0$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $a6cdda187280cdb0$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $a6cdda187280cdb0$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $a6cdda187280cdb0$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$a6cdda187280cdb0$var$ReactDOMHydrationRoot.prototype.render = $a6cdda187280cdb0$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(409));
    var current = root.current, lane = $a6cdda187280cdb0$var$requestUpdateLane();
    $a6cdda187280cdb0$var$updateContainerImpl(current, lane, children, root, null, null);
};
$a6cdda187280cdb0$var$ReactDOMHydrationRoot.prototype.unmount = $a6cdda187280cdb0$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $a6cdda187280cdb0$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $a6cdda187280cdb0$var$flushSyncWork$1();
        container[$a6cdda187280cdb0$var$internalContainerInstanceKey] = null;
    }
};
function $a6cdda187280cdb0$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$a6cdda187280cdb0$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $a6cdda187280cdb0$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $a6cdda187280cdb0$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $a6cdda187280cdb0$var$queuedExplicitHydrationTargets[i].priority; i++);
        $a6cdda187280cdb0$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $a6cdda187280cdb0$var$attemptExplicitHydrationTarget(target);
    }
};
var $a6cdda187280cdb0$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $dSwpL.version;
if ("19.2.4" !== $a6cdda187280cdb0$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(527, $a6cdda187280cdb0$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$a6cdda187280cdb0$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $a6cdda187280cdb0$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $a6cdda187280cdb0$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $a6cdda187280cdb0$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $a6cdda187280cdb0$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $a6cdda187280cdb0$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$a6cdda187280cdb0$var$hook$jscomp$inline_2348.isDisabled && $a6cdda187280cdb0$var$hook$jscomp$inline_2348.supportsFiber) try {
        $a6cdda187280cdb0$var$rendererID = $a6cdda187280cdb0$var$hook$jscomp$inline_2348.inject($a6cdda187280cdb0$var$internals$jscomp$inline_2347), $a6cdda187280cdb0$var$injectedHook = $a6cdda187280cdb0$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$a6cdda187280cdb0$export$882461b6382ed46c = function(container, options) {
    if (!$a6cdda187280cdb0$var$isValidContainer(container)) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $a6cdda187280cdb0$var$defaultOnUncaughtError, onCaughtError = $a6cdda187280cdb0$var$defaultOnCaughtError, onRecoverableError = $a6cdda187280cdb0$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $a6cdda187280cdb0$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $a6cdda187280cdb0$var$defaultOnDefaultTransitionIndicator);
    container[$a6cdda187280cdb0$var$internalContainerInstanceKey] = options.current;
    $a6cdda187280cdb0$var$listenToAllSupportedEvents(container);
    return new $a6cdda187280cdb0$var$ReactDOMRoot(options);
};
$a6cdda187280cdb0$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$a6cdda187280cdb0$var$isValidContainer(container)) throw Error($a6cdda187280cdb0$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $a6cdda187280cdb0$var$defaultOnUncaughtError, onCaughtError = $a6cdda187280cdb0$var$defaultOnCaughtError, onRecoverableError = $a6cdda187280cdb0$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $a6cdda187280cdb0$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $a6cdda187280cdb0$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $a6cdda187280cdb0$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $a6cdda187280cdb0$var$requestUpdateLane();
    isStrictMode = $a6cdda187280cdb0$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $a6cdda187280cdb0$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $a6cdda187280cdb0$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $a6cdda187280cdb0$var$markRootUpdated$1(initialChildren, options);
    $a6cdda187280cdb0$var$ensureRootIsScheduled(initialChildren);
    container[$a6cdda187280cdb0$var$internalContainerInstanceKey] = initialChildren.current;
    $a6cdda187280cdb0$var$listenToAllSupportedEvents(container);
    return new $a6cdda187280cdb0$var$ReactDOMHydrationRoot(initialChildren);
};
$a6cdda187280cdb0$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("a7qGw", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3KdLT"));

});
parcelRegister("3KdLT", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $2ba059b53e9fa30d$export$c4744153514ff05d; }, function (v) { return $2ba059b53e9fa30d$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $2ba059b53e9fa30d$export$3e506c1ccc9cc1a7; }, function (v) { return $2ba059b53e9fa30d$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $2ba059b53e9fa30d$export$e26fe2ed2fa76875; }, function (v) { return $2ba059b53e9fa30d$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $2ba059b53e9fa30d$export$502329bbf4b505b1; }, function (v) { return $2ba059b53e9fa30d$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $2ba059b53e9fa30d$export$6e3807111c4874c4; }, function (v) { return $2ba059b53e9fa30d$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $2ba059b53e9fa30d$export$c27134553091fb3a; }, function (v) { return $2ba059b53e9fa30d$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $2ba059b53e9fa30d$export$33ee1acdc04fd2a2; }, function (v) { return $2ba059b53e9fa30d$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $2ba059b53e9fa30d$export$b00a404bbd5edef2; }, function (v) { return $2ba059b53e9fa30d$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $2ba059b53e9fa30d$export$d66a1c1c77bd778b; }, function (v) { return $2ba059b53e9fa30d$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $2ba059b53e9fa30d$export$d3dfb8e4810cb555; }, function (v) { return $2ba059b53e9fa30d$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $2ba059b53e9fa30d$export$72fdf0e06517287b; }, function (v) { return $2ba059b53e9fa30d$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $2ba059b53e9fa30d$export$816d2913ae6b83b1; }, function (v) { return $2ba059b53e9fa30d$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $2ba059b53e9fa30d$export$61bcfe829111a1d0; }, function (v) { return $2ba059b53e9fa30d$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $2ba059b53e9fa30d$export$7ee8c9beb337bc3f; }, function (v) { return $2ba059b53e9fa30d$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $2ba059b53e9fa30d$export$b5836b71941fa3ed; }, function (v) { return $2ba059b53e9fa30d$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $2ba059b53e9fa30d$export$cf845f2c119da08a; }, function (v) { return $2ba059b53e9fa30d$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2ba059b53e9fa30d$export$c4744153514ff05d;
var $2ba059b53e9fa30d$export$3e506c1ccc9cc1a7;
var $2ba059b53e9fa30d$export$e26fe2ed2fa76875;
var $2ba059b53e9fa30d$export$502329bbf4b505b1;
var $2ba059b53e9fa30d$export$6e3807111c4874c4;
var $2ba059b53e9fa30d$export$c27134553091fb3a;
var $2ba059b53e9fa30d$export$33ee1acdc04fd2a2;
var $2ba059b53e9fa30d$export$b00a404bbd5edef2;
var $2ba059b53e9fa30d$export$d66a1c1c77bd778b;
var $2ba059b53e9fa30d$export$d3dfb8e4810cb555;
var $2ba059b53e9fa30d$export$72fdf0e06517287b;
var $2ba059b53e9fa30d$export$816d2913ae6b83b1;
var $2ba059b53e9fa30d$export$61bcfe829111a1d0;
var $2ba059b53e9fa30d$export$7ee8c9beb337bc3f;
var $2ba059b53e9fa30d$export$b5836b71941fa3ed;
var $2ba059b53e9fa30d$export$cf845f2c119da08a;
"use strict";
function $2ba059b53e9fa30d$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $2ba059b53e9fa30d$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $2ba059b53e9fa30d$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $2ba059b53e9fa30d$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $2ba059b53e9fa30d$var$compare(left, last)) rightIndex < length && 0 > $2ba059b53e9fa30d$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $2ba059b53e9fa30d$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $2ba059b53e9fa30d$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$2ba059b53e9fa30d$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $2ba059b53e9fa30d$var$localPerformance = performance;
    $2ba059b53e9fa30d$export$c4744153514ff05d = function() {
        return $2ba059b53e9fa30d$var$localPerformance.now();
    };
} else {
    var $2ba059b53e9fa30d$var$localDate = Date, $2ba059b53e9fa30d$var$initialTime = $2ba059b53e9fa30d$var$localDate.now();
    $2ba059b53e9fa30d$export$c4744153514ff05d = function() {
        return $2ba059b53e9fa30d$var$localDate.now() - $2ba059b53e9fa30d$var$initialTime;
    };
}
var $2ba059b53e9fa30d$var$taskQueue = [], $2ba059b53e9fa30d$var$timerQueue = [], $2ba059b53e9fa30d$var$taskIdCounter = 1, $2ba059b53e9fa30d$var$currentTask = null, $2ba059b53e9fa30d$var$currentPriorityLevel = 3, $2ba059b53e9fa30d$var$isPerformingWork = !1, $2ba059b53e9fa30d$var$isHostCallbackScheduled = !1, $2ba059b53e9fa30d$var$isHostTimeoutScheduled = !1, $2ba059b53e9fa30d$var$needsPaint = !1, $2ba059b53e9fa30d$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $2ba059b53e9fa30d$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $2ba059b53e9fa30d$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $2ba059b53e9fa30d$var$advanceTimers(currentTime) {
    for(var timer = $2ba059b53e9fa30d$var$peek($2ba059b53e9fa30d$var$timerQueue); null !== timer;){
        if (null === timer.callback) $2ba059b53e9fa30d$var$pop($2ba059b53e9fa30d$var$timerQueue);
        else if (timer.startTime <= currentTime) $2ba059b53e9fa30d$var$pop($2ba059b53e9fa30d$var$timerQueue), timer.sortIndex = timer.expirationTime, $2ba059b53e9fa30d$var$push($2ba059b53e9fa30d$var$taskQueue, timer);
        else break;
        timer = $2ba059b53e9fa30d$var$peek($2ba059b53e9fa30d$var$timerQueue);
    }
}
function $2ba059b53e9fa30d$var$handleTimeout(currentTime) {
    $2ba059b53e9fa30d$var$isHostTimeoutScheduled = !1;
    $2ba059b53e9fa30d$var$advanceTimers(currentTime);
    if (!$2ba059b53e9fa30d$var$isHostCallbackScheduled) {
        if (null !== $2ba059b53e9fa30d$var$peek($2ba059b53e9fa30d$var$taskQueue)) $2ba059b53e9fa30d$var$isHostCallbackScheduled = !0, $2ba059b53e9fa30d$var$isMessageLoopRunning || ($2ba059b53e9fa30d$var$isMessageLoopRunning = !0, $2ba059b53e9fa30d$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $2ba059b53e9fa30d$var$peek($2ba059b53e9fa30d$var$timerQueue);
            null !== firstTimer && $2ba059b53e9fa30d$var$requestHostTimeout($2ba059b53e9fa30d$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $2ba059b53e9fa30d$var$isMessageLoopRunning = !1, $2ba059b53e9fa30d$var$taskTimeoutID = -1, $2ba059b53e9fa30d$var$frameInterval = 5, $2ba059b53e9fa30d$var$startTime = -1;
function $2ba059b53e9fa30d$var$shouldYieldToHost() {
    return $2ba059b53e9fa30d$var$needsPaint ? !0 : $2ba059b53e9fa30d$export$c4744153514ff05d() - $2ba059b53e9fa30d$var$startTime < $2ba059b53e9fa30d$var$frameInterval ? !1 : !0;
}
function $2ba059b53e9fa30d$var$performWorkUntilDeadline() {
    $2ba059b53e9fa30d$var$needsPaint = !1;
    if ($2ba059b53e9fa30d$var$isMessageLoopRunning) {
        var currentTime = $2ba059b53e9fa30d$export$c4744153514ff05d();
        $2ba059b53e9fa30d$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $2ba059b53e9fa30d$var$isHostCallbackScheduled = !1;
                $2ba059b53e9fa30d$var$isHostTimeoutScheduled && ($2ba059b53e9fa30d$var$isHostTimeoutScheduled = !1, $2ba059b53e9fa30d$var$localClearTimeout($2ba059b53e9fa30d$var$taskTimeoutID), $2ba059b53e9fa30d$var$taskTimeoutID = -1);
                $2ba059b53e9fa30d$var$isPerformingWork = !0;
                var previousPriorityLevel = $2ba059b53e9fa30d$var$currentPriorityLevel;
                try {
                    b: {
                        $2ba059b53e9fa30d$var$advanceTimers(currentTime);
                        for($2ba059b53e9fa30d$var$currentTask = $2ba059b53e9fa30d$var$peek($2ba059b53e9fa30d$var$taskQueue); null !== $2ba059b53e9fa30d$var$currentTask && !($2ba059b53e9fa30d$var$currentTask.expirationTime > currentTime && $2ba059b53e9fa30d$var$shouldYieldToHost());){
                            var callback = $2ba059b53e9fa30d$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $2ba059b53e9fa30d$var$currentTask.callback = null;
                                $2ba059b53e9fa30d$var$currentPriorityLevel = $2ba059b53e9fa30d$var$currentTask.priorityLevel;
                                var continuationCallback = callback($2ba059b53e9fa30d$var$currentTask.expirationTime <= currentTime);
                                currentTime = $2ba059b53e9fa30d$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $2ba059b53e9fa30d$var$currentTask.callback = continuationCallback;
                                    $2ba059b53e9fa30d$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $2ba059b53e9fa30d$var$currentTask === $2ba059b53e9fa30d$var$peek($2ba059b53e9fa30d$var$taskQueue) && $2ba059b53e9fa30d$var$pop($2ba059b53e9fa30d$var$taskQueue);
                                $2ba059b53e9fa30d$var$advanceTimers(currentTime);
                            } else $2ba059b53e9fa30d$var$pop($2ba059b53e9fa30d$var$taskQueue);
                            $2ba059b53e9fa30d$var$currentTask = $2ba059b53e9fa30d$var$peek($2ba059b53e9fa30d$var$taskQueue);
                        }
                        if (null !== $2ba059b53e9fa30d$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $2ba059b53e9fa30d$var$peek($2ba059b53e9fa30d$var$timerQueue);
                            null !== firstTimer && $2ba059b53e9fa30d$var$requestHostTimeout($2ba059b53e9fa30d$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $2ba059b53e9fa30d$var$currentTask = null, $2ba059b53e9fa30d$var$currentPriorityLevel = previousPriorityLevel, $2ba059b53e9fa30d$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $2ba059b53e9fa30d$var$schedulePerformWorkUntilDeadline() : $2ba059b53e9fa30d$var$isMessageLoopRunning = !1;
        }
    }
}
var $2ba059b53e9fa30d$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $2ba059b53e9fa30d$var$localSetImmediate) $2ba059b53e9fa30d$var$schedulePerformWorkUntilDeadline = function() {
    $2ba059b53e9fa30d$var$localSetImmediate($2ba059b53e9fa30d$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $2ba059b53e9fa30d$var$channel = new MessageChannel(), $2ba059b53e9fa30d$var$port = $2ba059b53e9fa30d$var$channel.port2;
    $2ba059b53e9fa30d$var$channel.port1.onmessage = $2ba059b53e9fa30d$var$performWorkUntilDeadline;
    $2ba059b53e9fa30d$var$schedulePerformWorkUntilDeadline = function() {
        $2ba059b53e9fa30d$var$port.postMessage(null);
    };
} else $2ba059b53e9fa30d$var$schedulePerformWorkUntilDeadline = function() {
    $2ba059b53e9fa30d$var$localSetTimeout($2ba059b53e9fa30d$var$performWorkUntilDeadline, 0);
};
function $2ba059b53e9fa30d$var$requestHostTimeout(callback, ms) {
    $2ba059b53e9fa30d$var$taskTimeoutID = $2ba059b53e9fa30d$var$localSetTimeout(function() {
        callback($2ba059b53e9fa30d$export$c4744153514ff05d());
    }, ms);
}
$2ba059b53e9fa30d$export$3e506c1ccc9cc1a7 = 5;
$2ba059b53e9fa30d$export$e26fe2ed2fa76875 = 1;
$2ba059b53e9fa30d$export$502329bbf4b505b1 = 4;
$2ba059b53e9fa30d$export$6e3807111c4874c4 = 3;
$2ba059b53e9fa30d$export$c27134553091fb3a = null;
$2ba059b53e9fa30d$export$33ee1acdc04fd2a2 = 2;
$2ba059b53e9fa30d$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$2ba059b53e9fa30d$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $2ba059b53e9fa30d$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$2ba059b53e9fa30d$export$d3dfb8e4810cb555 = function() {
    return $2ba059b53e9fa30d$var$currentPriorityLevel;
};
$2ba059b53e9fa30d$export$72fdf0e06517287b = function(eventHandler) {
    switch($2ba059b53e9fa30d$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $2ba059b53e9fa30d$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $2ba059b53e9fa30d$var$currentPriorityLevel;
    $2ba059b53e9fa30d$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $2ba059b53e9fa30d$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$2ba059b53e9fa30d$export$816d2913ae6b83b1 = function() {
    $2ba059b53e9fa30d$var$needsPaint = !0;
};
$2ba059b53e9fa30d$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $2ba059b53e9fa30d$var$currentPriorityLevel;
    $2ba059b53e9fa30d$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $2ba059b53e9fa30d$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$2ba059b53e9fa30d$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $2ba059b53e9fa30d$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $2ba059b53e9fa30d$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $2ba059b53e9fa30d$var$push($2ba059b53e9fa30d$var$timerQueue, priorityLevel), null === $2ba059b53e9fa30d$var$peek($2ba059b53e9fa30d$var$taskQueue) && priorityLevel === $2ba059b53e9fa30d$var$peek($2ba059b53e9fa30d$var$timerQueue) && ($2ba059b53e9fa30d$var$isHostTimeoutScheduled ? ($2ba059b53e9fa30d$var$localClearTimeout($2ba059b53e9fa30d$var$taskTimeoutID), $2ba059b53e9fa30d$var$taskTimeoutID = -1) : $2ba059b53e9fa30d$var$isHostTimeoutScheduled = !0, $2ba059b53e9fa30d$var$requestHostTimeout($2ba059b53e9fa30d$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $2ba059b53e9fa30d$var$push($2ba059b53e9fa30d$var$taskQueue, priorityLevel), $2ba059b53e9fa30d$var$isHostCallbackScheduled || $2ba059b53e9fa30d$var$isPerformingWork || ($2ba059b53e9fa30d$var$isHostCallbackScheduled = !0, $2ba059b53e9fa30d$var$isMessageLoopRunning || ($2ba059b53e9fa30d$var$isMessageLoopRunning = !0, $2ba059b53e9fa30d$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$2ba059b53e9fa30d$export$b5836b71941fa3ed = $2ba059b53e9fa30d$var$shouldYieldToHost;
$2ba059b53e9fa30d$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $2ba059b53e9fa30d$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $2ba059b53e9fa30d$var$currentPriorityLevel;
        $2ba059b53e9fa30d$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $2ba059b53e9fa30d$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("dSwpL", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bYiAt"));

});
parcelRegister("bYiAt", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $8b73b759e6bd60a2$export$9c16c1426311996d; }, function (v) { return $8b73b759e6bd60a2$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $8b73b759e6bd60a2$export$dca3b0875bd9a954; }, function (v) { return $8b73b759e6bd60a2$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $8b73b759e6bd60a2$export$16fa2f45be04daa8; }, function (v) { return $8b73b759e6bd60a2$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $8b73b759e6bd60a2$export$ffb0004e005737fa; }, function (v) { return $8b73b759e6bd60a2$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $8b73b759e6bd60a2$export$e2c29f18771995cb; }, function (v) { return $8b73b759e6bd60a2$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $8b73b759e6bd60a2$export$221d75b3f55bb0bd; }, function (v) { return $8b73b759e6bd60a2$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8b73b759e6bd60a2$export$5f8d39834fd61797; }, function (v) { return $8b73b759e6bd60a2$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $8b73b759e6bd60a2$export$74bf444e3cd11ea5; }, function (v) { return $8b73b759e6bd60a2$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $8b73b759e6bd60a2$export$1ced07cd6b1985ce; }, function (v) { return $8b73b759e6bd60a2$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $8b73b759e6bd60a2$export$abd8e32b826d7ea7; }, function (v) { return $8b73b759e6bd60a2$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $8b73b759e6bd60a2$export$69a3209f1a06c04d; }, function (v) { return $8b73b759e6bd60a2$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $8b73b759e6bd60a2$export$8c538325882c7eec; }, function (v) { return $8b73b759e6bd60a2$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $8b73b759e6bd60a2$export$e530037191fcd5d7; }, function (v) { return $8b73b759e6bd60a2$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $8b73b759e6bd60a2$export$fd42f52fd3ae1109; }, function (v) { return $8b73b759e6bd60a2$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $8b73b759e6bd60a2$export$c8a8987d4410bf2d; }, function (v) { return $8b73b759e6bd60a2$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $8b73b759e6bd60a2$export$7d1e3a5e95ceca43; }, function (v) { return $8b73b759e6bd60a2$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $8b73b759e6bd60a2$export$257a8862b851cb5b; }, function (v) { return $8b73b759e6bd60a2$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $8b73b759e6bd60a2$export$a8257692ac88316c; }, function (v) { return $8b73b759e6bd60a2$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $8b73b759e6bd60a2$export$488013bae63b21da; }, function (v) { return $8b73b759e6bd60a2$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $8b73b759e6bd60a2$export$7c73462e0d25e514; }, function (v) { return $8b73b759e6bd60a2$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $8b73b759e6bd60a2$export$7568632d0d33d16d; }, function (v) { return $8b73b759e6bd60a2$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $8b73b759e6bd60a2$export$f93f40ac0ca7e3a8; }, function (v) { return $8b73b759e6bd60a2$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $8b73b759e6bd60a2$export$1f96ae73734a86cc; }, function (v) { return $8b73b759e6bd60a2$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $8b73b759e6bd60a2$export$9a47ced3238df325; }, function (v) { return $8b73b759e6bd60a2$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $8b73b759e6bd60a2$export$35808ee640e87ca7; }, function (v) { return $8b73b759e6bd60a2$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $8b73b759e6bd60a2$export$fae74005e78b1a27; }, function (v) { return $8b73b759e6bd60a2$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $8b73b759e6bd60a2$export$dc8fbce3eb94dc1e; }, function (v) { return $8b73b759e6bd60a2$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $8b73b759e6bd60a2$export$6a7bc4e911dc01cf; }, function (v) { return $8b73b759e6bd60a2$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $8b73b759e6bd60a2$export$6d9c69b0de29b591; }, function (v) { return $8b73b759e6bd60a2$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $8b73b759e6bd60a2$export$7f54fc3180508a52; }, function (v) { return $8b73b759e6bd60a2$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $8b73b759e6bd60a2$export$f680877a34711e37; }, function (v) { return $8b73b759e6bd60a2$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $8b73b759e6bd60a2$export$d5a552a76deda3c2; }, function (v) { return $8b73b759e6bd60a2$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $8b73b759e6bd60a2$export$aaabe4eda9ed9969; }, function (v) { return $8b73b759e6bd60a2$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $8b73b759e6bd60a2$export$e5c5a5f917a5871c; }, function (v) { return $8b73b759e6bd60a2$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $8b73b759e6bd60a2$export$1538c33de8887b59; }, function (v) { return $8b73b759e6bd60a2$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $8b73b759e6bd60a2$export$fca7f784ae7a249a; }, function (v) { return $8b73b759e6bd60a2$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $8b73b759e6bd60a2$export$13e3392192263954; }, function (v) { return $8b73b759e6bd60a2$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $8b73b759e6bd60a2$export$b8f5890fc79d6aca; }, function (v) { return $8b73b759e6bd60a2$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $8b73b759e6bd60a2$export$60241385465d0a34; }, function (v) { return $8b73b759e6bd60a2$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $8b73b759e6bd60a2$export$306c0aa65ff9ec16; }, function (v) { return $8b73b759e6bd60a2$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $8b73b759e6bd60a2$export$7b286972b8d8ccbf; }, function (v) { return $8b73b759e6bd60a2$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $8b73b759e6bd60a2$export$83d89fbfd8236492; }, function (v) { return $8b73b759e6bd60a2$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8b73b759e6bd60a2$export$9c16c1426311996d;
var $8b73b759e6bd60a2$export$dca3b0875bd9a954;
var $8b73b759e6bd60a2$export$16fa2f45be04daa8;
var $8b73b759e6bd60a2$export$ffb0004e005737fa;
var $8b73b759e6bd60a2$export$e2c29f18771995cb;
var $8b73b759e6bd60a2$export$221d75b3f55bb0bd;
var $8b73b759e6bd60a2$export$5f8d39834fd61797;
var $8b73b759e6bd60a2$export$74bf444e3cd11ea5;
var $8b73b759e6bd60a2$export$1ced07cd6b1985ce;
var $8b73b759e6bd60a2$export$abd8e32b826d7ea7;
var $8b73b759e6bd60a2$export$69a3209f1a06c04d;
var $8b73b759e6bd60a2$export$8c538325882c7eec;
var $8b73b759e6bd60a2$export$e530037191fcd5d7;
var $8b73b759e6bd60a2$export$fd42f52fd3ae1109;
var $8b73b759e6bd60a2$export$c8a8987d4410bf2d;
var $8b73b759e6bd60a2$export$7d1e3a5e95ceca43;
var $8b73b759e6bd60a2$export$257a8862b851cb5b;
var $8b73b759e6bd60a2$export$a8257692ac88316c;
var $8b73b759e6bd60a2$export$488013bae63b21da;
var $8b73b759e6bd60a2$export$7c73462e0d25e514;
var $8b73b759e6bd60a2$export$7568632d0d33d16d;
var $8b73b759e6bd60a2$export$f93f40ac0ca7e3a8;
var $8b73b759e6bd60a2$export$1f96ae73734a86cc;
var $8b73b759e6bd60a2$export$9a47ced3238df325;
var $8b73b759e6bd60a2$export$35808ee640e87ca7;
var $8b73b759e6bd60a2$export$fae74005e78b1a27;
var $8b73b759e6bd60a2$export$dc8fbce3eb94dc1e;
var $8b73b759e6bd60a2$export$6a7bc4e911dc01cf;
var $8b73b759e6bd60a2$export$6d9c69b0de29b591;
var $8b73b759e6bd60a2$export$7f54fc3180508a52;
var $8b73b759e6bd60a2$export$f680877a34711e37;
var $8b73b759e6bd60a2$export$d5a552a76deda3c2;
var $8b73b759e6bd60a2$export$aaabe4eda9ed9969;
var $8b73b759e6bd60a2$export$e5c5a5f917a5871c;
var $8b73b759e6bd60a2$export$1538c33de8887b59;
var $8b73b759e6bd60a2$export$fca7f784ae7a249a;
var $8b73b759e6bd60a2$export$13e3392192263954;
var $8b73b759e6bd60a2$export$b8f5890fc79d6aca;
var $8b73b759e6bd60a2$export$60241385465d0a34;
var $8b73b759e6bd60a2$export$306c0aa65ff9ec16;
var $8b73b759e6bd60a2$export$7b286972b8d8ccbf;
var $8b73b759e6bd60a2$export$83d89fbfd8236492;
"use strict";
var $8b73b759e6bd60a2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $8b73b759e6bd60a2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $8b73b759e6bd60a2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $8b73b759e6bd60a2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $8b73b759e6bd60a2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $8b73b759e6bd60a2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $8b73b759e6bd60a2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $8b73b759e6bd60a2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $8b73b759e6bd60a2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $8b73b759e6bd60a2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $8b73b759e6bd60a2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $8b73b759e6bd60a2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $8b73b759e6bd60a2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $8b73b759e6bd60a2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $8b73b759e6bd60a2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$8b73b759e6bd60a2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $8b73b759e6bd60a2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $8b73b759e6bd60a2$var$assign = Object.assign, $8b73b759e6bd60a2$var$emptyObject = {};
function $8b73b759e6bd60a2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $8b73b759e6bd60a2$var$emptyObject;
    this.updater = updater || $8b73b759e6bd60a2$var$ReactNoopUpdateQueue;
}
$8b73b759e6bd60a2$var$Component.prototype.isReactComponent = {};
$8b73b759e6bd60a2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$8b73b759e6bd60a2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $8b73b759e6bd60a2$var$ComponentDummy() {}
$8b73b759e6bd60a2$var$ComponentDummy.prototype = $8b73b759e6bd60a2$var$Component.prototype;
function $8b73b759e6bd60a2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $8b73b759e6bd60a2$var$emptyObject;
    this.updater = updater || $8b73b759e6bd60a2$var$ReactNoopUpdateQueue;
}
var $8b73b759e6bd60a2$var$pureComponentPrototype = $8b73b759e6bd60a2$var$PureComponent.prototype = new $8b73b759e6bd60a2$var$ComponentDummy();
$8b73b759e6bd60a2$var$pureComponentPrototype.constructor = $8b73b759e6bd60a2$var$PureComponent;
$8b73b759e6bd60a2$var$assign($8b73b759e6bd60a2$var$pureComponentPrototype, $8b73b759e6bd60a2$var$Component.prototype);
$8b73b759e6bd60a2$var$pureComponentPrototype.isPureReactComponent = !0;
var $8b73b759e6bd60a2$var$isArrayImpl = Array.isArray;
function $8b73b759e6bd60a2$var$noop() {}
var $8b73b759e6bd60a2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $8b73b759e6bd60a2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $8b73b759e6bd60a2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $8b73b759e6bd60a2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $8b73b759e6bd60a2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $8b73b759e6bd60a2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $8b73b759e6bd60a2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $8b73b759e6bd60a2$var$REACT_ELEMENT_TYPE;
}
function $8b73b759e6bd60a2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $8b73b759e6bd60a2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $8b73b759e6bd60a2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $8b73b759e6bd60a2$var$escape("" + element.key) : index.toString(36);
}
function $8b73b759e6bd60a2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($8b73b759e6bd60a2$var$noop, $8b73b759e6bd60a2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $8b73b759e6bd60a2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $8b73b759e6bd60a2$var$REACT_ELEMENT_TYPE:
                case $8b73b759e6bd60a2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $8b73b759e6bd60a2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $8b73b759e6bd60a2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $8b73b759e6bd60a2$var$getElementKey(children, 0) : nameSoFar, $8b73b759e6bd60a2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($8b73b759e6bd60a2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $8b73b759e6bd60a2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($8b73b759e6bd60a2$var$isValidElement(callback) && (callback = $8b73b759e6bd60a2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($8b73b759e6bd60a2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($8b73b759e6bd60a2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $8b73b759e6bd60a2$var$getElementKey(nameSoFar, i), invokeCallback += $8b73b759e6bd60a2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $8b73b759e6bd60a2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $8b73b759e6bd60a2$var$getElementKey(nameSoFar, i++), invokeCallback += $8b73b759e6bd60a2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $8b73b759e6bd60a2$var$mapIntoArray($8b73b759e6bd60a2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $8b73b759e6bd60a2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $8b73b759e6bd60a2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $8b73b759e6bd60a2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $8b73b759e6bd60a2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $8b73b759e6bd60a2$var$Children = {
    map: $8b73b759e6bd60a2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $8b73b759e6bd60a2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $8b73b759e6bd60a2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $8b73b759e6bd60a2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$8b73b759e6bd60a2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$8b73b759e6bd60a2$export$9c16c1426311996d = $8b73b759e6bd60a2$var$REACT_ACTIVITY_TYPE;
$8b73b759e6bd60a2$export$dca3b0875bd9a954 = $8b73b759e6bd60a2$var$Children;
$8b73b759e6bd60a2$export$16fa2f45be04daa8 = $8b73b759e6bd60a2$var$Component;
$8b73b759e6bd60a2$export$ffb0004e005737fa = $8b73b759e6bd60a2$var$REACT_FRAGMENT_TYPE;
$8b73b759e6bd60a2$export$e2c29f18771995cb = $8b73b759e6bd60a2$var$REACT_PROFILER_TYPE;
$8b73b759e6bd60a2$export$221d75b3f55bb0bd = $8b73b759e6bd60a2$var$PureComponent;
$8b73b759e6bd60a2$export$5f8d39834fd61797 = $8b73b759e6bd60a2$var$REACT_STRICT_MODE_TYPE;
$8b73b759e6bd60a2$export$74bf444e3cd11ea5 = $8b73b759e6bd60a2$var$REACT_SUSPENSE_TYPE;
$8b73b759e6bd60a2$export$1ced07cd6b1985ce = $8b73b759e6bd60a2$var$ReactSharedInternals;
$8b73b759e6bd60a2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$8b73b759e6bd60a2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$8b73b759e6bd60a2$export$8c538325882c7eec = function() {
    return null;
};
$8b73b759e6bd60a2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $8b73b759e6bd60a2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$8b73b759e6bd60a2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $8b73b759e6bd60a2$var$ReactElement(element.type, key, props);
};
$8b73b759e6bd60a2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $8b73b759e6bd60a2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $8b73b759e6bd60a2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$8b73b759e6bd60a2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$8b73b759e6bd60a2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $8b73b759e6bd60a2$var$ReactElement(type, key, props);
};
$8b73b759e6bd60a2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$8b73b759e6bd60a2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $8b73b759e6bd60a2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$8b73b759e6bd60a2$export$a8257692ac88316c = $8b73b759e6bd60a2$var$isValidElement;
$8b73b759e6bd60a2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $8b73b759e6bd60a2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $8b73b759e6bd60a2$var$lazyInitializer
    };
};
$8b73b759e6bd60a2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $8b73b759e6bd60a2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$8b73b759e6bd60a2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $8b73b759e6bd60a2$var$ReactSharedInternals.T, currentTransition = {};
    $8b73b759e6bd60a2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $8b73b759e6bd60a2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($8b73b759e6bd60a2$var$noop, $8b73b759e6bd60a2$var$reportGlobalError);
    } catch (error) {
        $8b73b759e6bd60a2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $8b73b759e6bd60a2$var$ReactSharedInternals.T = prevTransition;
    }
};
$8b73b759e6bd60a2$export$f93f40ac0ca7e3a8 = function() {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useCacheRefresh();
};
$8b73b759e6bd60a2$export$1f96ae73734a86cc = function(usable) {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.use(usable);
};
$8b73b759e6bd60a2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$8b73b759e6bd60a2$export$35808ee640e87ca7 = function(callback, deps) {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$8b73b759e6bd60a2$export$fae74005e78b1a27 = function(Context) {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useContext(Context);
};
$8b73b759e6bd60a2$export$dc8fbce3eb94dc1e = function() {};
$8b73b759e6bd60a2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$8b73b759e6bd60a2$export$6d9c69b0de29b591 = function(create, deps) {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$8b73b759e6bd60a2$export$7f54fc3180508a52 = function(callback) {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$8b73b759e6bd60a2$export$f680877a34711e37 = function() {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useId();
};
$8b73b759e6bd60a2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$8b73b759e6bd60a2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$8b73b759e6bd60a2$export$e5c5a5f917a5871c = function(create, deps) {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$8b73b759e6bd60a2$export$1538c33de8887b59 = function(create, deps) {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$8b73b759e6bd60a2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$8b73b759e6bd60a2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$8b73b759e6bd60a2$export$b8f5890fc79d6aca = function(initialValue) {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useRef(initialValue);
};
$8b73b759e6bd60a2$export$60241385465d0a34 = function(initialState) {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useState(initialState);
};
$8b73b759e6bd60a2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$8b73b759e6bd60a2$export$7b286972b8d8ccbf = function() {
    return $8b73b759e6bd60a2$var$ReactSharedInternals.H.useTransition();
};
$8b73b759e6bd60a2$export$83d89fbfd8236492 = "19.2.4";

});


parcelRegister("jZ3UM", function(module, exports) {
'use strict';
function $e8c6c036337e8c3a$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e8c6c036337e8c3a$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e8c6c036337e8c3a$var$checkDCE();

module.exports = (parcelRequire("a16ea"));

});
parcelRegister("a16ea", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $74aed4016cb8c319$export$69ce8ef3fe5cead0; }, function (v) { return $74aed4016cb8c319$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $74aed4016cb8c319$export$d39a5bbd09211389; }, function (v) { return $74aed4016cb8c319$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $74aed4016cb8c319$export$cd75ccfd720a3cd4; }, function (v) { return $74aed4016cb8c319$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $74aed4016cb8c319$export$a0816fa17a9e79be; }, function (v) { return $74aed4016cb8c319$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $74aed4016cb8c319$export$7292efcadded39f3; }, function (v) { return $74aed4016cb8c319$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $74aed4016cb8c319$export$da407abadb9b8f86; }, function (v) { return $74aed4016cb8c319$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $74aed4016cb8c319$export$314cfea32580671c; }, function (v) { return $74aed4016cb8c319$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $74aed4016cb8c319$export$513ccb98c53b8039; }, function (v) { return $74aed4016cb8c319$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $74aed4016cb8c319$export$dbca993bc2d264a; }, function (v) { return $74aed4016cb8c319$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $74aed4016cb8c319$export$4797a8006f0655d0; }, function (v) { return $74aed4016cb8c319$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $74aed4016cb8c319$export$c78a37762a8d58e1; }, function (v) { return $74aed4016cb8c319$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $74aed4016cb8c319$export$606f11b2eb45ecc6; }, function (v) { return $74aed4016cb8c319$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $74aed4016cb8c319$export$f7e8a0bf92324b1e; }, function (v) { return $74aed4016cb8c319$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $74aed4016cb8c319$export$83d89fbfd8236492; }, function (v) { return $74aed4016cb8c319$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $74aed4016cb8c319$export$69ce8ef3fe5cead0;
var $74aed4016cb8c319$export$d39a5bbd09211389;
var $74aed4016cb8c319$export$cd75ccfd720a3cd4;
var $74aed4016cb8c319$export$a0816fa17a9e79be;
var $74aed4016cb8c319$export$7292efcadded39f3;
var $74aed4016cb8c319$export$da407abadb9b8f86;
var $74aed4016cb8c319$export$314cfea32580671c;
var $74aed4016cb8c319$export$513ccb98c53b8039;
var $74aed4016cb8c319$export$dbca993bc2d264a;
var $74aed4016cb8c319$export$4797a8006f0655d0;
var $74aed4016cb8c319$export$c78a37762a8d58e1;
var $74aed4016cb8c319$export$606f11b2eb45ecc6;
var $74aed4016cb8c319$export$f7e8a0bf92324b1e;
var $74aed4016cb8c319$export$83d89fbfd8236492;
"use strict";

var $dSwpL = parcelRequire("dSwpL");
function $74aed4016cb8c319$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $74aed4016cb8c319$var$noop() {}
var $74aed4016cb8c319$var$Internals = {
    d: {
        f: $74aed4016cb8c319$var$noop,
        r: function() {
            throw Error($74aed4016cb8c319$var$formatProdErrorMessage(522));
        },
        D: $74aed4016cb8c319$var$noop,
        C: $74aed4016cb8c319$var$noop,
        L: $74aed4016cb8c319$var$noop,
        m: $74aed4016cb8c319$var$noop,
        X: $74aed4016cb8c319$var$noop,
        S: $74aed4016cb8c319$var$noop,
        M: $74aed4016cb8c319$var$noop
    },
    p: 0,
    findDOMNode: null
}, $74aed4016cb8c319$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $74aed4016cb8c319$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $74aed4016cb8c319$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $74aed4016cb8c319$var$ReactSharedInternals = $dSwpL.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $74aed4016cb8c319$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$74aed4016cb8c319$export$69ce8ef3fe5cead0 = $74aed4016cb8c319$var$Internals;
$74aed4016cb8c319$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($74aed4016cb8c319$var$formatProdErrorMessage(299));
    return $74aed4016cb8c319$var$createPortal$1(children, container, null, key);
};
$74aed4016cb8c319$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $74aed4016cb8c319$var$ReactSharedInternals.T, previousUpdatePriority = $74aed4016cb8c319$var$Internals.p;
    try {
        if ($74aed4016cb8c319$var$ReactSharedInternals.T = null, $74aed4016cb8c319$var$Internals.p = 2, fn) return fn();
    } finally{
        $74aed4016cb8c319$var$ReactSharedInternals.T = previousTransition, $74aed4016cb8c319$var$Internals.p = previousUpdatePriority, $74aed4016cb8c319$var$Internals.d.f();
    }
};
$74aed4016cb8c319$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $74aed4016cb8c319$var$Internals.d.C(href, options));
};
$74aed4016cb8c319$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $74aed4016cb8c319$var$Internals.d.D(href);
};
$74aed4016cb8c319$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $74aed4016cb8c319$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $74aed4016cb8c319$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $74aed4016cb8c319$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$74aed4016cb8c319$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $74aed4016cb8c319$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $74aed4016cb8c319$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $74aed4016cb8c319$var$Internals.d.M(href);
    }
};
$74aed4016cb8c319$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $74aed4016cb8c319$var$getCrossOriginStringAs(as, options.crossOrigin);
        $74aed4016cb8c319$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$74aed4016cb8c319$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $74aed4016cb8c319$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $74aed4016cb8c319$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $74aed4016cb8c319$var$Internals.d.m(href);
    }
};
$74aed4016cb8c319$export$4797a8006f0655d0 = function(form) {
    $74aed4016cb8c319$var$Internals.d.r(form);
};
$74aed4016cb8c319$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$74aed4016cb8c319$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $74aed4016cb8c319$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$74aed4016cb8c319$export$f7e8a0bf92324b1e = function() {
    return $74aed4016cb8c319$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$74aed4016cb8c319$export$83d89fbfd8236492 = "19.2.4";

});



parcelRegister("dPnrE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e81910832f94c1f$export$2e2bcd8739ae039; });

var $1KfxD = parcelRequire("1KfxD");
const $7e81910832f94c1f$var$Button = ({ label: label, onClick: onClick, type: type, src: src, color: color, className: className, size: size })=>{
    const colorMap = {
        orange: "text-orange-400 hover:bg-orange-400 border-orange-400 hover:text-white",
        green: "text-green-600 hover:bg-green-600 border-green-600 hover:text-white",
        blue: "text-blue-400 hover:bg-blue-400 border-blue-400 hover:text-white",
        red: "text-red-500 hover:bg-red-500 border-red-500 hover:text-white",
        black: "text-white bg-black hover:bg-white border-black hover:text-black",
        white: "text-black bg-white hover:bg-black border-black hover:text-black",
        noColor: ""
    };
    const selectedColor = colorMap[color] || colorMap.orange;
    const sizeMap = {
        small: "md:min-w-none w-fit h-auto p-1 font-medium text-sm",
        regular: "md:min-w- w-fit h-auto p-0.5 md:p-1.5 font-semibold text-base",
        large: "md:min-w- w-fit h-auto p-3 md:p-2 font-semibold text-lg"
    };
    const selectedSize = sizeMap[size] || sizeMap.regular;
    return /*#__PURE__*/ (0, $1KfxD.jsxs)("button", {
        onClick: onClick,
        type: type,
        className: `button-component rounded-md cursor-pointer items-center flex justify-center transition-colors duration-300 ease-in-out active:scale-95
        ${selectedColor}
        ${selectedSize}
        ${className}
        ${src ? "border-0 md:border space-x-1" : "border"}
        `,
        children: [
            src && /*#__PURE__*/ (0, $1KfxD.jsx)("img", {
                className: "reset-icon max-h-6 md:max-h-5 cursor-pointer hover:bg-orange- bg-none",
                src: src,
                alt: "Icon"
            }),
            /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                className: `uppercase ${src ? "hidden md:flex" : "flex"}`,
                children: label && label
            })
        ]
    });
};
var $7e81910832f94c1f$export$2e2bcd8739ae039 = $7e81910832f94c1f$var$Button;

});

parcelRegister("drrpd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c930e32ff338c45$export$2e2bcd8739ae039; });

var $dSwpL = parcelRequire("dSwpL");
const $9c930e32ff338c45$var$UserContext = /*#__PURE__*/ (0, $dSwpL.createContext)({
    loggedInUser: "Default User"
});
var $9c930e32ff338c45$export$2e2bcd8739ae039 = $9c930e32ff338c45$var$UserContext;

});

parcelRegister("61PDG", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $463ae48013decfab$export$bf730a2d8bf68b42; }, function (v) { return $463ae48013decfab$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $463ae48013decfab$export$bf730a2d8bf68b42;
"use strict";

var $dSwpL = parcelRequire("dSwpL");
function $463ae48013decfab$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $463ae48013decfab$var$objectIs = "function" === typeof Object.is ? Object.is : $463ae48013decfab$var$is, $463ae48013decfab$var$useSyncExternalStore = $dSwpL.useSyncExternalStore, $463ae48013decfab$var$useRef = $dSwpL.useRef, $463ae48013decfab$var$useEffect = $dSwpL.useEffect, $463ae48013decfab$var$useMemo = $dSwpL.useMemo, $463ae48013decfab$var$useDebugValue = $dSwpL.useDebugValue;
$463ae48013decfab$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $463ae48013decfab$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $463ae48013decfab$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($463ae48013decfab$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $463ae48013decfab$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $463ae48013decfab$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $463ae48013decfab$var$useDebugValue(value);
    return value;
};

});

parcelRegister("96eiz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a3ea06f91bccc23$export$2e2bcd8739ae039; });

var $1KfxD = parcelRequire("1KfxD");
const $3a3ea06f91bccc23$var$Shimmer = ()=>{
    return /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
        className: "shimmer-card-container flex flex-wrap gap-4 py-2 w-full animate-pulse",
        children: Array(8).fill("").map((e, index)=>{
            return /*#__PURE__*/ (0, $1KfxD.jsx)("p", {
                className: "shimmer-card h-32 w-38 md:h-44 md:w-52 bg-gray-300"
            }, index);
        })
    });
};
var $3a3ea06f91bccc23$export$2e2bcd8739ae039 = $3a3ea06f91bccc23$var$Shimmer;

});

parcelRegister("i2Aeq", function(module, exports) {
module.exports = $parcel$import("h1B49").then(()=>parcelRequire('c78Tr'));

});

parcelRegister("7Abyg", function(module, exports) {
module.exports = $parcel$import("g1FqD").then(()=>parcelRequire('fQuA2'));

});

parcelRegister("3IfSZ", function(module, exports) {

$parcel$export(module.exports, "Formik", function () { return Formik; });
$parcel$export(module.exports, "Field", function () { return Field; });
$parcel$export(module.exports, "Form", function () { return Form; });

var $3X3Yp = parcelRequire("3X3Yp");

var $OPUvm = parcelRequire("OPUvm");

var $fpUkv = parcelRequire("fpUkv");

var $dSwpL = parcelRequire("dSwpL");

var $dOiPr = parcelRequire("dOiPr");

var $e9INb = parcelRequire("e9INb");

var $cDy60 = parcelRequire("cDy60");

var $a2s7F = parcelRequire("a2s7F");

var $dGR8M = parcelRequire("dGR8M");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $dSwpL.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $dSwpL.useContext)(FormikContext);
    !!!formik && (0, $e9INb.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $dSwpL.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $a2s7F.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $cDy60.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $a2s7F.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $cDy60.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($dOiPr)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $dSwpL.useRef)(props.initialValues);
    var initialErrors = (0, $dSwpL.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $dSwpL.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $dSwpL.useRef)(props.initialStatus);
    var isMounted = (0, $dSwpL.useRef)(false);
    var fieldRegistry = (0, $dSwpL.useRef)({});
    (0, $dSwpL.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $dSwpL.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $dSwpL.useRef)({
        values: (0, $fpUkv.default)(props.initialValues),
        errors: (0, $fpUkv.default)(props.initialErrors) || emptyErrors,
        touched: (0, $fpUkv.default)(props.initialTouched) || emptyTouched,
        status: (0, $fpUkv.default)(props.initialStatus),
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $dSwpL.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $dSwpL.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $dSwpL.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $dSwpL.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $dSwpL.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $dSwpL.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $3X3Yp.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $dSwpL.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($dOiPr)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $dSwpL.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $dSwpL.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($dOiPr)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $dSwpL.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($dOiPr)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $dSwpL.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($dOiPr)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $dSwpL.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($dOiPr)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $dSwpL.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $dSwpL.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $dSwpL.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $dSwpL.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        var resolvedValue = isFunction(value) ? value(getIn(state.values, field)) : value;
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: resolvedValue
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, resolvedValue)) : Promise.resolve();
    });
    var executeChange = (0, $dSwpL.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            field;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $dSwpL.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        field;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $dSwpL.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $dSwpL.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $dSwpL.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $dSwpL.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $dSwpL.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $dSwpL.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $dSwpL.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($dOiPr)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $dSwpL.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $dSwpL.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $dSwpL.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $dSwpL.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $dSwpL.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $OPUvm.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $OPUvm.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $3X3Yp.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $3X3Yp.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $dSwpL.useLayoutEffect) : (0, $dSwpL.useEffect);
function useEventCallback(fn) {
    var ref = (0, $dSwpL.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $dSwpL.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $dSwpL.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $e9INb.default)(false);
    var fieldHelpers = (0, $dSwpL.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $dSwpL.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $dSwpL.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $dSwpL.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $dSwpL.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $dSwpL.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $dSwpL.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $dSwpL.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $dSwpL.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $dSwpL.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $dSwpL.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($dGR8M)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $dSwpL.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $e9INb.default)(false);
            return (0, $dSwpL.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($dGR8M)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === 'function' ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $fpUkv.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($dOiPr)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $dSwpL.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $dSwpL.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $dSwpL.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $dSwpL.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $dSwpL.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $e9INb.default)(false);
        !!(component && render) && (0, $e9INb.default)(false);
        !!(is && children && isFunction(children)) && (0, $e9INb.default)(false);
        !!(component && children && isFunction(children)) && (0, $e9INb.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $e9INb.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $dSwpL.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $dSwpL.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $dSwpL.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $dSwpL.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $dSwpL.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("3X3Yp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e09f6c950855309$export$2e2bcd8739ae039; });
var $2e09f6c950855309$var$isMergeableObject = function isMergeableObject(value) {
    return $2e09f6c950855309$var$isNonNullObject(value) && !$2e09f6c950855309$var$isSpecial(value);
};
function $2e09f6c950855309$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $2e09f6c950855309$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $2e09f6c950855309$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $2e09f6c950855309$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $2e09f6c950855309$var$REACT_ELEMENT_TYPE = $2e09f6c950855309$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $2e09f6c950855309$var$isReactElement(value) {
    return value.$$typeof === $2e09f6c950855309$var$REACT_ELEMENT_TYPE;
}
function $2e09f6c950855309$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $2e09f6c950855309$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $2e09f6c950855309$var$deepmerge($2e09f6c950855309$var$emptyTarget(value), value, options) : value;
}
function $2e09f6c950855309$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $2e09f6c950855309$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $2e09f6c950855309$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $2e09f6c950855309$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $2e09f6c950855309$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $2e09f6c950855309$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $2e09f6c950855309$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $2e09f6c950855309$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $2e09f6c950855309$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $2e09f6c950855309$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $2e09f6c950855309$var$mergeObject(target, source, options);
}
$2e09f6c950855309$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $2e09f6c950855309$var$deepmerge(prev, next, options);
    }, {});
};
var $2e09f6c950855309$var$deepmerge_1 = $2e09f6c950855309$var$deepmerge;
var $2e09f6c950855309$export$2e2bcd8739ae039 = $2e09f6c950855309$var$deepmerge_1;

});

parcelRegister("OPUvm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $098ceff1d2a456e6$export$2e2bcd8739ae039; });

var $iA9dk = parcelRequire("iA9dk");

var $eqX5A = parcelRequire("eqX5A");

var $4Wkzy = parcelRequire("4Wkzy");
/** `Object#toString` result references. */ var $098ceff1d2a456e6$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $098ceff1d2a456e6$var$funcProto = Function.prototype, $098ceff1d2a456e6$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $098ceff1d2a456e6$var$funcToString = $098ceff1d2a456e6$var$funcProto.toString;
/** Used to check objects for own properties. */ var $098ceff1d2a456e6$var$hasOwnProperty = $098ceff1d2a456e6$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $098ceff1d2a456e6$var$objectCtorString = $098ceff1d2a456e6$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $098ceff1d2a456e6$var$isPlainObject(value) {
    if (!(0, $4Wkzy.default)(value) || (0, $iA9dk.default)(value) != $098ceff1d2a456e6$var$objectTag) return false;
    var proto = (0, $eqX5A.default)(value);
    if (proto === null) return true;
    var Ctor = $098ceff1d2a456e6$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $098ceff1d2a456e6$var$funcToString.call(Ctor) == $098ceff1d2a456e6$var$objectCtorString;
}
var $098ceff1d2a456e6$export$2e2bcd8739ae039 = $098ceff1d2a456e6$var$isPlainObject;

});
parcelRegister("iA9dk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d872bc8337b9aa48$export$2e2bcd8739ae039; });

var $gxYDX = parcelRequire("gxYDX");

var $275hW = parcelRequire("275hW");

var $dqqQT = parcelRequire("dqqQT");
/** `Object#toString` result references. */ var $d872bc8337b9aa48$var$nullTag = '[object Null]', $d872bc8337b9aa48$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $d872bc8337b9aa48$var$symToStringTag = (0, $gxYDX.default) ? (0, $gxYDX.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $d872bc8337b9aa48$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $d872bc8337b9aa48$var$undefinedTag : $d872bc8337b9aa48$var$nullTag;
    return $d872bc8337b9aa48$var$symToStringTag && $d872bc8337b9aa48$var$symToStringTag in Object(value) ? (0, $275hW.default)(value) : (0, $dqqQT.default)(value);
}
var $d872bc8337b9aa48$export$2e2bcd8739ae039 = $d872bc8337b9aa48$var$baseGetTag;

});
parcelRegister("gxYDX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0bec4ed99656ae2$export$2e2bcd8739ae039; });

var $hi07e = parcelRequire("hi07e");
/** Built-in value references. */ var $c0bec4ed99656ae2$var$Symbol = (0, $hi07e.default).Symbol;
var $c0bec4ed99656ae2$export$2e2bcd8739ae039 = $c0bec4ed99656ae2$var$Symbol;

});
parcelRegister("hi07e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c964351802ca3829$export$2e2bcd8739ae039; });

var $48A5B = parcelRequire("48A5B");
/** Detect free variable `self`. */ var $c964351802ca3829$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $c964351802ca3829$var$root = (0, $48A5B.default) || $c964351802ca3829$var$freeSelf || Function('return this')();
var $c964351802ca3829$export$2e2bcd8739ae039 = $c964351802ca3829$var$root;

});
parcelRegister("48A5B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3033e759e90319fa$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $3033e759e90319fa$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $3033e759e90319fa$export$2e2bcd8739ae039 = $3033e759e90319fa$var$freeGlobal;

});



parcelRegister("275hW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18a05661f95980e3$export$2e2bcd8739ae039; });

var $gxYDX = parcelRequire("gxYDX");
/** Used for built-in method references. */ var $18a05661f95980e3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $18a05661f95980e3$var$hasOwnProperty = $18a05661f95980e3$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $18a05661f95980e3$var$nativeObjectToString = $18a05661f95980e3$var$objectProto.toString;
/** Built-in value references. */ var $18a05661f95980e3$var$symToStringTag = (0, $gxYDX.default) ? (0, $gxYDX.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $18a05661f95980e3$var$getRawTag(value) {
    var isOwn = $18a05661f95980e3$var$hasOwnProperty.call(value, $18a05661f95980e3$var$symToStringTag), tag = value[$18a05661f95980e3$var$symToStringTag];
    try {
        value[$18a05661f95980e3$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $18a05661f95980e3$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$18a05661f95980e3$var$symToStringTag] = tag;
        else delete value[$18a05661f95980e3$var$symToStringTag];
    }
    return result;
}
var $18a05661f95980e3$export$2e2bcd8739ae039 = $18a05661f95980e3$var$getRawTag;

});

parcelRegister("dqqQT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c62885396fb4359$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $9c62885396fb4359$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9c62885396fb4359$var$nativeObjectToString = $9c62885396fb4359$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $9c62885396fb4359$var$objectToString(value) {
    return $9c62885396fb4359$var$nativeObjectToString.call(value);
}
var $9c62885396fb4359$export$2e2bcd8739ae039 = $9c62885396fb4359$var$objectToString;

});


parcelRegister("eqX5A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a821544672a8c716$export$2e2bcd8739ae039; });

var $ktVHm = parcelRequire("ktVHm");
/** Built-in value references. */ var $a821544672a8c716$var$getPrototype = (0, $ktVHm.default)(Object.getPrototypeOf, Object);
var $a821544672a8c716$export$2e2bcd8739ae039 = $a821544672a8c716$var$getPrototype;

});
parcelRegister("ktVHm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee9345c1b71b098d$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ee9345c1b71b098d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $ee9345c1b71b098d$export$2e2bcd8739ae039 = $ee9345c1b71b098d$var$overArg;

});


parcelRegister("4Wkzy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $398c89786cfe2eb1$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $398c89786cfe2eb1$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $398c89786cfe2eb1$export$2e2bcd8739ae039 = $398c89786cfe2eb1$var$isObjectLike;

});


parcelRegister("fpUkv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b394e2b7c722c570$export$2e2bcd8739ae039; });

var $hePVl = parcelRequire("hePVl");
/** Used to compose bitmasks for cloning. */ var $b394e2b7c722c570$var$CLONE_DEEP_FLAG = 1, $b394e2b7c722c570$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $b394e2b7c722c570$var$cloneDeep(value) {
    return (0, $hePVl.default)(value, $b394e2b7c722c570$var$CLONE_DEEP_FLAG | $b394e2b7c722c570$var$CLONE_SYMBOLS_FLAG);
}
var $b394e2b7c722c570$export$2e2bcd8739ae039 = $b394e2b7c722c570$var$cloneDeep;

});
parcelRegister("hePVl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8cc057db83f8384$export$2e2bcd8739ae039; });

var $2z9Re = parcelRequire("2z9Re");

var $j0ySs = parcelRequire("j0ySs");

var $5QA1H = parcelRequire("5QA1H");

var $j3TUt = parcelRequire("j3TUt");

var $eBsKQ = parcelRequire("eBsKQ");

var $6IXrq = parcelRequire("6IXrq");

var $lkGqY = parcelRequire("lkGqY");

var $htTmQ = parcelRequire("htTmQ");

var $am6LV = parcelRequire("am6LV");

var $8q7Hc = parcelRequire("8q7Hc");

var $ffwkX = parcelRequire("ffwkX");

var $ajaGB = parcelRequire("ajaGB");

var $hMa52 = parcelRequire("hMa52");

var $5cVH4 = parcelRequire("5cVH4");

var $fJUYK = parcelRequire("fJUYK");

var $iLE7q = parcelRequire("iLE7q");

var $12ime = parcelRequire("12ime");

var $kJRFT = parcelRequire("kJRFT");

var $bd5nv = parcelRequire("bd5nv");

var $6vkfT = parcelRequire("6vkfT");

var $c5KVR = parcelRequire("c5KVR");

var $43eFw = parcelRequire("43eFw");
/** Used to compose bitmasks for cloning. */ var $c8cc057db83f8384$var$CLONE_DEEP_FLAG = 1, $c8cc057db83f8384$var$CLONE_FLAT_FLAG = 2, $c8cc057db83f8384$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $c8cc057db83f8384$var$argsTag = '[object Arguments]', $c8cc057db83f8384$var$arrayTag = '[object Array]', $c8cc057db83f8384$var$boolTag = '[object Boolean]', $c8cc057db83f8384$var$dateTag = '[object Date]', $c8cc057db83f8384$var$errorTag = '[object Error]', $c8cc057db83f8384$var$funcTag = '[object Function]', $c8cc057db83f8384$var$genTag = '[object GeneratorFunction]', $c8cc057db83f8384$var$mapTag = '[object Map]', $c8cc057db83f8384$var$numberTag = '[object Number]', $c8cc057db83f8384$var$objectTag = '[object Object]', $c8cc057db83f8384$var$regexpTag = '[object RegExp]', $c8cc057db83f8384$var$setTag = '[object Set]', $c8cc057db83f8384$var$stringTag = '[object String]', $c8cc057db83f8384$var$symbolTag = '[object Symbol]', $c8cc057db83f8384$var$weakMapTag = '[object WeakMap]';
var $c8cc057db83f8384$var$arrayBufferTag = '[object ArrayBuffer]', $c8cc057db83f8384$var$dataViewTag = '[object DataView]', $c8cc057db83f8384$var$float32Tag = '[object Float32Array]', $c8cc057db83f8384$var$float64Tag = '[object Float64Array]', $c8cc057db83f8384$var$int8Tag = '[object Int8Array]', $c8cc057db83f8384$var$int16Tag = '[object Int16Array]', $c8cc057db83f8384$var$int32Tag = '[object Int32Array]', $c8cc057db83f8384$var$uint8Tag = '[object Uint8Array]', $c8cc057db83f8384$var$uint8ClampedTag = '[object Uint8ClampedArray]', $c8cc057db83f8384$var$uint16Tag = '[object Uint16Array]', $c8cc057db83f8384$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $c8cc057db83f8384$var$cloneableTags = {};
$c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$argsTag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$arrayTag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$arrayBufferTag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$dataViewTag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$boolTag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$dateTag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$float32Tag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$float64Tag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$int8Tag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$int16Tag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$int32Tag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$mapTag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$numberTag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$objectTag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$regexpTag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$setTag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$stringTag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$symbolTag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$uint8Tag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$uint8ClampedTag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$uint16Tag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$uint32Tag] = true;
$c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$errorTag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$funcTag] = $c8cc057db83f8384$var$cloneableTags[$c8cc057db83f8384$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $c8cc057db83f8384$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $c8cc057db83f8384$var$CLONE_DEEP_FLAG, isFlat = bitmask & $c8cc057db83f8384$var$CLONE_FLAT_FLAG, isFull = bitmask & $c8cc057db83f8384$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $bd5nv.default)(value)) return value;
    var isArr = (0, $iLE7q.default)(value);
    if (isArr) {
        result = (0, $hMa52.default)(value);
        if (!isDeep) return (0, $lkGqY.default)(value, result);
    } else {
        var tag = (0, $ajaGB.default)(value), isFunc = tag == $c8cc057db83f8384$var$funcTag || tag == $c8cc057db83f8384$var$genTag;
        if ((0, $12ime.default)(value)) return (0, $6IXrq.default)(value, isDeep);
        if (tag == $c8cc057db83f8384$var$objectTag || tag == $c8cc057db83f8384$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $fJUYK.default)(value);
            if (!isDeep) return isFlat ? (0, $am6LV.default)(value, (0, $eBsKQ.default)(result, value)) : (0, $htTmQ.default)(value, (0, $j3TUt.default)(result, value));
        } else {
            if (!$c8cc057db83f8384$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $5cVH4.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $2z9Re.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $6vkfT.default)(value)) value.forEach(function(subValue) {
        result.add($c8cc057db83f8384$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $kJRFT.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $c8cc057db83f8384$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $ffwkX.default) : (0, $8q7Hc.default) : isFlat ? (0, $43eFw.default) : (0, $c5KVR.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $j0ySs.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $5QA1H.default)(result, key, $c8cc057db83f8384$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $c8cc057db83f8384$export$2e2bcd8739ae039 = $c8cc057db83f8384$var$baseClone;

});
parcelRegister("2z9Re", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1de67f2e706dec52$export$2e2bcd8739ae039; });

var $6r8m1 = parcelRequire("6r8m1");

var $76Ur8 = parcelRequire("76Ur8");

var $fTAPy = parcelRequire("fTAPy");

var $gso2q = parcelRequire("gso2q");

var $bkh7e = parcelRequire("bkh7e");

var $889vv = parcelRequire("889vv");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1de67f2e706dec52$var$Stack(entries) {
    var data = this.__data__ = new (0, $6r8m1.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$1de67f2e706dec52$var$Stack.prototype.clear = (0, $76Ur8.default);
$1de67f2e706dec52$var$Stack.prototype['delete'] = (0, $fTAPy.default);
$1de67f2e706dec52$var$Stack.prototype.get = (0, $gso2q.default);
$1de67f2e706dec52$var$Stack.prototype.has = (0, $bkh7e.default);
$1de67f2e706dec52$var$Stack.prototype.set = (0, $889vv.default);
var $1de67f2e706dec52$export$2e2bcd8739ae039 = $1de67f2e706dec52$var$Stack;

});
parcelRegister("6r8m1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4afbbeae4e70b82c$export$2e2bcd8739ae039; });

var $7FSgq = parcelRequire("7FSgq");

var $bp4wv = parcelRequire("bp4wv");

var $j8NlT = parcelRequire("j8NlT");

var $1lCuA = parcelRequire("1lCuA");

var $Wf02W = parcelRequire("Wf02W");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4afbbeae4e70b82c$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$4afbbeae4e70b82c$var$ListCache.prototype.clear = (0, $7FSgq.default);
$4afbbeae4e70b82c$var$ListCache.prototype['delete'] = (0, $bp4wv.default);
$4afbbeae4e70b82c$var$ListCache.prototype.get = (0, $j8NlT.default);
$4afbbeae4e70b82c$var$ListCache.prototype.has = (0, $1lCuA.default);
$4afbbeae4e70b82c$var$ListCache.prototype.set = (0, $Wf02W.default);
var $4afbbeae4e70b82c$export$2e2bcd8739ae039 = $4afbbeae4e70b82c$var$ListCache;

});
parcelRegister("7FSgq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5966746d8cef7658$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $5966746d8cef7658$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $5966746d8cef7658$export$2e2bcd8739ae039 = $5966746d8cef7658$var$listCacheClear;

});

parcelRegister("bp4wv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84d589c1329f8294$export$2e2bcd8739ae039; });

var $e5dzY = parcelRequire("e5dzY");
/** Used for built-in method references. */ var $84d589c1329f8294$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $84d589c1329f8294$var$splice = $84d589c1329f8294$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $84d589c1329f8294$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $e5dzY.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $84d589c1329f8294$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $84d589c1329f8294$export$2e2bcd8739ae039 = $84d589c1329f8294$var$listCacheDelete;

});
parcelRegister("e5dzY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a40c10d7e571b03c$export$2e2bcd8739ae039; });

var $klNLT = parcelRequire("klNLT");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a40c10d7e571b03c$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $klNLT.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $a40c10d7e571b03c$export$2e2bcd8739ae039 = $a40c10d7e571b03c$var$assocIndexOf;

});
parcelRegister("klNLT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed0c605e8d112120$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $ed0c605e8d112120$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $ed0c605e8d112120$export$2e2bcd8739ae039 = $ed0c605e8d112120$var$eq;

});



parcelRegister("j8NlT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $def50bf65e111db5$export$2e2bcd8739ae039; });

var $e5dzY = parcelRequire("e5dzY");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $def50bf65e111db5$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $e5dzY.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $def50bf65e111db5$export$2e2bcd8739ae039 = $def50bf65e111db5$var$listCacheGet;

});

parcelRegister("1lCuA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fb59c66ff5c49ee$export$2e2bcd8739ae039; });

var $e5dzY = parcelRequire("e5dzY");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0fb59c66ff5c49ee$var$listCacheHas(key) {
    return (0, $e5dzY.default)(this.__data__, key) > -1;
}
var $0fb59c66ff5c49ee$export$2e2bcd8739ae039 = $0fb59c66ff5c49ee$var$listCacheHas;

});

parcelRegister("Wf02W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0af10d883e69a41a$export$2e2bcd8739ae039; });

var $e5dzY = parcelRequire("e5dzY");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $0af10d883e69a41a$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $e5dzY.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $0af10d883e69a41a$export$2e2bcd8739ae039 = $0af10d883e69a41a$var$listCacheSet;

});


parcelRegister("76Ur8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52d4df16599b119e$export$2e2bcd8739ae039; });

var $6r8m1 = parcelRequire("6r8m1");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $52d4df16599b119e$var$stackClear() {
    this.__data__ = new (0, $6r8m1.default);
    this.size = 0;
}
var $52d4df16599b119e$export$2e2bcd8739ae039 = $52d4df16599b119e$var$stackClear;

});

parcelRegister("fTAPy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9288fd41404a764$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b9288fd41404a764$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $b9288fd41404a764$export$2e2bcd8739ae039 = $b9288fd41404a764$var$stackDelete;

});

parcelRegister("gso2q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfb1e859f84a78cf$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $bfb1e859f84a78cf$var$stackGet(key) {
    return this.__data__.get(key);
}
var $bfb1e859f84a78cf$export$2e2bcd8739ae039 = $bfb1e859f84a78cf$var$stackGet;

});

parcelRegister("bkh7e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83eed6c8246f23b5$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $83eed6c8246f23b5$var$stackHas(key) {
    return this.__data__.has(key);
}
var $83eed6c8246f23b5$export$2e2bcd8739ae039 = $83eed6c8246f23b5$var$stackHas;

});

parcelRegister("889vv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5eb671fcb4a1e196$export$2e2bcd8739ae039; });

var $6r8m1 = parcelRequire("6r8m1");

var $gy2Tj = parcelRequire("gy2Tj");

var $1DGG9 = parcelRequire("1DGG9");
/** Used as the size to enable large array optimizations. */ var $5eb671fcb4a1e196$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $5eb671fcb4a1e196$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $6r8m1.default)) {
        var pairs = data.__data__;
        if (!(0, $gy2Tj.default) || pairs.length < $5eb671fcb4a1e196$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $1DGG9.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $5eb671fcb4a1e196$export$2e2bcd8739ae039 = $5eb671fcb4a1e196$var$stackSet;

});
parcelRegister("gy2Tj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0c2106cd4ca15df$export$2e2bcd8739ae039; });

var $biB8D = parcelRequire("biB8D");

var $hi07e = parcelRequire("hi07e");
/* Built-in method references that are verified to be native. */ var $c0c2106cd4ca15df$var$Map = (0, $biB8D.default)((0, $hi07e.default), 'Map');
var $c0c2106cd4ca15df$export$2e2bcd8739ae039 = $c0c2106cd4ca15df$var$Map;

});
parcelRegister("biB8D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $839e2f082639ff98$export$2e2bcd8739ae039; });

var $iGIUT = parcelRequire("iGIUT");

var $75tE7 = parcelRequire("75tE7");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $839e2f082639ff98$var$getNative(object, key) {
    var value = (0, $75tE7.default)(object, key);
    return (0, $iGIUT.default)(value) ? value : undefined;
}
var $839e2f082639ff98$export$2e2bcd8739ae039 = $839e2f082639ff98$var$getNative;

});
parcelRegister("iGIUT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9aefdbd84c3ef15$export$2e2bcd8739ae039; });

var $k2UtG = parcelRequire("k2UtG");

var $6FnAd = parcelRequire("6FnAd");

var $bd5nv = parcelRequire("bd5nv");

var $2QMAC = parcelRequire("2QMAC");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $d9aefdbd84c3ef15$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $d9aefdbd84c3ef15$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $d9aefdbd84c3ef15$var$funcProto = Function.prototype, $d9aefdbd84c3ef15$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $d9aefdbd84c3ef15$var$funcToString = $d9aefdbd84c3ef15$var$funcProto.toString;
/** Used to check objects for own properties. */ var $d9aefdbd84c3ef15$var$hasOwnProperty = $d9aefdbd84c3ef15$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $d9aefdbd84c3ef15$var$reIsNative = RegExp('^' + $d9aefdbd84c3ef15$var$funcToString.call($d9aefdbd84c3ef15$var$hasOwnProperty).replace($d9aefdbd84c3ef15$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $d9aefdbd84c3ef15$var$baseIsNative(value) {
    if (!(0, $bd5nv.default)(value) || (0, $6FnAd.default)(value)) return false;
    var pattern = (0, $k2UtG.default)(value) ? $d9aefdbd84c3ef15$var$reIsNative : $d9aefdbd84c3ef15$var$reIsHostCtor;
    return pattern.test((0, $2QMAC.default)(value));
}
var $d9aefdbd84c3ef15$export$2e2bcd8739ae039 = $d9aefdbd84c3ef15$var$baseIsNative;

});
parcelRegister("k2UtG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e97fcdde0a7c3881$export$2e2bcd8739ae039; });

var $iA9dk = parcelRequire("iA9dk");

var $bd5nv = parcelRequire("bd5nv");
/** `Object#toString` result references. */ var $e97fcdde0a7c3881$var$asyncTag = '[object AsyncFunction]', $e97fcdde0a7c3881$var$funcTag = '[object Function]', $e97fcdde0a7c3881$var$genTag = '[object GeneratorFunction]', $e97fcdde0a7c3881$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $e97fcdde0a7c3881$var$isFunction(value) {
    if (!(0, $bd5nv.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $iA9dk.default)(value);
    return tag == $e97fcdde0a7c3881$var$funcTag || tag == $e97fcdde0a7c3881$var$genTag || tag == $e97fcdde0a7c3881$var$asyncTag || tag == $e97fcdde0a7c3881$var$proxyTag;
}
var $e97fcdde0a7c3881$export$2e2bcd8739ae039 = $e97fcdde0a7c3881$var$isFunction;

});
parcelRegister("bd5nv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $829514978b221f13$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $829514978b221f13$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $829514978b221f13$export$2e2bcd8739ae039 = $829514978b221f13$var$isObject;

});


parcelRegister("6FnAd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4da8dd82338b266b$export$2e2bcd8739ae039; });

var $bWsYj = parcelRequire("bWsYj");
/** Used to detect methods masquerading as native. */ var $4da8dd82338b266b$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $bWsYj.default) && (0, $bWsYj.default).keys && (0, $bWsYj.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $4da8dd82338b266b$var$isMasked(func) {
    return !!$4da8dd82338b266b$var$maskSrcKey && $4da8dd82338b266b$var$maskSrcKey in func;
}
var $4da8dd82338b266b$export$2e2bcd8739ae039 = $4da8dd82338b266b$var$isMasked;

});
parcelRegister("bWsYj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b1b95acb6536277$export$2e2bcd8739ae039; });

var $hi07e = parcelRequire("hi07e");
/** Used to detect overreaching core-js shims. */ var $8b1b95acb6536277$var$coreJsData = (0, $hi07e.default)['__core-js_shared__'];
var $8b1b95acb6536277$export$2e2bcd8739ae039 = $8b1b95acb6536277$var$coreJsData;

});


parcelRegister("2QMAC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21362100ef7505d9$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $21362100ef7505d9$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $21362100ef7505d9$var$funcToString = $21362100ef7505d9$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $21362100ef7505d9$var$toSource(func) {
    if (func != null) {
        try {
            return $21362100ef7505d9$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $21362100ef7505d9$export$2e2bcd8739ae039 = $21362100ef7505d9$var$toSource;

});


parcelRegister("75tE7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $528fff1dc740273a$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $528fff1dc740273a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $528fff1dc740273a$export$2e2bcd8739ae039 = $528fff1dc740273a$var$getValue;

});



parcelRegister("1DGG9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $131a8a18252e7fa4$export$2e2bcd8739ae039; });

var $6XBWz = parcelRequire("6XBWz");

var $p7iLd = parcelRequire("p7iLd");

var $2VcPt = parcelRequire("2VcPt");

var $cbtQY = parcelRequire("cbtQY");

var $g02Pq = parcelRequire("g02Pq");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $131a8a18252e7fa4$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$131a8a18252e7fa4$var$MapCache.prototype.clear = (0, $6XBWz.default);
$131a8a18252e7fa4$var$MapCache.prototype['delete'] = (0, $p7iLd.default);
$131a8a18252e7fa4$var$MapCache.prototype.get = (0, $2VcPt.default);
$131a8a18252e7fa4$var$MapCache.prototype.has = (0, $cbtQY.default);
$131a8a18252e7fa4$var$MapCache.prototype.set = (0, $g02Pq.default);
var $131a8a18252e7fa4$export$2e2bcd8739ae039 = $131a8a18252e7fa4$var$MapCache;

});
parcelRegister("6XBWz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5115af9760f204be$export$2e2bcd8739ae039; });

var $dYbEM = parcelRequire("dYbEM");

var $6r8m1 = parcelRequire("6r8m1");

var $gy2Tj = parcelRequire("gy2Tj");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $5115af9760f204be$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $dYbEM.default),
        'map': new ((0, $gy2Tj.default) || (0, $6r8m1.default)),
        'string': new (0, $dYbEM.default)
    };
}
var $5115af9760f204be$export$2e2bcd8739ae039 = $5115af9760f204be$var$mapCacheClear;

});
parcelRegister("dYbEM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2b9ebba954a9ca0$export$2e2bcd8739ae039; });

var $eLlrP = parcelRequire("eLlrP");

var $3mseR = parcelRequire("3mseR");

var $gyAfl = parcelRequire("gyAfl");

var $4qzzz = parcelRequire("4qzzz");

var $e5upi = parcelRequire("e5upi");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a2b9ebba954a9ca0$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$a2b9ebba954a9ca0$var$Hash.prototype.clear = (0, $eLlrP.default);
$a2b9ebba954a9ca0$var$Hash.prototype['delete'] = (0, $3mseR.default);
$a2b9ebba954a9ca0$var$Hash.prototype.get = (0, $gyAfl.default);
$a2b9ebba954a9ca0$var$Hash.prototype.has = (0, $4qzzz.default);
$a2b9ebba954a9ca0$var$Hash.prototype.set = (0, $e5upi.default);
var $a2b9ebba954a9ca0$export$2e2bcd8739ae039 = $a2b9ebba954a9ca0$var$Hash;

});
parcelRegister("eLlrP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abf6178f4685a2a9$export$2e2bcd8739ae039; });

var $krfKU = parcelRequire("krfKU");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $abf6178f4685a2a9$var$hashClear() {
    this.__data__ = (0, $krfKU.default) ? (0, $krfKU.default)(null) : {};
    this.size = 0;
}
var $abf6178f4685a2a9$export$2e2bcd8739ae039 = $abf6178f4685a2a9$var$hashClear;

});
parcelRegister("krfKU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee128d018aa0e4fe$export$2e2bcd8739ae039; });

var $biB8D = parcelRequire("biB8D");
/* Built-in method references that are verified to be native. */ var $ee128d018aa0e4fe$var$nativeCreate = (0, $biB8D.default)(Object, 'create');
var $ee128d018aa0e4fe$export$2e2bcd8739ae039 = $ee128d018aa0e4fe$var$nativeCreate;

});


parcelRegister("3mseR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $272954c64142dadf$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $272954c64142dadf$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $272954c64142dadf$export$2e2bcd8739ae039 = $272954c64142dadf$var$hashDelete;

});

parcelRegister("gyAfl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0dbf01c42344868$export$2e2bcd8739ae039; });

var $krfKU = parcelRequire("krfKU");
/** Used to stand-in for `undefined` hash values. */ var $c0dbf01c42344868$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $c0dbf01c42344868$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c0dbf01c42344868$var$hasOwnProperty = $c0dbf01c42344868$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c0dbf01c42344868$var$hashGet(key) {
    var data = this.__data__;
    if (0, $krfKU.default) {
        var result = data[key];
        return result === $c0dbf01c42344868$var$HASH_UNDEFINED ? undefined : result;
    }
    return $c0dbf01c42344868$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $c0dbf01c42344868$export$2e2bcd8739ae039 = $c0dbf01c42344868$var$hashGet;

});

parcelRegister("4qzzz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33952f1eb3a7b406$export$2e2bcd8739ae039; });

var $krfKU = parcelRequire("krfKU");
/** Used for built-in method references. */ var $33952f1eb3a7b406$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $33952f1eb3a7b406$var$hasOwnProperty = $33952f1eb3a7b406$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $33952f1eb3a7b406$var$hashHas(key) {
    var data = this.__data__;
    return (0, $krfKU.default) ? data[key] !== undefined : $33952f1eb3a7b406$var$hasOwnProperty.call(data, key);
}
var $33952f1eb3a7b406$export$2e2bcd8739ae039 = $33952f1eb3a7b406$var$hashHas;

});

parcelRegister("e5upi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4191e876befb990$export$2e2bcd8739ae039; });

var $krfKU = parcelRequire("krfKU");
/** Used to stand-in for `undefined` hash values. */ var $a4191e876befb990$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $a4191e876befb990$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $krfKU.default) && value === undefined ? $a4191e876befb990$var$HASH_UNDEFINED : value;
    return this;
}
var $a4191e876befb990$export$2e2bcd8739ae039 = $a4191e876befb990$var$hashSet;

});



parcelRegister("p7iLd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04b7ffdba047a42e$export$2e2bcd8739ae039; });

var $4lmer = parcelRequire("4lmer");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $04b7ffdba047a42e$var$mapCacheDelete(key) {
    var result = (0, $4lmer.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $04b7ffdba047a42e$export$2e2bcd8739ae039 = $04b7ffdba047a42e$var$mapCacheDelete;

});
parcelRegister("4lmer", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $329a5e5e317866c2$export$2e2bcd8739ae039; });

var $f5lcn = parcelRequire("f5lcn");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $329a5e5e317866c2$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $f5lcn.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $329a5e5e317866c2$export$2e2bcd8739ae039 = $329a5e5e317866c2$var$getMapData;

});
parcelRegister("f5lcn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afb7c4432d266be3$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $afb7c4432d266be3$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $afb7c4432d266be3$export$2e2bcd8739ae039 = $afb7c4432d266be3$var$isKeyable;

});



parcelRegister("2VcPt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $220adb3eb6ca317a$export$2e2bcd8739ae039; });

var $4lmer = parcelRequire("4lmer");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $220adb3eb6ca317a$var$mapCacheGet(key) {
    return (0, $4lmer.default)(this, key).get(key);
}
var $220adb3eb6ca317a$export$2e2bcd8739ae039 = $220adb3eb6ca317a$var$mapCacheGet;

});

parcelRegister("cbtQY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dedab63f3282b39$export$2e2bcd8739ae039; });

var $4lmer = parcelRequire("4lmer");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8dedab63f3282b39$var$mapCacheHas(key) {
    return (0, $4lmer.default)(this, key).has(key);
}
var $8dedab63f3282b39$export$2e2bcd8739ae039 = $8dedab63f3282b39$var$mapCacheHas;

});

parcelRegister("g02Pq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba5ed7183fd2f5e1$export$2e2bcd8739ae039; });

var $4lmer = parcelRequire("4lmer");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $ba5ed7183fd2f5e1$var$mapCacheSet(key, value) {
    var data = (0, $4lmer.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $ba5ed7183fd2f5e1$export$2e2bcd8739ae039 = $ba5ed7183fd2f5e1$var$mapCacheSet;

});




parcelRegister("j0ySs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd69124f44fe3a84$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $dd69124f44fe3a84$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $dd69124f44fe3a84$export$2e2bcd8739ae039 = $dd69124f44fe3a84$var$arrayEach;

});

parcelRegister("5QA1H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $441dc12f1e31bb18$export$2e2bcd8739ae039; });

var $fR9cV = parcelRequire("fR9cV");

var $klNLT = parcelRequire("klNLT");
/** Used for built-in method references. */ var $441dc12f1e31bb18$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $441dc12f1e31bb18$var$hasOwnProperty = $441dc12f1e31bb18$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $441dc12f1e31bb18$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($441dc12f1e31bb18$var$hasOwnProperty.call(object, key) && (0, $klNLT.default)(objValue, value)) || value === undefined && !(key in object)) (0, $fR9cV.default)(object, key, value);
}
var $441dc12f1e31bb18$export$2e2bcd8739ae039 = $441dc12f1e31bb18$var$assignValue;

});
parcelRegister("fR9cV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8b2f2aa3af21d0f$export$2e2bcd8739ae039; });

var $3ovpc = parcelRequire("3ovpc");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b8b2f2aa3af21d0f$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $3ovpc.default)) (0, $3ovpc.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $b8b2f2aa3af21d0f$export$2e2bcd8739ae039 = $b8b2f2aa3af21d0f$var$baseAssignValue;

});
parcelRegister("3ovpc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $278bf97b2fbec772$export$2e2bcd8739ae039; });

var $biB8D = parcelRequire("biB8D");
var $278bf97b2fbec772$var$defineProperty = function() {
    try {
        var func = (0, $biB8D.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $278bf97b2fbec772$export$2e2bcd8739ae039 = $278bf97b2fbec772$var$defineProperty;

});



parcelRegister("j3TUt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de09aaab32d2dce5$export$2e2bcd8739ae039; });

var $hYFm9 = parcelRequire("hYFm9");

var $c5KVR = parcelRequire("c5KVR");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $de09aaab32d2dce5$var$baseAssign(object, source) {
    return object && (0, $hYFm9.default)(source, (0, $c5KVR.default)(source), object);
}
var $de09aaab32d2dce5$export$2e2bcd8739ae039 = $de09aaab32d2dce5$var$baseAssign;

});
parcelRegister("hYFm9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1681ec2a2e1ba7c$export$2e2bcd8739ae039; });

var $5QA1H = parcelRequire("5QA1H");

var $fR9cV = parcelRequire("fR9cV");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $d1681ec2a2e1ba7c$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $fR9cV.default)(object, key, newValue);
        else (0, $5QA1H.default)(object, key, newValue);
    }
    return object;
}
var $d1681ec2a2e1ba7c$export$2e2bcd8739ae039 = $d1681ec2a2e1ba7c$var$copyObject;

});

parcelRegister("c5KVR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cda5b688b56ab6f$export$2e2bcd8739ae039; });

var $4OHhu = parcelRequire("4OHhu");

var $3REl5 = parcelRequire("3REl5");

var $7SysS = parcelRequire("7SysS");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $8cda5b688b56ab6f$var$keys(object) {
    return (0, $7SysS.default)(object) ? (0, $4OHhu.default)(object) : (0, $3REl5.default)(object);
}
var $8cda5b688b56ab6f$export$2e2bcd8739ae039 = $8cda5b688b56ab6f$var$keys;

});
parcelRegister("4OHhu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $381d67aa1bb7950b$export$2e2bcd8739ae039; });

var $7SToy = parcelRequire("7SToy");

var $ds9u5 = parcelRequire("ds9u5");

var $iLE7q = parcelRequire("iLE7q");

var $12ime = parcelRequire("12ime");

var $7aJzx = parcelRequire("7aJzx");

var $b6PCo = parcelRequire("b6PCo");
/** Used for built-in method references. */ var $381d67aa1bb7950b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $381d67aa1bb7950b$var$hasOwnProperty = $381d67aa1bb7950b$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $381d67aa1bb7950b$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $iLE7q.default)(value), isArg = !isArr && (0, $ds9u5.default)(value), isBuff = !isArr && !isArg && (0, $12ime.default)(value), isType = !isArr && !isArg && !isBuff && (0, $b6PCo.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $7SToy.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $381d67aa1bb7950b$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $7aJzx.default)(key, length)))) result.push(key);
    return result;
}
var $381d67aa1bb7950b$export$2e2bcd8739ae039 = $381d67aa1bb7950b$var$arrayLikeKeys;

});
parcelRegister("7SToy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bd88bd7e7ba6773$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $5bd88bd7e7ba6773$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $5bd88bd7e7ba6773$export$2e2bcd8739ae039 = $5bd88bd7e7ba6773$var$baseTimes;

});

parcelRegister("ds9u5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cb53f41323840e0$export$2e2bcd8739ae039; });

var $czGje = parcelRequire("czGje");

var $4Wkzy = parcelRequire("4Wkzy");
/** Used for built-in method references. */ var $9cb53f41323840e0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9cb53f41323840e0$var$hasOwnProperty = $9cb53f41323840e0$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $9cb53f41323840e0$var$propertyIsEnumerable = $9cb53f41323840e0$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $9cb53f41323840e0$var$isArguments = (0, $czGje.default)(function() {
    return arguments;
}()) ? (0, $czGje.default) : function(value) {
    return (0, $4Wkzy.default)(value) && $9cb53f41323840e0$var$hasOwnProperty.call(value, 'callee') && !$9cb53f41323840e0$var$propertyIsEnumerable.call(value, 'callee');
};
var $9cb53f41323840e0$export$2e2bcd8739ae039 = $9cb53f41323840e0$var$isArguments;

});
parcelRegister("czGje", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $927992a91ad1a55c$export$2e2bcd8739ae039; });

var $iA9dk = parcelRequire("iA9dk");

var $4Wkzy = parcelRequire("4Wkzy");
/** `Object#toString` result references. */ var $927992a91ad1a55c$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $927992a91ad1a55c$var$baseIsArguments(value) {
    return (0, $4Wkzy.default)(value) && (0, $iA9dk.default)(value) == $927992a91ad1a55c$var$argsTag;
}
var $927992a91ad1a55c$export$2e2bcd8739ae039 = $927992a91ad1a55c$var$baseIsArguments;

});


parcelRegister("iLE7q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da9bbc8a7df4f4ff$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $da9bbc8a7df4f4ff$var$isArray = Array.isArray;
var $da9bbc8a7df4f4ff$export$2e2bcd8739ae039 = $da9bbc8a7df4f4ff$var$isArray;

});

parcelRegister("12ime", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c1437c76bc9c996$export$2e2bcd8739ae039; });

var $hi07e = parcelRequire("hi07e");

var $k9zmT = parcelRequire("k9zmT");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $hi07e.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $k9zmT.default);
var $0c1437c76bc9c996$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("k9zmT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eac015527c1599bd$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $eac015527c1599bd$var$stubFalse() {
    return false;
}
var $eac015527c1599bd$export$2e2bcd8739ae039 = $eac015527c1599bd$var$stubFalse;

});


parcelRegister("7aJzx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $538cd148342510a5$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $538cd148342510a5$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $538cd148342510a5$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $538cd148342510a5$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $538cd148342510a5$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $538cd148342510a5$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $538cd148342510a5$export$2e2bcd8739ae039 = $538cd148342510a5$var$isIndex;

});

parcelRegister("b6PCo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81684b8afc455290$export$2e2bcd8739ae039; });

var $fyWMw = parcelRequire("fyWMw");

var $a76JN = parcelRequire("a76JN");

var $jnaOG = parcelRequire("jnaOG");
/* Node.js helper references. */ var $81684b8afc455290$var$nodeIsTypedArray = (0, $jnaOG.default) && (0, $jnaOG.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $81684b8afc455290$var$isTypedArray = $81684b8afc455290$var$nodeIsTypedArray ? (0, $a76JN.default)($81684b8afc455290$var$nodeIsTypedArray) : (0, $fyWMw.default);
var $81684b8afc455290$export$2e2bcd8739ae039 = $81684b8afc455290$var$isTypedArray;

});
parcelRegister("fyWMw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b547a0cb8c28bfbf$export$2e2bcd8739ae039; });

var $iA9dk = parcelRequire("iA9dk");

var $Pf2EK = parcelRequire("Pf2EK");

var $4Wkzy = parcelRequire("4Wkzy");
/** `Object#toString` result references. */ var $b547a0cb8c28bfbf$var$argsTag = '[object Arguments]', $b547a0cb8c28bfbf$var$arrayTag = '[object Array]', $b547a0cb8c28bfbf$var$boolTag = '[object Boolean]', $b547a0cb8c28bfbf$var$dateTag = '[object Date]', $b547a0cb8c28bfbf$var$errorTag = '[object Error]', $b547a0cb8c28bfbf$var$funcTag = '[object Function]', $b547a0cb8c28bfbf$var$mapTag = '[object Map]', $b547a0cb8c28bfbf$var$numberTag = '[object Number]', $b547a0cb8c28bfbf$var$objectTag = '[object Object]', $b547a0cb8c28bfbf$var$regexpTag = '[object RegExp]', $b547a0cb8c28bfbf$var$setTag = '[object Set]', $b547a0cb8c28bfbf$var$stringTag = '[object String]', $b547a0cb8c28bfbf$var$weakMapTag = '[object WeakMap]';
var $b547a0cb8c28bfbf$var$arrayBufferTag = '[object ArrayBuffer]', $b547a0cb8c28bfbf$var$dataViewTag = '[object DataView]', $b547a0cb8c28bfbf$var$float32Tag = '[object Float32Array]', $b547a0cb8c28bfbf$var$float64Tag = '[object Float64Array]', $b547a0cb8c28bfbf$var$int8Tag = '[object Int8Array]', $b547a0cb8c28bfbf$var$int16Tag = '[object Int16Array]', $b547a0cb8c28bfbf$var$int32Tag = '[object Int32Array]', $b547a0cb8c28bfbf$var$uint8Tag = '[object Uint8Array]', $b547a0cb8c28bfbf$var$uint8ClampedTag = '[object Uint8ClampedArray]', $b547a0cb8c28bfbf$var$uint16Tag = '[object Uint16Array]', $b547a0cb8c28bfbf$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $b547a0cb8c28bfbf$var$typedArrayTags = {};
$b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$float32Tag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$float64Tag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$int8Tag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$int16Tag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$int32Tag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$uint8Tag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$uint8ClampedTag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$uint16Tag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$uint32Tag] = true;
$b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$argsTag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$arrayTag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$arrayBufferTag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$boolTag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$dataViewTag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$dateTag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$errorTag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$funcTag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$mapTag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$numberTag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$objectTag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$regexpTag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$setTag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$stringTag] = $b547a0cb8c28bfbf$var$typedArrayTags[$b547a0cb8c28bfbf$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $b547a0cb8c28bfbf$var$baseIsTypedArray(value) {
    return (0, $4Wkzy.default)(value) && (0, $Pf2EK.default)(value.length) && !!$b547a0cb8c28bfbf$var$typedArrayTags[(0, $iA9dk.default)(value)];
}
var $b547a0cb8c28bfbf$export$2e2bcd8739ae039 = $b547a0cb8c28bfbf$var$baseIsTypedArray;

});
parcelRegister("Pf2EK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09a06e8814784839$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $09a06e8814784839$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $09a06e8814784839$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $09a06e8814784839$var$MAX_SAFE_INTEGER;
}
var $09a06e8814784839$export$2e2bcd8739ae039 = $09a06e8814784839$var$isLength;

});


parcelRegister("a76JN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75cfc8c3c5c2aeb5$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $75cfc8c3c5c2aeb5$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $75cfc8c3c5c2aeb5$export$2e2bcd8739ae039 = $75cfc8c3c5c2aeb5$var$baseUnary;

});

parcelRegister("jnaOG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1a88e393f67e03d$export$2e2bcd8739ae039; });

var $48A5B = parcelRequire("48A5B");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $48A5B.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $e1a88e393f67e03d$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("3REl5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d059cd3f5dfdab8$export$2e2bcd8739ae039; });

var $7MSsq = parcelRequire("7MSsq");

var $94XhV = parcelRequire("94XhV");
/** Used for built-in method references. */ var $2d059cd3f5dfdab8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2d059cd3f5dfdab8$var$hasOwnProperty = $2d059cd3f5dfdab8$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $2d059cd3f5dfdab8$var$baseKeys(object) {
    if (!(0, $7MSsq.default)(object)) return (0, $94XhV.default)(object);
    var result = [];
    for(var key in Object(object))if ($2d059cd3f5dfdab8$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $2d059cd3f5dfdab8$export$2e2bcd8739ae039 = $2d059cd3f5dfdab8$var$baseKeys;

});
parcelRegister("7MSsq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ab74234a7f9dbde$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $5ab74234a7f9dbde$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $5ab74234a7f9dbde$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $5ab74234a7f9dbde$var$objectProto;
    return value === proto;
}
var $5ab74234a7f9dbde$export$2e2bcd8739ae039 = $5ab74234a7f9dbde$var$isPrototype;

});

parcelRegister("94XhV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69c27a2998b87c37$export$2e2bcd8739ae039; });

var $ktVHm = parcelRequire("ktVHm");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $69c27a2998b87c37$var$nativeKeys = (0, $ktVHm.default)(Object.keys, Object);
var $69c27a2998b87c37$export$2e2bcd8739ae039 = $69c27a2998b87c37$var$nativeKeys;

});


parcelRegister("7SysS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bc84f8e6ba0e2e3$export$2e2bcd8739ae039; });

var $k2UtG = parcelRequire("k2UtG");

var $Pf2EK = parcelRequire("Pf2EK");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $5bc84f8e6ba0e2e3$var$isArrayLike(value) {
    return value != null && (0, $Pf2EK.default)(value.length) && !(0, $k2UtG.default)(value);
}
var $5bc84f8e6ba0e2e3$export$2e2bcd8739ae039 = $5bc84f8e6ba0e2e3$var$isArrayLike;

});



parcelRegister("eBsKQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa1ad3707784c791$export$2e2bcd8739ae039; });

var $hYFm9 = parcelRequire("hYFm9");

var $43eFw = parcelRequire("43eFw");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $aa1ad3707784c791$var$baseAssignIn(object, source) {
    return object && (0, $hYFm9.default)(source, (0, $43eFw.default)(source), object);
}
var $aa1ad3707784c791$export$2e2bcd8739ae039 = $aa1ad3707784c791$var$baseAssignIn;

});
parcelRegister("43eFw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f32d21d4c2d444b$export$2e2bcd8739ae039; });

var $4OHhu = parcelRequire("4OHhu");

var $xZ7wg = parcelRequire("xZ7wg");

var $7SysS = parcelRequire("7SysS");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $2f32d21d4c2d444b$var$keysIn(object) {
    return (0, $7SysS.default)(object) ? (0, $4OHhu.default)(object, true) : (0, $xZ7wg.default)(object);
}
var $2f32d21d4c2d444b$export$2e2bcd8739ae039 = $2f32d21d4c2d444b$var$keysIn;

});
parcelRegister("xZ7wg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06627e657834e1a8$export$2e2bcd8739ae039; });

var $bd5nv = parcelRequire("bd5nv");

var $7MSsq = parcelRequire("7MSsq");

var $fdOEc = parcelRequire("fdOEc");
/** Used for built-in method references. */ var $06627e657834e1a8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $06627e657834e1a8$var$hasOwnProperty = $06627e657834e1a8$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $06627e657834e1a8$var$baseKeysIn(object) {
    if (!(0, $bd5nv.default)(object)) return (0, $fdOEc.default)(object);
    var isProto = (0, $7MSsq.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$06627e657834e1a8$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $06627e657834e1a8$export$2e2bcd8739ae039 = $06627e657834e1a8$var$baseKeysIn;

});
parcelRegister("fdOEc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b14f5b705adc7e10$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $b14f5b705adc7e10$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $b14f5b705adc7e10$export$2e2bcd8739ae039 = $b14f5b705adc7e10$var$nativeKeysIn;

});




parcelRegister("6IXrq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e54f5f76cad612b$export$2e2bcd8739ae039; });

var $hi07e = parcelRequire("hi07e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $hi07e.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $4e54f5f76cad612b$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("lkGqY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f87c61bbedf8d210$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $f87c61bbedf8d210$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $f87c61bbedf8d210$export$2e2bcd8739ae039 = $f87c61bbedf8d210$var$copyArray;

});

parcelRegister("htTmQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cba017e76bd8ea20$export$2e2bcd8739ae039; });

var $hYFm9 = parcelRequire("hYFm9");

var $lkJMo = parcelRequire("lkJMo");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $cba017e76bd8ea20$var$copySymbols(source, object) {
    return (0, $hYFm9.default)(source, (0, $lkJMo.default)(source), object);
}
var $cba017e76bd8ea20$export$2e2bcd8739ae039 = $cba017e76bd8ea20$var$copySymbols;

});
parcelRegister("lkJMo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f87efa1908e87374$export$2e2bcd8739ae039; });

var $atMz2 = parcelRequire("atMz2");

var $iba3K = parcelRequire("iba3K");
/** Used for built-in method references. */ var $f87efa1908e87374$var$objectProto = Object.prototype;
/** Built-in value references. */ var $f87efa1908e87374$var$propertyIsEnumerable = $f87efa1908e87374$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f87efa1908e87374$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $f87efa1908e87374$var$getSymbols = !$f87efa1908e87374$var$nativeGetSymbols ? (0, $iba3K.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $atMz2.default)($f87efa1908e87374$var$nativeGetSymbols(object), function(symbol) {
        return $f87efa1908e87374$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $f87efa1908e87374$export$2e2bcd8739ae039 = $f87efa1908e87374$var$getSymbols;

});
parcelRegister("atMz2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a1248a710edc91b$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $7a1248a710edc91b$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $7a1248a710edc91b$export$2e2bcd8739ae039 = $7a1248a710edc91b$var$arrayFilter;

});

parcelRegister("iba3K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3c10eaaab2255fc$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $d3c10eaaab2255fc$var$stubArray() {
    return [];
}
var $d3c10eaaab2255fc$export$2e2bcd8739ae039 = $d3c10eaaab2255fc$var$stubArray;

});



parcelRegister("am6LV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78a1363ca89ccd42$export$2e2bcd8739ae039; });

var $hYFm9 = parcelRequire("hYFm9");

var $9XFo7 = parcelRequire("9XFo7");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $78a1363ca89ccd42$var$copySymbolsIn(source, object) {
    return (0, $hYFm9.default)(source, (0, $9XFo7.default)(source), object);
}
var $78a1363ca89ccd42$export$2e2bcd8739ae039 = $78a1363ca89ccd42$var$copySymbolsIn;

});
parcelRegister("9XFo7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7409ba851b973612$export$2e2bcd8739ae039; });

var $8WIIl = parcelRequire("8WIIl");

var $eqX5A = parcelRequire("eqX5A");

var $lkJMo = parcelRequire("lkJMo");

var $iba3K = parcelRequire("iba3K");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7409ba851b973612$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $7409ba851b973612$var$getSymbolsIn = !$7409ba851b973612$var$nativeGetSymbols ? (0, $iba3K.default) : function(object) {
    var result = [];
    while(object){
        (0, $8WIIl.default)(result, (0, $lkJMo.default)(object));
        object = (0, $eqX5A.default)(object);
    }
    return result;
};
var $7409ba851b973612$export$2e2bcd8739ae039 = $7409ba851b973612$var$getSymbolsIn;

});
parcelRegister("8WIIl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68366cd6adbb3aac$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $68366cd6adbb3aac$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $68366cd6adbb3aac$export$2e2bcd8739ae039 = $68366cd6adbb3aac$var$arrayPush;

});



parcelRegister("8q7Hc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6216b8a56ec818c1$export$2e2bcd8739ae039; });

var $fuV9V = parcelRequire("fuV9V");

var $lkJMo = parcelRequire("lkJMo");

var $c5KVR = parcelRequire("c5KVR");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $6216b8a56ec818c1$var$getAllKeys(object) {
    return (0, $fuV9V.default)(object, (0, $c5KVR.default), (0, $lkJMo.default));
}
var $6216b8a56ec818c1$export$2e2bcd8739ae039 = $6216b8a56ec818c1$var$getAllKeys;

});
parcelRegister("fuV9V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b485fefa7b5ce820$export$2e2bcd8739ae039; });

var $8WIIl = parcelRequire("8WIIl");

var $iLE7q = parcelRequire("iLE7q");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $b485fefa7b5ce820$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $iLE7q.default)(object) ? result : (0, $8WIIl.default)(result, symbolsFunc(object));
}
var $b485fefa7b5ce820$export$2e2bcd8739ae039 = $b485fefa7b5ce820$var$baseGetAllKeys;

});


parcelRegister("ffwkX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1a1572bdffd2d54$export$2e2bcd8739ae039; });

var $fuV9V = parcelRequire("fuV9V");

var $9XFo7 = parcelRequire("9XFo7");

var $43eFw = parcelRequire("43eFw");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $b1a1572bdffd2d54$var$getAllKeysIn(object) {
    return (0, $fuV9V.default)(object, (0, $43eFw.default), (0, $9XFo7.default));
}
var $b1a1572bdffd2d54$export$2e2bcd8739ae039 = $b1a1572bdffd2d54$var$getAllKeysIn;

});

parcelRegister("ajaGB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7813f7c54157e9c0$export$2e2bcd8739ae039; });

var $dYQkv = parcelRequire("dYQkv");

var $gy2Tj = parcelRequire("gy2Tj");

var $5K7J6 = parcelRequire("5K7J6");

var $6OTTp = parcelRequire("6OTTp");

var $apWz4 = parcelRequire("apWz4");

var $iA9dk = parcelRequire("iA9dk");

var $2QMAC = parcelRequire("2QMAC");
/** `Object#toString` result references. */ var $7813f7c54157e9c0$var$mapTag = '[object Map]', $7813f7c54157e9c0$var$objectTag = '[object Object]', $7813f7c54157e9c0$var$promiseTag = '[object Promise]', $7813f7c54157e9c0$var$setTag = '[object Set]', $7813f7c54157e9c0$var$weakMapTag = '[object WeakMap]';
var $7813f7c54157e9c0$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $7813f7c54157e9c0$var$dataViewCtorString = (0, $2QMAC.default)((0, $dYQkv.default)), $7813f7c54157e9c0$var$mapCtorString = (0, $2QMAC.default)((0, $gy2Tj.default)), $7813f7c54157e9c0$var$promiseCtorString = (0, $2QMAC.default)((0, $5K7J6.default)), $7813f7c54157e9c0$var$setCtorString = (0, $2QMAC.default)((0, $6OTTp.default)), $7813f7c54157e9c0$var$weakMapCtorString = (0, $2QMAC.default)((0, $apWz4.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $7813f7c54157e9c0$var$getTag = (0, $iA9dk.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $dYQkv.default) && $7813f7c54157e9c0$var$getTag(new (0, $dYQkv.default)(new ArrayBuffer(1))) != $7813f7c54157e9c0$var$dataViewTag || (0, $gy2Tj.default) && $7813f7c54157e9c0$var$getTag(new (0, $gy2Tj.default)) != $7813f7c54157e9c0$var$mapTag || (0, $5K7J6.default) && $7813f7c54157e9c0$var$getTag((0, $5K7J6.default).resolve()) != $7813f7c54157e9c0$var$promiseTag || (0, $6OTTp.default) && $7813f7c54157e9c0$var$getTag(new (0, $6OTTp.default)) != $7813f7c54157e9c0$var$setTag || (0, $apWz4.default) && $7813f7c54157e9c0$var$getTag(new (0, $apWz4.default)) != $7813f7c54157e9c0$var$weakMapTag) $7813f7c54157e9c0$var$getTag = function(value) {
    var result = (0, $iA9dk.default)(value), Ctor = result == $7813f7c54157e9c0$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $2QMAC.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $7813f7c54157e9c0$var$dataViewCtorString:
            return $7813f7c54157e9c0$var$dataViewTag;
        case $7813f7c54157e9c0$var$mapCtorString:
            return $7813f7c54157e9c0$var$mapTag;
        case $7813f7c54157e9c0$var$promiseCtorString:
            return $7813f7c54157e9c0$var$promiseTag;
        case $7813f7c54157e9c0$var$setCtorString:
            return $7813f7c54157e9c0$var$setTag;
        case $7813f7c54157e9c0$var$weakMapCtorString:
            return $7813f7c54157e9c0$var$weakMapTag;
    }
    return result;
};
var $7813f7c54157e9c0$export$2e2bcd8739ae039 = $7813f7c54157e9c0$var$getTag;

});
parcelRegister("dYQkv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2d9788a817df16c$export$2e2bcd8739ae039; });

var $biB8D = parcelRequire("biB8D");

var $hi07e = parcelRequire("hi07e");
/* Built-in method references that are verified to be native. */ var $a2d9788a817df16c$var$DataView = (0, $biB8D.default)((0, $hi07e.default), 'DataView');
var $a2d9788a817df16c$export$2e2bcd8739ae039 = $a2d9788a817df16c$var$DataView;

});

parcelRegister("5K7J6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42e73df484f39588$export$2e2bcd8739ae039; });

var $biB8D = parcelRequire("biB8D");

var $hi07e = parcelRequire("hi07e");
/* Built-in method references that are verified to be native. */ var $42e73df484f39588$var$Promise = (0, $biB8D.default)((0, $hi07e.default), 'Promise');
var $42e73df484f39588$export$2e2bcd8739ae039 = $42e73df484f39588$var$Promise;

});

parcelRegister("6OTTp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f72c4b0bb2204dc$export$2e2bcd8739ae039; });

var $biB8D = parcelRequire("biB8D");

var $hi07e = parcelRequire("hi07e");
/* Built-in method references that are verified to be native. */ var $4f72c4b0bb2204dc$var$Set = (0, $biB8D.default)((0, $hi07e.default), 'Set');
var $4f72c4b0bb2204dc$export$2e2bcd8739ae039 = $4f72c4b0bb2204dc$var$Set;

});

parcelRegister("apWz4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7959aae50d708528$export$2e2bcd8739ae039; });

var $biB8D = parcelRequire("biB8D");

var $hi07e = parcelRequire("hi07e");
/* Built-in method references that are verified to be native. */ var $7959aae50d708528$var$WeakMap = (0, $biB8D.default)((0, $hi07e.default), 'WeakMap');
var $7959aae50d708528$export$2e2bcd8739ae039 = $7959aae50d708528$var$WeakMap;

});


parcelRegister("hMa52", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf0ebd13a4aefc7d$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $cf0ebd13a4aefc7d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cf0ebd13a4aefc7d$var$hasOwnProperty = $cf0ebd13a4aefc7d$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $cf0ebd13a4aefc7d$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $cf0ebd13a4aefc7d$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $cf0ebd13a4aefc7d$export$2e2bcd8739ae039 = $cf0ebd13a4aefc7d$var$initCloneArray;

});

parcelRegister("5cVH4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3caad384f3412c7d$export$2e2bcd8739ae039; });

var $3QJca = parcelRequire("3QJca");

var $cmA0j = parcelRequire("cmA0j");

var $cBmkf = parcelRequire("cBmkf");

var $15eqz = parcelRequire("15eqz");

var $il9Ba = parcelRequire("il9Ba");
/** `Object#toString` result references. */ var $3caad384f3412c7d$var$boolTag = '[object Boolean]', $3caad384f3412c7d$var$dateTag = '[object Date]', $3caad384f3412c7d$var$mapTag = '[object Map]', $3caad384f3412c7d$var$numberTag = '[object Number]', $3caad384f3412c7d$var$regexpTag = '[object RegExp]', $3caad384f3412c7d$var$setTag = '[object Set]', $3caad384f3412c7d$var$stringTag = '[object String]', $3caad384f3412c7d$var$symbolTag = '[object Symbol]';
var $3caad384f3412c7d$var$arrayBufferTag = '[object ArrayBuffer]', $3caad384f3412c7d$var$dataViewTag = '[object DataView]', $3caad384f3412c7d$var$float32Tag = '[object Float32Array]', $3caad384f3412c7d$var$float64Tag = '[object Float64Array]', $3caad384f3412c7d$var$int8Tag = '[object Int8Array]', $3caad384f3412c7d$var$int16Tag = '[object Int16Array]', $3caad384f3412c7d$var$int32Tag = '[object Int32Array]', $3caad384f3412c7d$var$uint8Tag = '[object Uint8Array]', $3caad384f3412c7d$var$uint8ClampedTag = '[object Uint8ClampedArray]', $3caad384f3412c7d$var$uint16Tag = '[object Uint16Array]', $3caad384f3412c7d$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $3caad384f3412c7d$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $3caad384f3412c7d$var$arrayBufferTag:
            return (0, $3QJca.default)(object);
        case $3caad384f3412c7d$var$boolTag:
        case $3caad384f3412c7d$var$dateTag:
            return new Ctor(+object);
        case $3caad384f3412c7d$var$dataViewTag:
            return (0, $cmA0j.default)(object, isDeep);
        case $3caad384f3412c7d$var$float32Tag:
        case $3caad384f3412c7d$var$float64Tag:
        case $3caad384f3412c7d$var$int8Tag:
        case $3caad384f3412c7d$var$int16Tag:
        case $3caad384f3412c7d$var$int32Tag:
        case $3caad384f3412c7d$var$uint8Tag:
        case $3caad384f3412c7d$var$uint8ClampedTag:
        case $3caad384f3412c7d$var$uint16Tag:
        case $3caad384f3412c7d$var$uint32Tag:
            return (0, $il9Ba.default)(object, isDeep);
        case $3caad384f3412c7d$var$mapTag:
            return new Ctor;
        case $3caad384f3412c7d$var$numberTag:
        case $3caad384f3412c7d$var$stringTag:
            return new Ctor(object);
        case $3caad384f3412c7d$var$regexpTag:
            return (0, $cBmkf.default)(object);
        case $3caad384f3412c7d$var$setTag:
            return new Ctor;
        case $3caad384f3412c7d$var$symbolTag:
            return (0, $15eqz.default)(object);
    }
}
var $3caad384f3412c7d$export$2e2bcd8739ae039 = $3caad384f3412c7d$var$initCloneByTag;

});
parcelRegister("3QJca", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cd9494161df0eb9$export$2e2bcd8739ae039; });

var $iSB5j = parcelRequire("iSB5j");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $2cd9494161df0eb9$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $iSB5j.default)(result).set(new (0, $iSB5j.default)(arrayBuffer));
    return result;
}
var $2cd9494161df0eb9$export$2e2bcd8739ae039 = $2cd9494161df0eb9$var$cloneArrayBuffer;

});
parcelRegister("iSB5j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbea0968a0ee79d3$export$2e2bcd8739ae039; });

var $hi07e = parcelRequire("hi07e");
/** Built-in value references. */ var $dbea0968a0ee79d3$var$Uint8Array = (0, $hi07e.default).Uint8Array;
var $dbea0968a0ee79d3$export$2e2bcd8739ae039 = $dbea0968a0ee79d3$var$Uint8Array;

});


parcelRegister("cmA0j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $900377bc715920ad$export$2e2bcd8739ae039; });

var $3QJca = parcelRequire("3QJca");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $900377bc715920ad$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $3QJca.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $900377bc715920ad$export$2e2bcd8739ae039 = $900377bc715920ad$var$cloneDataView;

});

parcelRegister("cBmkf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92ca4226ee85711e$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $92ca4226ee85711e$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $92ca4226ee85711e$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $92ca4226ee85711e$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $92ca4226ee85711e$export$2e2bcd8739ae039 = $92ca4226ee85711e$var$cloneRegExp;

});

parcelRegister("15eqz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ca173178d69cd70$export$2e2bcd8739ae039; });

var $gxYDX = parcelRequire("gxYDX");
/** Used to convert symbols to primitives and strings. */ var $0ca173178d69cd70$var$symbolProto = (0, $gxYDX.default) ? (0, $gxYDX.default).prototype : undefined, $0ca173178d69cd70$var$symbolValueOf = $0ca173178d69cd70$var$symbolProto ? $0ca173178d69cd70$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $0ca173178d69cd70$var$cloneSymbol(symbol) {
    return $0ca173178d69cd70$var$symbolValueOf ? Object($0ca173178d69cd70$var$symbolValueOf.call(symbol)) : {};
}
var $0ca173178d69cd70$export$2e2bcd8739ae039 = $0ca173178d69cd70$var$cloneSymbol;

});

parcelRegister("il9Ba", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5a1a23b81571bd9$export$2e2bcd8739ae039; });

var $3QJca = parcelRequire("3QJca");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $d5a1a23b81571bd9$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $3QJca.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $d5a1a23b81571bd9$export$2e2bcd8739ae039 = $d5a1a23b81571bd9$var$cloneTypedArray;

});


parcelRegister("fJUYK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b75741c9fcc62e7f$export$2e2bcd8739ae039; });

var $eavTB = parcelRequire("eavTB");

var $eqX5A = parcelRequire("eqX5A");

var $7MSsq = parcelRequire("7MSsq");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $b75741c9fcc62e7f$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $7MSsq.default)(object) ? (0, $eavTB.default)((0, $eqX5A.default)(object)) : {};
}
var $b75741c9fcc62e7f$export$2e2bcd8739ae039 = $b75741c9fcc62e7f$var$initCloneObject;

});
parcelRegister("eavTB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a50abdb00edcf826$export$2e2bcd8739ae039; });

var $bd5nv = parcelRequire("bd5nv");
/** Built-in value references. */ var $a50abdb00edcf826$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $a50abdb00edcf826$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $bd5nv.default)(proto)) return {};
        if ($a50abdb00edcf826$var$objectCreate) return $a50abdb00edcf826$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $a50abdb00edcf826$export$2e2bcd8739ae039 = $a50abdb00edcf826$var$baseCreate;

});


parcelRegister("kJRFT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f191a545f723efdc$export$2e2bcd8739ae039; });

var $2V068 = parcelRequire("2V068");

var $a76JN = parcelRequire("a76JN");

var $jnaOG = parcelRequire("jnaOG");
/* Node.js helper references. */ var $f191a545f723efdc$var$nodeIsMap = (0, $jnaOG.default) && (0, $jnaOG.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $f191a545f723efdc$var$isMap = $f191a545f723efdc$var$nodeIsMap ? (0, $a76JN.default)($f191a545f723efdc$var$nodeIsMap) : (0, $2V068.default);
var $f191a545f723efdc$export$2e2bcd8739ae039 = $f191a545f723efdc$var$isMap;

});
parcelRegister("2V068", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2200fb1266f40890$export$2e2bcd8739ae039; });

var $ajaGB = parcelRequire("ajaGB");

var $4Wkzy = parcelRequire("4Wkzy");
/** `Object#toString` result references. */ var $2200fb1266f40890$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $2200fb1266f40890$var$baseIsMap(value) {
    return (0, $4Wkzy.default)(value) && (0, $ajaGB.default)(value) == $2200fb1266f40890$var$mapTag;
}
var $2200fb1266f40890$export$2e2bcd8739ae039 = $2200fb1266f40890$var$baseIsMap;

});


parcelRegister("6vkfT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bc559a24b2f1de5$export$2e2bcd8739ae039; });

var $jgIjB = parcelRequire("jgIjB");

var $a76JN = parcelRequire("a76JN");

var $jnaOG = parcelRequire("jnaOG");
/* Node.js helper references. */ var $4bc559a24b2f1de5$var$nodeIsSet = (0, $jnaOG.default) && (0, $jnaOG.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $4bc559a24b2f1de5$var$isSet = $4bc559a24b2f1de5$var$nodeIsSet ? (0, $a76JN.default)($4bc559a24b2f1de5$var$nodeIsSet) : (0, $jgIjB.default);
var $4bc559a24b2f1de5$export$2e2bcd8739ae039 = $4bc559a24b2f1de5$var$isSet;

});
parcelRegister("jgIjB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e071e3068cf335bb$export$2e2bcd8739ae039; });

var $ajaGB = parcelRequire("ajaGB");

var $4Wkzy = parcelRequire("4Wkzy");
/** `Object#toString` result references. */ var $e071e3068cf335bb$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $e071e3068cf335bb$var$baseIsSet(value) {
    return (0, $4Wkzy.default)(value) && (0, $ajaGB.default)(value) == $e071e3068cf335bb$var$setTag;
}
var $e071e3068cf335bb$export$2e2bcd8739ae039 = $e071e3068cf335bb$var$baseIsSet;

});




parcelRegister("dOiPr", function(module, exports) {
'use strict';
var $a0de8cddeb35af56$var$isArray = Array.isArray;
var $a0de8cddeb35af56$var$keyList = Object.keys;
var $a0de8cddeb35af56$var$hasProp = Object.prototype.hasOwnProperty;
var $a0de8cddeb35af56$var$hasElementType = typeof Element !== 'undefined';
function $a0de8cddeb35af56$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $a0de8cddeb35af56$var$isArray(a), arrB = $a0de8cddeb35af56$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$a0de8cddeb35af56$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $a0de8cddeb35af56$var$keyList(a);
        length = keys.length;
        if (length !== $a0de8cddeb35af56$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$a0de8cddeb35af56$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($a0de8cddeb35af56$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$a0de8cddeb35af56$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $a0de8cddeb35af56$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("e9INb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4e4a6c1be75adcb$export$2e2bcd8739ae039; });
var $a4e4a6c1be75adcb$var$isProduction = true;
function $a4e4a6c1be75adcb$var$warning(condition, message) {
    if (!$a4e4a6c1be75adcb$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $a4e4a6c1be75adcb$export$2e2bcd8739ae039 = $a4e4a6c1be75adcb$var$warning;

});

parcelRegister("cDy60", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9333934a035fb272$export$2e2bcd8739ae039; });

var $hePVl = parcelRequire("hePVl");
/** Used to compose bitmasks for cloning. */ var $9333934a035fb272$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $9333934a035fb272$var$clone(value) {
    return (0, $hePVl.default)(value, $9333934a035fb272$var$CLONE_SYMBOLS_FLAG);
}
var $9333934a035fb272$export$2e2bcd8739ae039 = $9333934a035fb272$var$clone;

});

parcelRegister("a2s7F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74efe7e30d5b8d70$export$2e2bcd8739ae039; });

var $f6OJU = parcelRequire("f6OJU");

var $lkGqY = parcelRequire("lkGqY");

var $iLE7q = parcelRequire("iLE7q");

var $fBJIR = parcelRequire("fBJIR");

var $3AJBH = parcelRequire("3AJBH");

var $2jKTq = parcelRequire("2jKTq");

var $3wPVS = parcelRequire("3wPVS");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $74efe7e30d5b8d70$var$toPath(value) {
    if ((0, $iLE7q.default)(value)) return (0, $f6OJU.default)(value, (0, $2jKTq.default));
    return (0, $fBJIR.default)(value) ? [
        value
    ] : (0, $lkGqY.default)((0, $3AJBH.default)((0, $3wPVS.default)(value)));
}
var $74efe7e30d5b8d70$export$2e2bcd8739ae039 = $74efe7e30d5b8d70$var$toPath;

});
parcelRegister("f6OJU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $affec656acc3986d$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $affec656acc3986d$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $affec656acc3986d$export$2e2bcd8739ae039 = $affec656acc3986d$var$arrayMap;

});

parcelRegister("fBJIR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5cdc73da7dee7bb$export$2e2bcd8739ae039; });

var $iA9dk = parcelRequire("iA9dk");

var $4Wkzy = parcelRequire("4Wkzy");
/** `Object#toString` result references. */ var $b5cdc73da7dee7bb$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b5cdc73da7dee7bb$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $4Wkzy.default)(value) && (0, $iA9dk.default)(value) == $b5cdc73da7dee7bb$var$symbolTag;
}
var $b5cdc73da7dee7bb$export$2e2bcd8739ae039 = $b5cdc73da7dee7bb$var$isSymbol;

});

parcelRegister("3AJBH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29d81c7a20352d97$export$2e2bcd8739ae039; });

var $5wUyj = parcelRequire("5wUyj");
/** Used to match property names within property paths. */ var $29d81c7a20352d97$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $29d81c7a20352d97$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $29d81c7a20352d97$var$stringToPath = (0, $5wUyj.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($29d81c7a20352d97$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($29d81c7a20352d97$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $29d81c7a20352d97$export$2e2bcd8739ae039 = $29d81c7a20352d97$var$stringToPath;

});
parcelRegister("5wUyj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $406bcf04fd1d0b44$export$2e2bcd8739ae039; });

var $4yfco = parcelRequire("4yfco");
/** Used as the maximum memoize cache size. */ var $406bcf04fd1d0b44$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $406bcf04fd1d0b44$var$memoizeCapped(func) {
    var result = (0, $4yfco.default)(func, function(key) {
        if (cache.size === $406bcf04fd1d0b44$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $406bcf04fd1d0b44$export$2e2bcd8739ae039 = $406bcf04fd1d0b44$var$memoizeCapped;

});
parcelRegister("4yfco", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3506208ebf8f92c2$export$2e2bcd8739ae039; });

var $1DGG9 = parcelRequire("1DGG9");
/** Error message constants. */ var $3506208ebf8f92c2$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $3506208ebf8f92c2$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($3506208ebf8f92c2$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($3506208ebf8f92c2$var$memoize.Cache || (0, $1DGG9.default));
    return memoized;
}
// Expose `MapCache`.
$3506208ebf8f92c2$var$memoize.Cache = (0, $1DGG9.default);
var $3506208ebf8f92c2$export$2e2bcd8739ae039 = $3506208ebf8f92c2$var$memoize;

});



parcelRegister("2jKTq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b01bb19f9255816$export$2e2bcd8739ae039; });

var $fBJIR = parcelRequire("fBJIR");
/** Used as references for various `Number` constants. */ var $1b01bb19f9255816$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $1b01bb19f9255816$var$toKey(value) {
    if (typeof value == 'string' || (0, $fBJIR.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$1b01bb19f9255816$var$INFINITY ? '-0' : result;
}
var $1b01bb19f9255816$export$2e2bcd8739ae039 = $1b01bb19f9255816$var$toKey;

});

parcelRegister("3wPVS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $291ca4f28138621a$export$2e2bcd8739ae039; });

var $cqzas = parcelRequire("cqzas");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $291ca4f28138621a$var$toString(value) {
    return value == null ? '' : (0, $cqzas.default)(value);
}
var $291ca4f28138621a$export$2e2bcd8739ae039 = $291ca4f28138621a$var$toString;

});
parcelRegister("cqzas", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90c331516ddee6c5$export$2e2bcd8739ae039; });

var $gxYDX = parcelRequire("gxYDX");

var $f6OJU = parcelRequire("f6OJU");

var $iLE7q = parcelRequire("iLE7q");

var $fBJIR = parcelRequire("fBJIR");
/** Used as references for various `Number` constants. */ var $90c331516ddee6c5$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $90c331516ddee6c5$var$symbolProto = (0, $gxYDX.default) ? (0, $gxYDX.default).prototype : undefined, $90c331516ddee6c5$var$symbolToString = $90c331516ddee6c5$var$symbolProto ? $90c331516ddee6c5$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $90c331516ddee6c5$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $iLE7q.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $f6OJU.default)(value, $90c331516ddee6c5$var$baseToString) + '';
    if ((0, $fBJIR.default)(value)) return $90c331516ddee6c5$var$symbolToString ? $90c331516ddee6c5$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$90c331516ddee6c5$var$INFINITY ? '-0' : result;
}
var $90c331516ddee6c5$export$2e2bcd8739ae039 = $90c331516ddee6c5$var$baseToString;

});



parcelRegister("dGR8M", function(module, exports) {
'use strict';

var $bg9vv = parcelRequire("bg9vv");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $9f786b39c214fe8d$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $9f786b39c214fe8d$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $9f786b39c214fe8d$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $9f786b39c214fe8d$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $9f786b39c214fe8d$var$TYPE_STATICS = {};
$9f786b39c214fe8d$var$TYPE_STATICS[$bg9vv.ForwardRef] = $9f786b39c214fe8d$var$FORWARD_REF_STATICS;
$9f786b39c214fe8d$var$TYPE_STATICS[$bg9vv.Memo] = $9f786b39c214fe8d$var$MEMO_STATICS;
function $9f786b39c214fe8d$var$getStatics(component) {
    // React v16.11 and below
    if ($bg9vv.isMemo(component)) return $9f786b39c214fe8d$var$MEMO_STATICS;
     // React v16.12 and above
    return $9f786b39c214fe8d$var$TYPE_STATICS[component['$$typeof']] || $9f786b39c214fe8d$var$REACT_STATICS;
}
var $9f786b39c214fe8d$var$defineProperty = Object.defineProperty;
var $9f786b39c214fe8d$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $9f786b39c214fe8d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $9f786b39c214fe8d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $9f786b39c214fe8d$var$getPrototypeOf = Object.getPrototypeOf;
var $9f786b39c214fe8d$var$objectPrototype = Object.prototype;
function $9f786b39c214fe8d$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($9f786b39c214fe8d$var$objectPrototype) {
            var inheritedComponent = $9f786b39c214fe8d$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $9f786b39c214fe8d$var$objectPrototype) $9f786b39c214fe8d$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $9f786b39c214fe8d$var$getOwnPropertyNames(sourceComponent);
        if ($9f786b39c214fe8d$var$getOwnPropertySymbols) keys = keys.concat($9f786b39c214fe8d$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $9f786b39c214fe8d$var$getStatics(targetComponent);
        var sourceStatics = $9f786b39c214fe8d$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$9f786b39c214fe8d$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $9f786b39c214fe8d$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $9f786b39c214fe8d$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $9f786b39c214fe8d$var$hoistNonReactStatics;

});
parcelRegister("bg9vv", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6jZRx"));

});
parcelRegister("6jZRx", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $49a481072e1b1678$export$2b8d127b894957b9; }, function (v) { return $49a481072e1b1678$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $49a481072e1b1678$export$cea3a54a6425200c; }, function (v) { return $49a481072e1b1678$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $49a481072e1b1678$export$a7c73072b1a182ae; }, function (v) { return $49a481072e1b1678$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $49a481072e1b1678$export$9f27bc3417b4524d; }, function (v) { return $49a481072e1b1678$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $49a481072e1b1678$export$db77ccec0bb4ccac; }, function (v) { return $49a481072e1b1678$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $49a481072e1b1678$export$8392c0c9d3dcbd35; }, function (v) { return $49a481072e1b1678$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $49a481072e1b1678$export$ffb0004e005737fa; }, function (v) { return $49a481072e1b1678$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $49a481072e1b1678$export$b624eff549462981; }, function (v) { return $49a481072e1b1678$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $49a481072e1b1678$export$7897aa7841a5380c; }, function (v) { return $49a481072e1b1678$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $49a481072e1b1678$export$602eac185826482c; }, function (v) { return $49a481072e1b1678$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $49a481072e1b1678$export$e2c29f18771995cb; }, function (v) { return $49a481072e1b1678$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $49a481072e1b1678$export$5f8d39834fd61797; }, function (v) { return $49a481072e1b1678$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $49a481072e1b1678$export$74bf444e3cd11ea5; }, function (v) { return $49a481072e1b1678$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $49a481072e1b1678$export$92387174baf9b227; }, function (v) { return $49a481072e1b1678$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $49a481072e1b1678$export$ec112efeb987d9c6; }, function (v) { return $49a481072e1b1678$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $49a481072e1b1678$export$b706b080d889d2c9; }, function (v) { return $49a481072e1b1678$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $49a481072e1b1678$export$5be5a87408f70ddc; }, function (v) { return $49a481072e1b1678$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $49a481072e1b1678$export$45a5e7f76e0caa8d; }, function (v) { return $49a481072e1b1678$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $49a481072e1b1678$export$455c2e768291efa6; }, function (v) { return $49a481072e1b1678$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $49a481072e1b1678$export$9522e17588c12572; }, function (v) { return $49a481072e1b1678$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $49a481072e1b1678$export$2110ac352bb060b9; }, function (v) { return $49a481072e1b1678$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $49a481072e1b1678$export$56885ab8b9c456ab; }, function (v) { return $49a481072e1b1678$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $49a481072e1b1678$export$d927fcb6adf8f9de; }, function (v) { return $49a481072e1b1678$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $49a481072e1b1678$export$b82d16f27459e05a; }, function (v) { return $49a481072e1b1678$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $49a481072e1b1678$export$522c17b4f5e123e8; }, function (v) { return $49a481072e1b1678$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $49a481072e1b1678$export$1aabd8a0274ecfd6; }, function (v) { return $49a481072e1b1678$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $49a481072e1b1678$export$9b621391a187a31a; }, function (v) { return $49a481072e1b1678$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $49a481072e1b1678$export$f5bbd400c2f4426f; }, function (v) { return $49a481072e1b1678$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $49a481072e1b1678$export$2b8d127b894957b9;
var $49a481072e1b1678$export$cea3a54a6425200c;
var $49a481072e1b1678$export$a7c73072b1a182ae;
var $49a481072e1b1678$export$9f27bc3417b4524d;
var $49a481072e1b1678$export$db77ccec0bb4ccac;
var $49a481072e1b1678$export$8392c0c9d3dcbd35;
var $49a481072e1b1678$export$ffb0004e005737fa;
var $49a481072e1b1678$export$b624eff549462981;
var $49a481072e1b1678$export$7897aa7841a5380c;
var $49a481072e1b1678$export$602eac185826482c;
var $49a481072e1b1678$export$e2c29f18771995cb;
var $49a481072e1b1678$export$5f8d39834fd61797;
var $49a481072e1b1678$export$74bf444e3cd11ea5;
var $49a481072e1b1678$export$92387174baf9b227;
var $49a481072e1b1678$export$ec112efeb987d9c6;
var $49a481072e1b1678$export$b706b080d889d2c9;
var $49a481072e1b1678$export$5be5a87408f70ddc;
var $49a481072e1b1678$export$45a5e7f76e0caa8d;
var $49a481072e1b1678$export$455c2e768291efa6;
var $49a481072e1b1678$export$9522e17588c12572;
var $49a481072e1b1678$export$2110ac352bb060b9;
var $49a481072e1b1678$export$56885ab8b9c456ab;
var $49a481072e1b1678$export$d927fcb6adf8f9de;
var $49a481072e1b1678$export$b82d16f27459e05a;
var $49a481072e1b1678$export$522c17b4f5e123e8;
var $49a481072e1b1678$export$1aabd8a0274ecfd6;
var $49a481072e1b1678$export$9b621391a187a31a;
var $49a481072e1b1678$export$f5bbd400c2f4426f;
'use strict';
var $49a481072e1b1678$var$b = "function" === typeof Symbol && Symbol.for, $49a481072e1b1678$var$c = $49a481072e1b1678$var$b ? Symbol.for("react.element") : 60103, $49a481072e1b1678$var$d = $49a481072e1b1678$var$b ? Symbol.for("react.portal") : 60106, $49a481072e1b1678$var$e = $49a481072e1b1678$var$b ? Symbol.for("react.fragment") : 60107, $49a481072e1b1678$var$f = $49a481072e1b1678$var$b ? Symbol.for("react.strict_mode") : 60108, $49a481072e1b1678$var$g = $49a481072e1b1678$var$b ? Symbol.for("react.profiler") : 60114, $49a481072e1b1678$var$h = $49a481072e1b1678$var$b ? Symbol.for("react.provider") : 60109, $49a481072e1b1678$var$k = $49a481072e1b1678$var$b ? Symbol.for("react.context") : 60110, $49a481072e1b1678$var$l = $49a481072e1b1678$var$b ? Symbol.for("react.async_mode") : 60111, $49a481072e1b1678$var$m = $49a481072e1b1678$var$b ? Symbol.for("react.concurrent_mode") : 60111, $49a481072e1b1678$var$n = $49a481072e1b1678$var$b ? Symbol.for("react.forward_ref") : 60112, $49a481072e1b1678$var$p = $49a481072e1b1678$var$b ? Symbol.for("react.suspense") : 60113, $49a481072e1b1678$var$q = $49a481072e1b1678$var$b ? Symbol.for("react.suspense_list") : 60120, $49a481072e1b1678$var$r = $49a481072e1b1678$var$b ? Symbol.for("react.memo") : 60115, $49a481072e1b1678$var$t = $49a481072e1b1678$var$b ? Symbol.for("react.lazy") : 60116, $49a481072e1b1678$var$v = $49a481072e1b1678$var$b ? Symbol.for("react.block") : 60121, $49a481072e1b1678$var$w = $49a481072e1b1678$var$b ? Symbol.for("react.fundamental") : 60117, $49a481072e1b1678$var$x = $49a481072e1b1678$var$b ? Symbol.for("react.responder") : 60118, $49a481072e1b1678$var$y = $49a481072e1b1678$var$b ? Symbol.for("react.scope") : 60119;
function $49a481072e1b1678$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $49a481072e1b1678$var$c:
                switch(a = a.type, a){
                    case $49a481072e1b1678$var$l:
                    case $49a481072e1b1678$var$m:
                    case $49a481072e1b1678$var$e:
                    case $49a481072e1b1678$var$g:
                    case $49a481072e1b1678$var$f:
                    case $49a481072e1b1678$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $49a481072e1b1678$var$k:
                            case $49a481072e1b1678$var$n:
                            case $49a481072e1b1678$var$t:
                            case $49a481072e1b1678$var$r:
                            case $49a481072e1b1678$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $49a481072e1b1678$var$d:
                return u;
        }
    }
}
function $49a481072e1b1678$var$A(a) {
    return $49a481072e1b1678$var$z(a) === $49a481072e1b1678$var$m;
}
$49a481072e1b1678$export$2b8d127b894957b9 = $49a481072e1b1678$var$l;
$49a481072e1b1678$export$cea3a54a6425200c = $49a481072e1b1678$var$m;
$49a481072e1b1678$export$a7c73072b1a182ae = $49a481072e1b1678$var$k;
$49a481072e1b1678$export$9f27bc3417b4524d = $49a481072e1b1678$var$h;
$49a481072e1b1678$export$db77ccec0bb4ccac = $49a481072e1b1678$var$c;
$49a481072e1b1678$export$8392c0c9d3dcbd35 = $49a481072e1b1678$var$n;
$49a481072e1b1678$export$ffb0004e005737fa = $49a481072e1b1678$var$e;
$49a481072e1b1678$export$b624eff549462981 = $49a481072e1b1678$var$t;
$49a481072e1b1678$export$7897aa7841a5380c = $49a481072e1b1678$var$r;
$49a481072e1b1678$export$602eac185826482c = $49a481072e1b1678$var$d;
$49a481072e1b1678$export$e2c29f18771995cb = $49a481072e1b1678$var$g;
$49a481072e1b1678$export$5f8d39834fd61797 = $49a481072e1b1678$var$f;
$49a481072e1b1678$export$74bf444e3cd11ea5 = $49a481072e1b1678$var$p;
$49a481072e1b1678$export$92387174baf9b227 = function(a) {
    return $49a481072e1b1678$var$A(a) || $49a481072e1b1678$var$z(a) === $49a481072e1b1678$var$l;
};
$49a481072e1b1678$export$ec112efeb987d9c6 = $49a481072e1b1678$var$A;
$49a481072e1b1678$export$b706b080d889d2c9 = function(a) {
    return $49a481072e1b1678$var$z(a) === $49a481072e1b1678$var$k;
};
$49a481072e1b1678$export$5be5a87408f70ddc = function(a) {
    return $49a481072e1b1678$var$z(a) === $49a481072e1b1678$var$h;
};
$49a481072e1b1678$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $49a481072e1b1678$var$c;
};
$49a481072e1b1678$export$455c2e768291efa6 = function(a) {
    return $49a481072e1b1678$var$z(a) === $49a481072e1b1678$var$n;
};
$49a481072e1b1678$export$9522e17588c12572 = function(a) {
    return $49a481072e1b1678$var$z(a) === $49a481072e1b1678$var$e;
};
$49a481072e1b1678$export$2110ac352bb060b9 = function(a) {
    return $49a481072e1b1678$var$z(a) === $49a481072e1b1678$var$t;
};
$49a481072e1b1678$export$56885ab8b9c456ab = function(a) {
    return $49a481072e1b1678$var$z(a) === $49a481072e1b1678$var$r;
};
$49a481072e1b1678$export$d927fcb6adf8f9de = function(a) {
    return $49a481072e1b1678$var$z(a) === $49a481072e1b1678$var$d;
};
$49a481072e1b1678$export$b82d16f27459e05a = function(a) {
    return $49a481072e1b1678$var$z(a) === $49a481072e1b1678$var$g;
};
$49a481072e1b1678$export$522c17b4f5e123e8 = function(a) {
    return $49a481072e1b1678$var$z(a) === $49a481072e1b1678$var$f;
};
$49a481072e1b1678$export$1aabd8a0274ecfd6 = function(a) {
    return $49a481072e1b1678$var$z(a) === $49a481072e1b1678$var$p;
};
$49a481072e1b1678$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $49a481072e1b1678$var$e || a === $49a481072e1b1678$var$m || a === $49a481072e1b1678$var$g || a === $49a481072e1b1678$var$f || a === $49a481072e1b1678$var$p || a === $49a481072e1b1678$var$q || "object" === typeof a && null !== a && (a.$$typeof === $49a481072e1b1678$var$t || a.$$typeof === $49a481072e1b1678$var$r || a.$$typeof === $49a481072e1b1678$var$h || a.$$typeof === $49a481072e1b1678$var$k || a.$$typeof === $49a481072e1b1678$var$n || a.$$typeof === $49a481072e1b1678$var$w || a.$$typeof === $49a481072e1b1678$var$x || a.$$typeof === $49a481072e1b1678$var$y || a.$$typeof === $49a481072e1b1678$var$v);
};
$49a481072e1b1678$export$f5bbd400c2f4426f = $49a481072e1b1678$var$z;

});




var $46be6bfb3e534eb8$exports = {};
$parcel$extendImportMap({
    "h1B49": "Profile.46e0a952.js",
    "g1FqD": "ProfileClass.f740c2a0.js",
    "9Uvt4": "no-image-found.a617352c.jpg"
});


var $1KfxD = parcelRequire("1KfxD");
var $dda887183a0ed747$exports = {};
'use strict';
function $dda887183a0ed747$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($dda887183a0ed747$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$dda887183a0ed747$var$checkDCE();

$dda887183a0ed747$exports = (parcelRequire("ejTrU"));


/**
 * react-router v7.14.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $dSwpL = parcelRequire("dSwpL");
var $9e8d2fd6513e67b8$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-EVOBXE3Y.mjs"
});
var $9e8d2fd6513e67b8$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $9e8d2fd6513e67b8$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $9e8d2fd6513e67b8$var$__typeError("Cannot " + msg);
var $9e8d2fd6513e67b8$var$__privateGet = (obj, member, getter)=>($9e8d2fd6513e67b8$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $9e8d2fd6513e67b8$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $9e8d2fd6513e67b8$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $9e8d2fd6513e67b8$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($9e8d2fd6513e67b8$export$e19cd5f9376f8cee || {});
var $9e8d2fd6513e67b8$var$PopStateEventType = "popstate";
function $9e8d2fd6513e67b8$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $9e8d2fd6513e67b8$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.unstable_mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, unstable_mask) {
        let location = $9e8d2fd6513e67b8$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, unstable_mask);
        $9e8d2fd6513e67b8$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $9e8d2fd6513e67b8$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $9e8d2fd6513e67b8$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $9e8d2fd6513e67b8$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $9e8d2fd6513e67b8$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $9e8d2fd6513e67b8$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $9e8d2fd6513e67b8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $9e8d2fd6513e67b8$export$fe53371bee54353d(to);
    }
    return $9e8d2fd6513e67b8$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $9e8d2fd6513e67b8$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $9e8d2fd6513e67b8$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $9e8d2fd6513e67b8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $9e8d2fd6513e67b8$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $9e8d2fd6513e67b8$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $9e8d2fd6513e67b8$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $9e8d2fd6513e67b8$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $9e8d2fd6513e67b8$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $9e8d2fd6513e67b8$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $9e8d2fd6513e67b8$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.unstable_mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $9e8d2fd6513e67b8$var$createLocation(current, to, state = null, key, unstable_mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $9e8d2fd6513e67b8$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $9e8d2fd6513e67b8$var$createKey(),
        unstable_mask: unstable_mask
    };
    return location;
}
function $9e8d2fd6513e67b8$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $9e8d2fd6513e67b8$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $9e8d2fd6513e67b8$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $9e8d2fd6513e67b8$var$isLocation(to) ? to : $9e8d2fd6513e67b8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $9e8d2fd6513e67b8$var$getHistoryState(location, index);
        let url = history.createHref(location.unstable_mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $9e8d2fd6513e67b8$var$isLocation(to) ? to : $9e8d2fd6513e67b8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $9e8d2fd6513e67b8$var$getHistoryState(location, index);
        let url = history.createHref(location.unstable_mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $9e8d2fd6513e67b8$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($9e8d2fd6513e67b8$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($9e8d2fd6513e67b8$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $9e8d2fd6513e67b8$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $9e8d2fd6513e67b8$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $9e8d2fd6513e67b8$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $9e8d2fd6513e67b8$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $9e8d2fd6513e67b8$var$_map;
var $9e8d2fd6513e67b8$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $9e8d2fd6513e67b8$var$__privateAdd(this, $9e8d2fd6513e67b8$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($9e8d2fd6513e67b8$var$__privateGet(this, $9e8d2fd6513e67b8$var$_map).has(context)) return $9e8d2fd6513e67b8$var$__privateGet(this, $9e8d2fd6513e67b8$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $9e8d2fd6513e67b8$var$__privateGet(this, $9e8d2fd6513e67b8$var$_map).set(context, value);
    }
};
$9e8d2fd6513e67b8$var$_map = new WeakMap();
var $9e8d2fd6513e67b8$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $9e8d2fd6513e67b8$var$isUnsupportedLazyRouteObjectKey(key) {
    return $9e8d2fd6513e67b8$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $9e8d2fd6513e67b8$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $9e8d2fd6513e67b8$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $9e8d2fd6513e67b8$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $9e8d2fd6513e67b8$var$isIndexRoute(route) {
    return route.index === true;
}
function $9e8d2fd6513e67b8$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $9e8d2fd6513e67b8$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $9e8d2fd6513e67b8$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($9e8d2fd6513e67b8$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $9e8d2fd6513e67b8$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $9e8d2fd6513e67b8$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $9e8d2fd6513e67b8$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $9e8d2fd6513e67b8$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $9e8d2fd6513e67b8$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $9e8d2fd6513e67b8$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $9e8d2fd6513e67b8$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $9e8d2fd6513e67b8$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $9e8d2fd6513e67b8$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $9e8d2fd6513e67b8$var$flattenRoutes(routes);
    $9e8d2fd6513e67b8$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $9e8d2fd6513e67b8$var$decodePath(pathname);
        matches = $9e8d2fd6513e67b8$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $9e8d2fd6513e67b8$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $9e8d2fd6513e67b8$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $9e8d2fd6513e67b8$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $9e8d2fd6513e67b8$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $9e8d2fd6513e67b8$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $9e8d2fd6513e67b8$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $9e8d2fd6513e67b8$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $9e8d2fd6513e67b8$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $9e8d2fd6513e67b8$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $9e8d2fd6513e67b8$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $9e8d2fd6513e67b8$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $9e8d2fd6513e67b8$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $9e8d2fd6513e67b8$var$paramRe = /^:[\w-]+$/;
var $9e8d2fd6513e67b8$var$dynamicSegmentValue = 3;
var $9e8d2fd6513e67b8$var$indexRouteValue = 2;
var $9e8d2fd6513e67b8$var$emptySegmentValue = 1;
var $9e8d2fd6513e67b8$var$staticSegmentValue = 10;
var $9e8d2fd6513e67b8$var$splatPenalty = -2;
var $9e8d2fd6513e67b8$var$isSplat = (s)=>s === "*";
function $9e8d2fd6513e67b8$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($9e8d2fd6513e67b8$var$isSplat)) initialScore += $9e8d2fd6513e67b8$var$splatPenalty;
    if (index) initialScore += $9e8d2fd6513e67b8$var$indexRouteValue;
    return segments.filter((s)=>!$9e8d2fd6513e67b8$var$isSplat(s)).reduce((score, segment)=>score + ($9e8d2fd6513e67b8$var$paramRe.test(segment) ? $9e8d2fd6513e67b8$var$dynamicSegmentValue : segment === "" ? $9e8d2fd6513e67b8$var$emptySegmentValue : $9e8d2fd6513e67b8$var$staticSegmentValue), initialScore);
}
function $9e8d2fd6513e67b8$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $9e8d2fd6513e67b8$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $9e8d2fd6513e67b8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $9e8d2fd6513e67b8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $9e8d2fd6513e67b8$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $9e8d2fd6513e67b8$var$normalizePathname($9e8d2fd6513e67b8$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $9e8d2fd6513e67b8$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $9e8d2fd6513e67b8$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $9e8d2fd6513e67b8$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $9e8d2fd6513e67b8$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $9e8d2fd6513e67b8$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $9e8d2fd6513e67b8$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $9e8d2fd6513e67b8$var$compilePath(path, caseSensitive = false, end = true) {
    $9e8d2fd6513e67b8$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $9e8d2fd6513e67b8$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $9e8d2fd6513e67b8$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $9e8d2fd6513e67b8$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $9e8d2fd6513e67b8$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $9e8d2fd6513e67b8$var$joinPaths([
        basename,
        pathname
    ]);
}
var $9e8d2fd6513e67b8$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $9e8d2fd6513e67b8$var$isAbsoluteUrl = (url)=>$9e8d2fd6513e67b8$var$ABSOLUTE_URL_REGEX.test(url);
function $9e8d2fd6513e67b8$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $9e8d2fd6513e67b8$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $9e8d2fd6513e67b8$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $9e8d2fd6513e67b8$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $9e8d2fd6513e67b8$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $9e8d2fd6513e67b8$var$normalizeSearch(search),
        hash: $9e8d2fd6513e67b8$var$normalizeHash(hash)
    };
}
function $9e8d2fd6513e67b8$var$resolvePathname(relativePath, fromPathname) {
    let segments = $9e8d2fd6513e67b8$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $9e8d2fd6513e67b8$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $9e8d2fd6513e67b8$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $9e8d2fd6513e67b8$var$getResolveToMatches(matches) {
    let pathMatches = $9e8d2fd6513e67b8$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $9e8d2fd6513e67b8$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $9e8d2fd6513e67b8$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $9e8d2fd6513e67b8$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $9e8d2fd6513e67b8$var$getInvalidPathError("?", "pathname", "search", to));
        $9e8d2fd6513e67b8$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $9e8d2fd6513e67b8$var$getInvalidPathError("#", "pathname", "hash", to));
        $9e8d2fd6513e67b8$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $9e8d2fd6513e67b8$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $9e8d2fd6513e67b8$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $9e8d2fd6513e67b8$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
var $9e8d2fd6513e67b8$var$joinPaths = (paths)=>$9e8d2fd6513e67b8$var$removeDoubleSlashes(paths.join("/"));
var $9e8d2fd6513e67b8$var$removeTrailingSlash = (path)=>path.replace(/\/+$/, "");
var $9e8d2fd6513e67b8$var$normalizePathname = (pathname)=>$9e8d2fd6513e67b8$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $9e8d2fd6513e67b8$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $9e8d2fd6513e67b8$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $9e8d2fd6513e67b8$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $9e8d2fd6513e67b8$export$4051a07651545597(data2, init) {
    return new $9e8d2fd6513e67b8$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $9e8d2fd6513e67b8$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $9e8d2fd6513e67b8$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $9e8d2fd6513e67b8$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $9e8d2fd6513e67b8$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $9e8d2fd6513e67b8$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $9e8d2fd6513e67b8$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $9e8d2fd6513e67b8$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $9e8d2fd6513e67b8$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $9e8d2fd6513e67b8$var$joinPaths(parts) || "/";
}
var $9e8d2fd6513e67b8$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $9e8d2fd6513e67b8$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$9e8d2fd6513e67b8$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($9e8d2fd6513e67b8$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = $9e8d2fd6513e67b8$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $9e8d2fd6513e67b8$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $9e8d2fd6513e67b8$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $9e8d2fd6513e67b8$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $9e8d2fd6513e67b8$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $9e8d2fd6513e67b8$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$9e8d2fd6513e67b8$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $9e8d2fd6513e67b8$var$wrapImpl(aggregated[key], original, (...args)=>$9e8d2fd6513e67b8$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$9e8d2fd6513e67b8$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$9e8d2fd6513e67b8$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $9e8d2fd6513e67b8$var$wrapImpl(aggregated.middleware, original, (...args)=>$9e8d2fd6513e67b8$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$9e8d2fd6513e67b8$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $9e8d2fd6513e67b8$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$9e8d2fd6513e67b8$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $9e8d2fd6513e67b8$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $9e8d2fd6513e67b8$export$fe53371bee54353d(to) : ".",
                ...$9e8d2fd6513e67b8$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$9e8d2fd6513e67b8$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$9e8d2fd6513e67b8$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $9e8d2fd6513e67b8$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$9e8d2fd6513e67b8$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$9e8d2fd6513e67b8$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $9e8d2fd6513e67b8$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $9e8d2fd6513e67b8$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $9e8d2fd6513e67b8$var$getReadonlyRequest(request),
            context: context != null ? $9e8d2fd6513e67b8$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $9e8d2fd6513e67b8$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $9e8d2fd6513e67b8$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $9e8d2fd6513e67b8$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $9e8d2fd6513e67b8$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $9e8d2fd6513e67b8$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $9e8d2fd6513e67b8$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $9e8d2fd6513e67b8$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $9e8d2fd6513e67b8$var$getReadonlyContext(context)
    };
}
function $9e8d2fd6513e67b8$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $9e8d2fd6513e67b8$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $9e8d2fd6513e67b8$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $9e8d2fd6513e67b8$var$getReadonlyContext(context) {
    if ($9e8d2fd6513e67b8$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $9e8d2fd6513e67b8$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $9e8d2fd6513e67b8$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $9e8d2fd6513e67b8$var$objectProtoNames;
}
// lib/router/router.ts
var $9e8d2fd6513e67b8$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $9e8d2fd6513e67b8$var$validMutationMethods = new Set($9e8d2fd6513e67b8$var$validMutationMethodsArr);
var $9e8d2fd6513e67b8$var$validRequestMethodsArr = [
    "GET",
    ...$9e8d2fd6513e67b8$var$validMutationMethodsArr
];
var $9e8d2fd6513e67b8$var$validRequestMethods = new Set($9e8d2fd6513e67b8$var$validRequestMethodsArr);
var $9e8d2fd6513e67b8$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $9e8d2fd6513e67b8$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $9e8d2fd6513e67b8$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $9e8d2fd6513e67b8$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $9e8d2fd6513e67b8$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $9e8d2fd6513e67b8$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $9e8d2fd6513e67b8$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $9e8d2fd6513e67b8$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $9e8d2fd6513e67b8$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $9e8d2fd6513e67b8$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $9e8d2fd6513e67b8$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$9e8d2fd6513e67b8$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $9e8d2fd6513e67b8$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $9e8d2fd6513e67b8$var$defaultDataStrategyWithMiddleware;
    let future = {
        unstable_passThroughRequests: false,
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $9e8d2fd6513e67b8$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $9e8d2fd6513e67b8$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $9e8d2fd6513e67b8$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$9e8d2fd6513e67b8$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $9e8d2fd6513e67b8$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $9e8d2fd6513e67b8$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $9e8d2fd6513e67b8$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $9e8d2fd6513e67b8$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $9e8d2fd6513e67b8$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$9e8d2fd6513e67b8$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $9e8d2fd6513e67b8$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $9e8d2fd6513e67b8$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $9e8d2fd6513e67b8$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $9e8d2fd6513e67b8$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $9e8d2fd6513e67b8$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $9e8d2fd6513e67b8$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $9e8d2fd6513e67b8$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $9e8d2fd6513e67b8$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.unstable_mask) {
            let partialPath = typeof opts.unstable_mask === "string" ? $9e8d2fd6513e67b8$export$8ccf933b0513f8d0(opts.unstable_mask) : {
                ...state.location.unstable_mask,
                ...opts.unstable_mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $9e8d2fd6513e67b8$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $9e8d2fd6513e67b8$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $9e8d2fd6513e67b8$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.unstable_defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $9e8d2fd6513e67b8$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $9e8d2fd6513e67b8$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $9e8d2fd6513e67b8$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $9e8d2fd6513e67b8$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $9e8d2fd6513e67b8$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $9e8d2fd6513e67b8$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $9e8d2fd6513e67b8$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $9e8d2fd6513e67b8$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($9e8d2fd6513e67b8$var$isErrorResult(result) && $9e8d2fd6513e67b8$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $9e8d2fd6513e67b8$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $9e8d2fd6513e67b8$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$9e8d2fd6513e67b8$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $9e8d2fd6513e67b8$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $9e8d2fd6513e67b8$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $9e8d2fd6513e67b8$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $9e8d2fd6513e67b8$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $9e8d2fd6513e67b8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $9e8d2fd6513e67b8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($9e8d2fd6513e67b8$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $9e8d2fd6513e67b8$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($9e8d2fd6513e67b8$var$isErrorResult(result)) {
            let boundaryMatch = $9e8d2fd6513e67b8$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $9e8d2fd6513e67b8$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $9e8d2fd6513e67b8$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $9e8d2fd6513e67b8$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $9e8d2fd6513e67b8$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $9e8d2fd6513e67b8$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $9e8d2fd6513e67b8$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$9e8d2fd6513e67b8$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $9e8d2fd6513e67b8$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $9e8d2fd6513e67b8$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $9e8d2fd6513e67b8$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$9e8d2fd6513e67b8$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $9e8d2fd6513e67b8$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $9e8d2fd6513e67b8$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $9e8d2fd6513e67b8$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $9e8d2fd6513e67b8$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $9e8d2fd6513e67b8$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $9e8d2fd6513e67b8$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $9e8d2fd6513e67b8$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.unstable_defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $9e8d2fd6513e67b8$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $9e8d2fd6513e67b8$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $9e8d2fd6513e67b8$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $9e8d2fd6513e67b8$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $9e8d2fd6513e67b8$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $9e8d2fd6513e67b8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($9e8d2fd6513e67b8$var$isRedirectResult(actionResult) || $9e8d2fd6513e67b8$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $9e8d2fd6513e67b8$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($9e8d2fd6513e67b8$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $9e8d2fd6513e67b8$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $9e8d2fd6513e67b8$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($9e8d2fd6513e67b8$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $9e8d2fd6513e67b8$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $9e8d2fd6513e67b8$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $9e8d2fd6513e67b8$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $9e8d2fd6513e67b8$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $9e8d2fd6513e67b8$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $9e8d2fd6513e67b8$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $9e8d2fd6513e67b8$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $9e8d2fd6513e67b8$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $9e8d2fd6513e67b8$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $9e8d2fd6513e67b8$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $9e8d2fd6513e67b8$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $9e8d2fd6513e67b8$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $9e8d2fd6513e67b8$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $9e8d2fd6513e67b8$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $9e8d2fd6513e67b8$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $9e8d2fd6513e67b8$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $9e8d2fd6513e67b8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $9e8d2fd6513e67b8$var$getDoneFetcher(void 0));
            return;
        }
        if ($9e8d2fd6513e67b8$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $9e8d2fd6513e67b8$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($9e8d2fd6513e67b8$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $9e8d2fd6513e67b8$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $9e8d2fd6513e67b8$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $9e8d2fd6513e67b8$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $9e8d2fd6513e67b8$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($9e8d2fd6513e67b8$var$isAbsoluteUrl(location)) {
                const url = $9e8d2fd6513e67b8$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $9e8d2fd6513e67b8$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $9e8d2fd6513e67b8$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($9e8d2fd6513e67b8$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $9e8d2fd6513e67b8$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $9e8d2fd6513e67b8$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $9e8d2fd6513e67b8$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$9e8d2fd6513e67b8$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($9e8d2fd6513e67b8$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $9e8d2fd6513e67b8$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $9e8d2fd6513e67b8$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $9e8d2fd6513e67b8$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $9e8d2fd6513e67b8$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $9e8d2fd6513e67b8$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $9e8d2fd6513e67b8$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $9e8d2fd6513e67b8$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $9e8d2fd6513e67b8$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $9e8d2fd6513e67b8$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $9e8d2fd6513e67b8$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $9e8d2fd6513e67b8$export$386d57f03f0b2883;
        $9e8d2fd6513e67b8$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $9e8d2fd6513e67b8$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $9e8d2fd6513e67b8$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $9e8d2fd6513e67b8$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $9e8d2fd6513e67b8$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$9e8d2fd6513e67b8$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $9e8d2fd6513e67b8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $9e8d2fd6513e67b8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $9e8d2fd6513e67b8$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $9e8d2fd6513e67b8$export$2708184779ceb39d(routesToUse, pathname, basename);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $9e8d2fd6513e67b8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $9e8d2fd6513e67b8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $9e8d2fd6513e67b8$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $9e8d2fd6513e67b8$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $9e8d2fd6513e67b8$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $9e8d2fd6513e67b8$export$3336b097a6fbc59a(routes, opts) {
    $9e8d2fd6513e67b8$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $9e8d2fd6513e67b8$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        unstable_passThroughRequests: false,
        // unused in static handler
        ...opts?.future
    };
    if (opts?.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$9e8d2fd6513e67b8$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $9e8d2fd6513e67b8$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, unstable_normalizePath: unstable_normalizePath } = {}) {
        let normalizePath = unstable_normalizePath || $9e8d2fd6513e67b8$var$defaultNormalizePath;
        let method = request.method;
        let location = $9e8d2fd6513e67b8$var$createLocation("", normalizePath(request), null, "default");
        let matches = $9e8d2fd6513e67b8$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $9e8d2fd6513e67b8$export$b8d3e69d4b3eff04();
        if (!$9e8d2fd6513e67b8$var$isValidMethod(method) && method !== "HEAD") {
            let error = $9e8d2fd6513e67b8$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $9e8d2fd6513e67b8$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $9e8d2fd6513e67b8$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $9e8d2fd6513e67b8$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $9e8d2fd6513e67b8$export$f5708dca728d7177(requestContext instanceof $9e8d2fd6513e67b8$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $9e8d2fd6513e67b8$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $9e8d2fd6513e67b8$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_url: $9e8d2fd6513e67b8$var$createDataFunctionUrl(request, location),
                    unstable_pattern: $9e8d2fd6513e67b8$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($9e8d2fd6513e67b8$export$6e80290866a84dd4(error)) return error;
                    if ($9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $9e8d2fd6513e67b8$export$f2680fa305b734ca(error.status, error.statusText, await $9e8d2fd6513e67b8$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($9e8d2fd6513e67b8$export$e0163cfdf7bc9cfa(error)) error = $9e8d2fd6513e67b8$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $9e8d2fd6513e67b8$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $9e8d2fd6513e67b8$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $9e8d2fd6513e67b8$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $9e8d2fd6513e67b8$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $9e8d2fd6513e67b8$export$f5708dca728d7177($9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, unstable_normalizePath: unstable_normalizePath } = {}) {
        let normalizePath = unstable_normalizePath || $9e8d2fd6513e67b8$var$defaultNormalizePath;
        let method = request.method;
        let location = $9e8d2fd6513e67b8$var$createLocation("", normalizePath(request), null, "default");
        let matches = $9e8d2fd6513e67b8$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $9e8d2fd6513e67b8$export$b8d3e69d4b3eff04();
        if (!$9e8d2fd6513e67b8$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $9e8d2fd6513e67b8$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $9e8d2fd6513e67b8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $9e8d2fd6513e67b8$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $9e8d2fd6513e67b8$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $9e8d2fd6513e67b8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $9e8d2fd6513e67b8$export$f5708dca728d7177(requestContext instanceof $9e8d2fd6513e67b8$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $9e8d2fd6513e67b8$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $9e8d2fd6513e67b8$var$runServerMiddlewarePipeline({
                request: request,
                unstable_url: $9e8d2fd6513e67b8$var$createDataFunctionUrl(request, location),
                unstable_pattern: $9e8d2fd6513e67b8$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($9e8d2fd6513e67b8$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($9e8d2fd6513e67b8$var$dataWithResponseInitToResponse(error));
                if ($9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $9e8d2fd6513e67b8$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($9e8d2fd6513e67b8$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $9e8d2fd6513e67b8$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($9e8d2fd6513e67b8$var$isDataStrategyResult(e) && $9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($9e8d2fd6513e67b8$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $9e8d2fd6513e67b8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $9e8d2fd6513e67b8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $9e8d2fd6513e67b8$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($9e8d2fd6513e67b8$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($9e8d2fd6513e67b8$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($9e8d2fd6513e67b8$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $9e8d2fd6513e67b8$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $9e8d2fd6513e67b8$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($9e8d2fd6513e67b8$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $9e8d2fd6513e67b8$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $9e8d2fd6513e67b8$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $9e8d2fd6513e67b8$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $9e8d2fd6513e67b8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $9e8d2fd6513e67b8$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $9e8d2fd6513e67b8$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $9e8d2fd6513e67b8$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $9e8d2fd6513e67b8$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $9e8d2fd6513e67b8$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $9e8d2fd6513e67b8$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $9e8d2fd6513e67b8$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $9e8d2fd6513e67b8$var$callDataStrategyImpl(dataStrategy || $9e8d2fd6513e67b8$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($9e8d2fd6513e67b8$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $9e8d2fd6513e67b8$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($9e8d2fd6513e67b8$export$e0163cfdf7bc9cfa(result.result)) throw $9e8d2fd6513e67b8$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $9e8d2fd6513e67b8$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $9e8d2fd6513e67b8$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $9e8d2fd6513e67b8$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $9e8d2fd6513e67b8$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $9e8d2fd6513e67b8$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $9e8d2fd6513e67b8$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $9e8d2fd6513e67b8$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $9e8d2fd6513e67b8$var$resolveTo(to ? to : ".", $9e8d2fd6513e67b8$var$getResolveToMatches(contextualMatches), $9e8d2fd6513e67b8$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $9e8d2fd6513e67b8$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $9e8d2fd6513e67b8$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $9e8d2fd6513e67b8$export$fe53371bee54353d(path);
}
function $9e8d2fd6513e67b8$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$9e8d2fd6513e67b8$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$9e8d2fd6513e67b8$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $9e8d2fd6513e67b8$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $9e8d2fd6513e67b8$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $9e8d2fd6513e67b8$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$9e8d2fd6513e67b8$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$9e8d2fd6513e67b8$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $9e8d2fd6513e67b8$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $9e8d2fd6513e67b8$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $9e8d2fd6513e67b8$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $9e8d2fd6513e67b8$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $9e8d2fd6513e67b8$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($9e8d2fd6513e67b8$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $9e8d2fd6513e67b8$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $9e8d2fd6513e67b8$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $9e8d2fd6513e67b8$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $9e8d2fd6513e67b8$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $9e8d2fd6513e67b8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $9e8d2fd6513e67b8$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $9e8d2fd6513e67b8$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$9e8d2fd6513e67b8$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $9e8d2fd6513e67b8$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($9e8d2fd6513e67b8$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $9e8d2fd6513e67b8$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($9e8d2fd6513e67b8$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $9e8d2fd6513e67b8$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $9e8d2fd6513e67b8$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $9e8d2fd6513e67b8$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $9e8d2fd6513e67b8$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $9e8d2fd6513e67b8$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $9e8d2fd6513e67b8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $9e8d2fd6513e67b8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($9e8d2fd6513e67b8$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $9e8d2fd6513e67b8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $9e8d2fd6513e67b8$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $9e8d2fd6513e67b8$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$9e8d2fd6513e67b8$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $9e8d2fd6513e67b8$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $9e8d2fd6513e67b8$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $9e8d2fd6513e67b8$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $9e8d2fd6513e67b8$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $9e8d2fd6513e67b8$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$9e8d2fd6513e67b8$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $9e8d2fd6513e67b8$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $9e8d2fd6513e67b8$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $9e8d2fd6513e67b8$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$9e8d2fd6513e67b8$var$isSameRoute(aChild, bChild))) ?? false;
}
var $9e8d2fd6513e67b8$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $9e8d2fd6513e67b8$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $9e8d2fd6513e67b8$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $9e8d2fd6513e67b8$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $9e8d2fd6513e67b8$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $9e8d2fd6513e67b8$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $9e8d2fd6513e67b8$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $9e8d2fd6513e67b8$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $9e8d2fd6513e67b8$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $9e8d2fd6513e67b8$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $9e8d2fd6513e67b8$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $9e8d2fd6513e67b8$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $9e8d2fd6513e67b8$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $9e8d2fd6513e67b8$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $9e8d2fd6513e67b8$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $9e8d2fd6513e67b8$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $9e8d2fd6513e67b8$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $9e8d2fd6513e67b8$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $9e8d2fd6513e67b8$var$isNonNullable(value) {
    return value !== void 0;
}
function $9e8d2fd6513e67b8$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $9e8d2fd6513e67b8$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($9e8d2fd6513e67b8$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $9e8d2fd6513e67b8$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $9e8d2fd6513e67b8$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $9e8d2fd6513e67b8$var$defaultDataStrategy(args);
    return $9e8d2fd6513e67b8$var$runClientMiddlewarePipeline(args, ()=>$9e8d2fd6513e67b8$var$defaultDataStrategy(args));
}
function $9e8d2fd6513e67b8$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $9e8d2fd6513e67b8$var$runMiddlewarePipeline(args, handler, processResult, $9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $9e8d2fd6513e67b8$export$e0163cfdf7bc9cfa(result) ? $9e8d2fd6513e67b8$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $9e8d2fd6513e67b8$var$runClientMiddlewarePipeline(args, handler) {
    return $9e8d2fd6513e67b8$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($9e8d2fd6513e67b8$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $9e8d2fd6513e67b8$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $9e8d2fd6513e67b8$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $9e8d2fd6513e67b8$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $9e8d2fd6513e67b8$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $9e8d2fd6513e67b8$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $9e8d2fd6513e67b8$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $9e8d2fd6513e67b8$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $9e8d2fd6513e67b8$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $9e8d2fd6513e67b8$var$loadLazyRoute(match.route, $9e8d2fd6513e67b8$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $9e8d2fd6513e67b8$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $9e8d2fd6513e67b8$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $9e8d2fd6513e67b8$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $9e8d2fd6513e67b8$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $9e8d2fd6513e67b8$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$9e8d2fd6513e67b8$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($9e8d2fd6513e67b8$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $9e8d2fd6513e67b8$var$callLoaderOrAction({
                request: request,
                path: path,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $9e8d2fd6513e67b8$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $9e8d2fd6513e67b8$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $9e8d2fd6513e67b8$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $9e8d2fd6513e67b8$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $9e8d2fd6513e67b8$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        unstable_url: $9e8d2fd6513e67b8$var$createDataFunctionUrl(request, path),
        unstable_pattern: $9e8d2fd6513e67b8$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $9e8d2fd6513e67b8$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $9e8d2fd6513e67b8$var$callLoaderOrAction({ request: request, path: path, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $9e8d2fd6513e67b8$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_url: $9e8d2fd6513e67b8$var$createDataFunctionUrl(request, path),
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $9e8d2fd6513e67b8$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $9e8d2fd6513e67b8$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $9e8d2fd6513e67b8$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $9e8d2fd6513e67b8$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $9e8d2fd6513e67b8$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $9e8d2fd6513e67b8$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($9e8d2fd6513e67b8$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $9e8d2fd6513e67b8$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $9e8d2fd6513e67b8$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $9e8d2fd6513e67b8$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($9e8d2fd6513e67b8$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $9e8d2fd6513e67b8$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $9e8d2fd6513e67b8$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$9e8d2fd6513e67b8$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $9e8d2fd6513e67b8$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $9e8d2fd6513e67b8$export$30ab200a1a0a2def = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $9e8d2fd6513e67b8$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($9e8d2fd6513e67b8$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if ($9e8d2fd6513e67b8$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $9e8d2fd6513e67b8$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $9e8d2fd6513e67b8$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($9e8d2fd6513e67b8$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $9e8d2fd6513e67b8$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($9e8d2fd6513e67b8$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $9e8d2fd6513e67b8$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $9e8d2fd6513e67b8$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $9e8d2fd6513e67b8$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $9e8d2fd6513e67b8$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $9e8d2fd6513e67b8$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $9e8d2fd6513e67b8$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $9e8d2fd6513e67b8$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $9e8d2fd6513e67b8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $9e8d2fd6513e67b8$export$f5708dca728d7177(!$9e8d2fd6513e67b8$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($9e8d2fd6513e67b8$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $9e8d2fd6513e67b8$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $9e8d2fd6513e67b8$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $9e8d2fd6513e67b8$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $9e8d2fd6513e67b8$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $9e8d2fd6513e67b8$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $9e8d2fd6513e67b8$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($9e8d2fd6513e67b8$var$isErrorResult(result)) {
            let boundaryMatch = $9e8d2fd6513e67b8$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($9e8d2fd6513e67b8$var$isRedirectResult(result)) $9e8d2fd6513e67b8$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $9e8d2fd6513e67b8$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $9e8d2fd6513e67b8$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $9e8d2fd6513e67b8$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $9e8d2fd6513e67b8$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $9e8d2fd6513e67b8$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $9e8d2fd6513e67b8$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $9e8d2fd6513e67b8$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $9e8d2fd6513e67b8$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $9e8d2fd6513e67b8$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $9e8d2fd6513e67b8$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($9e8d2fd6513e67b8$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $9e8d2fd6513e67b8$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $9e8d2fd6513e67b8$export$8ccf933b0513f8d0(path) : path;
    return $9e8d2fd6513e67b8$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $9e8d2fd6513e67b8$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $9e8d2fd6513e67b8$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $9e8d2fd6513e67b8$var$dataWithResponseInitToErrorResponse(data2) {
    return new $9e8d2fd6513e67b8$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $9e8d2fd6513e67b8$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $9e8d2fd6513e67b8$var$isDataStrategyResult(value));
}
function $9e8d2fd6513e67b8$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $9e8d2fd6513e67b8$var$isRedirectDataStrategyResult(result) {
    return $9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27(result.result) && $9e8d2fd6513e67b8$var$redirectStatusCodes.has(result.result.status);
}
function $9e8d2fd6513e67b8$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $9e8d2fd6513e67b8$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $9e8d2fd6513e67b8$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $9e8d2fd6513e67b8$export$794b2760043cf8cd(statusCode) {
    return $9e8d2fd6513e67b8$var$redirectStatusCodes.has(statusCode);
}
function $9e8d2fd6513e67b8$export$6e80290866a84dd4(result) {
    return $9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27(result) && $9e8d2fd6513e67b8$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $9e8d2fd6513e67b8$var$isValidMethod(method) {
    return $9e8d2fd6513e67b8$var$validRequestMethods.has(method.toUpperCase());
}
function $9e8d2fd6513e67b8$export$cbae47800eb95bc3(method) {
    return $9e8d2fd6513e67b8$var$validMutationMethods.has(method.toUpperCase());
}
function $9e8d2fd6513e67b8$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $9e8d2fd6513e67b8$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $9e8d2fd6513e67b8$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $9e8d2fd6513e67b8$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $9e8d2fd6513e67b8$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $9e8d2fd6513e67b8$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $9e8d2fd6513e67b8$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $9e8d2fd6513e67b8$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $9e8d2fd6513e67b8$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $9e8d2fd6513e67b8$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $9e8d2fd6513e67b8$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $9e8d2fd6513e67b8$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($9e8d2fd6513e67b8$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $9e8d2fd6513e67b8$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($9e8d2fd6513e67b8$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $9e8d2fd6513e67b8$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $9e8d2fd6513e67b8$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $9e8d2fd6513e67b8$export$2eeee58951ff3c1c = $dSwpL.createContext(null);
$9e8d2fd6513e67b8$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $9e8d2fd6513e67b8$export$315e3ffb01f217 = $dSwpL.createContext(null);
$9e8d2fd6513e67b8$export$315e3ffb01f217.displayName = "DataRouterState";
var $9e8d2fd6513e67b8$export$717f757c655223f1 = $dSwpL.createContext(false);
function $9e8d2fd6513e67b8$var$useIsRSCRouterContext() {
    return $dSwpL.useContext($9e8d2fd6513e67b8$export$717f757c655223f1);
}
var $9e8d2fd6513e67b8$export$3681f408decb40d1 = $dSwpL.createContext({
    isTransitioning: false
});
$9e8d2fd6513e67b8$export$3681f408decb40d1.displayName = "ViewTransition";
var $9e8d2fd6513e67b8$export$cb3f1df1bef00a39 = $dSwpL.createContext(/* @__PURE__ */ new Map());
$9e8d2fd6513e67b8$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $9e8d2fd6513e67b8$var$AwaitContext = $dSwpL.createContext(null);
$9e8d2fd6513e67b8$var$AwaitContext.displayName = "Await";
var $9e8d2fd6513e67b8$export$2666c20e15407622 = (props)=>$dSwpL.createElement($9e8d2fd6513e67b8$var$AwaitContext.Provider, props);
var $9e8d2fd6513e67b8$export$3044ab7fdabeaee6 = $dSwpL.createContext(null);
$9e8d2fd6513e67b8$export$3044ab7fdabeaee6.displayName = "Navigation";
var $9e8d2fd6513e67b8$export$e6a44b110a0c44d3 = $dSwpL.createContext(null);
$9e8d2fd6513e67b8$export$e6a44b110a0c44d3.displayName = "Location";
var $9e8d2fd6513e67b8$export$aac280ed165a4397 = $dSwpL.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$9e8d2fd6513e67b8$export$aac280ed165a4397.displayName = "Route";
var $9e8d2fd6513e67b8$var$RouteErrorContext = $dSwpL.createContext(null);
$9e8d2fd6513e67b8$var$RouteErrorContext.displayName = "RouteError";
var $9e8d2fd6513e67b8$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $9e8d2fd6513e67b8$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $9e8d2fd6513e67b8$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $9e8d2fd6513e67b8$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $9e8d2fd6513e67b8$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$9e8d2fd6513e67b8$var$ERROR_DIGEST_BASE}:${$9e8d2fd6513e67b8$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $9e8d2fd6513e67b8$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$9e8d2fd6513e67b8$var$ERROR_DIGEST_BASE}:${$9e8d2fd6513e67b8$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $9e8d2fd6513e67b8$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $9e8d2fd6513e67b8$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $9e8d2fd6513e67b8$export$f5708dca728d7177($9e8d2fd6513e67b8$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $dSwpL.useContext($9e8d2fd6513e67b8$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $9e8d2fd6513e67b8$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $9e8d2fd6513e67b8$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $9e8d2fd6513e67b8$export$9c954a9d03d32f4a() {
    return $dSwpL.useContext($9e8d2fd6513e67b8$export$e6a44b110a0c44d3) != null;
}
function $9e8d2fd6513e67b8$export$45d76561a5302f2b() {
    $9e8d2fd6513e67b8$export$f5708dca728d7177($9e8d2fd6513e67b8$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $dSwpL.useContext($9e8d2fd6513e67b8$export$e6a44b110a0c44d3).location;
}
function $9e8d2fd6513e67b8$export$1b3f31771c5d07c() {
    return $dSwpL.useContext($9e8d2fd6513e67b8$export$e6a44b110a0c44d3).navigationType;
}
function $9e8d2fd6513e67b8$export$6c330e8992e8a295(pattern) {
    $9e8d2fd6513e67b8$export$f5708dca728d7177($9e8d2fd6513e67b8$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $9e8d2fd6513e67b8$export$45d76561a5302f2b();
    return $dSwpL.useMemo(()=>$9e8d2fd6513e67b8$export$81336c211d5ff295(pattern, $9e8d2fd6513e67b8$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $9e8d2fd6513e67b8$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $9e8d2fd6513e67b8$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $dSwpL.useContext($9e8d2fd6513e67b8$export$3044ab7fdabeaee6).static;
    if (!isStatic) $dSwpL.useLayoutEffect(cb);
}
function $9e8d2fd6513e67b8$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $dSwpL.useContext($9e8d2fd6513e67b8$export$aac280ed165a4397);
    return isDataRoute ? $9e8d2fd6513e67b8$var$useNavigateStable() : $9e8d2fd6513e67b8$var$useNavigateUnstable();
}
function $9e8d2fd6513e67b8$var$useNavigateUnstable() {
    $9e8d2fd6513e67b8$export$f5708dca728d7177($9e8d2fd6513e67b8$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $dSwpL.useContext($9e8d2fd6513e67b8$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $dSwpL.useContext($9e8d2fd6513e67b8$export$3044ab7fdabeaee6);
    let { matches: matches } = $dSwpL.useContext($9e8d2fd6513e67b8$export$aac280ed165a4397);
    let { pathname: locationPathname } = $9e8d2fd6513e67b8$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($9e8d2fd6513e67b8$var$getResolveToMatches(matches));
    let activeRef = $dSwpL.useRef(false);
    $9e8d2fd6513e67b8$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $dSwpL.useCallback((to, options = {})=>{
        $9e8d2fd6513e67b8$var$warning(activeRef.current, $9e8d2fd6513e67b8$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $9e8d2fd6513e67b8$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $9e8d2fd6513e67b8$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $9e8d2fd6513e67b8$var$OutletContext = $dSwpL.createContext(null);
function $9e8d2fd6513e67b8$export$4138103a3ae699cc() {
    return $dSwpL.useContext($9e8d2fd6513e67b8$var$OutletContext);
}
function $9e8d2fd6513e67b8$export$a3be3530d8e40d0b(context) {
    let outlet = $dSwpL.useContext($9e8d2fd6513e67b8$export$aac280ed165a4397).outlet;
    return $dSwpL.useMemo(()=>outlet && /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $9e8d2fd6513e67b8$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $dSwpL.useContext($9e8d2fd6513e67b8$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $9e8d2fd6513e67b8$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $dSwpL.useContext($9e8d2fd6513e67b8$export$aac280ed165a4397);
    let { pathname: locationPathname } = $9e8d2fd6513e67b8$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($9e8d2fd6513e67b8$var$getResolveToMatches(matches));
    return $dSwpL.useMemo(()=>$9e8d2fd6513e67b8$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $9e8d2fd6513e67b8$export$5d3fca4a98652595(routes, locationArg) {
    return $9e8d2fd6513e67b8$var$useRoutesImpl(routes, locationArg);
}
function $9e8d2fd6513e67b8$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $9e8d2fd6513e67b8$export$f5708dca728d7177($9e8d2fd6513e67b8$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $dSwpL.useContext($9e8d2fd6513e67b8$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $dSwpL.useContext($9e8d2fd6513e67b8$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($9e8d2fd6513e67b8$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $9e8d2fd6513e67b8$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $9e8d2fd6513e67b8$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $9e8d2fd6513e67b8$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $9e8d2fd6513e67b8$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $9e8d2fd6513e67b8$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($9e8d2fd6513e67b8$export$945fecf35a8ef089) {
        $9e8d2fd6513e67b8$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $9e8d2fd6513e67b8$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $9e8d2fd6513e67b8$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $9e8d2fd6513e67b8$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $9e8d2fd6513e67b8$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                unstable_mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $9e8d2fd6513e67b8$var$DefaultErrorComponent() {
    let error = $9e8d2fd6513e67b8$export$ed527bf60f6e05f2();
    let message = $9e8d2fd6513e67b8$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($9e8d2fd6513e67b8$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $dSwpL.createElement($dSwpL.Fragment, null, /* @__PURE__ */ $dSwpL.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $dSwpL.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $dSwpL.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $dSwpL.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $dSwpL.createElement($dSwpL.Fragment, null, /* @__PURE__ */ $dSwpL.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $dSwpL.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $dSwpL.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $9e8d2fd6513e67b8$var$defaultErrorElement = /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$DefaultErrorComponent, null);
var $9e8d2fd6513e67b8$var$RenderErrorBoundary = class extends $dSwpL.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $9e8d2fd6513e67b8$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$9e8d2fd6513e67b8$var$RenderErrorBoundary.contextType = $9e8d2fd6513e67b8$export$717f757c655223f1;
var $9e8d2fd6513e67b8$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $9e8d2fd6513e67b8$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $dSwpL.useContext($9e8d2fd6513e67b8$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $9e8d2fd6513e67b8$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $9e8d2fd6513e67b8$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $9e8d2fd6513e67b8$var$parseToInfo(redirect2.location, basename);
            if ($9e8d2fd6513e67b8$var$isBrowser && !$9e8d2fd6513e67b8$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = parsed.absoluteURL || parsed.to;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $9e8d2fd6513e67b8$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $dSwpL.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${parsed.absoluteURL || parsed.to}`
            });
        }
    }
    return children;
}
function $9e8d2fd6513e67b8$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $dSwpL.useContext($9e8d2fd6513e67b8$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $9e8d2fd6513e67b8$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $9e8d2fd6513e67b8$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            unstable_pattern: $9e8d2fd6513e67b8$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $9e8d2fd6513e67b8$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $9e8d2fd6513e67b8$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $dSwpL.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $9e8d2fd6513e67b8$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $9e8d2fd6513e67b8$var$useDataRouterContext(hookName) {
    let ctx = $dSwpL.useContext($9e8d2fd6513e67b8$export$2eeee58951ff3c1c);
    $9e8d2fd6513e67b8$export$f5708dca728d7177(ctx, $9e8d2fd6513e67b8$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $9e8d2fd6513e67b8$var$useDataRouterState(hookName) {
    let state = $dSwpL.useContext($9e8d2fd6513e67b8$export$315e3ffb01f217);
    $9e8d2fd6513e67b8$export$f5708dca728d7177(state, $9e8d2fd6513e67b8$var$getDataRouterConsoleError(hookName));
    return state;
}
function $9e8d2fd6513e67b8$var$useRouteContext(hookName) {
    let route = $dSwpL.useContext($9e8d2fd6513e67b8$export$aac280ed165a4397);
    $9e8d2fd6513e67b8$export$f5708dca728d7177(route, $9e8d2fd6513e67b8$var$getDataRouterConsoleError(hookName));
    return route;
}
function $9e8d2fd6513e67b8$var$useCurrentRouteId(hookName) {
    let route = $9e8d2fd6513e67b8$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $9e8d2fd6513e67b8$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $9e8d2fd6513e67b8$var$useRouteId() {
    return $9e8d2fd6513e67b8$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $9e8d2fd6513e67b8$export$d0fd4b7106de2769() {
    let state = $9e8d2fd6513e67b8$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $9e8d2fd6513e67b8$export$600dc272ed516c15() {
    let dataRouterContext = $9e8d2fd6513e67b8$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $9e8d2fd6513e67b8$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $dSwpL.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $dSwpL.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $9e8d2fd6513e67b8$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $9e8d2fd6513e67b8$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $dSwpL.useMemo(()=>matches.map((m)=>$9e8d2fd6513e67b8$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $9e8d2fd6513e67b8$export$1448a5050d252c4d() {
    let state = $9e8d2fd6513e67b8$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $9e8d2fd6513e67b8$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $9e8d2fd6513e67b8$export$fd5d37484eab868d(routeId) {
    let state = $9e8d2fd6513e67b8$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $9e8d2fd6513e67b8$export$fdc00f3f26066d5e() {
    let state = $9e8d2fd6513e67b8$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $9e8d2fd6513e67b8$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $9e8d2fd6513e67b8$export$ed527bf60f6e05f2() {
    let error = $dSwpL.useContext($9e8d2fd6513e67b8$var$RouteErrorContext);
    let state = $9e8d2fd6513e67b8$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $9e8d2fd6513e67b8$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $9e8d2fd6513e67b8$export$78a72ddb39bdd145() {
    let value = $dSwpL.useContext($9e8d2fd6513e67b8$var$AwaitContext);
    return value?._data;
}
function $9e8d2fd6513e67b8$export$17f53340677d5831() {
    let value = $dSwpL.useContext($9e8d2fd6513e67b8$var$AwaitContext);
    return value?._error;
}
var $9e8d2fd6513e67b8$var$blockerId = 0;
function $9e8d2fd6513e67b8$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $9e8d2fd6513e67b8$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $9e8d2fd6513e67b8$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $dSwpL.useState("");
    let blockerFunction = $dSwpL.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $9e8d2fd6513e67b8$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $9e8d2fd6513e67b8$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $dSwpL.useEffect(()=>{
        let key = String(++$9e8d2fd6513e67b8$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $dSwpL.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $9e8d2fd6513e67b8$export$386d57f03f0b2883;
}
function $9e8d2fd6513e67b8$var$useNavigateStable() {
    let { router: router } = $9e8d2fd6513e67b8$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $9e8d2fd6513e67b8$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $dSwpL.useRef(false);
    $9e8d2fd6513e67b8$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $dSwpL.useCallback(async (to, options = {})=>{
        $9e8d2fd6513e67b8$var$warning(activeRef.current, $9e8d2fd6513e67b8$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $9e8d2fd6513e67b8$var$alreadyWarned = {};
function $9e8d2fd6513e67b8$var$warningOnce(key, cond, message) {
    if (!cond && !$9e8d2fd6513e67b8$var$alreadyWarned[key]) {
        $9e8d2fd6513e67b8$var$alreadyWarned[key] = true;
        $9e8d2fd6513e67b8$var$warning(false, message);
    }
}
function $9e8d2fd6513e67b8$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $9e8d2fd6513e67b8$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $9e8d2fd6513e67b8$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
// lib/server-runtime/warnings.ts
var $9e8d2fd6513e67b8$var$alreadyWarned2 = {};
function $9e8d2fd6513e67b8$export$5b28268982f175ba(condition, message) {
    if (!condition && !$9e8d2fd6513e67b8$var$alreadyWarned2[message]) {
        $9e8d2fd6513e67b8$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $9e8d2fd6513e67b8$var$USE_OPTIMISTIC = "useOptimistic";
var $9e8d2fd6513e67b8$var$useOptimisticImpl = $dSwpL[$9e8d2fd6513e67b8$var$USE_OPTIMISTIC];
var $9e8d2fd6513e67b8$var$stableUseOptimisticSetter = ()=>void 0;
function $9e8d2fd6513e67b8$var$useOptimisticSafe(val) {
    if ($9e8d2fd6513e67b8$var$useOptimisticImpl) return $9e8d2fd6513e67b8$var$useOptimisticImpl(val);
    else return [
        val,
        $9e8d2fd6513e67b8$var$stableUseOptimisticSetter
    ];
}
function $9e8d2fd6513e67b8$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($9e8d2fd6513e67b8$export$945fecf35a8ef089) {
            if (route.element) $9e8d2fd6513e67b8$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $dSwpL.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($9e8d2fd6513e67b8$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $9e8d2fd6513e67b8$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $dSwpL.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($9e8d2fd6513e67b8$export$945fecf35a8ef089) {
            if (route.errorElement) $9e8d2fd6513e67b8$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $dSwpL.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $9e8d2fd6513e67b8$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $9e8d2fd6513e67b8$export$f30f7e456d254e83(routes, opts) {
    return $9e8d2fd6513e67b8$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $9e8d2fd6513e67b8$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $9e8d2fd6513e67b8$export$e2fd2c03906469db,
        mapRouteProperties: $9e8d2fd6513e67b8$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
var $9e8d2fd6513e67b8$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $9e8d2fd6513e67b8$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, unstable_useTransitions: unstable_useTransitions }) {
    let unstable_rsc = $9e8d2fd6513e67b8$var$useIsRSCRouterContext();
    unstable_useTransitions = unstable_rsc || unstable_useTransitions;
    let [_state, setStateImpl] = $dSwpL.useState(router.state);
    let [state, setOptimisticState] = $9e8d2fd6513e67b8$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $dSwpL.useState();
    let [vtContext, setVtContext] = $dSwpL.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $dSwpL.useState();
    let [transition, setTransition] = $dSwpL.useState();
    let [interruption, setInterruption] = $dSwpL.useState();
    let fetcherData = $dSwpL.useRef(/* @__PURE__ */ new Map());
    let setState = $dSwpL.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                unstable_pattern: $9e8d2fd6513e67b8$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $9e8d2fd6513e67b8$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $9e8d2fd6513e67b8$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (unstable_useTransitions === false) setStateImpl(newState);
            else $dSwpL.startTransition(()=>{
                if (unstable_useTransitions === true) setOptimisticState((s)=>$9e8d2fd6513e67b8$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        unstable_useTransitions,
        setOptimisticState,
        onError
    ]);
    $dSwpL.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let initialized = state.initialized;
    $dSwpL.useLayoutEffect(()=>{
        if (!initialized && router.state.initialized) setState(router.state, {
            deletedFetchers: [],
            flushSync: false,
            newErrors: null
        });
    }, [
        initialized,
        setState,
        router.state
    ]);
    $dSwpL.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $9e8d2fd6513e67b8$var$Deferred());
    }, [
        vtContext
    ]);
    $dSwpL.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (unstable_useTransitions === false) setStateImpl(newState);
                else $dSwpL.startTransition(()=>{
                    if (unstable_useTransitions === true) setOptimisticState((s)=>$9e8d2fd6513e67b8$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        unstable_useTransitions,
        setOptimisticState
    ]);
    $dSwpL.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $dSwpL.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $dSwpL.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $dSwpL.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $dSwpL.createElement($dSwpL.Fragment, null, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        unstable_useTransitions: unstable_useTransitions
    }, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $9e8d2fd6513e67b8$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $9e8d2fd6513e67b8$var$MemoizedDataRoutes = $dSwpL.memo($9e8d2fd6513e67b8$var$DataRoutes);
function $9e8d2fd6513e67b8$var$DataRoutes({ routes: routes, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $9e8d2fd6513e67b8$var$useRoutesImpl(routes, void 0, {
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $9e8d2fd6513e67b8$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, unstable_useTransitions: unstable_useTransitions }) {
    let historyRef = $dSwpL.useRef();
    if (historyRef.current == null) historyRef.current = $9e8d2fd6513e67b8$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dSwpL.useState({
        action: history.action,
        location: history.location
    });
    let setState = $dSwpL.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $dSwpL.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $dSwpL.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $9e8d2fd6513e67b8$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $9e8d2fd6513e67b8$export$f5708dca728d7177($9e8d2fd6513e67b8$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $dSwpL.useContext($9e8d2fd6513e67b8$export$3044ab7fdabeaee6);
    $9e8d2fd6513e67b8$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $dSwpL.useContext($9e8d2fd6513e67b8$export$aac280ed165a4397);
    let { pathname: locationPathname } = $9e8d2fd6513e67b8$export$45d76561a5302f2b();
    let navigate = $9e8d2fd6513e67b8$export$9770f232ac06a008();
    let path = $9e8d2fd6513e67b8$var$resolveTo(to, $9e8d2fd6513e67b8$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $dSwpL.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $9e8d2fd6513e67b8$export$910ae8079b2c2852(props) {
    return $9e8d2fd6513e67b8$export$a3be3530d8e40d0b(props.context);
}
function $9e8d2fd6513e67b8$export$e7b0ac011bb776c6(props) {
    $9e8d2fd6513e67b8$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $9e8d2fd6513e67b8$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, unstable_useTransitions: unstable_useTransitions }) {
    $9e8d2fd6513e67b8$export$f5708dca728d7177(!$9e8d2fd6513e67b8$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $dSwpL.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            unstable_useTransitions: unstable_useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        unstable_useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $9e8d2fd6513e67b8$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", unstable_mask: unstable_mask } = locationProp;
    let locationContext = $dSwpL.useMemo(()=>{
        let trailingPathname = $9e8d2fd6513e67b8$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                unstable_mask: unstable_mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        unstable_mask
    ]);
    $9e8d2fd6513e67b8$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $9e8d2fd6513e67b8$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $9e8d2fd6513e67b8$export$5d3fca4a98652595($9e8d2fd6513e67b8$export$16da398f5434bdec(children), location);
}
function $9e8d2fd6513e67b8$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $dSwpL.useContext($9e8d2fd6513e67b8$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $dSwpL.useContext($9e8d2fd6513e67b8$export$315e3ffb01f217);
    let onError = $dSwpL.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            unstable_pattern: $9e8d2fd6513e67b8$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$ResolveAwait, null, children));
}
var $9e8d2fd6513e67b8$var$AwaitErrorBoundary = class extends $dSwpL.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $9e8d2fd6513e67b8$var$ResolveAwait({ children: children }) {
    let data2 = $9e8d2fd6513e67b8$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $dSwpL.createElement($dSwpL.Fragment, null, toRender);
}
function $9e8d2fd6513e67b8$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $dSwpL.Children.forEach(children, (element, index)=>{
        if (!$dSwpL.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $dSwpL.Fragment) {
            routes.push.apply(routes, $9e8d2fd6513e67b8$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $9e8d2fd6513e67b8$export$f5708dca728d7177(element.type === $9e8d2fd6513e67b8$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $9e8d2fd6513e67b8$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $9e8d2fd6513e67b8$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $9e8d2fd6513e67b8$export$9b5b6d122dea0c88 = $9e8d2fd6513e67b8$export$16da398f5434bdec;
function $9e8d2fd6513e67b8$export$daf73786167a7f72(matches) {
    return $9e8d2fd6513e67b8$var$_renderMatches(matches);
}
function $9e8d2fd6513e67b8$var$useRouteComponentProps() {
    return {
        params: $9e8d2fd6513e67b8$export$99eaa27ddbbb95ef(),
        loaderData: $9e8d2fd6513e67b8$export$1448a5050d252c4d(),
        actionData: $9e8d2fd6513e67b8$export$fdc00f3f26066d5e(),
        matches: $9e8d2fd6513e67b8$export$2378eb7f5ff86053()
    };
}
function $9e8d2fd6513e67b8$export$6c4f3826290c37af({ children: children }) {
    const props = $9e8d2fd6513e67b8$var$useRouteComponentProps();
    return $dSwpL.cloneElement(children, props);
}
function $9e8d2fd6513e67b8$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $9e8d2fd6513e67b8$var$useRouteComponentProps();
        return $dSwpL.createElement(Component4, props);
    };
}
function $9e8d2fd6513e67b8$var$useHydrateFallbackProps() {
    return {
        params: $9e8d2fd6513e67b8$export$99eaa27ddbbb95ef(),
        loaderData: $9e8d2fd6513e67b8$export$1448a5050d252c4d(),
        actionData: $9e8d2fd6513e67b8$export$fdc00f3f26066d5e()
    };
}
function $9e8d2fd6513e67b8$export$f8cff34f39c1932a({ children: children }) {
    const props = $9e8d2fd6513e67b8$var$useHydrateFallbackProps();
    return $dSwpL.cloneElement(children, props);
}
function $9e8d2fd6513e67b8$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $9e8d2fd6513e67b8$var$useHydrateFallbackProps();
        return $dSwpL.createElement(HydrateFallback, props);
    };
}
function $9e8d2fd6513e67b8$var$useErrorBoundaryProps() {
    return {
        params: $9e8d2fd6513e67b8$export$99eaa27ddbbb95ef(),
        loaderData: $9e8d2fd6513e67b8$export$1448a5050d252c4d(),
        actionData: $9e8d2fd6513e67b8$export$fdc00f3f26066d5e(),
        error: $9e8d2fd6513e67b8$export$ed527bf60f6e05f2()
    };
}
function $9e8d2fd6513e67b8$export$e5afde5c4b6d747b({ children: children }) {
    const props = $9e8d2fd6513e67b8$var$useErrorBoundaryProps();
    return $dSwpL.cloneElement(children, props);
}
function $9e8d2fd6513e67b8$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $9e8d2fd6513e67b8$var$useErrorBoundaryProps();
        return $dSwpL.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $9e8d2fd6513e67b8$var$defaultMethod = "get";
var $9e8d2fd6513e67b8$var$defaultEncType = "application/x-www-form-urlencoded";
function $9e8d2fd6513e67b8$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $9e8d2fd6513e67b8$var$isButtonElement(object) {
    return $9e8d2fd6513e67b8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $9e8d2fd6513e67b8$var$isFormElement(object) {
    return $9e8d2fd6513e67b8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $9e8d2fd6513e67b8$var$isInputElement(object) {
    return $9e8d2fd6513e67b8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $9e8d2fd6513e67b8$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $9e8d2fd6513e67b8$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$9e8d2fd6513e67b8$var$isModifiedEvent(event);
}
function $9e8d2fd6513e67b8$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $9e8d2fd6513e67b8$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $9e8d2fd6513e67b8$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $9e8d2fd6513e67b8$var$_formDataSupportsSubmitter = null;
function $9e8d2fd6513e67b8$var$isFormDataSubmitterSupported() {
    if ($9e8d2fd6513e67b8$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $9e8d2fd6513e67b8$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $9e8d2fd6513e67b8$var$_formDataSupportsSubmitter = true;
    }
    return $9e8d2fd6513e67b8$var$_formDataSupportsSubmitter;
}
var $9e8d2fd6513e67b8$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $9e8d2fd6513e67b8$var$getFormEncType(encType) {
    if (encType != null && !$9e8d2fd6513e67b8$var$supportedFormEncTypes.has(encType)) {
        $9e8d2fd6513e67b8$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$9e8d2fd6513e67b8$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $9e8d2fd6513e67b8$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($9e8d2fd6513e67b8$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $9e8d2fd6513e67b8$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $9e8d2fd6513e67b8$var$defaultMethod;
        encType = $9e8d2fd6513e67b8$var$getFormEncType(target.getAttribute("enctype")) || $9e8d2fd6513e67b8$var$defaultEncType;
        formData = new FormData(target);
    } else if ($9e8d2fd6513e67b8$var$isButtonElement(target) || $9e8d2fd6513e67b8$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $9e8d2fd6513e67b8$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $9e8d2fd6513e67b8$var$defaultMethod;
        encType = $9e8d2fd6513e67b8$var$getFormEncType(target.getAttribute("formenctype")) || $9e8d2fd6513e67b8$var$getFormEncType(form.getAttribute("enctype")) || $9e8d2fd6513e67b8$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$9e8d2fd6513e67b8$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($9e8d2fd6513e67b8$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $9e8d2fd6513e67b8$var$defaultMethod;
        action = null;
        encType = $9e8d2fd6513e67b8$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $9e8d2fd6513e67b8$var$HOLE = -1;
var $9e8d2fd6513e67b8$var$NAN = -2;
var $9e8d2fd6513e67b8$var$NEGATIVE_INFINITY = -3;
var $9e8d2fd6513e67b8$var$NEGATIVE_ZERO = -4;
var $9e8d2fd6513e67b8$var$NULL = -5;
var $9e8d2fd6513e67b8$var$POSITIVE_INFINITY = -6;
var $9e8d2fd6513e67b8$var$UNDEFINED = -7;
var $9e8d2fd6513e67b8$var$TYPE_BIGINT = "B";
var $9e8d2fd6513e67b8$var$TYPE_DATE = "D";
var $9e8d2fd6513e67b8$var$TYPE_ERROR = "E";
var $9e8d2fd6513e67b8$var$TYPE_MAP = "M";
var $9e8d2fd6513e67b8$var$TYPE_NULL_OBJECT = "N";
var $9e8d2fd6513e67b8$var$TYPE_PROMISE = "P";
var $9e8d2fd6513e67b8$var$TYPE_REGEXP = "R";
var $9e8d2fd6513e67b8$var$TYPE_SET = "S";
var $9e8d2fd6513e67b8$var$TYPE_SYMBOL = "Y";
var $9e8d2fd6513e67b8$var$TYPE_URL = "U";
var $9e8d2fd6513e67b8$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $9e8d2fd6513e67b8$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $9e8d2fd6513e67b8$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $9e8d2fd6513e67b8$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $9e8d2fd6513e67b8$var$TIME_LIMIT_MS = 1;
var $9e8d2fd6513e67b8$var$getNow = ()=>Date.now();
var $9e8d2fd6513e67b8$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $9e8d2fd6513e67b8$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $9e8d2fd6513e67b8$var$UNDEFINED;
    if (input === null) return $9e8d2fd6513e67b8$var$NULL;
    if (Number.isNaN(input)) return $9e8d2fd6513e67b8$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $9e8d2fd6513e67b8$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $9e8d2fd6513e67b8$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $9e8d2fd6513e67b8$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $9e8d2fd6513e67b8$var$stringify.call(this, stack);
    return index;
}
async function $9e8d2fd6513e67b8$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $9e8d2fd6513e67b8$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $9e8d2fd6513e67b8$var$UNDEFINED;
        if (value === null) return $9e8d2fd6513e67b8$var$NULL;
        if (Number.isNaN(value)) return $9e8d2fd6513e67b8$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $9e8d2fd6513e67b8$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $9e8d2fd6513e67b8$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $9e8d2fd6513e67b8$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $9e8d2fd6513e67b8$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $9e8d2fd6513e67b8$var$TIME_LIMIT_MS) {
            await $9e8d2fd6513e67b8$var$yieldToMain();
            lastYieldTime = $9e8d2fd6513e67b8$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$9e8d2fd6513e67b8$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$9e8d2fd6513e67b8$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$9e8d2fd6513e67b8$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $9e8d2fd6513e67b8$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$9e8d2fd6513e67b8$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$9e8d2fd6513e67b8$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$9e8d2fd6513e67b8$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$9e8d2fd6513e67b8$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$9e8d2fd6513e67b8$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$9e8d2fd6513e67b8$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$9e8d2fd6513e67b8$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$9e8d2fd6513e67b8$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$9e8d2fd6513e67b8$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$9e8d2fd6513e67b8$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($9e8d2fd6513e67b8$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $9e8d2fd6513e67b8$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $9e8d2fd6513e67b8$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $9e8d2fd6513e67b8$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $9e8d2fd6513e67b8$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $9e8d2fd6513e67b8$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $9e8d2fd6513e67b8$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $9e8d2fd6513e67b8$var$hydrate.call(this, startIndex);
}
function $9e8d2fd6513e67b8$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $9e8d2fd6513e67b8$var$UNDEFINED:
                set(void 0);
                continue;
            case $9e8d2fd6513e67b8$var$NULL:
                set(null);
                continue;
            case $9e8d2fd6513e67b8$var$NAN:
                set(NaN);
                continue;
            case $9e8d2fd6513e67b8$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $9e8d2fd6513e67b8$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $9e8d2fd6513e67b8$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $9e8d2fd6513e67b8$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $9e8d2fd6513e67b8$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $9e8d2fd6513e67b8$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $9e8d2fd6513e67b8$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $9e8d2fd6513e67b8$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $9e8d2fd6513e67b8$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $9e8d2fd6513e67b8$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $9e8d2fd6513e67b8$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $9e8d2fd6513e67b8$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $9e8d2fd6513e67b8$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $9e8d2fd6513e67b8$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $9e8d2fd6513e67b8$var$globalObj && $9e8d2fd6513e67b8$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $9e8d2fd6513e67b8$var$globalObj && typeof $9e8d2fd6513e67b8$var$globalObj[errorType] === "function" ? new $9e8d2fd6513e67b8$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $9e8d2fd6513e67b8$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $9e8d2fd6513e67b8$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $9e8d2fd6513e67b8$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $9e8d2fd6513e67b8$var$Deferred2();
    const reader = readable.pipeThrough($9e8d2fd6513e67b8$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $9e8d2fd6513e67b8$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $9e8d2fd6513e67b8$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $9e8d2fd6513e67b8$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $9e8d2fd6513e67b8$var$unflatten.call(this, line)
    };
}
async function $9e8d2fd6513e67b8$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $9e8d2fd6513e67b8$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $9e8d2fd6513e67b8$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $9e8d2fd6513e67b8$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $9e8d2fd6513e67b8$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $9e8d2fd6513e67b8$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $9e8d2fd6513e67b8$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $9e8d2fd6513e67b8$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$9e8d2fd6513e67b8$var$TYPE_PROMISE}${deferredId}:[["${$9e8d2fd6513e67b8$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$9e8d2fd6513e67b8$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$9e8d2fd6513e67b8$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $9e8d2fd6513e67b8$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$9e8d2fd6513e67b8$var$TYPE_ERROR}${deferredId}:[["${$9e8d2fd6513e67b8$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$9e8d2fd6513e67b8$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$9e8d2fd6513e67b8$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $9e8d2fd6513e67b8$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $9e8d2fd6513e67b8$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $9e8d2fd6513e67b8$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $9e8d2fd6513e67b8$export$4cf11838cdc2a8a8(html) {
    return html.replace($9e8d2fd6513e67b8$var$ESCAPE_REGEX, (match)=>$9e8d2fd6513e67b8$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $9e8d2fd6513e67b8$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $9e8d2fd6513e67b8$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $9e8d2fd6513e67b8$var$SingleFetchNoResultError = class extends Error {
};
var $9e8d2fd6513e67b8$export$ae9272e641ead836 = 202;
var $9e8d2fd6513e67b8$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $9e8d2fd6513e67b8$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $dSwpL.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$9e8d2fd6513e67b8$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $dSwpL.createElement($dSwpL.Fragment, null, scriptTag, /* @__PURE__ */ $dSwpL.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $dSwpL.createElement($dSwpL.Fragment, null, scriptTag, /* @__PURE__ */ $dSwpL.createElement($dSwpL.Suspense, null, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $9e8d2fd6513e67b8$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $9e8d2fd6513e67b8$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $9e8d2fd6513e67b8$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $9e8d2fd6513e67b8$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $9e8d2fd6513e67b8$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $9e8d2fd6513e67b8$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $9e8d2fd6513e67b8$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $9e8d2fd6513e67b8$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $9e8d2fd6513e67b8$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $9e8d2fd6513e67b8$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $9e8d2fd6513e67b8$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $9e8d2fd6513e67b8$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($9e8d2fd6513e67b8$export$3f1eb41d9a6a6a27(result.result) || $9e8d2fd6513e67b8$export$972111febbeef05b(result.result) || $9e8d2fd6513e67b8$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $9e8d2fd6513e67b8$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $9e8d2fd6513e67b8$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $9e8d2fd6513e67b8$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $9e8d2fd6513e67b8$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$9e8d2fd6513e67b8$var$createDeferred2());
    let singleFetchDfd = $9e8d2fd6513e67b8$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $9e8d2fd6513e67b8$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $9e8d2fd6513e67b8$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $9e8d2fd6513e67b8$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $9e8d2fd6513e67b8$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $9e8d2fd6513e67b8$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $9e8d2fd6513e67b8$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $9e8d2fd6513e67b8$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $9e8d2fd6513e67b8$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $9e8d2fd6513e67b8$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $9e8d2fd6513e67b8$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $9e8d2fd6513e67b8$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$9e8d2fd6513e67b8$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$9e8d2fd6513e67b8$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $9e8d2fd6513e67b8$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $9e8d2fd6513e67b8$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $9e8d2fd6513e67b8$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $9e8d2fd6513e67b8$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $9e8d2fd6513e67b8$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $9e8d2fd6513e67b8$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($9e8d2fd6513e67b8$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $9e8d2fd6513e67b8$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $9e8d2fd6513e67b8$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($9e8d2fd6513e67b8$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$9e8d2fd6513e67b8$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $9e8d2fd6513e67b8$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $9e8d2fd6513e67b8$export$4023ad4ecd4126a2(body, global) {
    return $9e8d2fd6513e67b8$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $9e8d2fd6513e67b8$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $9e8d2fd6513e67b8$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$9e8d2fd6513e67b8$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $9e8d2fd6513e67b8$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $9e8d2fd6513e67b8$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $9e8d2fd6513e67b8$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $9e8d2fd6513e67b8$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $9e8d2fd6513e67b8$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $9e8d2fd6513e67b8$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $9e8d2fd6513e67b8$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $9e8d2fd6513e67b8$var$getModuleLinkHrefs(matches, manifest);
    return $9e8d2fd6513e67b8$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $9e8d2fd6513e67b8$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $9e8d2fd6513e67b8$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $9e8d2fd6513e67b8$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($9e8d2fd6513e67b8$var$prefetchStyleLink));
}
async function $9e8d2fd6513e67b8$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$9e8d2fd6513e67b8$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$9e8d2fd6513e67b8$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$9e8d2fd6513e67b8$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($9e8d2fd6513e67b8$var$prefetchStyleLink));
}
async function $9e8d2fd6513e67b8$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $9e8d2fd6513e67b8$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $9e8d2fd6513e67b8$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $9e8d2fd6513e67b8$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $9e8d2fd6513e67b8$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $9e8d2fd6513e67b8$var$dedupeLinkDescriptors(links.flat(1).filter($9e8d2fd6513e67b8$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $9e8d2fd6513e67b8$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $9e8d2fd6513e67b8$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $9e8d2fd6513e67b8$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $9e8d2fd6513e67b8$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $9e8d2fd6513e67b8$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $9e8d2fd6513e67b8$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$9e8d2fd6513e67b8$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($9e8d2fd6513e67b8$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $9e8d2fd6513e67b8$var$_isPreloadSupported;
function $9e8d2fd6513e67b8$var$isPreloadSupported() {
    if ($9e8d2fd6513e67b8$var$_isPreloadSupported !== void 0) return $9e8d2fd6513e67b8$var$_isPreloadSupported;
    let el = document.createElement("link");
    $9e8d2fd6513e67b8$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $9e8d2fd6513e67b8$var$_isPreloadSupported;
}
function $9e8d2fd6513e67b8$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $9e8d2fd6513e67b8$export$945fecf35a8ef089 ? /* @__PURE__ */ $dSwpL.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $9e8d2fd6513e67b8$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $9e8d2fd6513e67b8$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $9e8d2fd6513e67b8$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $9e8d2fd6513e67b8$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$RemixRootDefaultErrorBoundary, {
            error: $9e8d2fd6513e67b8$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $dSwpL.createElement(routeModule.Layout, null, /* @__PURE__ */ $dSwpL.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $dSwpL.createElement(routeModule.Layout, null, /* @__PURE__ */ $dSwpL.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $dSwpL.createElement(routeModule.Layout, null, /* @__PURE__ */ $dSwpL.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $9e8d2fd6513e67b8$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $9e8d2fd6513e67b8$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $9e8d2fd6513e67b8$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$9e8d2fd6513e67b8$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $9e8d2fd6513e67b8$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $9e8d2fd6513e67b8$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $9e8d2fd6513e67b8$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $9e8d2fd6513e67b8$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $9e8d2fd6513e67b8$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $9e8d2fd6513e67b8$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $9e8d2fd6513e67b8$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $9e8d2fd6513e67b8$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $9e8d2fd6513e67b8$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $9e8d2fd6513e67b8$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $9e8d2fd6513e67b8$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $9e8d2fd6513e67b8$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $9e8d2fd6513e67b8$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$9e8d2fd6513e67b8$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $9e8d2fd6513e67b8$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern, unstable_url: unstable_url }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $9e8d2fd6513e67b8$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            unstable_url: unstable_url,
                            async serverLoader () {
                                $9e8d2fd6513e67b8$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $9e8d2fd6513e67b8$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern, unstable_url: unstable_url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $9e8d2fd6513e67b8$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $9e8d2fd6513e67b8$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        unstable_url: unstable_url,
                        async serverAction () {
                            $9e8d2fd6513e67b8$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $9e8d2fd6513e67b8$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $9e8d2fd6513e67b8$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $9e8d2fd6513e67b8$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $9e8d2fd6513e67b8$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $9e8d2fd6513e67b8$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $9e8d2fd6513e67b8$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $9e8d2fd6513e67b8$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $9e8d2fd6513e67b8$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $9e8d2fd6513e67b8$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $9e8d2fd6513e67b8$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $9e8d2fd6513e67b8$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $9e8d2fd6513e67b8$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $9e8d2fd6513e67b8$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $9e8d2fd6513e67b8$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $9e8d2fd6513e67b8$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $9e8d2fd6513e67b8$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $9e8d2fd6513e67b8$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $9e8d2fd6513e67b8$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $9e8d2fd6513e67b8$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $9e8d2fd6513e67b8$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $9e8d2fd6513e67b8$var$nextPaths = /* @__PURE__ */ new Set();
var $9e8d2fd6513e67b8$var$discoveredPathsMaxSize = 1e3;
var $9e8d2fd6513e67b8$var$discoveredPaths = /* @__PURE__ */ new Set();
var $9e8d2fd6513e67b8$var$URL_LIMIT = 7680;
function $9e8d2fd6513e67b8$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $9e8d2fd6513e67b8$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $9e8d2fd6513e67b8$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $9e8d2fd6513e67b8$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$9e8d2fd6513e67b8$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($9e8d2fd6513e67b8$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $9e8d2fd6513e67b8$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $9e8d2fd6513e67b8$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $9e8d2fd6513e67b8$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $dSwpL.useEffect(()=>{
        if (!$9e8d2fd6513e67b8$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$9e8d2fd6513e67b8$var$discoveredPaths.has(pathname)) $9e8d2fd6513e67b8$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($9e8d2fd6513e67b8$var$nextPaths.keys()).filter((path)=>{
                if ($9e8d2fd6513e67b8$var$discoveredPaths.has(path)) {
                    $9e8d2fd6513e67b8$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $9e8d2fd6513e67b8$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $9e8d2fd6513e67b8$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $9e8d2fd6513e67b8$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $9e8d2fd6513e67b8$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $9e8d2fd6513e67b8$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $9e8d2fd6513e67b8$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($9e8d2fd6513e67b8$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $9e8d2fd6513e67b8$var$URL_LIMIT) {
        $9e8d2fd6513e67b8$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($9e8d2fd6513e67b8$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($9e8d2fd6513e67b8$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($9e8d2fd6513e67b8$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$9e8d2fd6513e67b8$var$addToFifoQueue(p, $9e8d2fd6513e67b8$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $9e8d2fd6513e67b8$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $9e8d2fd6513e67b8$var$addToFifoQueue(path, queue) {
    if (queue.size >= $9e8d2fd6513e67b8$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $9e8d2fd6513e67b8$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $9e8d2fd6513e67b8$var$useDataRouterContext2() {
    let context = $dSwpL.useContext($9e8d2fd6513e67b8$export$2eeee58951ff3c1c);
    $9e8d2fd6513e67b8$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $9e8d2fd6513e67b8$var$useDataRouterStateContext() {
    let context = $dSwpL.useContext($9e8d2fd6513e67b8$export$315e3ffb01f217);
    $9e8d2fd6513e67b8$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $9e8d2fd6513e67b8$export$208d6a3bc3aa62bd = $dSwpL.createContext(void 0);
$9e8d2fd6513e67b8$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $9e8d2fd6513e67b8$var$useFrameworkContext() {
    let context = $dSwpL.useContext($9e8d2fd6513e67b8$export$208d6a3bc3aa62bd);
    $9e8d2fd6513e67b8$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $9e8d2fd6513e67b8$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $dSwpL.useContext($9e8d2fd6513e67b8$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $dSwpL.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $dSwpL.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $dSwpL.useRef(null);
    $dSwpL.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $dSwpL.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $9e8d2fd6513e67b8$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $9e8d2fd6513e67b8$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $9e8d2fd6513e67b8$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $9e8d2fd6513e67b8$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $9e8d2fd6513e67b8$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $9e8d2fd6513e67b8$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $9e8d2fd6513e67b8$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$9e8d2fd6513e67b8$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $9e8d2fd6513e67b8$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $9e8d2fd6513e67b8$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $9e8d2fd6513e67b8$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $9e8d2fd6513e67b8$var$useDataRouterStateContext();
    let matches = $9e8d2fd6513e67b8$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $dSwpL.useMemo(()=>$9e8d2fd6513e67b8$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $dSwpL.createElement($dSwpL.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $dSwpL.createElement("style", {
        [$9e8d2fd6513e67b8$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $dSwpL.createElement("link", {
        [$9e8d2fd6513e67b8$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$9e8d2fd6513e67b8$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $dSwpL.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $9e8d2fd6513e67b8$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $9e8d2fd6513e67b8$var$useIsRSCRouterContext();
    let { router: router } = $9e8d2fd6513e67b8$var$useDataRouterContext2();
    let matches = $dSwpL.useMemo(()=>$9e8d2fd6513e67b8$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (rsc) return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $9e8d2fd6513e67b8$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $9e8d2fd6513e67b8$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $dSwpL.useState([]);
    $dSwpL.useEffect(()=>{
        let interrupted = false;
        $9e8d2fd6513e67b8$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $9e8d2fd6513e67b8$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $9e8d2fd6513e67b8$export$45d76561a5302f2b();
    let { future: future } = $9e8d2fd6513e67b8$var$useFrameworkContext();
    let { basename: basename } = $9e8d2fd6513e67b8$var$useDataRouterContext2();
    let dataHrefs = $dSwpL.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $9e8d2fd6513e67b8$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $dSwpL.createElement($dSwpL.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $dSwpL.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $9e8d2fd6513e67b8$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $9e8d2fd6513e67b8$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $9e8d2fd6513e67b8$var$useFrameworkContext();
    let { basename: basename } = $9e8d2fd6513e67b8$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $9e8d2fd6513e67b8$var$useDataRouterStateContext();
    let newMatchesForData = $dSwpL.useMemo(()=>$9e8d2fd6513e67b8$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $dSwpL.useMemo(()=>$9e8d2fd6513e67b8$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $dSwpL.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $9e8d2fd6513e67b8$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $dSwpL.useMemo(()=>$9e8d2fd6513e67b8$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $9e8d2fd6513e67b8$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $dSwpL.createElement($dSwpL.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $dSwpL.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $dSwpL.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $dSwpL.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $9e8d2fd6513e67b8$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $9e8d2fd6513e67b8$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $9e8d2fd6513e67b8$var$useDataRouterStateContext();
    let location = $9e8d2fd6513e67b8$export$45d76561a5302f2b();
    let _matches = $9e8d2fd6513e67b8$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $dSwpL.createElement($dSwpL.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$9e8d2fd6513e67b8$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $dSwpL.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $dSwpL.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $dSwpL.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $dSwpL.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $9e8d2fd6513e67b8$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $dSwpL.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $9e8d2fd6513e67b8$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $9e8d2fd6513e67b8$var$isHydrated = false;
function $9e8d2fd6513e67b8$export$3be068dde909e563() {
    $9e8d2fd6513e67b8$var$isHydrated = true;
}
function $9e8d2fd6513e67b8$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $9e8d2fd6513e67b8$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $9e8d2fd6513e67b8$var$useDataRouterContext2();
    let { matches: routerMatches } = $9e8d2fd6513e67b8$var$useDataRouterStateContext();
    let isRSCRouterContext = $9e8d2fd6513e67b8$var$useIsRSCRouterContext();
    let enableFogOfWar = $9e8d2fd6513e67b8$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $9e8d2fd6513e67b8$var$getActiveMatches(routerMatches, null, isSpaMode);
    $dSwpL.useEffect(()=>{
        $9e8d2fd6513e67b8$export$3be068dde909e563();
    }, []);
    let initialScripts = $dSwpL.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $9e8d2fd6513e67b8$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($9e8d2fd6513e67b8$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $dSwpL.createElement($dSwpL.Fragment, null, /* @__PURE__ */ $dSwpL.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $dSwpL.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $9e8d2fd6513e67b8$var$isHydrated || isRSCRouterContext ? [] : $9e8d2fd6513e67b8$var$dedupe(manifest.entry.imports.concat($9e8d2fd6513e67b8$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $9e8d2fd6513e67b8$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $9e8d2fd6513e67b8$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $dSwpL.createElement($dSwpL.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $dSwpL.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $dSwpL.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $dSwpL.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $dSwpL.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $9e8d2fd6513e67b8$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $9e8d2fd6513e67b8$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $9e8d2fd6513e67b8$export$32e57f52df4b6e34 = class extends $dSwpL.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $9e8d2fd6513e67b8$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $dSwpL.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($9e8d2fd6513e67b8$export$972111febbeef05b(error)) return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $dSwpL.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $9e8d2fd6513e67b8$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $dSwpL.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $dSwpL.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $9e8d2fd6513e67b8$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $9e8d2fd6513e67b8$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $dSwpL.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $dSwpL.createElement("head", null, /* @__PURE__ */ $dSwpL.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $dSwpL.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $dSwpL.createElement("title", null, title)), /* @__PURE__ */ $dSwpL.createElement("body", null, /* @__PURE__ */ $dSwpL.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$ff0bf87698939488, null) : null)));
}
var $9e8d2fd6513e67b8$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($9e8d2fd6513e67b8$var$isBrowser2) window.__reactRouterVersion = "7.14.2";
} catch (e) {}
function $9e8d2fd6513e67b8$export$1f3f55432a00e06d(routes, opts) {
    return $9e8d2fd6513e67b8$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $9e8d2fd6513e67b8$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $9e8d2fd6513e67b8$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $9e8d2fd6513e67b8$export$9269a41d8c4635e,
        hydrationRouteProperties: $9e8d2fd6513e67b8$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $9e8d2fd6513e67b8$export$1ba7ed8a3a7b3765(routes, opts) {
    return $9e8d2fd6513e67b8$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $9e8d2fd6513e67b8$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $9e8d2fd6513e67b8$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $9e8d2fd6513e67b8$export$9269a41d8c4635e,
        hydrationRouteProperties: $9e8d2fd6513e67b8$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $9e8d2fd6513e67b8$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $9e8d2fd6513e67b8$var$deserializeErrors(state.errors)
    };
    return state;
}
function $9e8d2fd6513e67b8$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $9e8d2fd6513e67b8$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $9e8d2fd6513e67b8$export$9ba4e89fdfa1fc54({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $dSwpL.useRef();
    if (historyRef.current == null) historyRef.current = $9e8d2fd6513e67b8$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dSwpL.useState({
        action: history.action,
        location: history.location
    });
    let setState = $dSwpL.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $dSwpL.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $dSwpL.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $9e8d2fd6513e67b8$export$7221d69dcfc8e36b({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $dSwpL.useRef();
    if (historyRef.current == null) historyRef.current = $9e8d2fd6513e67b8$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dSwpL.useState({
        action: history.action,
        location: history.location
    });
    let setState = $dSwpL.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $dSwpL.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $dSwpL.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $9e8d2fd6513e67b8$export$de73885c9336221c({ basename: basename, children: children, history: history, unstable_useTransitions: unstable_useTransitions }) {
    let [state, setStateImpl] = $dSwpL.useState({
        action: history.action,
        location: history.location
    });
    let setState = $dSwpL.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $dSwpL.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $dSwpL.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
$9e8d2fd6513e67b8$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $9e8d2fd6513e67b8$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $9e8d2fd6513e67b8$export$a6c7ac8248d6e38a = $dSwpL.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, unstable_mask: unstable_mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, unstable_useTransitions: unstable_useTransitions } = $dSwpL.useContext($9e8d2fd6513e67b8$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $9e8d2fd6513e67b8$var$ABSOLUTE_URL_REGEX2.test(to);
    let parsed = $9e8d2fd6513e67b8$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $9e8d2fd6513e67b8$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $9e8d2fd6513e67b8$export$45d76561a5302f2b();
    let maskedHref = null;
    if (unstable_mask) {
        let resolved = $9e8d2fd6513e67b8$var$resolveTo(unstable_mask, [], location.unstable_mask ? location.unstable_mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $9e8d2fd6513e67b8$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $9e8d2fd6513e67b8$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $9e8d2fd6513e67b8$export$67621102c14d847(to, {
        replace: replace2,
        unstable_mask: unstable_mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate,
        unstable_useTransitions: unstable_useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $dSwpL.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $9e8d2fd6513e67b8$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $dSwpL.createElement($dSwpL.Fragment, null, link, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$9e8d2fd6513e67b8$export$a6c7ac8248d6e38a.displayName = "Link";
var $9e8d2fd6513e67b8$export$b0d92dbee9b5b60d = $dSwpL.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $9e8d2fd6513e67b8$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $9e8d2fd6513e67b8$export$45d76561a5302f2b();
    let routerState = $dSwpL.useContext($9e8d2fd6513e67b8$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $dSwpL.useContext($9e8d2fd6513e67b8$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $9e8d2fd6513e67b8$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $9e8d2fd6513e67b8$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$9e8d2fd6513e67b8$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $9e8d2fd6513e67b8$export$a7fed597f4b8afd8 = $dSwpL.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $9e8d2fd6513e67b8$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { unstable_useTransitions: unstable_useTransitions } = $dSwpL.useContext($9e8d2fd6513e67b8$export$3044ab7fdabeaee6);
    let submit = $9e8d2fd6513e67b8$export$47c85c6e3a081d3();
    let formAction = $9e8d2fd6513e67b8$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $9e8d2fd6513e67b8$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
            });
        if (unstable_useTransitions && navigate !== false) $dSwpL.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $dSwpL.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$9e8d2fd6513e67b8$export$a7fed597f4b8afd8.displayName = "Form";
function $9e8d2fd6513e67b8$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $dSwpL.useContext($9e8d2fd6513e67b8$export$208d6a3bc3aa62bd);
    let { basename: basename } = $dSwpL.useContext($9e8d2fd6513e67b8$export$3044ab7fdabeaee6);
    let location = $9e8d2fd6513e67b8$export$45d76561a5302f2b();
    let matches = $9e8d2fd6513e67b8$export$2378eb7f5ff86053();
    $9e8d2fd6513e67b8$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $dSwpL.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $9e8d2fd6513e67b8$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $dSwpL.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$9e8d2fd6513e67b8$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $9e8d2fd6513e67b8$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$9e8d2fd6513e67b8$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$9e8d2fd6513e67b8$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $9e8d2fd6513e67b8$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $9e8d2fd6513e67b8$var$useDataRouterContext3(hookName) {
    let ctx = $dSwpL.useContext($9e8d2fd6513e67b8$export$2eeee58951ff3c1c);
    $9e8d2fd6513e67b8$export$f5708dca728d7177(ctx, $9e8d2fd6513e67b8$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $9e8d2fd6513e67b8$var$useDataRouterState2(hookName) {
    let state = $dSwpL.useContext($9e8d2fd6513e67b8$export$315e3ffb01f217);
    $9e8d2fd6513e67b8$export$f5708dca728d7177(state, $9e8d2fd6513e67b8$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $9e8d2fd6513e67b8$export$67621102c14d847(to, { target: target, replace: replaceProp, unstable_mask: unstable_mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, unstable_useTransitions: unstable_useTransitions } = {}) {
    let navigate = $9e8d2fd6513e67b8$export$9770f232ac06a008();
    let location = $9e8d2fd6513e67b8$export$45d76561a5302f2b();
    let path = $9e8d2fd6513e67b8$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $dSwpL.useCallback((event)=>{
        if ($9e8d2fd6513e67b8$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $9e8d2fd6513e67b8$export$fe53371bee54353d(location) === $9e8d2fd6513e67b8$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    unstable_mask: unstable_mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
                });
            if (unstable_useTransitions) $dSwpL.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        unstable_mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        unstable_defaultShouldRevalidate,
        unstable_useTransitions
    ]);
}
function $9e8d2fd6513e67b8$export$f1a78c17382fe22a(defaultInit) {
    $9e8d2fd6513e67b8$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $dSwpL.useRef($9e8d2fd6513e67b8$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $dSwpL.useRef(false);
    let location = $9e8d2fd6513e67b8$export$45d76561a5302f2b();
    let searchParams = $dSwpL.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $9e8d2fd6513e67b8$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $9e8d2fd6513e67b8$export$9770f232ac06a008();
    let setSearchParams = $dSwpL.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $9e8d2fd6513e67b8$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $9e8d2fd6513e67b8$var$fetcherId = 0;
var $9e8d2fd6513e67b8$var$getUniqueFetcherId = ()=>`__${String(++$9e8d2fd6513e67b8$var$fetcherId)}__`;
function $9e8d2fd6513e67b8$export$47c85c6e3a081d3() {
    let { router: router } = $9e8d2fd6513e67b8$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $dSwpL.useContext($9e8d2fd6513e67b8$export$3044ab7fdabeaee6);
    let currentRouteId = $9e8d2fd6513e67b8$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $dSwpL.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $9e8d2fd6513e67b8$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $9e8d2fd6513e67b8$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $9e8d2fd6513e67b8$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $dSwpL.useContext($9e8d2fd6513e67b8$export$3044ab7fdabeaee6);
    let routeContext = $dSwpL.useContext($9e8d2fd6513e67b8$export$aac280ed165a4397);
    $9e8d2fd6513e67b8$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$9e8d2fd6513e67b8$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $9e8d2fd6513e67b8$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $9e8d2fd6513e67b8$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $9e8d2fd6513e67b8$export$fe53371bee54353d(path);
}
function $9e8d2fd6513e67b8$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $9e8d2fd6513e67b8$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $9e8d2fd6513e67b8$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $dSwpL.useContext($9e8d2fd6513e67b8$export$cb3f1df1bef00a39);
    let route = $dSwpL.useContext($9e8d2fd6513e67b8$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $9e8d2fd6513e67b8$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $9e8d2fd6513e67b8$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $9e8d2fd6513e67b8$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $dSwpL.useId();
    let [fetcherKey, setFetcherKey] = $dSwpL.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $dSwpL.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $dSwpL.useCallback(async (href, opts)=>{
        $9e8d2fd6513e67b8$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $9e8d2fd6513e67b8$export$47c85c6e3a081d3();
    let submit = $dSwpL.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $dSwpL.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $dSwpL.useMemo(()=>{
        let FetcherForm2 = $dSwpL.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $9e8d2fd6513e67b8$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $dSwpL.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $9e8d2fd6513e67b8$export$fa996778a3a31087() {
    let state = $9e8d2fd6513e67b8$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $9e8d2fd6513e67b8$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $9e8d2fd6513e67b8$var$savedScrollPositions = {};
function $9e8d2fd6513e67b8$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $9e8d2fd6513e67b8$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $9e8d2fd6513e67b8$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $9e8d2fd6513e67b8$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $9e8d2fd6513e67b8$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $dSwpL.useContext($9e8d2fd6513e67b8$export$3044ab7fdabeaee6);
    let location = $9e8d2fd6513e67b8$export$45d76561a5302f2b();
    let matches = $9e8d2fd6513e67b8$export$2378eb7f5ff86053();
    let navigation = $9e8d2fd6513e67b8$export$d0fd4b7106de2769();
    $dSwpL.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $9e8d2fd6513e67b8$var$usePageHide($dSwpL.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $9e8d2fd6513e67b8$var$getScrollRestorationKey(location, matches, basename, getKey);
            $9e8d2fd6513e67b8$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $9e8d2fd6513e67b8$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($9e8d2fd6513e67b8$var$savedScrollPositions));
        } catch (error) {
            $9e8d2fd6513e67b8$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $dSwpL.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $9e8d2fd6513e67b8$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $9e8d2fd6513e67b8$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $dSwpL.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($9e8d2fd6513e67b8$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$9e8d2fd6513e67b8$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $dSwpL.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $9e8d2fd6513e67b8$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $9e8d2fd6513e67b8$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $dSwpL.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $9e8d2fd6513e67b8$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $dSwpL.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $9e8d2fd6513e67b8$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $9e8d2fd6513e67b8$export$b273b3273281a049(when);
    $dSwpL.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $dSwpL.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $9e8d2fd6513e67b8$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $dSwpL.useContext($9e8d2fd6513e67b8$export$3681f408decb40d1);
    $9e8d2fd6513e67b8$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $9e8d2fd6513e67b8$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $9e8d2fd6513e67b8$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $9e8d2fd6513e67b8$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $9e8d2fd6513e67b8$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $9e8d2fd6513e67b8$export$81336c211d5ff295(path.pathname, nextPath) != null || $9e8d2fd6513e67b8$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $9e8d2fd6513e67b8$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $9e8d2fd6513e67b8$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        unstable_mask: void 0
    };
    let staticNavigator = $9e8d2fd6513e67b8$var$getStatelessNavigator();
    return /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        unstable_useTransitions: false
    });
}
function $9e8d2fd6513e67b8$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $9e8d2fd6513e67b8$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $9e8d2fd6513e67b8$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $9e8d2fd6513e67b8$var$serializeErrors(context.errors)
        };
        let json = $9e8d2fd6513e67b8$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $dSwpL.createElement($dSwpL.Fragment, null, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        unstable_useTransitions: false
    }, /* @__PURE__ */ $dSwpL.createElement($9e8d2fd6513e67b8$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $dSwpL.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $9e8d2fd6513e67b8$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($9e8d2fd6513e67b8$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $9e8d2fd6513e67b8$var$getStatelessNavigator() {
    return {
        createHref: $9e8d2fd6513e67b8$var$createHref,
        encodeLocation: $9e8d2fd6513e67b8$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $9e8d2fd6513e67b8$export$69163f0b72ec60d9(routes, opts) {
    return $9e8d2fd6513e67b8$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $9e8d2fd6513e67b8$export$9269a41d8c4635e
    });
}
function $9e8d2fd6513e67b8$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $9e8d2fd6513e67b8$export$87cb1a9238dc3fba(routes, $9e8d2fd6513e67b8$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                unstable_passThroughRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $9e8d2fd6513e67b8$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $9e8d2fd6513e67b8$var$createHref,
        encodeLocation: $9e8d2fd6513e67b8$var$encodeLocation,
        getFetcher () {
            return $9e8d2fd6513e67b8$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $9e8d2fd6513e67b8$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $9e8d2fd6513e67b8$var$createHref(to) {
    return typeof to === "string" ? to : $9e8d2fd6513e67b8$export$fe53371bee54353d(to);
}
function $9e8d2fd6513e67b8$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $9e8d2fd6513e67b8$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $9e8d2fd6513e67b8$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $9e8d2fd6513e67b8$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;



var $1KfxD = parcelRequire("1KfxD");

var $1KfxD = parcelRequire("1KfxD");
parcelRequire("dSwpL");
const $b56b9875e86e18a1$export$94e7423f6fc45a54 = [
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "804071",
            name: "Pizza Hut",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2026/2/12/ad6e92d8-fa38-41ae-8d47-57b2c7d0444e_804071.JPG",
            locality: "Chandni Chowk",
            areaName: "Chandni Chowk",
            costForTwo: "\u20B9350 for two",
            cuisines: [
                "Pizzas"
            ],
            avgRating: 4.2,
            parentId: "721",
            avgRatingString: "4.2",
            totalRatingsString: "499",
            sla: {
                deliveryTime: 25,
                lastMileTravel: 1.4,
                serviceability: "SERVICEABLE",
                slaString: "20-25 mins",
                lastMileTravelString: "1.4 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2026-04-09 23:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "66% OFF",
                subHeader: "UPTO \u20B9126",
                headerTypeV2: 12
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "4.8",
                    ratingCount: "128"
                },
                source: "GOOGLE",
                sourceIconImageId: "v1704440323/google_ratings/rating_google_tag"
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ddba2a6a-b865-4355-b8e9-ac6a53c0c409"
        },
        cta: {
            link: "https://www.swiggy.com/city/delhi/pizza-hut-chandni-chowk-rest804071",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "1072666",
            name: "Punjabi Angithi (Vegorama Group)",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2025/6/19/993813cc-f53a-4f5c-9a58-fd8a35365733_1072666.jpg",
            locality: "KAROL BAGH",
            areaName: "Jhandewalan",
            costForTwo: "\u20B9300 for two",
            cuisines: [
                "North Indian",
                "Chinese",
                "Tandoor",
                "rolls"
            ],
            avgRating: 4.4,
            veg: true,
            parentId: "465050",
            avgRatingString: "4.4",
            totalRatingsString: "4.2K+",
            sla: {
                deliveryTime: 25,
                lastMileTravel: 5.6,
                serviceability: "SERVICEABLE",
                slaString: "25-30 mins",
                lastMileTravelString: "5.6 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2026-04-09 23:59:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "brand_cards/Badges%202026/26_Best%20in%20North%20Indian2026.png",
                        description: "Best in North Indian"
                    },
                    {
                        imageId: "v1695133679/badges/Pure_Veg111.png",
                        description: "pureveg"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "Best in North Indian",
                                    imageId: "brand_cards/Badges%202026/26_Best%20in%20North%20Indian2026.png",
                                    theme: ""
                                }
                            },
                            {
                                attributes: {
                                    description: "pureveg",
                                    imageId: "v1695133679/badges/Pure_Veg111.png",
                                    theme: ""
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "66% OFF",
                subHeader: "UPTO \u20B9126",
                headerTypeV2: 12,
                secondaryDiscountCallout: "\u20B966 Cashback"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ddba2a6a-b865-4355-b8e9-ac6a53c0c409"
        },
        cta: {
            link: "https://www.swiggy.com/city/delhi/punjabi-angithi-vegorama-group-karol-bagh-jhandewalan-rest1072666",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "807783",
            name: "Burger King",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2025/6/18/a049117e-1a3d-4ca0-94a0-9e25a17879df_807783.jpg",
            locality: "Omaxe Mall",
            areaName: "Chandni Chowk",
            costForTwo: "\u20B9350 for two",
            cuisines: [
                "Burgers",
                "American"
            ],
            avgRating: 4.3,
            parentId: "166",
            avgRatingString: "4.3",
            totalRatingsString: "1.0K+",
            sla: {
                deliveryTime: 21,
                lastMileTravel: 1.7,
                serviceability: "SERVICEABLE",
                slaString: "20-25 mins",
                lastMileTravelString: "1.7 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2026-04-09 23:59:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "brand_cards/Badges%202026/41_Best%20in%20Burger2026.png",
                        description: "Best in Burger"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "Best in Burger",
                                    imageId: "brand_cards/Badges%202026/41_Best%20in%20Burger2026.png",
                                    theme: ""
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "66% OFF",
                subHeader: "UPTO \u20B9126",
                headerTypeV2: 12
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ddba2a6a-b865-4355-b8e9-ac6a53c0c409"
        },
        cta: {
            link: "https://www.swiggy.com/city/delhi/burger-king-omaxe-mall-chandni-chowk-rest807783",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "798674",
            name: "Wow! Momo",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2025/6/30/f364b773-d901-4f53-bd41-ade71823bef7_798674.jpg",
            locality: "Chandni Chowk",
            areaName: "Omaxe Chowk",
            costForTwo: "\u20B9300 for two",
            cuisines: [
                "Momos",
                "Chinese",
                "fastfood",
                "Asian",
                "Beverages"
            ],
            avgRating: 4.4,
            parentId: "1776",
            avgRatingString: "4.4",
            totalRatingsString: "295",
            sla: {
                deliveryTime: 21,
                lastMileTravel: 1.4,
                serviceability: "SERVICEABLE",
                slaString: "20-25 mins",
                lastMileTravelString: "1.4 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2026-04-09 23:59:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "android/static-assets/icons/big_rx.png",
                        description: "bolt!"
                    },
                    {
                        imageId: "brand_cards/Badges%202026/66_Best%20in%20Momo2026.png",
                        description: "Best in Momo"
                    },
                    {
                        imageId: "Rxawards/_CATEGORY-Chinese.png",
                        description: "Delivery!"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "bolt!",
                                    imageId: "android/static-assets/icons/big_rx.png"
                                }
                            },
                            {
                                attributes: {
                                    description: "Best in Momo",
                                    imageId: "brand_cards/Badges%202026/66_Best%20in%20Momo2026.png",
                                    theme: ""
                                }
                            },
                            {
                                attributes: {
                                    description: "Delivery!",
                                    imageId: "Rxawards/_CATEGORY-Chinese.png",
                                    theme: ""
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "66% OFF",
                subHeader: "UPTO \u20B9126",
                headerTypeV2: 12
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "3.3",
                    ratingCount: "56"
                },
                source: "GOOGLE",
                sourceIconImageId: "v1704440323/google_ratings/rating_google_tag"
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ddba2a6a-b865-4355-b8e9-ac6a53c0c409"
        },
        cta: {
            link: "https://www.swiggy.com/city/delhi/wow-momo-chandni-chowk-omaxe-chowk-rest798674",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "169835",
            name: "NIC Ice Creams",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2026/2/4/d6aacb57-0aac-4164-aae7-53362b75ac2c_169835.JPG",
            locality: "Beadon Pura",
            areaName: "Karol Bagh",
            costForTwo: "\u20B9120 for two",
            cuisines: [
                "Ice Cream",
                "Desserts"
            ],
            avgRating: 4.7,
            veg: true,
            parentId: "6249",
            avgRatingString: "4.7",
            totalRatingsString: "10K+",
            sla: {
                deliveryTime: 24,
                lastMileTravel: 6.8,
                serviceability: "SERVICEABLE",
                slaString: "20-25 mins",
                lastMileTravelString: "6.8 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2026-04-10 00:00:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "brand_cards/Badges%202026/56_Best%20in%20Ice%20Cream2026.png",
                        description: "Best in Ice Cream"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "Best in Ice Cream",
                                    imageId: "brand_cards/Badges%202026/56_Best%20in%20Ice%20Cream2026.png",
                                    theme: ""
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "\u20B9166 OFF",
                subHeader: "ABOVE \u20B9549",
                discountTag: "FLAT DEAL",
                headerTypeV2: 12
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ddba2a6a-b865-4355-b8e9-ac6a53c0c409"
        },
        cta: {
            link: "https://www.swiggy.com/city/delhi/nic-ice-creams-beadon-pura-karol-bagh-rest169835",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "51510",
            name: "Biryani By Kilo",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2024/12/4/789f3c41-1343-4f1c-bb0a-84eff4157fe8_51510.JPG",
            locality: "Rajiv Chowk",
            areaName: "Connaught Place",
            costForTwo: "\u20B9700 for two",
            cuisines: [
                "Biryani",
                "Hyderabadi",
                "North Indian",
                "Kebabs",
                "Mughlai",
                "Desserts"
            ],
            avgRating: 4.3,
            parentId: "130",
            avgRatingString: "4.3",
            totalRatingsString: "9.5K+",
            sla: {
                deliveryTime: 37,
                lastMileTravel: 6.4,
                serviceability: "SERVICEABLE",
                slaString: "35-45 mins",
                lastMileTravelString: "6.4 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2026-04-09 23:59:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "brand_cards/Badges%202026/39_Best%20in%20Biryani2026.png",
                        description: "Best in Biryani"
                    },
                    {
                        imageId: "newg.png",
                        description: "Gourmet"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "Best in Biryani",
                                    imageId: "brand_cards/Badges%202026/39_Best%20in%20Biryani2026.png",
                                    theme: ""
                                }
                            },
                            {
                                attributes: {
                                    description: "Gourmet",
                                    imageId: "newg.png",
                                    theme: ""
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "66% OFF",
                subHeader: "UPTO \u20B9136",
                headerTypeV2: 12,
                secondaryDiscountCallout: "\u20B966 Cashback"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "4.0",
                    ratingCount: "2.5K+"
                },
                source: "GOOGLE",
                sourceIconImageId: "v1704440323/google_ratings/rating_google_tag"
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ddba2a6a-b865-4355-b8e9-ac6a53c0c409"
        },
        cta: {
            link: "https://www.swiggy.com/city/delhi/biryani-by-kilo-rajiv-chowk-connaught-place-rest51510",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "417161",
            name: "Rominus Pizza And Burger",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2025/4/11/b287db0b-f985-46e4-80d4-45168e58501d_417161.jpg",
            locality: "Vikash Marg",
            areaName: "Laxmi Nagar",
            costForTwo: "\u20B9150 for two",
            cuisines: [
                "Pizzas",
                "Italian-American",
                "American",
                "Barbecue",
                "Snacks",
                "Grill",
                "Italian",
                "Pastas",
                "Sweets",
                "Desserts"
            ],
            avgRating: 4.3,
            parentId: "8387",
            avgRatingString: "4.3",
            totalRatingsString: "13K+",
            sla: {
                deliveryTime: 45,
                lastMileTravel: 8.5,
                serviceability: "SERVICEABLE",
                slaString: "40-45 mins",
                lastMileTravelString: "8.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2026-04-10 05:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "75% OFF",
                subHeader: "UPTO \u20B9160",
                discountTag: "SAVE BIG"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "4.7",
                    ratingCount: "1.0K+"
                },
                source: "GOOGLE",
                sourceIconImageId: "v1704440323/google_ratings/rating_google_tag"
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ddba2a6a-b865-4355-b8e9-ac6a53c0c409"
        },
        cta: {
            link: "https://www.swiggy.com/city/delhi/rominus-pizza-and-burger-vikash-marg-laxmi-nagar-rest417161",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
        info: {
            id: "1053751",
            name: "Honest Bowl",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2025/12/12/db2400cb-2414-4044-8db2-97ccd486b973_1053751.JPG",
            locality: "Connaught Place",
            areaName: "Connaught Place",
            costForTwo: "\u20B9200 for two",
            cuisines: [
                "North Indian",
                "High Protein",
                "Biryani"
            ],
            avgRating: 4.1,
            parentId: "612552",
            avgRatingString: "4.1",
            totalRatingsString: "178",
            sla: {
                deliveryTime: 25,
                lastMileTravel: 4.6,
                serviceability: "SERVICEABLE",
                slaString: "20-25 mins",
                lastMileTravelString: "4.6 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2026-04-09 23:59:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "High%20Protein/rx%20tag%205.png",
                        description: "High Protein"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "High Protein",
                                    imageId: "High%20Protein/rx%20tag%205.png",
                                    theme: ""
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "60% OFF",
                subHeader: "UPTO \u20B9110"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-ddba2a6a-b865-4355-b8e9-ac6a53c0c409"
        },
        cta: {
            link: "https://www.swiggy.com/city/delhi/honest-bowl-connaught-place-rest1053751",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    }
];
const $b56b9875e86e18a1$export$d82609210b8816e6 = "https://user-images.githubusercontent.com/19409/135924939-03845d0b-e7bb-414b-89b6-e627dfa9f614.png";
const $b56b9875e86e18a1$export$3c67ec6258c4a827 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
const $b56b9875e86e18a1$export$7c6ff693f8aa5426 = "/dapi/restaurants/list/v5?lat=28.6098012&lng=77.1001525&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";
const $b56b9875e86e18a1$export$fbde561f2925a76a = "/mapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=28.6098012&lng=77.1001525&restaurantId="; // export const RESTAURANT_DETAILS_URL =
 //   "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=28.6098012&lng=77.1001525&restaurantId=722373";




var $dPnrE = parcelRequire("dPnrE");

var $1KfxD = parcelRequire("1KfxD");

var $dSwpL = parcelRequire("dSwpL");

var $drrpd = parcelRequire("drrpd");

var $dPnrE = parcelRequire("dPnrE");

var $dSwpL = parcelRequire("dSwpL");
var $45f8ad4c79aae5cd$exports = {};
'use strict';

$45f8ad4c79aae5cd$exports = (parcelRequire("61PDG"));


var $d70dbdb49916e071$var$__defProp = Object.defineProperty;
var $d70dbdb49916e071$var$__defProps = Object.defineProperties;
var $d70dbdb49916e071$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d70dbdb49916e071$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d70dbdb49916e071$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d70dbdb49916e071$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d70dbdb49916e071$var$__defNormalProp = (obj, key, value)=>key in obj ? $d70dbdb49916e071$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d70dbdb49916e071$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d70dbdb49916e071$var$__hasOwnProp.call(b, prop)) $d70dbdb49916e071$var$__defNormalProp(a, prop, b[prop]);
    if ($d70dbdb49916e071$var$__getOwnPropSymbols) {
        for (var prop of $d70dbdb49916e071$var$__getOwnPropSymbols(b))if ($d70dbdb49916e071$var$__propIsEnum.call(b, prop)) $d70dbdb49916e071$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d70dbdb49916e071$var$__spreadProps = (a, b)=>$d70dbdb49916e071$var$__defProps(a, $d70dbdb49916e071$var$__getOwnPropDescs(b));
var $d70dbdb49916e071$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d70dbdb49916e071$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d70dbdb49916e071$var$__getOwnPropSymbols) {
        for (var prop of $d70dbdb49916e071$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d70dbdb49916e071$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $d70dbdb49916e071$var$IS_REACT_19 = /* @__PURE__ */ $dSwpL.version.startsWith("19");
var $d70dbdb49916e071$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($d70dbdb49916e071$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $d70dbdb49916e071$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $d70dbdb49916e071$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $d70dbdb49916e071$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $d70dbdb49916e071$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $d70dbdb49916e071$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $d70dbdb49916e071$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $d70dbdb49916e071$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $d70dbdb49916e071$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $d70dbdb49916e071$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $d70dbdb49916e071$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $d70dbdb49916e071$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $d70dbdb49916e071$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $d70dbdb49916e071$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $d70dbdb49916e071$var$ForwardRef = $d70dbdb49916e071$var$REACT_FORWARD_REF_TYPE;
var $d70dbdb49916e071$var$Memo = $d70dbdb49916e071$var$REACT_MEMO_TYPE;
function $d70dbdb49916e071$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $d70dbdb49916e071$var$REACT_FRAGMENT_TYPE || type === $d70dbdb49916e071$var$REACT_PROFILER_TYPE || type === $d70dbdb49916e071$var$REACT_STRICT_MODE_TYPE || type === $d70dbdb49916e071$var$REACT_SUSPENSE_TYPE || type === $d70dbdb49916e071$var$REACT_SUSPENSE_LIST_TYPE || type === $d70dbdb49916e071$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $d70dbdb49916e071$var$REACT_LAZY_TYPE || type.$$typeof === $d70dbdb49916e071$var$REACT_MEMO_TYPE || type.$$typeof === $d70dbdb49916e071$var$REACT_CONTEXT_TYPE || type.$$typeof === $d70dbdb49916e071$var$REACT_CONSUMER_TYPE || type.$$typeof === $d70dbdb49916e071$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $d70dbdb49916e071$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $d70dbdb49916e071$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $d70dbdb49916e071$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $d70dbdb49916e071$var$REACT_FRAGMENT_TYPE:
                    case $d70dbdb49916e071$var$REACT_PROFILER_TYPE:
                    case $d70dbdb49916e071$var$REACT_STRICT_MODE_TYPE:
                    case $d70dbdb49916e071$var$REACT_SUSPENSE_TYPE:
                    case $d70dbdb49916e071$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $d70dbdb49916e071$var$REACT_CONTEXT_TYPE:
                            case $d70dbdb49916e071$var$REACT_FORWARD_REF_TYPE:
                            case $d70dbdb49916e071$var$REACT_LAZY_TYPE:
                            case $d70dbdb49916e071$var$REACT_MEMO_TYPE:
                                return object;
                            case $d70dbdb49916e071$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $d70dbdb49916e071$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $d70dbdb49916e071$var$isContextConsumer(object) {
    return $d70dbdb49916e071$var$IS_REACT_19 ? $d70dbdb49916e071$var$typeOf(object) === $d70dbdb49916e071$var$REACT_CONSUMER_TYPE : $d70dbdb49916e071$var$typeOf(object) === $d70dbdb49916e071$var$REACT_CONTEXT_TYPE;
}
function $d70dbdb49916e071$var$isMemo(object) {
    return $d70dbdb49916e071$var$typeOf(object) === $d70dbdb49916e071$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $d70dbdb49916e071$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $d70dbdb49916e071$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $d70dbdb49916e071$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $d70dbdb49916e071$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $d70dbdb49916e071$var$verify(mapStateToProps, "mapStateToProps");
    $d70dbdb49916e071$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $d70dbdb49916e071$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $d70dbdb49916e071$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $d70dbdb49916e071$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $d70dbdb49916e071$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $d70dbdb49916e071$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $d70dbdb49916e071$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $d70dbdb49916e071$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $d70dbdb49916e071$var$verifyPlainObject(value, displayName, methodName) {
    if (!$d70dbdb49916e071$var$isPlainObject(value)) $d70dbdb49916e071$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $d70dbdb49916e071$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $d70dbdb49916e071$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $d70dbdb49916e071$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $d70dbdb49916e071$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $d70dbdb49916e071$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $d70dbdb49916e071$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $d70dbdb49916e071$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $d70dbdb49916e071$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $d70dbdb49916e071$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $d70dbdb49916e071$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $d70dbdb49916e071$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $d70dbdb49916e071$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $d70dbdb49916e071$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $d70dbdb49916e071$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $d70dbdb49916e071$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $d70dbdb49916e071$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $d70dbdb49916e071$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $d70dbdb49916e071$var$__spreadValues($d70dbdb49916e071$var$__spreadValues($d70dbdb49916e071$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $d70dbdb49916e071$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $d70dbdb49916e071$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$d70dbdb49916e071$var$defaultMergeProps : typeof mergeProps === "function" ? $d70dbdb49916e071$var$wrapMergePropsFunc(mergeProps) : $d70dbdb49916e071$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $d70dbdb49916e071$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $d70dbdb49916e071$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $d70dbdb49916e071$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $d70dbdb49916e071$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $d70dbdb49916e071$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $d70dbdb49916e071$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $d70dbdb49916e071$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $d70dbdb49916e071$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $d70dbdb49916e071$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $d70dbdb49916e071$var$isDOM = /* @__PURE__ */ $d70dbdb49916e071$var$canUseDOM();
var $d70dbdb49916e071$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $d70dbdb49916e071$var$isReactNative = /* @__PURE__ */ $d70dbdb49916e071$var$isRunningInReactNative();
var $d70dbdb49916e071$var$getUseIsomorphicLayoutEffect = ()=>$d70dbdb49916e071$var$isDOM || $d70dbdb49916e071$var$isReactNative ? $dSwpL.useLayoutEffect : $dSwpL.useEffect;
var $d70dbdb49916e071$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $d70dbdb49916e071$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $d70dbdb49916e071$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $d70dbdb49916e071$export$d36bdfa510afb180(objA, objB) {
    if ($d70dbdb49916e071$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$d70dbdb49916e071$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $d70dbdb49916e071$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $d70dbdb49916e071$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $d70dbdb49916e071$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $d70dbdb49916e071$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $d70dbdb49916e071$var$TYPE_STATICS = {
    [$d70dbdb49916e071$var$ForwardRef]: $d70dbdb49916e071$var$FORWARD_REF_STATICS,
    [$d70dbdb49916e071$var$Memo]: $d70dbdb49916e071$var$MEMO_STATICS
};
function $d70dbdb49916e071$var$getStatics(component) {
    if ($d70dbdb49916e071$var$isMemo(component)) return $d70dbdb49916e071$var$MEMO_STATICS;
    return $d70dbdb49916e071$var$TYPE_STATICS[component["$$typeof"]] || $d70dbdb49916e071$var$REACT_STATICS;
}
var $d70dbdb49916e071$var$defineProperty = Object.defineProperty;
var $d70dbdb49916e071$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $d70dbdb49916e071$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $d70dbdb49916e071$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $d70dbdb49916e071$var$getPrototypeOf = Object.getPrototypeOf;
var $d70dbdb49916e071$var$objectPrototype = Object.prototype;
function $d70dbdb49916e071$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($d70dbdb49916e071$var$objectPrototype) {
            const inheritedComponent = $d70dbdb49916e071$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $d70dbdb49916e071$var$objectPrototype) $d70dbdb49916e071$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $d70dbdb49916e071$var$getOwnPropertyNames(sourceComponent);
        if ($d70dbdb49916e071$var$getOwnPropertySymbols) keys = keys.concat($d70dbdb49916e071$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $d70dbdb49916e071$var$getStatics(targetComponent);
        const sourceStatics = $d70dbdb49916e071$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$d70dbdb49916e071$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $d70dbdb49916e071$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $d70dbdb49916e071$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $d70dbdb49916e071$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $d70dbdb49916e071$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $d70dbdb49916e071$var$getContext() {
    var _a;
    if (!$dSwpL.createContext) return {};
    const contextMap = (_a = $d70dbdb49916e071$var$gT[$d70dbdb49916e071$var$ContextKey]) != null ? _a : $d70dbdb49916e071$var$gT[$d70dbdb49916e071$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($dSwpL.createContext);
    if (!realContext) {
        realContext = $dSwpL.createContext(null);
        contextMap.set($dSwpL.createContext, realContext);
    }
    return realContext;
}
var $d70dbdb49916e071$export$cc80c08dc91f1c00 = /* @__PURE__ */ $d70dbdb49916e071$var$getContext();
// src/components/connect.tsx
var $d70dbdb49916e071$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $d70dbdb49916e071$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $d70dbdb49916e071$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $d70dbdb49916e071$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $d70dbdb49916e071$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $d70dbdb49916e071$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $d70dbdb49916e071$var$strictEqual(a, b) {
    return a === b;
}
var $d70dbdb49916e071$var$hasWarnedAboutDeprecatedPureOption = false;
function $d70dbdb49916e071$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $d70dbdb49916e071$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $d70dbdb49916e071$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $d70dbdb49916e071$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $d70dbdb49916e071$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $d70dbdb49916e071$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $d70dbdb49916e071$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $d70dbdb49916e071$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $d70dbdb49916e071$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $dSwpL.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $d70dbdb49916e071$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $dSwpL.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $dSwpL.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $dSwpL.useMemo(()=>{
                return $d70dbdb49916e071$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $dSwpL.useMemo(()=>{
                if (!shouldHandleStateChanges) return $d70dbdb49916e071$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $d70dbdb49916e071$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $dSwpL.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $d70dbdb49916e071$var$__spreadProps($d70dbdb49916e071$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $dSwpL.useRef(void 0);
            const lastWrapperProps = $dSwpL.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $dSwpL.useRef(void 0);
            const renderIsScheduled = $dSwpL.useRef(false);
            const isMounted = $dSwpL.useRef(false);
            const latestSubscriptionCallbackError = $dSwpL.useRef(void 0);
            $d70dbdb49916e071$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $dSwpL.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $dSwpL.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $d70dbdb49916e071$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $d70dbdb49916e071$var$useIsomorphicLayoutEffectWithArgs($d70dbdb49916e071$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $dSwpL.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $d70dbdb49916e071$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $dSwpL.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $dSwpL.createElement(WrappedComponent, $d70dbdb49916e071$var$__spreadProps($d70dbdb49916e071$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $dSwpL.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $dSwpL.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $dSwpL.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $dSwpL.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $dSwpL.createElement(Connect, $d70dbdb49916e071$var$__spreadProps($d70dbdb49916e071$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $d70dbdb49916e071$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $d70dbdb49916e071$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $d70dbdb49916e071$export$64605811ab45167f = $d70dbdb49916e071$var$connect;
// src/components/Provider.tsx
function $d70dbdb49916e071$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $dSwpL.useMemo(()=>{
        const subscription = $d70dbdb49916e071$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $dSwpL.useMemo(()=>store.getState(), [
        store
    ]);
    $d70dbdb49916e071$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $d70dbdb49916e071$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $dSwpL.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $d70dbdb49916e071$export$2881499e37b75b9a = $d70dbdb49916e071$var$Provider;
// src/hooks/useReduxContext.ts
function $d70dbdb49916e071$var$createReduxContextHook(context = $d70dbdb49916e071$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $dSwpL.useContext(context);
        return contextValue;
    };
}
var $d70dbdb49916e071$var$useReduxContext = /* @__PURE__ */ $d70dbdb49916e071$var$createReduxContextHook();
// src/hooks/useStore.ts
function $d70dbdb49916e071$export$671dba69185d0304(context = $d70dbdb49916e071$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $d70dbdb49916e071$export$cc80c08dc91f1c00 ? $d70dbdb49916e071$var$useReduxContext : // @ts-ignore
    $d70dbdb49916e071$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $d70dbdb49916e071$export$6ccbb43953eebf8 = /* @__PURE__ */ $d70dbdb49916e071$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $d70dbdb49916e071$export$bc9b55530897c558(context = $d70dbdb49916e071$export$cc80c08dc91f1c00) {
    const useStore2 = context === $d70dbdb49916e071$export$cc80c08dc91f1c00 ? $d70dbdb49916e071$export$6ccbb43953eebf8 : $d70dbdb49916e071$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $d70dbdb49916e071$export$8ad76b76a4c905f8 = /* @__PURE__ */ $d70dbdb49916e071$export$bc9b55530897c558();
var $d70dbdb49916e071$var$refEquality = (a, b)=>a === b;
function $d70dbdb49916e071$export$2b53f90d2bd1cbfb(context = $d70dbdb49916e071$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $d70dbdb49916e071$export$cc80c08dc91f1c00 ? $d70dbdb49916e071$var$useReduxContext : $d70dbdb49916e071$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $d70dbdb49916e071$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $dSwpL.useRef(true);
        const wrappedSelector = $dSwpL.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $45f8ad4c79aae5cd$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $dSwpL.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $d70dbdb49916e071$export$2105062e25df4afe = /* @__PURE__ */ $d70dbdb49916e071$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $d70dbdb49916e071$export$712ea50be43a7858 = $d70dbdb49916e071$var$defaultNoopBatch;


// src/utils/formatProdErrorMessage.ts
function $f0caac4bad82347e$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $f0caac4bad82347e$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $f0caac4bad82347e$var$symbol_observable_default = $f0caac4bad82347e$var$$$observable;
// src/utils/actionTypes.ts
var $f0caac4bad82347e$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $f0caac4bad82347e$var$ActionTypes = {
    INIT: `@@redux/INIT${$f0caac4bad82347e$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$f0caac4bad82347e$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$f0caac4bad82347e$var$randomString()}`
};
var $f0caac4bad82347e$export$4219e499db7ca678 = $f0caac4bad82347e$var$ActionTypes;
// src/utils/isPlainObject.ts
function $f0caac4bad82347e$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $f0caac4bad82347e$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($f0caac4bad82347e$var$isDate(val)) return "date";
    if ($f0caac4bad82347e$var$isError(val)) return "error";
    const constructorName = $f0caac4bad82347e$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $f0caac4bad82347e$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $f0caac4bad82347e$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $f0caac4bad82347e$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $f0caac4bad82347e$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $f0caac4bad82347e$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(1));
        return enhancer($f0caac4bad82347e$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$f0caac4bad82347e$export$53b83ca8eaab0383(action)) throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $f0caac4bad82347e$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$f0caac4bad82347e$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $f0caac4bad82347e$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$f0caac4bad82347e$var$symbol_observable_default]: observable
    };
    return store;
}
function $f0caac4bad82347e$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $f0caac4bad82347e$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $f0caac4bad82347e$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $f0caac4bad82347e$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $f0caac4bad82347e$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$f0caac4bad82347e$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$f0caac4bad82347e$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $f0caac4bad82347e$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $f0caac4bad82347e$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $f0caac4bad82347e$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $f0caac4bad82347e$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(13));
    });
}
function $f0caac4bad82347e$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $f0caac4bad82347e$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $f0caac4bad82347e$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $f0caac4bad82347e$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $f0caac4bad82347e$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $f0caac4bad82347e$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $f0caac4bad82347e$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $f0caac4bad82347e$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($f0caac4bad82347e$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $f0caac4bad82347e$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $f0caac4bad82347e$export$b956e38827fca970(action) {
    return $f0caac4bad82347e$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $b153aa7c4cf57be0$var$__defProp = Object.defineProperty;
var $b153aa7c4cf57be0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b153aa7c4cf57be0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b153aa7c4cf57be0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b153aa7c4cf57be0$var$__defNormalProp = (obj, key, value)=>key in obj ? $b153aa7c4cf57be0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b153aa7c4cf57be0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b153aa7c4cf57be0$var$__hasOwnProp.call(b, prop)) $b153aa7c4cf57be0$var$__defNormalProp(a, prop, b[prop]);
    if ($b153aa7c4cf57be0$var$__getOwnPropSymbols) {
        for (var prop of $b153aa7c4cf57be0$var$__getOwnPropSymbols(b))if ($b153aa7c4cf57be0$var$__propIsEnum.call(b, prop)) $b153aa7c4cf57be0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $b153aa7c4cf57be0$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $b153aa7c4cf57be0$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $b153aa7c4cf57be0$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $b153aa7c4cf57be0$var$errors = [];
function $b153aa7c4cf57be0$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $b153aa7c4cf57be0$var$O = Object;
var $b153aa7c4cf57be0$var$getPrototypeOf = $b153aa7c4cf57be0$var$O.getPrototypeOf;
var $b153aa7c4cf57be0$var$CONSTRUCTOR = "constructor";
var $b153aa7c4cf57be0$var$PROTOTYPE = "prototype";
var $b153aa7c4cf57be0$var$CONFIGURABLE = "configurable";
var $b153aa7c4cf57be0$var$ENUMERABLE = "enumerable";
var $b153aa7c4cf57be0$var$WRITABLE = "writable";
var $b153aa7c4cf57be0$var$VALUE = "value";
var $b153aa7c4cf57be0$export$541ac630993a4c84 = (value)=>!!value && !!value[$b153aa7c4cf57be0$var$DRAFT_STATE];
function $b153aa7c4cf57be0$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $b153aa7c4cf57be0$var$isPlainObject(value) || $b153aa7c4cf57be0$var$isArray(value) || !!value[$b153aa7c4cf57be0$export$6ee2082928bcb0ee] || !!((_a = value[$b153aa7c4cf57be0$var$CONSTRUCTOR]) == null ? void 0 : _a[$b153aa7c4cf57be0$export$6ee2082928bcb0ee]) || $b153aa7c4cf57be0$var$isMap(value) || $b153aa7c4cf57be0$var$isSet(value);
}
var $b153aa7c4cf57be0$var$objectCtorString = $b153aa7c4cf57be0$var$O[$b153aa7c4cf57be0$var$PROTOTYPE][$b153aa7c4cf57be0$var$CONSTRUCTOR].toString();
var $b153aa7c4cf57be0$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $b153aa7c4cf57be0$var$isPlainObject(value) {
    if (!value || !$b153aa7c4cf57be0$var$isObjectish(value)) return false;
    const proto = $b153aa7c4cf57be0$var$getPrototypeOf(value);
    if (proto === null || proto === $b153aa7c4cf57be0$var$O[$b153aa7c4cf57be0$var$PROTOTYPE]) return true;
    const Ctor = $b153aa7c4cf57be0$var$O.hasOwnProperty.call(proto, $b153aa7c4cf57be0$var$CONSTRUCTOR) && proto[$b153aa7c4cf57be0$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$b153aa7c4cf57be0$var$isFunction(Ctor)) return false;
    let ctorString = $b153aa7c4cf57be0$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $b153aa7c4cf57be0$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $b153aa7c4cf57be0$var$objectCtorString;
}
function $b153aa7c4cf57be0$export$22e8af3f75a010e3(value) {
    if (!$b153aa7c4cf57be0$export$541ac630993a4c84(value)) $b153aa7c4cf57be0$var$die(15, value);
    return value[$b153aa7c4cf57be0$var$DRAFT_STATE].base_;
}
function $b153aa7c4cf57be0$var$each(obj, iter, strict = true) {
    if ($b153aa7c4cf57be0$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $b153aa7c4cf57be0$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $b153aa7c4cf57be0$var$getArchtype(thing) {
    const state = thing[$b153aa7c4cf57be0$var$DRAFT_STATE];
    return state ? state.type_ : $b153aa7c4cf57be0$var$isArray(thing) ? 1 /* Array */  : $b153aa7c4cf57be0$var$isMap(thing) ? 2 /* Map */  : $b153aa7c4cf57be0$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $b153aa7c4cf57be0$var$has = (thing, prop, type = $b153aa7c4cf57be0$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $b153aa7c4cf57be0$var$O[$b153aa7c4cf57be0$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $b153aa7c4cf57be0$var$get = (thing, prop, type = $b153aa7c4cf57be0$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $b153aa7c4cf57be0$var$set = (thing, propOrOldValue, value, type = $b153aa7c4cf57be0$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $b153aa7c4cf57be0$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $b153aa7c4cf57be0$var$isArray = Array.isArray;
var $b153aa7c4cf57be0$var$isMap = (target)=>target instanceof Map;
var $b153aa7c4cf57be0$var$isSet = (target)=>target instanceof Set;
var $b153aa7c4cf57be0$var$isObjectish = (target)=>typeof target === "object";
var $b153aa7c4cf57be0$var$isFunction = (target)=>typeof target === "function";
var $b153aa7c4cf57be0$var$isBoolean = (target)=>typeof target === "boolean";
function $b153aa7c4cf57be0$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $b153aa7c4cf57be0$var$getProxyDraft = (value)=>{
    if (!$b153aa7c4cf57be0$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$b153aa7c4cf57be0$var$DRAFT_STATE];
};
var $b153aa7c4cf57be0$var$latest = (state)=>state.copy_ || state.base_;
var $b153aa7c4cf57be0$var$getValue = (value)=>{
    var _a;
    const proxyDraft = $b153aa7c4cf57be0$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var $b153aa7c4cf57be0$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $b153aa7c4cf57be0$var$shallowCopy(base, strict) {
    if ($b153aa7c4cf57be0$var$isMap(base)) return new Map(base);
    if ($b153aa7c4cf57be0$var$isSet(base)) return new Set(base);
    if ($b153aa7c4cf57be0$var$isArray(base)) return Array[$b153aa7c4cf57be0$var$PROTOTYPE].slice.call(base);
    const isPlain = $b153aa7c4cf57be0$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $b153aa7c4cf57be0$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$b153aa7c4cf57be0$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$b153aa7c4cf57be0$var$WRITABLE] === false) {
                desc[$b153aa7c4cf57be0$var$WRITABLE] = true;
                desc[$b153aa7c4cf57be0$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$b153aa7c4cf57be0$var$CONFIGURABLE]: true,
                [$b153aa7c4cf57be0$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$b153aa7c4cf57be0$var$ENUMERABLE]: desc[$b153aa7c4cf57be0$var$ENUMERABLE],
                [$b153aa7c4cf57be0$var$VALUE]: base[key]
            };
        }
        return $b153aa7c4cf57be0$var$O.create($b153aa7c4cf57be0$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $b153aa7c4cf57be0$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $b153aa7c4cf57be0$var$__spreadValues({}, base);
        const obj = $b153aa7c4cf57be0$var$O.create(proto);
        return $b153aa7c4cf57be0$var$O.assign(obj, base);
    }
}
function $b153aa7c4cf57be0$export$792f3d81ea979f55(obj, deep = false) {
    if ($b153aa7c4cf57be0$var$isFrozen(obj) || $b153aa7c4cf57be0$export$541ac630993a4c84(obj) || !$b153aa7c4cf57be0$export$16e3aed3edb85946(obj)) return obj;
    if ($b153aa7c4cf57be0$var$getArchtype(obj) > 1) $b153aa7c4cf57be0$var$O.defineProperties(obj, {
        set: $b153aa7c4cf57be0$var$dontMutateMethodOverride,
        add: $b153aa7c4cf57be0$var$dontMutateMethodOverride,
        clear: $b153aa7c4cf57be0$var$dontMutateMethodOverride,
        delete: $b153aa7c4cf57be0$var$dontMutateMethodOverride
    });
    $b153aa7c4cf57be0$var$O.freeze(obj);
    if (deep) $b153aa7c4cf57be0$var$each(obj, (_key, value)=>{
        $b153aa7c4cf57be0$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $b153aa7c4cf57be0$var$dontMutateFrozenCollections() {
    $b153aa7c4cf57be0$var$die(2);
}
var $b153aa7c4cf57be0$var$dontMutateMethodOverride = {
    [$b153aa7c4cf57be0$var$VALUE]: $b153aa7c4cf57be0$var$dontMutateFrozenCollections
};
function $b153aa7c4cf57be0$var$isFrozen(obj) {
    if (obj === null || !$b153aa7c4cf57be0$var$isObjectish(obj)) return true;
    return $b153aa7c4cf57be0$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $b153aa7c4cf57be0$var$PluginMapSet = "MapSet";
var $b153aa7c4cf57be0$var$PluginPatches = "Patches";
var $b153aa7c4cf57be0$var$PluginArrayMethods = "ArrayMethods";
var $b153aa7c4cf57be0$var$plugins = {};
function $b153aa7c4cf57be0$var$getPlugin(pluginKey) {
    const plugin = $b153aa7c4cf57be0$var$plugins[pluginKey];
    if (!plugin) $b153aa7c4cf57be0$var$die(0, pluginKey);
    return plugin;
}
var $b153aa7c4cf57be0$var$isPluginLoaded = (pluginKey)=>!!$b153aa7c4cf57be0$var$plugins[pluginKey];
function $b153aa7c4cf57be0$var$loadPlugin(pluginKey, implementation) {
    if (!$b153aa7c4cf57be0$var$plugins[pluginKey]) $b153aa7c4cf57be0$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $b153aa7c4cf57be0$var$currentScope;
var $b153aa7c4cf57be0$var$getCurrentScope = ()=>$b153aa7c4cf57be0$var$currentScope;
var $b153aa7c4cf57be0$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $b153aa7c4cf57be0$var$isPluginLoaded($b153aa7c4cf57be0$var$PluginMapSet) ? $b153aa7c4cf57be0$var$getPlugin($b153aa7c4cf57be0$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $b153aa7c4cf57be0$var$isPluginLoaded($b153aa7c4cf57be0$var$PluginArrayMethods) ? $b153aa7c4cf57be0$var$getPlugin($b153aa7c4cf57be0$var$PluginArrayMethods) : void 0
    });
function $b153aa7c4cf57be0$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $b153aa7c4cf57be0$var$getPlugin($b153aa7c4cf57be0$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $b153aa7c4cf57be0$var$revokeScope(scope) {
    $b153aa7c4cf57be0$var$leaveScope(scope);
    scope.drafts_.forEach($b153aa7c4cf57be0$var$revokeDraft);
    scope.drafts_ = null;
}
function $b153aa7c4cf57be0$var$leaveScope(scope) {
    if (scope === $b153aa7c4cf57be0$var$currentScope) $b153aa7c4cf57be0$var$currentScope = scope.parent_;
}
var $b153aa7c4cf57be0$var$enterScope = (immer2)=>$b153aa7c4cf57be0$var$currentScope = $b153aa7c4cf57be0$var$createScope($b153aa7c4cf57be0$var$currentScope, immer2);
function $b153aa7c4cf57be0$var$revokeDraft(draft) {
    const state = draft[$b153aa7c4cf57be0$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $b153aa7c4cf57be0$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$b153aa7c4cf57be0$var$DRAFT_STATE].modified_) {
            $b153aa7c4cf57be0$var$revokeScope(scope);
            $b153aa7c4cf57be0$var$die(4);
        }
        if ($b153aa7c4cf57be0$export$16e3aed3edb85946(result)) result = $b153aa7c4cf57be0$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$b153aa7c4cf57be0$var$DRAFT_STATE].base_, result, scope);
    } else result = $b153aa7c4cf57be0$var$finalize(scope, baseDraft);
    $b153aa7c4cf57be0$var$maybeFreeze(scope, result, true);
    $b153aa7c4cf57be0$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $b153aa7c4cf57be0$export$45b790e32b2810ee ? result : void 0;
}
function $b153aa7c4cf57be0$var$finalize(rootScope, value) {
    if ($b153aa7c4cf57be0$var$isFrozen(value)) return value;
    const state = value[$b153aa7c4cf57be0$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $b153aa7c4cf57be0$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$b153aa7c4cf57be0$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $b153aa7c4cf57be0$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $b153aa7c4cf57be0$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $b153aa7c4cf57be0$export$792f3d81ea979f55(value, deep);
}
function $b153aa7c4cf57be0$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $b153aa7c4cf57be0$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $b153aa7c4cf57be0$var$EMPTY_LOCATIONS_RESULT = [];
function $b153aa7c4cf57be0$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $b153aa7c4cf57be0$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $b153aa7c4cf57be0$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $b153aa7c4cf57be0$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $b153aa7c4cf57be0$var$each(parentCopy, (key, value)=>{
            if ($b153aa7c4cf57be0$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $b153aa7c4cf57be0$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$b153aa7c4cf57be0$var$set(parentCopy, location, finalizedValue, parentType);
}
function $b153aa7c4cf57be0$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$b153aa7c4cf57be0$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $b153aa7c4cf57be0$var$getFinalValue(state);
        $b153aa7c4cf57be0$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $b153aa7c4cf57be0$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $b153aa7c4cf57be0$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $b153aa7c4cf57be0$var$markStateFinalized(state);
    }
}
function $b153aa7c4cf57be0$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($b153aa7c4cf57be0$export$541ac630993a4c84(value)) {
        const state = value[$b153aa7c4cf57be0$var$DRAFT_STATE];
        if ($b153aa7c4cf57be0$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $b153aa7c4cf57be0$var$prepareCopy(target);
            const finalizedValue = $b153aa7c4cf57be0$var$getFinalValue(state);
            $b153aa7c4cf57be0$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($b153aa7c4cf57be0$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $b153aa7c4cf57be0$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $b153aa7c4cf57be0$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($b153aa7c4cf57be0$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $b153aa7c4cf57be0$var$handleValue($b153aa7c4cf57be0$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $b153aa7c4cf57be0$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($b153aa7c4cf57be0$export$541ac630993a4c84(target) || handledSet.has(target) || !$b153aa7c4cf57be0$export$16e3aed3edb85946(target) || $b153aa7c4cf57be0$var$isFrozen(target)) return target;
    handledSet.add(target);
    $b153aa7c4cf57be0$var$each(target, (key, value)=>{
        if ($b153aa7c4cf57be0$export$541ac630993a4c84(value)) {
            const state = value[$b153aa7c4cf57be0$var$DRAFT_STATE];
            if ($b153aa7c4cf57be0$var$isSameScope(state, rootScope)) {
                const updatedValue = $b153aa7c4cf57be0$var$getFinalValue(state);
                $b153aa7c4cf57be0$var$set(target, key, updatedValue, target.type_);
                $b153aa7c4cf57be0$var$markStateFinalized(state);
            }
        } else if ($b153aa7c4cf57be0$export$16e3aed3edb85946(value)) $b153aa7c4cf57be0$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $b153aa7c4cf57be0$var$createProxyProxy(base, parent) {
    const baseIsArray = $b153aa7c4cf57be0$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $b153aa7c4cf57be0$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $b153aa7c4cf57be0$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $b153aa7c4cf57be0$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $b153aa7c4cf57be0$var$objectTraps = {
    get (state, prop) {
        if (prop === $b153aa7c4cf57be0$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $b153aa7c4cf57be0$var$latest(state);
        if (!$b153aa7c4cf57be0$var$has(source, prop, state.type_)) return $b153aa7c4cf57be0$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$b153aa7c4cf57be0$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $b153aa7c4cf57be0$var$isArrayIndex(prop)) return value;
        if (value === $b153aa7c4cf57be0$var$peek(state.base_, prop)) {
            $b153aa7c4cf57be0$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $b153aa7c4cf57be0$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $b153aa7c4cf57be0$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($b153aa7c4cf57be0$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $b153aa7c4cf57be0$var$getDescriptorFromProto($b153aa7c4cf57be0$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $b153aa7c4cf57be0$var$peek($b153aa7c4cf57be0$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$b153aa7c4cf57be0$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($b153aa7c4cf57be0$var$is(value, current2) && (value !== void 0 || $b153aa7c4cf57be0$var$has(state.base_, prop, state.type_))) return true;
            $b153aa7c4cf57be0$var$prepareCopy(state);
            $b153aa7c4cf57be0$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $b153aa7c4cf57be0$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $b153aa7c4cf57be0$var$prepareCopy(state);
        if ($b153aa7c4cf57be0$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $b153aa7c4cf57be0$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $b153aa7c4cf57be0$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$b153aa7c4cf57be0$var$WRITABLE]: true,
            [$b153aa7c4cf57be0$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$b153aa7c4cf57be0$var$ENUMERABLE]: desc[$b153aa7c4cf57be0$var$ENUMERABLE],
            [$b153aa7c4cf57be0$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $b153aa7c4cf57be0$var$die(11);
    },
    getPrototypeOf (state) {
        return $b153aa7c4cf57be0$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $b153aa7c4cf57be0$var$die(12);
    }
};
var $b153aa7c4cf57be0$var$arrayTraps = {};
for(let key in $b153aa7c4cf57be0$var$objectTraps){
    let fn = $b153aa7c4cf57be0$var$objectTraps[key];
    $b153aa7c4cf57be0$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$b153aa7c4cf57be0$var$arrayTraps.deleteProperty = function(state, prop) {
    return $b153aa7c4cf57be0$var$arrayTraps.set.call(this, state, prop, void 0);
};
$b153aa7c4cf57be0$var$arrayTraps.set = function(state, prop, value) {
    return $b153aa7c4cf57be0$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $b153aa7c4cf57be0$var$peek(draft, prop) {
    const state = draft[$b153aa7c4cf57be0$var$DRAFT_STATE];
    const source = state ? $b153aa7c4cf57be0$var$latest(state) : draft;
    return source[prop];
}
function $b153aa7c4cf57be0$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $b153aa7c4cf57be0$var$getDescriptorFromProto(source, prop);
    return desc ? $b153aa7c4cf57be0$var$VALUE in desc ? desc[$b153aa7c4cf57be0$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $b153aa7c4cf57be0$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $b153aa7c4cf57be0$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $b153aa7c4cf57be0$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $b153aa7c4cf57be0$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $b153aa7c4cf57be0$var$markChanged(state.parent_);
    }
}
function $b153aa7c4cf57be0$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $b153aa7c4cf57be0$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $b153aa7c4cf57be0$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($b153aa7c4cf57be0$var$isFunction(base) && !$b153aa7c4cf57be0$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$b153aa7c4cf57be0$var$isFunction(recipe)) $b153aa7c4cf57be0$var$die(6);
            if (patchListener !== void 0 && !$b153aa7c4cf57be0$var$isFunction(patchListener)) $b153aa7c4cf57be0$var$die(7);
            let result;
            if ($b153aa7c4cf57be0$export$16e3aed3edb85946(base)) {
                const scope = $b153aa7c4cf57be0$var$enterScope(this);
                const proxy = $b153aa7c4cf57be0$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $b153aa7c4cf57be0$var$revokeScope(scope);
                    else $b153aa7c4cf57be0$var$leaveScope(scope);
                }
                $b153aa7c4cf57be0$var$usePatchesInScope(scope, patchListener);
                return $b153aa7c4cf57be0$var$processResult(result, scope);
            } else if (!base || !$b153aa7c4cf57be0$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $b153aa7c4cf57be0$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $b153aa7c4cf57be0$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $b153aa7c4cf57be0$var$getPlugin($b153aa7c4cf57be0$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $b153aa7c4cf57be0$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($b153aa7c4cf57be0$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($b153aa7c4cf57be0$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($b153aa7c4cf57be0$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($b153aa7c4cf57be0$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$b153aa7c4cf57be0$export$16e3aed3edb85946(base)) $b153aa7c4cf57be0$var$die(8);
        if ($b153aa7c4cf57be0$export$541ac630993a4c84(base)) base = $b153aa7c4cf57be0$export$97aac956da55dae9(base);
        const scope = $b153aa7c4cf57be0$var$enterScope(this);
        const proxy = $b153aa7c4cf57be0$var$createProxy(scope, base, void 0);
        proxy[$b153aa7c4cf57be0$var$DRAFT_STATE].isManual_ = true;
        $b153aa7c4cf57be0$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$b153aa7c4cf57be0$var$DRAFT_STATE];
        if (!state || !state.isManual_) $b153aa7c4cf57be0$var$die(9);
        const { scope_: scope } = state;
        $b153aa7c4cf57be0$var$usePatchesInScope(scope, patchListener);
        return $b153aa7c4cf57be0$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $b153aa7c4cf57be0$var$getPlugin($b153aa7c4cf57be0$var$PluginPatches).applyPatches_;
        if ($b153aa7c4cf57be0$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $b153aa7c4cf57be0$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $b153aa7c4cf57be0$var$isMap(value) ? $b153aa7c4cf57be0$var$getPlugin($b153aa7c4cf57be0$var$PluginMapSet).proxyMap_(value, parent) : $b153aa7c4cf57be0$var$isSet(value) ? $b153aa7c4cf57be0$var$getPlugin($b153aa7c4cf57be0$var$PluginMapSet).proxySet_(value, parent) : $b153aa7c4cf57be0$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $b153aa7c4cf57be0$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $b153aa7c4cf57be0$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $b153aa7c4cf57be0$export$97aac956da55dae9(value) {
    if (!$b153aa7c4cf57be0$export$541ac630993a4c84(value)) $b153aa7c4cf57be0$var$die(10, value);
    return $b153aa7c4cf57be0$var$currentImpl(value);
}
function $b153aa7c4cf57be0$var$currentImpl(value) {
    if (!$b153aa7c4cf57be0$export$16e3aed3edb85946(value) || $b153aa7c4cf57be0$var$isFrozen(value)) return value;
    const state = value[$b153aa7c4cf57be0$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $b153aa7c4cf57be0$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $b153aa7c4cf57be0$var$shallowCopy(value, true);
    $b153aa7c4cf57be0$var$each(copy, (key, childValue)=>{
        $b153aa7c4cf57be0$var$set(copy, key, $b153aa7c4cf57be0$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $b153aa7c4cf57be0$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if (state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $b153aa7c4cf57be0$var$getProxyDraft($b153aa7c4cf57be0$var$get(parentCopy, state.key_));
            const valueAtKey = $b153aa7c4cf57be0$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $b153aa7c4cf57be0$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $b153aa7c4cf57be0$var$get(current2, key);
            if (!$b153aa7c4cf57be0$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$b153aa7c4cf57be0$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $b153aa7c4cf57be0$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $b153aa7c4cf57be0$var$get(base_, key, type_);
            const value = $b153aa7c4cf57be0$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $b153aa7c4cf57be0$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $b153aa7c4cf57be0$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $b153aa7c4cf57be0$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $b153aa7c4cf57be0$var$CONSTRUCTOR)) $b153aa7c4cf57be0$var$die(errorOffset + 3);
                if ($b153aa7c4cf57be0$var$isFunction(base) && p === $b153aa7c4cf57be0$var$PROTOTYPE) $b153aa7c4cf57be0$var$die(errorOffset + 3);
                base = $b153aa7c4cf57be0$var$get(base, p);
                if (!$b153aa7c4cf57be0$var$isObjectish(base)) $b153aa7c4cf57be0$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $b153aa7c4cf57be0$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $b153aa7c4cf57be0$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $b153aa7c4cf57be0$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$b153aa7c4cf57be0$export$16e3aed3edb85946(obj)) return obj;
        if ($b153aa7c4cf57be0$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($b153aa7c4cf57be0$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($b153aa7c4cf57be0$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($b153aa7c4cf57be0$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($b153aa7c4cf57be0$var$has(obj, $b153aa7c4cf57be0$export$6ee2082928bcb0ee)) cloned[$b153aa7c4cf57be0$export$6ee2082928bcb0ee] = obj[$b153aa7c4cf57be0$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($b153aa7c4cf57be0$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $b153aa7c4cf57be0$var$loadPlugin($b153aa7c4cf57be0$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $b153aa7c4cf57be0$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$b153aa7c4cf57be0$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $b153aa7c4cf57be0$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $b153aa7c4cf57be0$var$latest(this[$b153aa7c4cf57be0$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $b153aa7c4cf57be0$var$latest(this[$b153aa7c4cf57be0$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$b153aa7c4cf57be0$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$b153aa7c4cf57be0$var$latest(state).has(key) || $b153aa7c4cf57be0$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $b153aa7c4cf57be0$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $b153aa7c4cf57be0$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$b153aa7c4cf57be0$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $b153aa7c4cf57be0$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$b153aa7c4cf57be0$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($b153aa7c4cf57be0$var$latest(state).size) {
                prepareMapCopy(state);
                $b153aa7c4cf57be0$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $b153aa7c4cf57be0$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$b153aa7c4cf57be0$var$DRAFT_STATE];
            $b153aa7c4cf57be0$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$b153aa7c4cf57be0$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $b153aa7c4cf57be0$var$latest(state).get(key);
            if (state.finalized_ || !$b153aa7c4cf57be0$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $b153aa7c4cf57be0$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $b153aa7c4cf57be0$var$latest(this[$b153aa7c4cf57be0$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($b153aa7c4cf57be0$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$b153aa7c4cf57be0$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$b153aa7c4cf57be0$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $b153aa7c4cf57be0$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $b153aa7c4cf57be0$var$latest(this[$b153aa7c4cf57be0$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$b153aa7c4cf57be0$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$b153aa7c4cf57be0$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $b153aa7c4cf57be0$var$markChanged(state);
                state.copy_.add(value);
                $b153aa7c4cf57be0$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$b153aa7c4cf57be0$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $b153aa7c4cf57be0$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$b153aa7c4cf57be0$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($b153aa7c4cf57be0$var$latest(state).size) {
                prepareSetCopy(state);
                $b153aa7c4cf57be0$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$b153aa7c4cf57be0$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$b153aa7c4cf57be0$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($b153aa7c4cf57be0$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$b153aa7c4cf57be0$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($b153aa7c4cf57be0$export$16e3aed3edb85946(value)) {
                    const draft = $b153aa7c4cf57be0$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $b153aa7c4cf57be0$var$die(3, JSON.stringify($b153aa7c4cf57be0$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($b153aa7c4cf57be0$var$getValue(value));
            });
        }
    }
    $b153aa7c4cf57be0$var$loadPlugin($b153aa7c4cf57be0$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $b153aa7c4cf57be0$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $b153aa7c4cf57be0$var$prepareCopy(state);
        const result = operation();
        $b153aa7c4cf57be0$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            $b153aa7c4cf57be0$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            var _a;
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex((_a = args[0]) != null ? _a : 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = $b153aa7c4cf57be0$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $b153aa7c4cf57be0$var$loadPlugin($b153aa7c4cf57be0$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $b153aa7c4cf57be0$var$immer = new $b153aa7c4cf57be0$export$aaadc6ff0f822719();
var $b153aa7c4cf57be0$export$b46cabe22e78bc00 = $b153aa7c4cf57be0$var$immer.produce;
var $b153aa7c4cf57be0$export$4da66d41c9492c78 = /* @__PURE__ */ $b153aa7c4cf57be0$var$immer.produceWithPatches.bind($b153aa7c4cf57be0$var$immer);
var $b153aa7c4cf57be0$export$573f26f60825c493 = /* @__PURE__ */ $b153aa7c4cf57be0$var$immer.setAutoFreeze.bind($b153aa7c4cf57be0$var$immer);
var $b153aa7c4cf57be0$export$333ce65961cbe047 = /* @__PURE__ */ $b153aa7c4cf57be0$var$immer.setUseStrictShallowCopy.bind($b153aa7c4cf57be0$var$immer);
var $b153aa7c4cf57be0$export$1045b3be3904c489 = /* @__PURE__ */ $b153aa7c4cf57be0$var$immer.setUseStrictIteration.bind($b153aa7c4cf57be0$var$immer);
var $b153aa7c4cf57be0$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $b153aa7c4cf57be0$var$immer.applyPatches.bind($b153aa7c4cf57be0$var$immer);
var $b153aa7c4cf57be0$export$3c3214997190395f = /* @__PURE__ */ $b153aa7c4cf57be0$var$immer.createDraft.bind($b153aa7c4cf57be0$var$immer);
var $b153aa7c4cf57be0$export$c60f5e69c521b528 = /* @__PURE__ */ $b153aa7c4cf57be0$var$immer.finishDraft.bind($b153aa7c4cf57be0$var$immer);
var $b153aa7c4cf57be0$export$c05b21e3257751e5 = (value)=>value;
var $b153aa7c4cf57be0$export$20f911b3f8cf0b74 = (value)=>value;


var $05d909542afa3260$var$__defProp = Object.defineProperty;
var $05d909542afa3260$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $05d909542afa3260$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $05d909542afa3260$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $05d909542afa3260$var$__defNormalProp = (obj, key, value)=>key in obj ? $05d909542afa3260$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $05d909542afa3260$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($05d909542afa3260$var$__hasOwnProp.call(b, prop)) $05d909542afa3260$var$__defNormalProp(a, prop, b[prop]);
    if ($05d909542afa3260$var$__getOwnPropSymbols) {
        for (var prop of $05d909542afa3260$var$__getOwnPropSymbols(b))if ($05d909542afa3260$var$__propIsEnum.call(b, prop)) $05d909542afa3260$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $05d909542afa3260$var$__publicField = (obj, key, value)=>{
    $05d909542afa3260$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $05d909542afa3260$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $05d909542afa3260$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $05d909542afa3260$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $05d909542afa3260$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($05d909542afa3260$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $05d909542afa3260$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $05d909542afa3260$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $05d909542afa3260$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $05d909542afa3260$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $05d909542afa3260$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $05d909542afa3260$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $05d909542afa3260$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $05d909542afa3260$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $05d909542afa3260$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $05d909542afa3260$var$__spreadValues($05d909542afa3260$var$__spreadValues({}, $05d909542afa3260$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $05d909542afa3260$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $05d909542afa3260$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $05d909542afa3260$var$$REVISION = 0;
var $05d909542afa3260$var$CURRENT_TRACKER = null;
var $05d909542afa3260$var$Cell = class {
    constructor(initialValue, isEqual = $05d909542afa3260$var$tripleEq){
        $05d909542afa3260$var$__publicField(this, "revision", $05d909542afa3260$var$$REVISION);
        $05d909542afa3260$var$__publicField(this, "_value");
        $05d909542afa3260$var$__publicField(this, "_lastValue");
        $05d909542afa3260$var$__publicField(this, "_isEqual", $05d909542afa3260$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $05d909542afa3260$var$CURRENT_TRACKER == null || $05d909542afa3260$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$05d909542afa3260$var$$REVISION;
    }
};
function $05d909542afa3260$var$tripleEq(a, b) {
    return a === b;
}
var $05d909542afa3260$var$TrackingCache = class {
    constructor(fn){
        $05d909542afa3260$var$__publicField(this, "_cachedValue");
        $05d909542afa3260$var$__publicField(this, "_cachedRevision", -1);
        $05d909542afa3260$var$__publicField(this, "_deps", []);
        $05d909542afa3260$var$__publicField(this, "hits", 0);
        $05d909542afa3260$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $05d909542afa3260$var$CURRENT_TRACKER;
            $05d909542afa3260$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $05d909542afa3260$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $05d909542afa3260$var$CURRENT_TRACKER == null || $05d909542afa3260$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $05d909542afa3260$var$getValue(cell) {
    if (!(cell instanceof $05d909542afa3260$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $05d909542afa3260$var$setValue(storage, value) {
    if (!(storage instanceof $05d909542afa3260$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $05d909542afa3260$var$createCell(initialValue, isEqual = $05d909542afa3260$var$tripleEq) {
    return new $05d909542afa3260$var$Cell(initialValue, isEqual);
}
function $05d909542afa3260$var$createCache(fn) {
    $05d909542afa3260$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $05d909542afa3260$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $05d909542afa3260$var$neverEq = (a, b)=>false;
function $05d909542afa3260$var$createTag() {
    return $05d909542afa3260$var$createCell(null, $05d909542afa3260$var$neverEq);
}
function $05d909542afa3260$var$dirtyTag(tag, value) {
    $05d909542afa3260$var$setValue(tag, value);
}
var $05d909542afa3260$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $05d909542afa3260$var$createTag();
    $05d909542afa3260$var$getValue(tag);
};
var $05d909542afa3260$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $05d909542afa3260$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $05d909542afa3260$var$REDUX_PROXY_LABEL = Symbol();
var $05d909542afa3260$var$nextId = 0;
var $05d909542afa3260$var$proto = Object.getPrototypeOf({});
var $05d909542afa3260$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $05d909542afa3260$var$__publicField(this, "proxy", new Proxy(this, $05d909542afa3260$var$objectProxyHandler));
        $05d909542afa3260$var$__publicField(this, "tag", $05d909542afa3260$var$createTag());
        $05d909542afa3260$var$__publicField(this, "tags", {});
        $05d909542afa3260$var$__publicField(this, "children", {});
        $05d909542afa3260$var$__publicField(this, "collectionTag", null);
        $05d909542afa3260$var$__publicField(this, "id", $05d909542afa3260$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $05d909542afa3260$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $05d909542afa3260$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $05d909542afa3260$var$createNode(childValue);
                if (childNode.tag) $05d909542afa3260$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $05d909542afa3260$var$createTag();
                    tag.value = childValue;
                }
                $05d909542afa3260$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $05d909542afa3260$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $05d909542afa3260$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $05d909542afa3260$var$__publicField(this, "proxy", new Proxy([
            this
        ], $05d909542afa3260$var$arrayProxyHandler));
        $05d909542afa3260$var$__publicField(this, "tag", $05d909542afa3260$var$createTag());
        $05d909542afa3260$var$__publicField(this, "tags", {});
        $05d909542afa3260$var$__publicField(this, "children", {});
        $05d909542afa3260$var$__publicField(this, "collectionTag", null);
        $05d909542afa3260$var$__publicField(this, "id", $05d909542afa3260$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $05d909542afa3260$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $05d909542afa3260$var$consumeCollection(node);
        return $05d909542afa3260$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $05d909542afa3260$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $05d909542afa3260$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $05d909542afa3260$var$objectProxyHandler.has(node, prop);
    }
};
function $05d909542afa3260$var$createNode(value) {
    if (Array.isArray(value)) return new $05d909542afa3260$var$ArrayTreeNode(value);
    return new $05d909542afa3260$var$ObjectTreeNode(value);
}
function $05d909542afa3260$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $05d909542afa3260$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $05d909542afa3260$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $05d909542afa3260$var$dirtyCollection(node);
            $05d909542afa3260$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $05d909542afa3260$var$updateNode(childNode, newChildValue);
        else {
            $05d909542afa3260$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $05d909542afa3260$var$deleteNode(node) {
    if (node.tag) $05d909542afa3260$var$dirtyTag(node.tag, null);
    $05d909542afa3260$var$dirtyCollection(node);
    for(const key in node.tags)$05d909542afa3260$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$05d909542afa3260$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $05d909542afa3260$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $05d909542afa3260$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $05d909542afa3260$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $05d909542afa3260$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $05d909542afa3260$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $05d909542afa3260$export$3f025202a230c6dd = (a, b)=>a === b;
function $05d909542afa3260$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $05d909542afa3260$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $05d909542afa3260$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $05d909542afa3260$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $05d909542afa3260$var$createSingletonCache(comparator) : $05d909542afa3260$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $05d909542afa3260$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $05d909542afa3260$export$c8f9cf88d9fdee55(func) {
    const node = $05d909542afa3260$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $05d909542afa3260$var$createCacheKeyComparator($05d909542afa3260$export$3f025202a230c6dd);
    const cache = $05d909542afa3260$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $05d909542afa3260$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $05d909542afa3260$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $05d909542afa3260$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $05d909542afa3260$var$StrongRef;
var $05d909542afa3260$var$UNTERMINATED = 0;
var $05d909542afa3260$var$TERMINATED = 1;
function $05d909542afa3260$var$createCacheNode() {
    return {
        s: $05d909542afa3260$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $05d909542afa3260$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $05d909542afa3260$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $05d909542afa3260$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $05d909542afa3260$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $05d909542afa3260$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $05d909542afa3260$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $05d909542afa3260$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $05d909542afa3260$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $05d909542afa3260$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $05d909542afa3260$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $05d909542afa3260$var$__spreadValues($05d909542afa3260$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $05d909542afa3260$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $05d909542afa3260$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $05d909542afa3260$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $05d909542afa3260$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $05d909542afa3260$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $05d909542afa3260$export$595d22ed68ca2841 = /* @__PURE__ */ $05d909542afa3260$export$5943f4447f6ef248($05d909542afa3260$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $05d909542afa3260$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $05d909542afa3260$export$595d22ed68ca2841)=>{
    $05d909542afa3260$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$05d909542afa3260$export$75979cfcd91bf38f
});


// src/index.ts
function $213776a63cf6ffeb$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $213776a63cf6ffeb$export$dd164f5517779f15 = $213776a63cf6ffeb$var$createThunkMiddleware();
var $213776a63cf6ffeb$export$16d06542a1949d9e = $213776a63cf6ffeb$var$createThunkMiddleware;


var $ead9048c02d75bca$var$__defProp = Object.defineProperty;
var $ead9048c02d75bca$var$__defProps = Object.defineProperties;
var $ead9048c02d75bca$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $ead9048c02d75bca$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ead9048c02d75bca$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ead9048c02d75bca$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ead9048c02d75bca$var$__defNormalProp = (obj, key, value)=>key in obj ? $ead9048c02d75bca$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ead9048c02d75bca$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ead9048c02d75bca$var$__hasOwnProp.call(b, prop)) $ead9048c02d75bca$var$__defNormalProp(a, prop, b[prop]);
    if ($ead9048c02d75bca$var$__getOwnPropSymbols) {
        for (var prop of $ead9048c02d75bca$var$__getOwnPropSymbols(b))if ($ead9048c02d75bca$var$__propIsEnum.call(b, prop)) $ead9048c02d75bca$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $ead9048c02d75bca$var$__spreadProps = (a, b)=>$ead9048c02d75bca$var$__defProps(a, $ead9048c02d75bca$var$__getOwnPropDescs(b));
var $ead9048c02d75bca$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($ead9048c02d75bca$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $ead9048c02d75bca$var$__getOwnPropSymbols) {
        for (var prop of $ead9048c02d75bca$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $ead9048c02d75bca$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $ead9048c02d75bca$var$__publicField = (obj, key, value)=>$ead9048c02d75bca$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/createDraftSafeSelector.ts
var $ead9048c02d75bca$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $05d909542afa3260$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $b153aa7c4cf57be0$export$541ac630993a4c84)(value) ? (0, $b153aa7c4cf57be0$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $ead9048c02d75bca$export$a5d3c27355e35910 = /* @__PURE__ */ $ead9048c02d75bca$export$aab6de9e3dbb1473((0, $05d909542afa3260$export$8402dc26d96f6902));
// src/devtoolsExtension.ts
var $ead9048c02d75bca$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $f0caac4bad82347e$export$f672e0b6f7222cd7;
    return (0, $f0caac4bad82347e$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $ead9048c02d75bca$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $ead9048c02d75bca$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $ead9048c02d75bca$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($ead9048c02d75bca$export$378fa86b259c0280(0));
            return $ead9048c02d75bca$var$__spreadValues($ead9048c02d75bca$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $f0caac4bad82347e$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $ead9048c02d75bca$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $ead9048c02d75bca$var$hasMatchFunction(action);
}
function $ead9048c02d75bca$export$ebd532f9034651f3(action) {
    return (0, $f0caac4bad82347e$export$b956e38827fca970)(action) && Object.keys(action).every($ead9048c02d75bca$var$isValidKey);
}
function $ead9048c02d75bca$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $ead9048c02d75bca$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $ead9048c02d75bca$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function $ead9048c02d75bca$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $ead9048c02d75bca$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $ead9048c02d75bca$var$freezeDraftable(val) {
    return (0, $b153aa7c4cf57be0$export$16e3aed3edb85946)(val) ? (0, $b153aa7c4cf57be0$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $ead9048c02d75bca$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $ead9048c02d75bca$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $ead9048c02d75bca$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $ead9048c02d75bca$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $ead9048c02d75bca$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $ead9048c02d75bca$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = $ead9048c02d75bca$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function $ead9048c02d75bca$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $ead9048c02d75bca$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $ead9048c02d75bca$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function $ead9048c02d75bca$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $f0caac4bad82347e$export$53b83ca8eaab0383)(val);
}
function $ead9048c02d75bca$export$ada5dca0b571bc7(value, path = "", isSerializable = $ead9048c02d75bca$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $ead9048c02d75bca$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $ead9048c02d75bca$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $ead9048c02d75bca$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$ead9048c02d75bca$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $ead9048c02d75bca$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $ead9048c02d75bca$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $ead9048c02d75bca$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $ead9048c02d75bca$export$1908877435b1d5e9();
        if (thunk) {
            if ($ead9048c02d75bca$var$isBoolean(thunk)) middlewareArray.push((0, $213776a63cf6ffeb$export$dd164f5517779f15));
            else middlewareArray.push((0, $213776a63cf6ffeb$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $ead9048c02d75bca$export$8fb31c0f05df007b = "RTK_autoBatch";
var $ead9048c02d75bca$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$ead9048c02d75bca$export$8fb31c0f05df007b]: true
            }
        });
var $ead9048c02d75bca$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $ead9048c02d75bca$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $ead9048c02d75bca$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $ead9048c02d75bca$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$ead9048c02d75bca$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $ead9048c02d75bca$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $ead9048c02d75bca$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($ead9048c02d75bca$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $ead9048c02d75bca$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $ead9048c02d75bca$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $f0caac4bad82347e$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $f0caac4bad82347e$export$66e4520cdb265d18)(reducer);
    else throw new Error($ead9048c02d75bca$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $f0caac4bad82347e$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $ead9048c02d75bca$var$composeWithDevTools($ead9048c02d75bca$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $f0caac4bad82347e$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $ead9048c02d75bca$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $f0caac4bad82347e$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $ead9048c02d75bca$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($ead9048c02d75bca$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($ead9048c02d75bca$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $ead9048c02d75bca$var$isStateFunction(x) {
    return typeof x === "function";
}
function $ead9048c02d75bca$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $ead9048c02d75bca$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($ead9048c02d75bca$var$isStateFunction(initialState)) getInitialState = ()=>$ead9048c02d75bca$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $ead9048c02d75bca$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $b153aa7c4cf57be0$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $b153aa7c4cf57be0$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $b153aa7c4cf57be0$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $ead9048c02d75bca$var$matches = (matcher, action)=>{
    if ($ead9048c02d75bca$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $ead9048c02d75bca$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$ead9048c02d75bca$var$matches(matcher, action));
    };
}
function $ead9048c02d75bca$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$ead9048c02d75bca$var$matches(matcher, action));
    };
}
function $ead9048c02d75bca$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $ead9048c02d75bca$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $ead9048c02d75bca$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$ead9048c02d75bca$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$ead9048c02d75bca$var$isAsyncThunkArray(asyncThunks)) return $ead9048c02d75bca$export$872dec21e9a69476()(asyncThunks[0]);
    return $ead9048c02d75bca$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $ead9048c02d75bca$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$ead9048c02d75bca$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$ead9048c02d75bca$var$isAsyncThunkArray(asyncThunks)) return $ead9048c02d75bca$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $ead9048c02d75bca$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $ead9048c02d75bca$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $ead9048c02d75bca$export$9dd1fb32974da385($ead9048c02d75bca$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$ead9048c02d75bca$var$isAsyncThunkArray(asyncThunks)) return $ead9048c02d75bca$export$fcc3388fb56de601()(asyncThunks[0]);
    return $ead9048c02d75bca$export$9dd1fb32974da385($ead9048c02d75bca$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $ead9048c02d75bca$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$ead9048c02d75bca$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$ead9048c02d75bca$var$isAsyncThunkArray(asyncThunks)) return $ead9048c02d75bca$export$1da80a6ef1307441()(asyncThunks[0]);
    return $ead9048c02d75bca$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $ead9048c02d75bca$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$ead9048c02d75bca$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$ead9048c02d75bca$var$isAsyncThunkArray(asyncThunks)) return $ead9048c02d75bca$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $ead9048c02d75bca$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $ead9048c02d75bca$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $ead9048c02d75bca$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $ead9048c02d75bca$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $ead9048c02d75bca$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $ead9048c02d75bca$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $ead9048c02d75bca$var$__publicField(this, "_type");
    }
};
var $ead9048c02d75bca$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $ead9048c02d75bca$var$__publicField(this, "_type");
    }
};
var $ead9048c02d75bca$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $ead9048c02d75bca$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $ead9048c02d75bca$var$externalAbortMessage = "External signal was aborted";
var $ead9048c02d75bca$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $ead9048c02d75bca$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $ead9048c02d75bca$var$__spreadProps($ead9048c02d75bca$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $ead9048c02d75bca$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $ead9048c02d75bca$var$__spreadProps($ead9048c02d75bca$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $ead9048c02d75bca$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $ead9048c02d75bca$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $ead9048c02d75bca$var$__spreadProps($ead9048c02d75bca$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $ead9048c02d75bca$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($ead9048c02d75bca$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($ead9048c02d75bca$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($ead9048c02d75bca$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $ead9048c02d75bca$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $ead9048c02d75bca$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $ead9048c02d75bca$var$RejectWithValue) throw result;
                                if (result instanceof $ead9048c02d75bca$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $ead9048c02d75bca$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($ead9048c02d75bca$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $ead9048c02d75bca$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $ead9048c02d75bca$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $ead9048c02d75bca$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $ead9048c02d75bca$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $ead9048c02d75bca$export$343355ed40c51c46 = {
    [$ead9048c02d75bca$var$asyncThunkSymbol]: $ead9048c02d75bca$export$6abd22dc03e5063f
};
var $ead9048c02d75bca$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($ead9048c02d75bca$export$23a094319a4b586 || {});
function $ead9048c02d75bca$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $ead9048c02d75bca$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$ead9048c02d75bca$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($ead9048c02d75bca$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($ead9048c02d75bca$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($ead9048c02d75bca$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($ead9048c02d75bca$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $ead9048c02d75bca$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($ead9048c02d75bca$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $ead9048c02d75bca$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $ead9048c02d75bca$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $ead9048c02d75bca$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $ead9048c02d75bca$var$__spreadValues($ead9048c02d75bca$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $ead9048c02d75bca$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $ead9048c02d75bca$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $ead9048c02d75bca$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $ead9048c02d75bca$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $ead9048c02d75bca$var$wrapSelector(selector, selectState, ()=>$ead9048c02d75bca$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $ead9048c02d75bca$var$__spreadProps($ead9048c02d75bca$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $ead9048c02d75bca$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $ead9048c02d75bca$var$__spreadValues($ead9048c02d75bca$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $ead9048c02d75bca$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $ead9048c02d75bca$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $ead9048c02d75bca$export$affdea4146de9cf5();
function $ead9048c02d75bca$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $ead9048c02d75bca$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $ead9048c02d75bca$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$ead9048c02d75bca$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($ead9048c02d75bca$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $ead9048c02d75bca$export$309c7a02b0b0bc62(type, prepareCallback) : $ead9048c02d75bca$export$309c7a02b0b0bc62(type));
}
function $ead9048c02d75bca$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $ead9048c02d75bca$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $ead9048c02d75bca$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($ead9048c02d75bca$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $ead9048c02d75bca$var$noop,
        pending: pending || $ead9048c02d75bca$var$noop,
        rejected: rejected || $ead9048c02d75bca$var$noop,
        settled: settled || $ead9048c02d75bca$var$noop
    });
}
function $ead9048c02d75bca$var$noop() {}
// src/entities/entity_state.ts
function $ead9048c02d75bca$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $ead9048c02d75bca$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($ead9048c02d75bca$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $ead9048c02d75bca$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $ead9048c02d75bca$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $ead9048c02d75bca$var$isDraftTyped = (0, $b153aa7c4cf57be0$export$541ac630993a4c84);
function $ead9048c02d75bca$var$createSingleArgumentStateOperator(mutator) {
    const operator = $ead9048c02d75bca$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $ead9048c02d75bca$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $ead9048c02d75bca$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($ead9048c02d75bca$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $b153aa7c4cf57be0$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $ead9048c02d75bca$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $ead9048c02d75bca$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $ead9048c02d75bca$var$getCurrent(value) {
    return (0, $b153aa7c4cf57be0$export$541ac630993a4c84)(value) ? (0, $b153aa7c4cf57be0$export$97aac956da55dae9)(value) : value;
}
function $ead9048c02d75bca$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $ead9048c02d75bca$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $ead9048c02d75bca$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $ead9048c02d75bca$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $ead9048c02d75bca$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $ead9048c02d75bca$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $ead9048c02d75bca$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $ead9048c02d75bca$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $ead9048c02d75bca$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $ead9048c02d75bca$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $ead9048c02d75bca$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $ead9048c02d75bca$var$__spreadValues($ead9048c02d75bca$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$ead9048c02d75bca$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $ead9048c02d75bca$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $ead9048c02d75bca$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $ead9048c02d75bca$var$createStateOperator(addOneMutably),
        addMany: $ead9048c02d75bca$var$createStateOperator(addManyMutably),
        setOne: $ead9048c02d75bca$var$createStateOperator(setOneMutably),
        setMany: $ead9048c02d75bca$var$createStateOperator(setManyMutably),
        setAll: $ead9048c02d75bca$var$createStateOperator(setAllMutably),
        updateOne: $ead9048c02d75bca$var$createStateOperator(updateOneMutably),
        updateMany: $ead9048c02d75bca$var$createStateOperator(updateManyMutably),
        upsertOne: $ead9048c02d75bca$var$createStateOperator(upsertOneMutably),
        upsertMany: $ead9048c02d75bca$var$createStateOperator(upsertManyMutably),
        removeOne: $ead9048c02d75bca$var$createStateOperator(removeOneMutably),
        removeMany: $ead9048c02d75bca$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $ead9048c02d75bca$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $ead9048c02d75bca$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $ead9048c02d75bca$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $ead9048c02d75bca$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $ead9048c02d75bca$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $ead9048c02d75bca$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $ead9048c02d75bca$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $ead9048c02d75bca$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $ead9048c02d75bca$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $ead9048c02d75bca$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $ead9048c02d75bca$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $ead9048c02d75bca$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $ead9048c02d75bca$var$getCurrent(state.entities);
        const currentIds = $ead9048c02d75bca$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $ead9048c02d75bca$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $ead9048c02d75bca$var$createStateOperator(addOneMutably),
        updateOne: $ead9048c02d75bca$var$createStateOperator(updateOneMutably),
        upsertOne: $ead9048c02d75bca$var$createStateOperator(upsertOneMutably),
        setOne: $ead9048c02d75bca$var$createStateOperator(setOneMutably),
        setMany: $ead9048c02d75bca$var$createStateOperator(setManyMutably),
        setAll: $ead9048c02d75bca$var$createStateOperator(setAllMutably),
        addMany: $ead9048c02d75bca$var$createStateOperator(addManyMutably),
        updateMany: $ead9048c02d75bca$var$createStateOperator(updateManyMutably),
        upsertMany: $ead9048c02d75bca$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $ead9048c02d75bca$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $ead9048c02d75bca$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $ead9048c02d75bca$var$createSortedStateAdapter(selectId, sortComparer) : $ead9048c02d75bca$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $ead9048c02d75bca$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $ead9048c02d75bca$var$createSelectorsFactory();
    return $ead9048c02d75bca$var$__spreadValues($ead9048c02d75bca$var$__spreadValues($ead9048c02d75bca$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $ead9048c02d75bca$var$task = "task";
var $ead9048c02d75bca$var$listener = "listener";
var $ead9048c02d75bca$var$completed = "completed";
var $ead9048c02d75bca$var$cancelled = "cancelled";
var $ead9048c02d75bca$var$taskCancelled = `task-${$ead9048c02d75bca$var$cancelled}`;
var $ead9048c02d75bca$var$taskCompleted = `task-${$ead9048c02d75bca$var$completed}`;
var $ead9048c02d75bca$var$listenerCancelled = `${$ead9048c02d75bca$var$listener}-${$ead9048c02d75bca$var$cancelled}`;
var $ead9048c02d75bca$var$listenerCompleted = `${$ead9048c02d75bca$var$listener}-${$ead9048c02d75bca$var$completed}`;
var $ead9048c02d75bca$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $ead9048c02d75bca$var$__publicField(this, "name", "TaskAbortError");
        $ead9048c02d75bca$var$__publicField(this, "message");
        this.message = `${$ead9048c02d75bca$var$task} ${$ead9048c02d75bca$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $ead9048c02d75bca$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($ead9048c02d75bca$export$378fa86b259c0280(32));
};
var $ead9048c02d75bca$var$noop2 = ()=>{};
var $ead9048c02d75bca$var$catchRejection = (promise, onError = $ead9048c02d75bca$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $ead9048c02d75bca$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var $ead9048c02d75bca$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $ead9048c02d75bca$export$cb1bdac908fed7f(signal.reason);
};
function $ead9048c02d75bca$var$raceWithSignal(signal, promise) {
    let cleanup = $ead9048c02d75bca$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $ead9048c02d75bca$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $ead9048c02d75bca$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $ead9048c02d75bca$var$noop2;
    });
}
var $ead9048c02d75bca$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $ead9048c02d75bca$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $ead9048c02d75bca$var$createPause = (signal)=>{
    return (promise)=>{
        return $ead9048c02d75bca$var$catchRejection($ead9048c02d75bca$var$raceWithSignal(signal, promise).then((output)=>{
            $ead9048c02d75bca$var$validateActive(signal);
            return output;
        }));
    };
};
var $ead9048c02d75bca$var$createDelay = (signal)=>{
    const pause = $ead9048c02d75bca$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $ead9048c02d75bca$var$assign } = Object;
var $ead9048c02d75bca$var$INTERNAL_NIL_TOKEN = {};
var $ead9048c02d75bca$var$alm = "listenerMiddleware";
var $ead9048c02d75bca$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$ead9048c02d75bca$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $ead9048c02d75bca$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $ead9048c02d75bca$var$runTask(async ()=>{
            $ead9048c02d75bca$var$validateActive(parentAbortSignal);
            $ead9048c02d75bca$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $ead9048c02d75bca$var$createPause(childAbortController.signal),
                delay: $ead9048c02d75bca$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $ead9048c02d75bca$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort($ead9048c02d75bca$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($ead9048c02d75bca$var$noop2));
        return {
            result: $ead9048c02d75bca$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($ead9048c02d75bca$var$taskCancelled);
            }
        };
    };
};
var $ead9048c02d75bca$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $ead9048c02d75bca$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $ead9048c02d75bca$var$raceWithSignal(signal, Promise.race(promises));
            $ead9048c02d75bca$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$ead9048c02d75bca$var$catchRejection(take(predicate, timeout));
};
var $ead9048c02d75bca$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $ead9048c02d75bca$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($ead9048c02d75bca$export$378fa86b259c0280(21));
    $ead9048c02d75bca$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $ead9048c02d75bca$var$createListenerEntry = /* @__PURE__ */ $ead9048c02d75bca$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $ead9048c02d75bca$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $ead9048c02d75bca$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($ead9048c02d75bca$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$ead9048c02d75bca$var$createListenerEntry
});
var $ead9048c02d75bca$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $ead9048c02d75bca$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $ead9048c02d75bca$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($ead9048c02d75bca$var$listenerCancelled);
    });
};
var $ead9048c02d75bca$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())$ead9048c02d75bca$var$cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var $ead9048c02d75bca$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $ead9048c02d75bca$export$f03a6b845d3fb58b = /* @__PURE__ */ $ead9048c02d75bca$var$assign(/* @__PURE__ */ $ead9048c02d75bca$export$309c7a02b0b0bc62(`${$ead9048c02d75bca$var$alm}/add`), {
    withTypes: ()=>$ead9048c02d75bca$export$f03a6b845d3fb58b
});
var $ead9048c02d75bca$export$b1b8022855fb2b71 = /* @__PURE__ */ $ead9048c02d75bca$export$309c7a02b0b0bc62(`${$ead9048c02d75bca$var$alm}/removeAll`);
var $ead9048c02d75bca$export$b03e9483f936dccb = /* @__PURE__ */ $ead9048c02d75bca$var$assign(/* @__PURE__ */ $ead9048c02d75bca$export$309c7a02b0b0bc62(`${$ead9048c02d75bca$var$alm}/remove`), {
    withTypes: ()=>$ead9048c02d75bca$export$b03e9483f936dccb
});
var $ead9048c02d75bca$var$defaultErrorHandler = (...args)=>{
    console.error(`${$ead9048c02d75bca$var$alm}/error`, ...args);
};
var $ead9048c02d75bca$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $ead9048c02d75bca$var$defaultErrorHandler } = middlewareOptions;
    $ead9048c02d75bca$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $ead9048c02d75bca$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $ead9048c02d75bca$var$findListenerEntry(listenerMap, options)) != null ? _a : $ead9048c02d75bca$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $ead9048c02d75bca$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $ead9048c02d75bca$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $ead9048c02d75bca$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $ead9048c02d75bca$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $ead9048c02d75bca$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $ead9048c02d75bca$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $ead9048c02d75bca$var$createDelay(internalTaskController.signal),
                pause: $ead9048c02d75bca$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $ead9048c02d75bca$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($ead9048c02d75bca$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($ead9048c02d75bca$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $ead9048c02d75bca$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $ead9048c02d75bca$export$cb1bdac908fed7f)) $ead9048c02d75bca$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($ead9048c02d75bca$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $ead9048c02d75bca$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $f0caac4bad82347e$export$b956e38827fca970)(action)) return next(action);
                if ($ead9048c02d75bca$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($ead9048c02d75bca$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($ead9048c02d75bca$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $ead9048c02d75bca$var$INTERNAL_NIL_TOKEN) throw new Error($ead9048c02d75bca$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $ead9048c02d75bca$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $ead9048c02d75bca$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $ead9048c02d75bca$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $ead9048c02d75bca$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $ead9048c02d75bca$export$4bb1606a79445586 = ()=>{
    const instanceId = $ead9048c02d75bca$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($ead9048c02d75bca$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $ead9048c02d75bca$var$getOrInsertComputed(middlewareMap, middleware2, $ead9048c02d75bca$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$ead9048c02d75bca$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $f0caac4bad82347e$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $ead9048c02d75bca$export$9dd1fb32974da385(withMiddleware, $ead9048c02d75bca$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $ead9048c02d75bca$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $ead9048c02d75bca$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$ead9048c02d75bca$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $ead9048c02d75bca$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $ead9048c02d75bca$var$isStateProxy = (value)=>!!value && !!value[$ead9048c02d75bca$var$ORIGINAL_STATE];
var $ead9048c02d75bca$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $ead9048c02d75bca$var$createStateProxy = (state, reducerMap, initialStateCache)=>$ead9048c02d75bca$var$getOrInsertComputed($ead9048c02d75bca$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $ead9048c02d75bca$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $ead9048c02d75bca$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($ead9048c02d75bca$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $ead9048c02d75bca$var$original = (state)=>{
    if (!$ead9048c02d75bca$var$isStateProxy(state)) throw new Error($ead9048c02d75bca$export$378fa86b259c0280(25));
    return state[$ead9048c02d75bca$var$ORIGINAL_STATE];
};
var $ead9048c02d75bca$var$emptyObject = {};
var $ead9048c02d75bca$var$noopReducer = (state = $ead9048c02d75bca$var$emptyObject)=>state;
function $ead9048c02d75bca$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($ead9048c02d75bca$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $f0caac4bad82347e$export$66e4520cdb265d18)(reducerMap) : $ead9048c02d75bca$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($ead9048c02d75bca$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $ead9048c02d75bca$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $ead9048c02d75bca$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $fd2d666be553f7be$var$loadCartFromLocalStorage = ()=>{
    try {
        const serializedState = localStorage.getItem("cartItems");
        if (serializedState === null) return [];
        return JSON.parse(serializedState);
    } catch (err) {
        return [];
    }
};
const $fd2d666be553f7be$var$cartSlice = (0, $ead9048c02d75bca$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: $fd2d666be553f7be$var$loadCartFromLocalStorage()
    },
    reducers: {
        addItem: (state, action)=>{
            const existingItem = state.items.find((item)=>item.card.info.id === action.payload.card.info.id);
            if (existingItem) existingItem.quantity += 1;
            else state.items.push({
                ...action.payload,
                quantity: 1
            });
            localStorage.setItem("cartItems", JSON.stringify(state.items));
        },
        removeItem: (state, action)=>{
            const itemIndex = state.items.findIndex((item)=>item?.card?.info?.id === action.payload);
            if (itemIndex !== -1) {
                if (state.items[itemIndex].quantity > 1) state.items[itemIndex].quantity -= 1;
                else state.items.splice(itemIndex, 1);
                localStorage.setItem("cartItems", JSON.stringify(state.items));
            }
        },
        clearCart: (state)=>{
            state.items.length = 0;
            localStorage.removeItem("cartItems");
        }
    }
});
const { addItem: $fd2d666be553f7be$export$fb9705de59d96855, removeItem: $fd2d666be553f7be$export$fe2d9b4e03920b4c, clearCart: $fd2d666be553f7be$export$810121176e3e3671 } = $fd2d666be553f7be$var$cartSlice.actions;
var $fd2d666be553f7be$export$2e2bcd8739ae039 = $fd2d666be553f7be$var$cartSlice.reducer;



var $1KfxD = parcelRequire("1KfxD");



var $dPnrE = parcelRequire("dPnrE");

const $8b11fe4b2c0db66c$var$ItemList = ({ itemCards: itemCards, isCart: isCart })=>{
    const dispatch = (0, $d70dbdb49916e071$export$8ad76b76a4c905f8)();
    const handleAddItems = (item)=>{
        dispatch((0, $fd2d666be553f7be$export$fb9705de59d96855)(item));
    };
    const handleRemoveItems = (item)=>{
        dispatch((0, $fd2d666be553f7be$export$fe2d9b4e03920b4c)(item?.card?.info?.id));
    };
    return /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
        children: itemCards?.map((item)=>/*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                className: " bg-gray-100 px-4 flex w-full justify-betwee items-cente",
                children: /*#__PURE__*/ (0, $1KfxD.jsxs)("ul", {
                    className: "border-b last:border- border-gray-300 flex w-full p-2 justify-between space-x-2 items-cente",
                    children: [
                        /*#__PURE__*/ (0, $1KfxD.jsxs)("li", {
                            className: "w-full items-start my-2",
                            children: [
                                /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                                    className: "flex font-semibold md:text-lg w-ful",
                                    children: item?.card?.info?.name
                                }),
                                /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                                    children: item?.card?.info?.finalPrice && item?.card?.info?.defaultPrice && /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
                                        className: "flex space-x-2 md:text-lg",
                                        children: [
                                            /*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
                                                className: "pr-1 line-through font-medium text-gray-500",
                                                children: [
                                                    "\u20B9 ",
                                                    item?.card?.info?.defaultPrice / 100
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
                                                className: "pr-1 bg-violet-600 rounded-tl-xl rounded-br-xl text-white font-medium",
                                                children: [
                                                    "\u20B9 ",
                                                    item?.card?.info?.finalPrice / 100
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                                    children: !item?.card?.info?.defaultPrice && !item?.card?.info?.finalPrice && item?.card?.info?.price && /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
                                        className: "flex space-x-2 md:text-lg",
                                        children: /*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
                                            className: "pr-1 font-medium text-gray-900",
                                            children: [
                                                "\u20B9 ",
                                                item?.card?.info?.price / 100
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                                    children: !item?.card?.info?.defaultPrice && item?.card?.info?.finalPrice && item?.card?.info?.price && /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
                                        className: "flex space-x-2 md:text-lg",
                                        children: [
                                            /*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
                                                className: "pr-1 line-through font-medium text-gray-500",
                                                children: [
                                                    "\u20B9 ",
                                                    item?.card?.info?.price / 100
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
                                                className: "pr-1 bg-violet-600 rounded-tl-xl rounded-br-xl text-white font-medium",
                                                children: [
                                                    "\u20B9 ",
                                                    item?.card?.info?.finalPrice / 100
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                                    children: item?.card?.info?.defaultPrice && !item?.card?.info?.finalPrice && /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
                                        className: "flex space-x-2 md:text-lg",
                                        children: /*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
                                            className: "pr-1 font-medium text-gray-900",
                                            children: [
                                                "\u20B9 ",
                                                item?.card?.info?.defaultPrice / 100
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
                                    className: "rating-time flex space-x-1 align-middle items-center",
                                    children: [
                                        item?.card?.info?.ratings?.aggregatedRating?.ratingCount && /*#__PURE__*/ (0, $1KfxD.jsxs)((0, $1KfxD.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $1KfxD.jsxs)("svg", {
                                                    width: "20",
                                                    height: "20",
                                                    viewBox: "0 0 20 20",
                                                    fill: "none",
                                                    "aria-hidden": "true",
                                                    strokecolor: "rgba(2, 6, 12, 0.92)",
                                                    fillcolor: "rgba(2, 6, 12, 0.92)",
                                                    children: [
                                                        /*#__PURE__*/ (0, $1KfxD.jsx)("circle", {
                                                            cx: "10",
                                                            cy: "10",
                                                            r: "9",
                                                            fill: "url(#StoreRating20_svg__paint0_linear_32982_71567)"
                                                        }),
                                                        /*#__PURE__*/ (0, $1KfxD.jsx)("path", {
                                                            d: "M10.0816 12.865C10.0312 12.8353 9.96876 12.8353 9.91839 12.865L7.31647 14.3968C6.93482 14.6214 6.47106 14.2757 6.57745 13.8458L7.27568 11.0245C7.29055 10.9644 7.26965 10.9012 7.22195 10.8618L4.95521 8.99028C4.60833 8.70388 4.78653 8.14085 5.23502 8.10619L8.23448 7.87442C8.29403 7.86982 8.34612 7.83261 8.36979 7.77777L9.54092 5.06385C9.71462 4.66132 10.2854 4.66132 10.4591 5.06385L11.6302 7.77777C11.6539 7.83261 11.706 7.86982 11.7655 7.87442L14.765 8.10619C15.2135 8.14085 15.3917 8.70388 15.0448 8.99028L12.7781 10.8618C12.7303 10.9012 12.7095 10.9644 12.7243 11.0245L13.4225 13.8458C13.5289 14.2757 13.0652 14.6214 12.6835 14.3968L10.0816 12.865Z",
                                                            fill: "white"
                                                        }),
                                                        /*#__PURE__*/ (0, $1KfxD.jsx)("defs", {
                                                            children: /*#__PURE__*/ (0, $1KfxD.jsxs)("linearGradient", {
                                                                id: "StoreRating20_svg__paint0_linear_32982_71567",
                                                                x1: "10",
                                                                y1: "1",
                                                                x2: "10",
                                                                y2: "19",
                                                                gradientUnits: "userSpaceOnUse",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $1KfxD.jsx)("stop", {
                                                                        stopColor: "#21973B"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $1KfxD.jsx)("stop", {
                                                                        offset: "1",
                                                                        stopColor: "#128540"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                                                    className: "font-semibold",
                                                    children: item?.card?.info?.ratings?.aggregatedRating?.rating
                                                })
                                            ]
                                        }),
                                        item?.card?.info?.ratings?.aggregatedRating.ratingCountV2 && /*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
                                            className: "font-semibold",
                                            children: [
                                                "(",
                                                item?.card?.info?.ratings?.aggregatedRating?.ratingCountV2,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                item?.card?.info?.description && !isCart && /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                                    className: "flex py-4 text-gray-700",
                                    children: item?.card?.info?.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
                            className: "flex w-full h-full my-auto max-h-28 max-w-24 md:max-h-28 md:max-w-42 items-center justify-center relative",
                            children: [
                                item?.card?.info?.imageId ? /*#__PURE__*/ (0, $1KfxD.jsx)("img", {
                                    src: (0, $b56b9875e86e18a1$export$3c67ec6258c4a827) + item?.card?.info?.imageId,
                                    alt: "Dish Image",
                                    className: "flex self-center w-full h-full max-h-24 max-w-24 md:max-h-28 ml-auto md:max-w-42 object-cover rounded-xl shadow-lg hover:shadow-violet-400 transition-all ease-in-out duration-300 hover:scale-125"
                                }) : /*#__PURE__*/ (0, $1KfxD.jsx)("img", {
                                    src: "https://www.ilounge.com/wp-content/uploads/2019/11/no-image-found.jpg",
                                    alt: "Dish Image",
                                    className: "flex self-center w-full h-full max-h-24 max-w-16 md:max-h-28 ml-auto md:max-w-42 object-cover rounded-xl shadow-lg hover:shadow-violet-400 transition-all ease-in-out duration-300 hover:scale-125"
                                }),
                                !isCart && /*#__PURE__*/ (0, $1KfxD.jsx)((0, $dPnrE.default), {
                                    size: "small",
                                    color: "black",
                                    label: "Add+",
                                    className: "absolute bottom-2.5 md:bottom-1.5",
                                    onClick: ()=>handleAddItems(item)
                                }),
                                isCart && /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
                                    className: "absolute min-w-18 justify-between  bg-black items-center rounded-md flex bottom-2.5 md:bottom-1.5",
                                    children: [
                                        /*#__PURE__*/ (0, $1KfxD.jsx)((0, $dPnrE.default), {
                                            size: "small",
                                            color: "black",
                                            label: "-",
                                            className: "min-w-5",
                                            onClick: ()=>handleRemoveItems(item)
                                        }),
                                        /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                                            className: "flex text-white font-semibold px-2",
                                            children: item.quantity
                                        }),
                                        /*#__PURE__*/ (0, $1KfxD.jsx)((0, $dPnrE.default), {
                                            size: "small",
                                            color: "black",
                                            label: "+",
                                            className: "min-w-5",
                                            onClick: ()=>handleAddItems(item)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, item?.card?.info?.id)
            }, item?.card?.info?.id))
    });
};
var $8b11fe4b2c0db66c$export$2e2bcd8739ae039 = $8b11fe4b2c0db66c$var$ItemList;


const $1d8aa4d68b04108d$var$Cart = ()=>{
    const data = (0, $dSwpL.useContext)((0, $drrpd.default));
    const firstName = data?.loggedInUser?.trim().split(" ")[0];
    const dispatch = (0, $d70dbdb49916e071$export$8ad76b76a4c905f8)();
    const handleClearCart = ()=>{
        dispatch((0, $fd2d666be553f7be$export$810121176e3e3671)());
    };
    const cartItems = (0, $d70dbdb49916e071$export$2105062e25df4afe)((store)=>store.cart.items);
    return /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
        className: "flex flex-col gap-4 p-2 max-w-7xl w-full mx-auto items-center overflow-auto",
        children: [
            /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
                className: "flex flex-col gap-2 items-center",
                children: [
                    /*#__PURE__*/ (0, $1KfxD.jsxs)("h1", {
                        className: "flex text-xl md:text-3xl uppercase font-semibold text-orange-400 items-center mx-auto",
                        children: [
                            firstName,
                            "'s Cart (",
                            cartItems.length,
                            " Items)"
                        ]
                    }),
                    /*#__PURE__*/ (0, $1KfxD.jsx)((0, $dPnrE.default), {
                        label: "Clear Cart",
                        onClick: handleClearCart,
                        color: "red"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
                className: "flex flex-col md:max-w-[50%] pb-10",
                children: /*#__PURE__*/ (0, $1KfxD.jsx)((0, $8b11fe4b2c0db66c$export$2e2bcd8739ae039), {
                    isCart: true,
                    itemCards: cartItems
                })
            })
        ]
    });
};
var $1d8aa4d68b04108d$export$2e2bcd8739ae039 = $1d8aa4d68b04108d$var$Cart;



var $dSwpL = parcelRequire("dSwpL");
const $40b1dd295cb29d97$var$useOnline = ()=>{
    const [isOnline, setIsOnline] = (0, $dSwpL.useState)(true);
    (0, $dSwpL.useEffect)(()=>{
        window.addEventListener("online", ()=>{
            setIsOnline(true);
        });
        window.addEventListener("offline", ()=>{
            setIsOnline(false);
        });
    }, []);
    return isOnline;
};
var $40b1dd295cb29d97$export$2e2bcd8739ae039 = $40b1dd295cb29d97$var$useOnline;


parcelRequire("drrpd");

var $1KfxD = parcelRequire("1KfxD");

var $dSwpL = parcelRequire("dSwpL");


var $dPnrE = parcelRequire("dPnrE");


var $drrpd = parcelRequire("drrpd");
const $837562b7ff8ad52e$var$UserDropdownMenu = ()=>{
    const [isLoggedIn, setIsLoggedIn] = (0, $dSwpL.useState)(true);
    const [showMenu, setShowMenu] = (0, $dSwpL.useState)(false);
    const isOnline = (0, $40b1dd295cb29d97$export$2e2bcd8739ae039)();
    const navigate = (0, $9e8d2fd6513e67b8$export$9770f232ac06a008)();
    const data = (0, $dSwpL.useContext)((0, $drrpd.default));
    // console.log("data-UserDropdownMenu", data);
    const handleLogout = ()=>{
        setIsLoggedIn(false);
        localStorage.removeItem("isAuth");
        // Clear the saved name
        localStorage.removeItem("userName");
        navigate("/auth/login");
    };
    const firstNameLetter = data?.loggedInUser?.charAt(0).toUpperCase();
    // console.log('firstNameLetter',firstNameLetter)
    const UserDropdownItems = [
        {
            label: data?.loggedInUser,
            icon: "https://cdn-icons-png.flaticon.com/512/9653/9653907.png",
            color: "bg-blue-500 text-white font-semibold border-b",
            disabled: true
        },
        isLoggedIn ? {
            icon: "https://cdn-icons-png.flaticon.com/512/12635/12635060.png",
            label: "Logout",
            color: "bg-white text-red-500 hover:bg-red-600 hover:text-white font-semibold cursor-pointer",
            action: handleLogout
        } : {
            icon: "https://cdn-icons-png.flaticon.com/512/9653/9653907.png",
            label: "Login",
            color: "bg-green-500 text-white hover:bg-green-600 font-semibold border-b cursor-pointer",
            action: ()=>{
                setIsLoggedIn(true);
                navigate("/auth/login");
            }
        }
    ];
    (0, $dSwpL.useEffect)(()=>{
        const handleClickOutside = ()=>setShowMenu(false);
        if (showMenu) window.addEventListener("click", handleClickOutside);
        return ()=>window.removeEventListener("click", handleClickOutside);
    }, [
        showMenu
    ]);
    return /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
        className: "relative ",
        children: [
            /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                className: " rounded-full",
                children: /*#__PURE__*/ (0, $1KfxD.jsx)((0, $dPnrE.default), {
                    onClick: (e)=>{
                        e.stopPropagation();
                        setShowMenu((prev)=>!prev);
                    },
                    color: "orange",
                    className: "md:rounded-full rounded-[50%] md:px-3 p-1 px-3 py-1 h-auto md:h-auto md:w-full w-full",
                    label: firstNameLetter || "User"
                })
            }),
            showMenu && /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
                className: "absolute right-0 mt-2 min-w-40 md:w-full bg-white shadow-lg hover:shadow-amber-500 rounded-xl z-50",
                children: UserDropdownItems?.map((dropownItem)=>/*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
                        onClick: (e)=>{
                            e.stopPropagation();
                            if (!dropownItem.disabled && dropownItem.action) dropownItem.action();
                        },
                        className: `flex items-center space-x-2 px-2 py-1 text-sm w-full uppercase border-b border-b-gray-200 first:rounded-t-md last:rounded-b-md last:border-b-0 mt- 
                    ${dropownItem.disabled ? "cursor-default " : dropownItem.color}`,
                        children: [
                            /*#__PURE__*/ (0, $1KfxD.jsx)("img", {
                                src: dropownItem?.icon,
                                alt: dropownItem.label,
                                className: "flex w-6 h-6"
                            }),
                            /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                                className: "font-semibold",
                                children: dropownItem?.label
                            })
                        ]
                    }, dropownItem.label))
            })
        ]
    });
};
var $837562b7ff8ad52e$export$2e2bcd8739ae039 = $837562b7ff8ad52e$var$UserDropdownMenu;



const $e871d5d4e0264d30$var$Title = ()=>{
    return /*#__PURE__*/ (0, $1KfxD.jsx)((0, $9e8d2fd6513e67b8$export$a6c7ac8248d6e38a), {
        to: "/",
        className: "title-div",
        children: /*#__PURE__*/ (0, $1KfxD.jsx)("img", {
            className: "title-img flex max-w-28 md:max-w-40 h-auto w-full",
            src: (0, $b56b9875e86e18a1$export$d82609210b8816e6),
            alt: "title-image"
        })
    });
};
const $e871d5d4e0264d30$var$navLinks = [
    {
        page: "Home",
        link: "/",
        src: "https://gimgs2.nohat.cc/thumb/f/640/home-icon-png-orange--m2i8K9m2N4m2K9m2.jpg"
    },
    {
        page: "About",
        link: "/about",
        src: "https://www.freeiconspng.com/uploads/about-us-icon-29.png"
    },
    {
        page: "Contact",
        link: "/contact",
        src: "https://www.citypng.com/public/uploads/preview/hd-orange-round-circle-phone-icon-png-701751695060018jyrdgtl0mm.png"
    }
];
const $e871d5d4e0264d30$var$NavItems = ()=>{
    const isOnline = (0, $40b1dd295cb29d97$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $1KfxD.jsxs)("ul", {
        className: "navitem-list flex space-x-1 md:space-x-5 items-center",
        children: [
            $e871d5d4e0264d30$var$navLinks.map((item)=>{
                return /*#__PURE__*/ (0, $1KfxD.jsxs)((0, $9e8d2fd6513e67b8$export$a6c7ac8248d6e38a), {
                    to: item.link,
                    className: "Link flex items-center space-x-1",
                    children: [
                        item.src && /*#__PURE__*/ (0, $1KfxD.jsx)("img", {
                            className: "max-h-6 md:max-h-5 cursor-pointer hover:bg-white items-center flex",
                            src: item.src,
                            alt: "nav-icon"
                        }),
                        /*#__PURE__*/ (0, $1KfxD.jsx)("li", {
                            className: "md:flex hidden font-semibold hover:text-orange-400",
                            children: item.page
                        })
                    ]
                }, item.link);
            }),
            /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                label: "Online Status",
                className: "ml- text-2xl",
                children: isOnline ? /*#__PURE__*/ (0, $1KfxD.jsx)("img", {
                    src: "https://cdn-icons-png.flaticon.com/512/7749/7749544.png",
                    className: "w-10 h-auto flex"
                }) : "\uD83D\uDD34"
            })
        ]
    });
};
const $e871d5d4e0264d30$var$CartButton = ()=>{
    const navigate = (0, $9e8d2fd6513e67b8$export$9770f232ac06a008)();
    const cartItems = (0, $d70dbdb49916e071$export$2105062e25df4afe)((store)=>store.cart.items);
    return /*#__PURE__*/ (0, $1KfxD.jsx)((0, $9e8d2fd6513e67b8$export$a6c7ac8248d6e38a), {
        to: "/cart",
        className: "flex items-center ",
        children: /*#__PURE__*/ (0, $1KfxD.jsx)((0, $dPnrE.default), {
            label: `Cart (${cartItems.length})`,
            src: "https://uxwing.com/wp-content/themes/uxwing/download/e-commerce-currency-shopping/shopping-cart-trolley-icon.png"
        })
    });
};
const $e871d5d4e0264d30$var$Header = ()=>{
    return /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
        className: "header-component p-2 rounded-b-4xl opacity-95 bg-gray-100 h-16 md:h-20 w-full shadow-lg z-50 items-center fixed top-0 right-0 left-0 mb-2 overflow-hidde",
        children: /*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
            className: "max-w-7xl w-full flex justify-between h-full items-center mx-auto",
            children: [
                /*#__PURE__*/ (0, $1KfxD.jsx)($e871d5d4e0264d30$var$Title, {}),
                /*#__PURE__*/ (0, $1KfxD.jsx)($e871d5d4e0264d30$var$NavItems, {}),
                /*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
                    className: "flex space-x-1 md:space-x-",
                    children: [
                        /*#__PURE__*/ (0, $1KfxD.jsx)($e871d5d4e0264d30$var$CartButton, {}),
                        /*#__PURE__*/ (0, $1KfxD.jsx)((0, $837562b7ff8ad52e$export$2e2bcd8739ae039), {})
                    ]
                })
            ]
        })
    });
};
var $e871d5d4e0264d30$export$2e2bcd8739ae039 = $e871d5d4e0264d30$var$Header;



var $1KfxD = parcelRequire("1KfxD");

var $1KfxD = parcelRequire("1KfxD");

const $70cdd3443b737ef3$var$RestaurantCard = ({ name: name, avgRating: avgRating, sla: sla, cuisines: cuisines, areaName: areaName, cloudinaryImageId: cloudinaryImageId })=>{
    return /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
        className: "restaurant-card h-full flex flex-col justify-star hover:scale-95 transition-all duration-300 ease-in-out w-full",
        children: [
            /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
                className: "relativ",
                children: /*#__PURE__*/ (0, $1KfxD.jsx)("img", {
                    src: (0, $b56b9875e86e18a1$export$3c67ec6258c4a827) + cloudinaryImageId,
                    alt: "Restaurant Image",
                    className: "restaurant-image max-w-72 w-full object-cover h-48 rounded-xl drop-shadow-xl/25 "
                })
            }),
            /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
                className: "flex flex-col p-2",
                children: [
                    /*#__PURE__*/ (0, $1KfxD.jsx)("h3", {
                        className: "font-bold text-lg",
                        children: name ? name?.split(" ").slice(0, 3).join(" ") + (name?.split(" ").length > 3 ? "..." : "") : "Unknown"
                    }),
                    /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
                        className: "rating-time flex space-x-1 align-middle items-center",
                        children: [
                            avgRating && /*#__PURE__*/ (0, $1KfxD.jsxs)((0, $1KfxD.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $1KfxD.jsxs)("svg", {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 20 20",
                                        fill: "none",
                                        "aria-hidden": "true",
                                        strokecolor: "rgba(2, 6, 12, 0.92)",
                                        fillcolor: "rgba(2, 6, 12, 0.92)",
                                        children: [
                                            /*#__PURE__*/ (0, $1KfxD.jsx)("circle", {
                                                cx: "10",
                                                cy: "10",
                                                r: "9",
                                                fill: "url(#StoreRating20_svg__paint0_linear_32982_71567)"
                                            }),
                                            /*#__PURE__*/ (0, $1KfxD.jsx)("path", {
                                                d: "M10.0816 12.865C10.0312 12.8353 9.96876 12.8353 9.91839 12.865L7.31647 14.3968C6.93482 14.6214 6.47106 14.2757 6.57745 13.8458L7.27568 11.0245C7.29055 10.9644 7.26965 10.9012 7.22195 10.8618L4.95521 8.99028C4.60833 8.70388 4.78653 8.14085 5.23502 8.10619L8.23448 7.87442C8.29403 7.86982 8.34612 7.83261 8.36979 7.77777L9.54092 5.06385C9.71462 4.66132 10.2854 4.66132 10.4591 5.06385L11.6302 7.77777C11.6539 7.83261 11.706 7.86982 11.7655 7.87442L14.765 8.10619C15.2135 8.14085 15.3917 8.70388 15.0448 8.99028L12.7781 10.8618C12.7303 10.9012 12.7095 10.9644 12.7243 11.0245L13.4225 13.8458C13.5289 14.2757 13.0652 14.6214 12.6835 14.3968L10.0816 12.865Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $1KfxD.jsx)("defs", {
                                                children: /*#__PURE__*/ (0, $1KfxD.jsxs)("linearGradient", {
                                                    id: "StoreRating20_svg__paint0_linear_32982_71567",
                                                    x1: "10",
                                                    y1: "1",
                                                    x2: "10",
                                                    y2: "19",
                                                    gradientUnits: "userSpaceOnUse",
                                                    children: [
                                                        /*#__PURE__*/ (0, $1KfxD.jsx)("stop", {
                                                            stopColor: "#21973B"
                                                        }),
                                                        /*#__PURE__*/ (0, $1KfxD.jsx)("stop", {
                                                            offset: "1",
                                                            stopColor: "#128540"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                                        className: "font-semibold",
                                        children: avgRating + " - "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                                className: "font-semibold",
                                children: sla?.slaString
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1KfxD.jsx)("p", {
                        className: "font-semibold text-gray-500 text-sm",
                        children: cuisines?.slice(0, 3).join(", ") + (cuisines?.length > 3 ? "..." : "")
                    }),
                    /*#__PURE__*/ (0, $1KfxD.jsx)("p", {
                        className: "font-semibold text-gray-500 text-sm",
                        children: areaName
                    })
                ]
            })
        ]
    });
};
const $70cdd3443b737ef3$export$8213bd21feea48b3 = (RestaurantCard)=>{
    return (props)=>{
        return /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
            className: "relative grow",
            children: [
                /*#__PURE__*/ (0, $1KfxD.jsx)("label", {
                    className: "px-3 p-1 absolute z-10 md:bottom-36 left-1/3 -translate-y-1/6 md:translate-y-1/6 bottom-40 d:left-25 rounded-2xl font-semibold text-green-500 bg-black opacity-75",
                    children: "Pure Veg"
                }),
                /*#__PURE__*/ (0, $1KfxD.jsx)(RestaurantCard, {
                    ...props
                })
            ]
        });
    };
};
var $70cdd3443b737ef3$export$2e2bcd8739ae039 = $70cdd3443b737ef3$var$RestaurantCard;



var $dSwpL = parcelRequire("dSwpL");

var $96eiz = parcelRequire("96eiz");


const $c9c0b97a2341e2cb$export$fa82680f88ffae57 = (searchInput, allRestaurants)=>allRestaurants.filter((filterData)=>filterData?.info?.name?.toLowerCase().includes(searchInput.toLowerCase()));



var $dSwpL = parcelRequire("dSwpL");

const $4a0149162470eda7$var$useRestaurant = ()=>{
    const [allRestaurants, setAllRestaurants] = (0, $dSwpL.useState)([]);
    const [loading, setLoading] = (0, $dSwpL.useState)(false);
    (0, $dSwpL.useEffect)(()=>{
        fetchRestaurants();
    }, []);
    const fetchRestaurants = async ()=>{
        setLoading(true);
        const fetchData = await fetch((0, $b56b9875e86e18a1$export$7c6ff693f8aa5426));
        const dataJson = await fetchData.json();
        const restaurantGridWidget = dataJson?.data?.cards?.filter((c)=>c?.card?.card?.["@type"] === "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget");
        const restaurantsData = restaurantGridWidget.filter((c)=>c?.card?.card?.gridElements?.infoWithStyle?.restaurants);
        // console.log("restaurantGridWidget useRes", restaurantGridWidget);
        setAllRestaurants(restaurantsData);
        setLoading(false);
    };
    return {
        loading: loading,
        allRestaurants: allRestaurants,
        setLoading: setLoading
    };
};
var $4a0149162470eda7$export$2e2bcd8739ae039 = $4a0149162470eda7$var$useRestaurant;




var $drrpd = parcelRequire("drrpd");

var $dPnrE = parcelRequire("dPnrE");
const $1b20b4191a6fe390$var$Body = ()=>{
    const isOnline = (0, $40b1dd295cb29d97$export$2e2bcd8739ae039)();
    const { restaurantId: restaurantId } = (0, $9e8d2fd6513e67b8$export$99eaa27ddbbb95ef)();
    const [searchInput, setSearchInput] = (0, $dSwpL.useState)("");
    const [filteredRestaurants, setFilteredRestaurants] = (0, $dSwpL.useState)([]);
    const [activeFilter, setActiveFilter] = (0, $dSwpL.useState)("");
    const { allRestaurants: allRestaurants, loading: loading, setLoading: setLoading } = (0, $4a0149162470eda7$export$2e2bcd8739ae039)();
    const RestaurantCardVeg = (0, $70cdd3443b737ef3$export$8213bd21feea48b3)((0, $70cdd3443b737ef3$export$2e2bcd8739ae039));
    const { userName: userName, setUserName: setUserName, loggedInUser: loggedInUser } = (0, $dSwpL.useContext)((0, $drrpd.default));
    // console.log("filteredRestaurants", filteredRestaurants);
    const normalizedRestaurants = (0, $dSwpL.useMemo)(()=>{
        const combined = allRestaurants.flatMap((item)=>item?.card?.card?.gridElements?.infoWithStyle?.restaurants || []);
        return Array.from(new Map(combined.map((r)=>[
                r?.info?.id,
                r
            ])).values());
    }, [
        allRestaurants
    ]);
    const topRatedRestaurants = normalizedRestaurants?.filter((top)=>top.info.avgRating >= 4.5);
    console.log("topRatedRestaurants", topRatedRestaurants);
    (0, $dSwpL.useEffect)(()=>{
        setFilteredRestaurants(normalizedRestaurants);
        setActiveFilter("");
    }, [
        normalizedRestaurants
    ]);
    console.log("uniqueRestaurants", normalizedRestaurants);
    const resetSearch = ()=>{
        setSearchInput("");
        setFilteredRestaurants(normalizedRestaurants);
        setActiveFilter("");
    };
    return /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
        className: "body-container flex flex-col p-2 my-2 overflow-auto max-w-7xl mx-auto w-full",
        children: [
            /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
                className: "flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-2",
                children: [
                    /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
                        className: "search-bar-container self-start flex max-h-8 rounded-md max-w-fit justify-center overflow-hidden border border-black p-2 w-full items-center space-x-1",
                        children: [
                            /*#__PURE__*/ (0, $1KfxD.jsx)("input", {
                                className: "search-bar outline-0",
                                type: "text",
                                maxLength: 20,
                                placeholder: "Search Yummy Food",
                                value: searchInput,
                                onChange: (e)=>{
                                    setSearchInput(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $1KfxD.jsx)("button", {
                                className: "search-button",
                                children: /*#__PURE__*/ (0, $1KfxD.jsx)("img", {
                                    className: "search-icon max-h-5 cursor-pointer",
                                    src: "https://www.svgrepo.com/show/356535/search-button.svg",
                                    alt: "search icon",
                                    onClick: ()=>{
                                        setLoading(true);
                                        const info = (0, $c9c0b97a2341e2cb$export$fa82680f88ffae57)(searchInput, normalizedRestaurants);
                                        setFilteredRestaurants(info);
                                        setLoading(false);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
                        className: "flex space-x-3",
                        children: [
                            /*#__PURE__*/ (0, $1KfxD.jsx)((0, $dPnrE.default), {
                                size: "small",
                                color: "green",
                                label: "Top Rated Restaurants",
                                className: `w-fit py-2 md:py-0 
              ${activeFilter === "topRatedRestaurants" ? "bg-green-600 text-white" : ""}
              `,
                                onClick: ()=>{
                                    setFilteredRestaurants(topRatedRestaurants);
                                    setActiveFilter("topRatedRestaurants");
                                }
                            }),
                            /*#__PURE__*/ (0, $1KfxD.jsx)((0, $dPnrE.default), {
                                size: "medium",
                                color: "blue",
                                src: "https://cdn-icons-png.magnific.com/256/11507/11507214.png?semt=ais_white_label",
                                className: "p-0 px-0 md:pl-2.5 pr-0",
                                onClick: resetSearch
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1KfxD.jsx)("input", {
                        className: "search-bar outline-0 hidden bg-gray-200 self-start md:flex max-h-8 rounded-md max-w-fit justify-center overflow-hidden border border-black p-2 w-full items-center space-x-1 font-semibold text-center",
                        type: "text",
                        maxLength: 20,
                        placeholder: "Provide User Name",
                        value: loggedInUser,
                        onChange: (e)=>{
                            setUserName(e.target.value);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1KfxD.jsx)((0, $1KfxD.Fragment), {
                children: filteredRestaurants?.length ? /*#__PURE__*/ (0, $1KfxD.jsxs)("p", {
                    className: "restaurants-length font-semibold my-2",
                    children: [
                        "Showing ",
                        filteredRestaurants?.length,
                        " Restaurants"
                    ]
                }) : ""
            }),
            filteredRestaurants?.length === 0 ? /*#__PURE__*/ (0, $1KfxD.jsx)((0, $96eiz.default), {}) : /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
                className: "restaurants flex flex-wrap grow gap-4 h-full mx-auto w-full justify-between md:justify-start xl:justify-between",
                children: /*#__PURE__*/ (0, $1KfxD.jsx)((0, $1KfxD.Fragment), {
                    children: filteredRestaurants?.map((restaurant)=>{
                        return /*#__PURE__*/ (0, $1KfxD.jsx)((0, $9e8d2fd6513e67b8$export$a6c7ac8248d6e38a), {
                            to: `/restaurant-details/${restaurant?.info?.id}`,
                            state: {
                                restaurant: restaurant?.info
                            },
                            className: "restaurant-card-link mx-auto md:mx-0 flex flex-col grow items-stretch max-w-48 md:max-w-72 w-full",
                            children: restaurant?.info?.veg ? /*#__PURE__*/ (0, $1KfxD.jsx)(RestaurantCardVeg, {
                                ...restaurant?.info
                            }) : /*#__PURE__*/ (0, $1KfxD.jsx)((0, $70cdd3443b737ef3$export$2e2bcd8739ae039), {
                                ...restaurant?.info
                            })
                        }, restaurant?.info?.id);
                    })
                })
            })
        ]
    });
};
var $1b20b4191a6fe390$export$2e2bcd8739ae039 = $1b20b4191a6fe390$var$Body;



var $1KfxD = parcelRequire("1KfxD");
const $26322f53f5774901$var$Footer = ()=>{
    return /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
        className: "footer mt-2 rounded-t-4xl bg-gray-100 shadow flex p-2 borde h-18 w-full items-center justify-center",
        children: "Footer"
    });
};
var $26322f53f5774901$export$2e2bcd8739ae039 = $26322f53f5774901$var$Footer;




var $1KfxD = parcelRequire("1KfxD");

var $dSwpL = parcelRequire("dSwpL");
parcelRequire("96eiz");

const $97b68e048b5cf722$var$Profile = /*#__PURE__*/ (0, $dSwpL.lazy)(()=>(parcelRequire("i2Aeq")));

const $97b68e048b5cf722$var$ProfileClass = /*#__PURE__*/ (0, $dSwpL.lazy)(()=>(parcelRequire("7Abyg")));
const $97b68e048b5cf722$var$About = ()=>{
    return /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
        className: "about-page flex flex-col p-2 my-2 overflow-auto max-w-7xl mx-auto w-full",
        children: [
            /*#__PURE__*/ (0, $1KfxD.jsx)("h1", {
                className: "text-2xl font-semibold text-center",
                children: "About Page"
            }),
            /*#__PURE__*/ (0, $1KfxD.jsx)("h3", {
                className: "text-lg font-semibold text-center",
                children: "This is About Page showing Functional and Class based components"
            }),
            /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
                className: "profile-components flex md:flex-row flex-col mt-4 p-2 gap-4 space-y-2 rounded-md justify-between mx-auto",
                children: [
                    /*#__PURE__*/ (0, $1KfxD.jsx)($97b68e048b5cf722$var$Profile, {
                        name: "Yogesh"
                    }),
                    /*#__PURE__*/ (0, $1KfxD.jsx)($97b68e048b5cf722$var$ProfileClass, {
                        name: "Yogesh"
                    })
                ]
            })
        ]
    });
};
var $97b68e048b5cf722$export$2e2bcd8739ae039 = $97b68e048b5cf722$var$About;



var $1KfxD = parcelRequire("1KfxD");
parcelRequire("dSwpL");


var $dPnrE = parcelRequire("dPnrE");
const $09f1789730a6f99e$var$ErrorPage = ()=>{
    const error = (0, $9e8d2fd6513e67b8$export$ed527bf60f6e05f2)();
    console.log("This is router error: ", error.status);
    return /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
        className: "error-page min-h-screen flex flex-col m-auto justify-center items-center space-y-4 text-center",
        children: [
            /*#__PURE__*/ (0, $1KfxD.jsx)("img", {
                src: "https://static.vecteezy.com/system/resources/thumbnails/024/800/866/small/oops-comic-blast-with-white-and-green-colors-cloud-explosion-bubbles-for-cartoons-comic-burst-with-colorful-clouds-and-smash-free-png.png",
                alt: "error img",
                className: "flex max-w-52 bg-transparent w-full h-full object-contain"
            }),
            /*#__PURE__*/ (0, $1KfxD.jsx)("h1", {
                className: "error-oops text-3xl font-semibold text-red-600 flex flex-wrap",
                children: "Oopss!! Something Went Wrong!!"
            }),
            /*#__PURE__*/ (0, $1KfxD.jsxs)("h2", {
                className: "error-status text-xl font-semibold text-red-600",
                children: [
                    "Status: Error ",
                    error.status,
                    " ",
                    error.statusText
                ]
            }),
            /*#__PURE__*/ (0, $1KfxD.jsxs)("h2", {
                className: "error-data text-xl font-semibold text-orange-600",
                children: [
                    error.data,
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $1KfxD.jsx)((0, $9e8d2fd6513e67b8$export$a6c7ac8248d6e38a), {
                to: "/",
                children: /*#__PURE__*/ (0, $1KfxD.jsx)((0, $dPnrE.default), {
                    size: "large",
                    color: "green",
                    label: "Back to home",
                    className: "error-back-to-home border-2",
                    src: "https://img.icons8.com/?size=100&id=2tuQdCmArB2K&format=png&color=40C057"
                })
            })
        ]
    });
};
var $09f1789730a6f99e$export$2e2bcd8739ae039 = $09f1789730a6f99e$var$ErrorPage;



var $1KfxD = parcelRequire("1KfxD");
parcelRequire("dSwpL");
const $79198b9808b69df1$var$Contact = ()=>{
    return /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
        className: "contact-page flex flex-col p-2 my-2 overflow-auto max-w-7xl mx-auto w-full space-y-2",
        children: [
            /*#__PURE__*/ (0, $1KfxD.jsx)("h1", {
                className: "text-2xl font-semibold text-center",
                children: "Contact Page"
            }),
            /*#__PURE__*/ (0, $1KfxD.jsx)("p", {
                className: "text-lg font-semibold text-center",
                children: "This is Contact Page"
            })
        ]
    });
};
var $79198b9808b69df1$export$2e2bcd8739ae039 = $79198b9808b69df1$var$Contact;



var $1KfxD = parcelRequire("1KfxD");

var $dSwpL = parcelRequire("dSwpL");




var $96eiz = parcelRequire("96eiz");

var $dSwpL = parcelRequire("dSwpL");


const $a7fb6e331c16830a$var$useRestaurantDetails = (restaurantId)=>{
    const [loading, setLoading] = (0, $dSwpL.useState)(false);
    const [restaurantDetail, setRestaurantDetail] = (0, $dSwpL.useState)([]);
    const [restaurantInfo, setRestaurantInfo] = (0, $dSwpL.useState)(null);
    const RESTAURANT_URL = (0, $b56b9875e86e18a1$export$fbde561f2925a76a) + restaurantId;
    (0, $dSwpL.useEffect)(()=>{
        getRestaurantDetails();
    }, []);
    const getRestaurantDetails = async ()=>{
        setLoading(true);
        const restaurantDetailFetch = await fetch(RESTAURANT_URL);
        const restaurantDetailJson = await restaurantDetailFetch.json();
        const restDetailArray = restaurantDetailJson?.data?.cards[5]?.groupedCard?.cardGroupMap?.REGULAR.cards;
        const restaurantDetailsInfo = restDetailArray[4]?.card?.card?.itemCards;
        const restaurantInfoData = restaurantDetailJson?.data?.cards[2]?.card?.card?.info;
        // console.log('restaurantInfoData',restaurantInfoData)
        setRestaurantInfo(restaurantInfoData);
        setRestaurantDetail(restDetailArray);
        setLoading(false);
    };
    return {
        loading: loading,
        restaurantInfo: restaurantInfo,
        restaurantDetail: restaurantDetail,
        setLoading: setLoading
    };
};
var $a7fb6e331c16830a$export$2e2bcd8739ae039 = $a7fb6e331c16830a$var$useRestaurantDetails;




var $1KfxD = parcelRequire("1KfxD");
parcelRequire("dSwpL");



parcelRequire("dPnrE");

const $d655bcdbf8a2f3d8$var$RestaurantCategory = ({ restaurantCategoryInfo: restaurantCategoryInfo, category: category, setShowItems: setShowItems, showItems: showItems })=>{
    // console.log("category", category);
    const { restaurantId: restaurantId } = (0, $9e8d2fd6513e67b8$export$99eaa27ddbbb95ef)();
    const displayItems = ()=>{
        setShowItems();
    };
    return /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
        className: "flex flex-col rounded-lg md:my-2 md:min-h-20 space-y-2 max-w-5xl mx-auto ",
        children: /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
            className: "flex flex-col justify-between m-2 mx-auto w-full",
            children: [
                /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
                    className: "flex text-lg justify-between bg-gray-300 py-1 px-3 md:py-4 md:px-6 rounded-t-lg cursor-pointer hover:shadow-lg shadow-amber-200",
                    onClick: displayItems,
                    children: [
                        /*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
                            className: "flex font-semibold md:font-bold",
                            children: [
                                category?.card?.card?.title,
                                " (",
                                category?.card?.card?.title?.length,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                            className: "flex pb-1 items-center h-full",
                            children: "\u2304"
                        })
                    ]
                }),
                showItems && /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
                    className: "block z-20",
                    children: /*#__PURE__*/ (0, $1KfxD.jsx)((0, $8b11fe4b2c0db66c$export$2e2bcd8739ae039), {
                        itemCards: category?.card?.card?.itemCards
                    })
                })
            ]
        })
    });
};
var $d655bcdbf8a2f3d8$export$2e2bcd8739ae039 = $d655bcdbf8a2f3d8$var$RestaurantCategory;


const $3a9c1fdb0ffbaad9$var$RestaurantPage = ()=>{
    const { restaurantId: restaurantId } = (0, $9e8d2fd6513e67b8$export$99eaa27ddbbb95ef)();
    const { loading: loading, restaurantInfo: restaurantInfo, restaurantDetail: restaurantDetail } = (0, $a7fb6e331c16830a$export$2e2bcd8739ae039)(restaurantId);
    const [showItems, setShowItems] = (0, $dSwpL.useState)(0);
    const [showAddress, setShowAddress] = (0, $dSwpL.useState)(true);
    const handleAddress = ()=>{
        return setShowAddress(!showAddress);
    };
    console.log("restaurantId", restaurantId);
    // console.log("restaurantInfo", restaurantInfo);
    const restaurantCategoryInfo = restaurantDetail?.filter((c)=>c?.card?.card?.["@type"] === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory");
    // console.log("restaurantCategoryInfo ResPage", restaurantCategoryInfo);
    return /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
        className: "restaurant-details-page max-w-7xl w-full mx-auto p-2 md:p-0",
        children: loading ? /*#__PURE__*/ (0, $1KfxD.jsx)((0, $96eiz.default), {}) : /*#__PURE__*/ (0, $1KfxD.jsxs)((0, $1KfxD.Fragment), {
            children: [
                /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
                    className: "restaurant-details md:flex space-x-4 justify-between max-w-5xl mx-auto w-full",
                    children: /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
                        className: "items-cente mb-5 md:my-5 rounded-2xl p-4 md:p-10 flex mx-auto justify-between w-full shadow-2xl",
                        children: [
                            /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
                                className: "font-semibold md:flex flex-col uppercase items-cente space-x-2 space-y-1",
                                children: [
                                    /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
                                        className: "flex md:flex-row flex-col flex-wrap justify-start md:items-center text-left space-x-1 w-fu",
                                        children: [
                                            /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                                                className: "flex text-xl font-bold md:text-3xl text-black",
                                                children: restaurantInfo?.name || "Restaurant"
                                            }),
                                            /*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
                                                className: "text-sm md:text-lg text-gray-400 italic font-normal",
                                                children: [
                                                    "(",
                                                    restaurantId || "Restaurant ID",
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                                        className: "flex text-sm md:text-lg italic text-amber-500",
                                        children: restaurantInfo?.cuisines.join(", ")
                                    }),
                                    /*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
                                        className: "flex text-sm md:text-lg italic text-green-500",
                                        children: [
                                            "Cost For Two: \u20B9 ",
                                            restaurantInfo?.costForTwo / 100
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
                                        onClick: handleAddress,
                                        className: `text-sm md:text-lg w-fit max-w-44 md:max-w-none text-black cursor-pointer 
                    ${showAddress ? "hidden" : "flex"}
                  `,
                                        children: [
                                            /*#__PURE__*/ (0, $1KfxD.jsx)("label", {
                                                className: "no-underline",
                                                children: "\uD83D\uDCCD"
                                            }),
                                            /*#__PURE__*/ (0, $1KfxD.jsx)("span", {
                                                className: "underline",
                                                children: restaurantInfo?.labels[1]?.message
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
                                        onClick: handleAddress,
                                        className: `text-sm md:text-lg w-fit max-w-44 md:max-w-none text-black cursor-pointer
                    ${!showAddress ? "hidden" : "flex"}
                  `,
                                        children: [
                                            /*#__PURE__*/ (0, $1KfxD.jsx)("label", {
                                                className: "no-underline",
                                                children: "\uD83D\uDCCD"
                                            }),
                                            /*#__PURE__*/ (0, $1KfxD.jsxs)("span", {
                                                className: "underline",
                                                children: [
                                                    restaurantInfo?.locality,
                                                    ", ",
                                                    restaurantInfo?.areaName
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            restaurantInfo?.cloudinaryImageId ? /*#__PURE__*/ (0, $1KfxD.jsx)("img", {
                                className: "restaurant-details-image max-w-42 max-h-36 md:max-w-96 md:max-h-48 object-cover object-top md:object-center my2 rounded-md w-full md:h-fit shadow hover:shadow-violet-400 transition-all ease-in-out duration-300 hover:scale-125",
                                src: (0, $b56b9875e86e18a1$export$3c67ec6258c4a827) + restaurantInfo?.cloudinaryImageId,
                                alt: "restaurant-details-image"
                            }) : /*#__PURE__*/ (0, $1KfxD.jsx)("img", {
                                className: "restaurant-details-image md:max-w-96 md:max-h-48 object-cover my2 rounded-md w-full h-fit shadow hover:shadow-violet-400 transition-all ease-in-out duration-300 hover:scale-125",
                                src: "https://www.ilounge.com/wp-content/uploads/2019/11/no-image-found.jpg",
                                alt: "restaurant-details-image"
                            })
                        ]
                    })
                }),
                restaurantCategoryInfo.map((categoryList, i)=>/*#__PURE__*/ (0, $1KfxD.jsx)((0, $d655bcdbf8a2f3d8$export$2e2bcd8739ae039), {
                        category: categoryList,
                        showItems: i === showItems,
                        setShowItems: ()=>setShowItems((prev)=>prev === i ? null : i)
                    }, categoryList?.card?.card?.title))
            ]
        })
    });
};
var $3a9c1fdb0ffbaad9$export$2e2bcd8739ae039 = $3a9c1fdb0ffbaad9$var$RestaurantPage;



var $1KfxD = parcelRequire("1KfxD");
parcelRequire("dSwpL");
parcelRequire("jZ3UM");

var $3IfSZ = parcelRequire("3IfSZ");

var $2d70e076c9860a64$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $2d70e076c9860a64$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$2d70e076c9860a64$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$2d70e076c9860a64$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$2d70e076c9860a64$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $2d70e076c9860a64$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $2d70e076c9860a64$var$DIGIT_REGEX = /^\d+$/, $2d70e076c9860a64$var$LEAD_DIGIT_REGEX = /^\d/, $2d70e076c9860a64$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $2d70e076c9860a64$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $2d70e076c9860a64$var$MAX_CACHE_SIZE = 512;
var $2d70e076c9860a64$var$pathCache = new $2d70e076c9860a64$var$Cache($2d70e076c9860a64$var$MAX_CACHE_SIZE), $2d70e076c9860a64$var$setCache = new $2d70e076c9860a64$var$Cache($2d70e076c9860a64$var$MAX_CACHE_SIZE), $2d70e076c9860a64$var$getCache = new $2d70e076c9860a64$var$Cache($2d70e076c9860a64$var$MAX_CACHE_SIZE);
var $2d70e076c9860a64$var$config;
$2d70e076c9860a64$exports = {
    Cache: $2d70e076c9860a64$var$Cache,
    split: $2d70e076c9860a64$var$split,
    normalizePath: $2d70e076c9860a64$var$normalizePath,
    setter: function(path) {
        var parts = $2d70e076c9860a64$var$normalizePath(path);
        return $2d70e076c9860a64$var$setCache.get(path) || $2d70e076c9860a64$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $2d70e076c9860a64$var$normalizePath(path);
        return $2d70e076c9860a64$var$getCache.get(path) || $2d70e076c9860a64$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($2d70e076c9860a64$var$isQuoted(part) || $2d70e076c9860a64$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $2d70e076c9860a64$var$forEach(Array.isArray(path) ? path : $2d70e076c9860a64$var$split(path), cb, thisArg);
    }
};
function $2d70e076c9860a64$var$normalizePath(path) {
    return $2d70e076c9860a64$var$pathCache.get(path) || $2d70e076c9860a64$var$pathCache.set(path, $2d70e076c9860a64$var$split(path).map(function(part) {
        return part.replace($2d70e076c9860a64$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $2d70e076c9860a64$var$split(path) {
    return path.match($2d70e076c9860a64$var$SPLIT_REGEX) || [
        ''
    ];
}
function $2d70e076c9860a64$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($2d70e076c9860a64$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $2d70e076c9860a64$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $2d70e076c9860a64$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $2d70e076c9860a64$var$hasLeadingNumber(part) {
    return part.match($2d70e076c9860a64$var$LEAD_DIGIT_REGEX) && !part.match($2d70e076c9860a64$var$DIGIT_REGEX);
}
function $2d70e076c9860a64$var$hasSpecialChars(part) {
    return $2d70e076c9860a64$var$SPEC_CHAR_REGEX.test(part);
}
function $2d70e076c9860a64$var$shouldBeQuoted(part) {
    return !$2d70e076c9860a64$var$isQuoted(part) && ($2d70e076c9860a64$var$hasLeadingNumber(part) || $2d70e076c9860a64$var$hasSpecialChars(part));
}


var $f64b4cdf9bece7b0$exports = {};
const $f64b4cdf9bece7b0$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $f64b4cdf9bece7b0$var$words = (str)=>str.match($f64b4cdf9bece7b0$var$reWords) || [];
const $f64b4cdf9bece7b0$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $f64b4cdf9bece7b0$var$join = (str, d)=>$f64b4cdf9bece7b0$var$words(str).join(d).toLowerCase();
const $f64b4cdf9bece7b0$var$camelCase = (str)=>$f64b4cdf9bece7b0$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, '');
const $f64b4cdf9bece7b0$var$pascalCase = (str)=>$f64b4cdf9bece7b0$var$upperFirst($f64b4cdf9bece7b0$var$camelCase(str));
const $f64b4cdf9bece7b0$var$snakeCase = (str)=>$f64b4cdf9bece7b0$var$join(str, '_');
const $f64b4cdf9bece7b0$var$kebabCase = (str)=>$f64b4cdf9bece7b0$var$join(str, '-');
const $f64b4cdf9bece7b0$var$sentenceCase = (str)=>$f64b4cdf9bece7b0$var$upperFirst($f64b4cdf9bece7b0$var$join(str, ' '));
const $f64b4cdf9bece7b0$var$titleCase = (str)=>$f64b4cdf9bece7b0$var$words(str).map($f64b4cdf9bece7b0$var$upperFirst).join(' ');
$f64b4cdf9bece7b0$exports = {
    words: $f64b4cdf9bece7b0$var$words,
    upperFirst: $f64b4cdf9bece7b0$var$upperFirst,
    camelCase: $f64b4cdf9bece7b0$var$camelCase,
    pascalCase: $f64b4cdf9bece7b0$var$pascalCase,
    snakeCase: $f64b4cdf9bece7b0$var$snakeCase,
    kebabCase: $f64b4cdf9bece7b0$var$kebabCase,
    sentenceCase: $f64b4cdf9bece7b0$var$sentenceCase,
    titleCase: $f64b4cdf9bece7b0$var$titleCase
};


var $d4628d7c14b59e4d$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $d4628d7c14b59e4d$exports = function(edges) {
    return $d4628d7c14b59e4d$var$toposort($d4628d7c14b59e4d$var$uniqueNodes(edges), edges);
};
$d4628d7c14b59e4d$exports.array = $d4628d7c14b59e4d$var$toposort;
function $d4628d7c14b59e4d$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $d4628d7c14b59e4d$var$makeOutgoingEdges(edges), nodesHash = $d4628d7c14b59e4d$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $d4628d7c14b59e4d$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $d4628d7c14b59e4d$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $d4628d7c14b59e4d$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $ba7fa9d46dea301e$var$toString = Object.prototype.toString;
const $ba7fa9d46dea301e$var$errorToString = Error.prototype.toString;
const $ba7fa9d46dea301e$var$regExpToString = RegExp.prototype.toString;
const $ba7fa9d46dea301e$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $ba7fa9d46dea301e$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $ba7fa9d46dea301e$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $ba7fa9d46dea301e$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $ba7fa9d46dea301e$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $ba7fa9d46dea301e$var$symbolToString.call(val).replace($ba7fa9d46dea301e$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $ba7fa9d46dea301e$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $ba7fa9d46dea301e$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $ba7fa9d46dea301e$var$regExpToString.call(val);
    return null;
}
function $ba7fa9d46dea301e$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $ba7fa9d46dea301e$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $ba7fa9d46dea301e$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $ba7fa9d46dea301e$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $ba7fa9d46dea301e$var$_Symbol$toStringTag, $ba7fa9d46dea301e$var$_Symbol$hasInstance, $ba7fa9d46dea301e$var$_Symbol$toStringTag2;
let $ba7fa9d46dea301e$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$ba7fa9d46dea301e$var$_Symbol$toStringTag = Symbol.toStringTag;
class $ba7fa9d46dea301e$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$ba7fa9d46dea301e$var$_Symbol$toStringTag] = 'Error';
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $ba7fa9d46dea301e$var$toArray(errorOrErrors).forEach((err)=>{
            if ($ba7fa9d46dea301e$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$ba7fa9d46dea301e$var$_Symbol$hasInstance = Symbol.hasInstance;
$ba7fa9d46dea301e$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $ba7fa9d46dea301e$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        // Attempt to make the path more friendly for error message interpolation.
        const path = params.label || params.path || 'this';
        // Store the original path under `originalPath` so it isn't lost to custom
        // message functions; e.g., ones provided in `setLocale()` calls.
        params = Object.assign({}, params, {
            path: path,
            originalPath: params.path
        });
        if (typeof message === 'string') return message.replace($ba7fa9d46dea301e$var$strReg, (_, key)=>$ba7fa9d46dea301e$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $ba7fa9d46dea301e$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$ba7fa9d46dea301e$var$_Symbol$toStringTag2] = 'Error';
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $ba7fa9d46dea301e$export$2191b9da168c6cf0);
    }
    static [$ba7fa9d46dea301e$var$_Symbol$hasInstance](inst) {
        return $ba7fa9d46dea301e$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
}
let $ba7fa9d46dea301e$var$mixed = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    defined: '${path} must be defined',
    notNull: '${path} cannot be null',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$ba7fa9d46dea301e$export$5790025c6e6c2ba6(originalValue, true)}\`).` : '.';
        return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$ba7fa9d46dea301e$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$ba7fa9d46dea301e$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $ba7fa9d46dea301e$var$string = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    datetime: '${path} must be a valid ISO date-time',
    datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $ba7fa9d46dea301e$var$number = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $ba7fa9d46dea301e$var$date = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $ba7fa9d46dea301e$var$boolean = {
    isValue: '${path} field must be ${value}'
};
let $ba7fa9d46dea301e$var$object = {
    noUnknown: '${path} field has unspecified keys: ${unknown}',
    exact: '${path} object contains unknown properties: ${properties}'
};
let $ba7fa9d46dea301e$var$array = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
let $ba7fa9d46dea301e$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$ba7fa9d46dea301e$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$ba7fa9d46dea301e$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $ba7fa9d46dea301e$export$2191b9da168c6cf0.formatError($ba7fa9d46dea301e$var$mixed.notType, params);
    }
};
var $ba7fa9d46dea301e$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $ba7fa9d46dea301e$var$mixed,
    string: $ba7fa9d46dea301e$var$string,
    number: $ba7fa9d46dea301e$var$number,
    date: $ba7fa9d46dea301e$var$date,
    object: $ba7fa9d46dea301e$var$object,
    array: $ba7fa9d46dea301e$var$array,
    boolean: $ba7fa9d46dea301e$var$boolean,
    tuple: $ba7fa9d46dea301e$var$tuple
});
const $ba7fa9d46dea301e$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $ba7fa9d46dea301e$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        return new $ba7fa9d46dea301e$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$ba7fa9d46dea301e$export$213e2a3e7c4f326e(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
const $ba7fa9d46dea301e$var$prefixes = {
    context: '$',
    value: '.'
};
function $ba7fa9d46dea301e$export$eff4d24c3ff7876e(key, options) {
    return new $ba7fa9d46dea301e$var$Reference(key, options);
}
class $ba7fa9d46dea301e$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $ba7fa9d46dea301e$var$prefixes.context;
        this.isValue = this.key[0] === $ba7fa9d46dea301e$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $ba7fa9d46dea301e$var$prefixes.context : this.isValue ? $ba7fa9d46dea301e$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $2d70e076c9860a64$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$ba7fa9d46dea301e$var$Reference.prototype.__isYupRef = true;
const $ba7fa9d46dea301e$var$isAbsent = (value)=>value == null;
function $ba7fa9d46dea301e$var$createValidation(config) {
    function validate({ value: value, path: path = '', options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        const resolveOptions = {
            value: value,
            parent: parent,
            context: context
        };
        function createError(overrides = {}) {
            const nextParams = $ba7fa9d46dea301e$var$resolveParams(Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params), resolveOptions);
            const error = new $ba7fa9d46dea301e$export$2191b9da168c6cf0($ba7fa9d46dea301e$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve (item) {
                return $ba7fa9d46dea301e$var$resolveMaybeRef(item, resolveOptions);
            },
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($ba7fa9d46dea301e$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($ba7fa9d46dea301e$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $ba7fa9d46dea301e$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
// Warning: mutates the input
function $ba7fa9d46dea301e$var$resolveParams(params, options) {
    if (!params) return params;
    for (const key of Object.keys(params))params[key] = $ba7fa9d46dea301e$var$resolveMaybeRef(params[key], options);
    return params;
}
function $ba7fa9d46dea301e$var$resolveMaybeRef(item, options) {
    return $ba7fa9d46dea301e$var$Reference.isRef(item) ? item.getValue(options.value, options.parent, options.context) : item;
}
function $ba7fa9d46dea301e$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $2d70e076c9860a64$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === 'tuple';
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $ba7fa9d46dea301e$export$cfedb76369cc7782(obj, path, value, context) {
    return $ba7fa9d46dea301e$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $ba7fa9d46dea301e$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($ba7fa9d46dea301e$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $ba7fa9d46dea301e$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $ba7fa9d46dea301e$var$clone(src, seen = new Map()) {
    if ($ba7fa9d46dea301e$export$213e2a3e7c4f326e(src) || !src || typeof src !== 'object') return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $ba7fa9d46dea301e$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $ba7fa9d46dea301e$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($ba7fa9d46dea301e$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $ba7fa9d46dea301e$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
/**
 * Copied from @standard-schema/spec to avoid having a dependency on it.
 * https://github.com/standard-schema/standard-schema/blob/main/packages/spec/src/index.ts
 */ function $ba7fa9d46dea301e$var$createStandardPath(path) {
    if (!(path != null && path.length)) return undefined;
    // Array to store the final path segments
    const segments = [];
    // Buffer for building the current segment
    let currentSegment = '';
    // Track if we're inside square brackets (array/property access)
    let inBrackets = false;
    // Track if we're inside quotes (for property names with special chars)
    let inQuotes = false;
    for(let i = 0; i < path.length; i++){
        const char = path[i];
        if (char === '[' && !inQuotes) {
            // When entering brackets, push any accumulated segment after splitting on dots
            if (currentSegment) {
                segments.push(...currentSegment.split('.').filter(Boolean));
                currentSegment = '';
            }
            inBrackets = true;
            continue;
        }
        if (char === ']' && !inQuotes) {
            if (currentSegment) {
                // Handle numeric indices (e.g. arr[0])
                if (/^\d+$/.test(currentSegment)) segments.push(currentSegment);
                else // Handle quoted property names (e.g. obj["foo.bar"])
                segments.push(currentSegment.replace(/^"|"$/g, ''));
                currentSegment = '';
            }
            inBrackets = false;
            continue;
        }
        if (char === '"') {
            // Toggle quote state for handling quoted property names
            inQuotes = !inQuotes;
            continue;
        }
        if (char === '.' && !inBrackets && !inQuotes) {
            // On dots outside brackets/quotes, push current segment
            if (currentSegment) {
                segments.push(currentSegment);
                currentSegment = '';
            }
            continue;
        }
        currentSegment += char;
    }
    // Push any remaining segment after splitting on dots
    if (currentSegment) segments.push(...currentSegment.split('.').filter(Boolean));
    return segments;
}
function $ba7fa9d46dea301e$var$createStandardIssues(error, parentPath) {
    const path = parentPath ? `${parentPath}.${error.path}` : error.path;
    return error.errors.map((err)=>({
            message: err,
            path: $ba7fa9d46dea301e$var$createStandardPath(path)
        }));
}
function $ba7fa9d46dea301e$var$issuesFromValidationError(error, parentPath) {
    var _error$inner;
    if (!((_error$inner = error.inner) != null && _error$inner.length) && error.errors.length) return $ba7fa9d46dea301e$var$createStandardIssues(error, parentPath);
    const path = parentPath ? `${parentPath}.${error.path}` : error.path;
    return error.inner.flatMap((err)=>$ba7fa9d46dea301e$var$issuesFromValidationError(err, path));
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $ba7fa9d46dea301e$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $ba7fa9d46dea301e$var$ReferenceSet();
        this._blacklist = new $ba7fa9d46dea301e$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($ba7fa9d46dea301e$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $ba7fa9d46dea301e$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let allowOptionality = options.assert === 'ignore-optionality';
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $ba7fa9d46dea301e$var$isAbsent(result)) return result;
            let formattedValue = $ba7fa9d46dea301e$export$5790025c6e6c2ba6(value);
            let formattedResult = $ba7fa9d46dea301e$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this, options), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError('Must include `key` or `index` for nested validations');
        const isIndex = typeof k === 'number';
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? 'index' : 'key']: k,
            path: isIndex || k.includes('.') ? `${parentPath || ''}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($ba7fa9d46dea301e$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $ba7fa9d46dea301e$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($ba7fa9d46dea301e$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $ba7fa9d46dea301e$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($ba7fa9d46dea301e$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($ba7fa9d46dea301e$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this, options) : $ba7fa9d46dea301e$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $ba7fa9d46dea301e$var$createValidation({
            message: message,
            name: 'nullable',
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $ba7fa9d46dea301e$var$createValidation({
            message: message,
            name: 'optionality',
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $ba7fa9d46dea301e$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $ba7fa9d46dea301e$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $ba7fa9d46dea301e$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $ba7fa9d46dea301e$var$mixed.default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = $ba7fa9d46dea301e$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = $ba7fa9d46dea301e$var$toArray(keys).map((key)=>new $ba7fa9d46dea301e$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === 'function' ? new $ba7fa9d46dea301e$var$Condition(deps, options) : $ba7fa9d46dea301e$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $ba7fa9d46dea301e$var$createValidation({
            message: message,
            name: 'typeError',
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $ba7fa9d46dea301e$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $ba7fa9d46dea301e$var$createValidation({
            message: message,
            name: 'oneOf',
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $ba7fa9d46dea301e$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $ba7fa9d46dea301e$var$createValidation({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.filter((n, idx, list)=>list.findIndex((c)=>c.OPTIONS.name === n.OPTIONS.name) === idx).map((fn)=>{
                const params = fn.OPTIONS.params && options ? $ba7fa9d46dea301e$var$resolveParams(Object.assign({}, fn.OPTIONS.params), options) : fn.OPTIONS.params;
                return {
                    name: fn.OPTIONS.name,
                    params: params
                };
            })
        };
        return description;
    }
    get ['~standard']() {
        const schema = this;
        const standard = {
            version: 1,
            vendor: 'yup',
            async validate (value) {
                try {
                    const result = await schema.validate(value, {
                        abortEarly: false
                    });
                    return {
                        value: result
                    };
                } catch (err) {
                    if (err instanceof $ba7fa9d46dea301e$export$2191b9da168c6cf0) return {
                        issues: $ba7fa9d46dea301e$var$issuesFromValidationError(err)
                    };
                    throw err;
                }
            }
        };
        return standard;
    }
}
// @ts-expect-error
$ba7fa9d46dea301e$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$ba7fa9d46dea301e$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $ba7fa9d46dea301e$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$ba7fa9d46dea301e$export$19342e026b58ebb7.prototype[alias] = $ba7fa9d46dea301e$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$ba7fa9d46dea301e$export$19342e026b58ebb7.prototype[alias] = $ba7fa9d46dea301e$export$19342e026b58ebb7.prototype.notOneOf;
const $ba7fa9d46dea301e$var$returnsTrue = ()=>true;
function $ba7fa9d46dea301e$export$9b30b6294c1449a8(spec) {
    return new $ba7fa9d46dea301e$export$1e88358c94ddec71(spec);
}
class $ba7fa9d46dea301e$export$1e88358c94ddec71 extends $ba7fa9d46dea301e$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === 'function' ? {
            type: 'mixed',
            check: spec
        } : Object.assign({
            type: 'mixed',
            check: $ba7fa9d46dea301e$var$returnsTrue
        }, spec));
    }
}
$ba7fa9d46dea301e$export$9b30b6294c1449a8.prototype = $ba7fa9d46dea301e$export$1e88358c94ddec71.prototype;
function $ba7fa9d46dea301e$export$87b259aa03e3d267() {
    return new $ba7fa9d46dea301e$export$c7980688f11e1f49();
}
class $ba7fa9d46dea301e$export$c7980688f11e1f49 extends $ba7fa9d46dea301e$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'boolean',
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === 'boolean';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                if (this.spec.coerce && !this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $ba7fa9d46dea301e$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return $ba7fa9d46dea301e$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $ba7fa9d46dea301e$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return $ba7fa9d46dea301e$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$ba7fa9d46dea301e$export$87b259aa03e3d267.prototype = $ba7fa9d46dea301e$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $ba7fa9d46dea301e$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $ba7fa9d46dea301e$var$parseIsoDate(date) {
    const struct = $ba7fa9d46dea301e$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $ba7fa9d46dea301e$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $ba7fa9d46dea301e$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $ba7fa9d46dea301e$var$toNumber(regexResult[1]),
        month: $ba7fa9d46dea301e$var$toNumber(regexResult[2], 1) - 1,
        day: $ba7fa9d46dea301e$var$toNumber(regexResult[3], 1),
        hour: $ba7fa9d46dea301e$var$toNumber(regexResult[4]),
        minute: $ba7fa9d46dea301e$var$toNumber(regexResult[5]),
        second: $ba7fa9d46dea301e$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $ba7fa9d46dea301e$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $ba7fa9d46dea301e$var$toNumber(regexResult[10]),
        minuteOffset: $ba7fa9d46dea301e$var$toNumber(regexResult[11])
    };
}
function $ba7fa9d46dea301e$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $ba7fa9d46dea301e$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $ba7fa9d46dea301e$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $ba7fa9d46dea301e$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $ba7fa9d46dea301e$var$yearMonthDay = '^\\d{4}-\\d{2}-\\d{2}';
let $ba7fa9d46dea301e$var$hourMinuteSecond = '\\d{2}:\\d{2}:\\d{2}';
let $ba7fa9d46dea301e$var$zOrOffset = '(([+-]\\d{2}(:?\\d{2})?)|Z)';
let $ba7fa9d46dea301e$var$rIsoDateTime = new RegExp(`${$ba7fa9d46dea301e$var$yearMonthDay}T${$ba7fa9d46dea301e$var$hourMinuteSecond}(\\.\\d+)?${$ba7fa9d46dea301e$var$zOrOffset}$`);
let $ba7fa9d46dea301e$var$isTrimmed = (value)=>$ba7fa9d46dea301e$var$isAbsent(value) || value === value.trim();
let $ba7fa9d46dea301e$var$objStringTag = ({}).toString();
function $ba7fa9d46dea301e$export$22b082955e083ec3() {
    return new $ba7fa9d46dea301e$export$49bf8b2ede5138eb();
}
class $ba7fa9d46dea301e$export$49bf8b2ede5138eb extends $ba7fa9d46dea301e$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'string',
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === 'string';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                if (!this.spec.coerce || this.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $ba7fa9d46dea301e$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $ba7fa9d46dea301e$var$mixed.required,
                name: 'required',
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== 'required');
            return schema;
        });
    }
    length(length, message = $ba7fa9d46dea301e$var$string.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $ba7fa9d46dea301e$var$string.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $ba7fa9d46dea301e$var$string.max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || $ba7fa9d46dea301e$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $ba7fa9d46dea301e$var$string.email) {
        return this.matches($ba7fa9d46dea301e$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $ba7fa9d46dea301e$var$string.url) {
        return this.matches($ba7fa9d46dea301e$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $ba7fa9d46dea301e$var$string.uuid) {
        return this.matches($ba7fa9d46dea301e$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = '';
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === 'object') ({ message: message = '', allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($ba7fa9d46dea301e$var$rIsoDateTime, {
            name: 'datetime',
            message: message || $ba7fa9d46dea301e$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: 'datetime_offset',
            message: message || $ba7fa9d46dea301e$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $ba7fa9d46dea301e$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: 'datetime_precision',
            message: message || $ba7fa9d46dea301e$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $ba7fa9d46dea301e$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = $ba7fa9d46dea301e$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $ba7fa9d46dea301e$var$isTrimmed
        });
    }
    lowercase(message = $ba7fa9d46dea301e$var$string.lowercase) {
        return this.transform((value)=>!$ba7fa9d46dea301e$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$ba7fa9d46dea301e$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $ba7fa9d46dea301e$var$string.uppercase) {
        return this.transform((value)=>!$ba7fa9d46dea301e$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$ba7fa9d46dea301e$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$ba7fa9d46dea301e$export$22b082955e083ec3.prototype = $ba7fa9d46dea301e$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $ba7fa9d46dea301e$var$isNaN$1 = (value)=>value != +value;
function $ba7fa9d46dea301e$export$98e628dec113755e() {
    return new $ba7fa9d46dea301e$export$f192ec5e9228ab19();
}
class $ba7fa9d46dea301e$export$f192ec5e9228ab19 extends $ba7fa9d46dea301e$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'number',
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === 'number' && !$ba7fa9d46dea301e$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                if (!this.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (this.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $ba7fa9d46dea301e$var$number.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $ba7fa9d46dea301e$var$number.max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $ba7fa9d46dea301e$var$number.lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $ba7fa9d46dea301e$var$number.moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $ba7fa9d46dea301e$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $ba7fa9d46dea301e$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $ba7fa9d46dea301e$var$number.integer) {
        return this.test({
            name: 'integer',
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$ba7fa9d46dea301e$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round';
        // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!$ba7fa9d46dea301e$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$ba7fa9d46dea301e$export$98e628dec113755e.prototype = $ba7fa9d46dea301e$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $ba7fa9d46dea301e$var$invalidDate = new Date('');
let $ba7fa9d46dea301e$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $ba7fa9d46dea301e$export$324d90190a8b822a() {
    return new $ba7fa9d46dea301e$export$18ec3cc5a157503f();
}
class $ba7fa9d46dea301e$export$18ec3cc5a157503f extends $ba7fa9d46dea301e$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'date',
            check (v) {
                return $ba7fa9d46dea301e$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!this.spec.coerce || this.isType(value) || value === null) return value;
                value = $ba7fa9d46dea301e$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $ba7fa9d46dea301e$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$ba7fa9d46dea301e$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $ba7fa9d46dea301e$var$date.min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $ba7fa9d46dea301e$var$date.max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$ba7fa9d46dea301e$export$18ec3cc5a157503f.INVALID_DATE = $ba7fa9d46dea301e$var$invalidDate;
$ba7fa9d46dea301e$export$324d90190a8b822a.prototype = $ba7fa9d46dea301e$export$18ec3cc5a157503f.prototype;
$ba7fa9d46dea301e$export$324d90190a8b822a.INVALID_DATE = $ba7fa9d46dea301e$var$invalidDate;
// @ts-expect-error
function $ba7fa9d46dea301e$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $2d70e076c9860a64$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($ba7fa9d46dea301e$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($ba7fa9d46dea301e$export$213e2a3e7c4f326e(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($d4628d7c14b59e4d$exports))).array(Array.from(nodes), edges).reverse();
}
function $ba7fa9d46dea301e$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $ba7fa9d46dea301e$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $ba7fa9d46dea301e$var$findIndex(keys, a) - $ba7fa9d46dea301e$var$findIndex(keys, b);
    };
}
const $ba7fa9d46dea301e$var$parseJson = (value, _, schema)=>{
    if (typeof value !== 'string') return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return schema.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $ba7fa9d46dea301e$var$deepPartial(schema) {
    if ('fields' in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $ba7fa9d46dea301e$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === 'array') {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $ba7fa9d46dea301e$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === 'tuple') return schema.optional().clone({
        types: schema.spec.types.map($ba7fa9d46dea301e$var$deepPartial)
    });
    if ('optional' in schema) return schema.optional();
    return schema;
}
const $ba7fa9d46dea301e$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $2d70e076c9860a64$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $2d70e076c9860a64$exports.getter)((0, $2d70e076c9860a64$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $ba7fa9d46dea301e$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $ba7fa9d46dea301e$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $ba7fa9d46dea301e$var$defaultSort = $ba7fa9d46dea301e$var$sortByKeyOrder([]);
function $ba7fa9d46dea301e$export$be5493f9613cbbe(spec) {
    return new $ba7fa9d46dea301e$export$18b4fc70ec7eccf8(spec);
}
class $ba7fa9d46dea301e$export$18b4fc70ec7eccf8 extends $ba7fa9d46dea301e$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: 'object',
            check (value) {
                return $ba7fa9d46dea301e$var$isObject(value) || typeof value === 'function';
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $ba7fa9d46dea301e$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            let inputValue = value[prop];
            if (field) {
                let fieldValue;
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $ba7fa9d46dea301e$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(inputValue, innerOptions) : inputValue;
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = inputValue;
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== inputValue) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$ba7fa9d46dea301e$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $ba7fa9d46dea301e$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ('default' in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $ba7fa9d46dea301e$var$sortFields(shape, excludedEdges);
        next._sortErrors = $ba7fa9d46dea301e$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $ba7fa9d46dea301e$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $2d70e076c9860a64$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($ba7fa9d46dea301e$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($ba7fa9d46dea301e$var$parseJson);
    }
    /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */ exact(message) {
        return this.test({
            name: 'exact',
            exclusive: true,
            message: message || $ba7fa9d46dea301e$var$object.exact,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $ba7fa9d46dea301e$var$unknown(this.schema, value);
                return unknownKeys.length === 0 || this.createError({
                    params: {
                        properties: unknownKeys.join(', ')
                    }
                });
            }
        });
    }
    stripUnknown() {
        return this.clone({
            noUnknown: true
        });
    }
    noUnknown(noAllow = true, message = $ba7fa9d46dea301e$var$object.noUnknown) {
        if (typeof noAllow !== 'boolean') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $ba7fa9d46dea301e$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $ba7fa9d46dea301e$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $f64b4cdf9bece7b0$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $f64b4cdf9bece7b0$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $f64b4cdf9bece7b0$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$ba7fa9d46dea301e$export$be5493f9613cbbe.prototype = $ba7fa9d46dea301e$export$18b4fc70ec7eccf8.prototype;
function $ba7fa9d46dea301e$export$2f23118c22fb2630(type) {
    return new $ba7fa9d46dea301e$export$4347112b8447a7d(type);
}
class $ba7fa9d46dea301e$export$4347112b8447a7d extends $ba7fa9d46dea301e$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: 'array',
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`,
                parent: value,
                originalValue: v,
                value: v,
                index: idx
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($ba7fa9d46dea301e$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$ba7fa9d46dea301e$export$213e2a3e7c4f326e(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + $ba7fa9d46dea301e$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $ba7fa9d46dea301e$var$array.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $ba7fa9d46dea301e$var$array.min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $ba7fa9d46dea301e$var$array.max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$ba7fa9d46dea301e$export$2f23118c22fb2630.prototype = $ba7fa9d46dea301e$export$4347112b8447a7d.prototype;
// @ts-ignore
function $ba7fa9d46dea301e$export$65e3907585753458(schemas) {
    return new $ba7fa9d46dea301e$export$411c3b3687e8ecc8(schemas);
}
class $ba7fa9d46dea301e$export$411c3b3687e8ecc8 extends $ba7fa9d46dea301e$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: 'tuple',
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($ba7fa9d46dea301e$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ''}[${idx}]`,
                parent: value,
                originalValue: value[idx],
                value: value[idx],
                index: idx
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$ba7fa9d46dea301e$export$65e3907585753458.prototype = $ba7fa9d46dea301e$export$411c3b3687e8ecc8.prototype;
function $ba7fa9d46dea301e$export$488013bae63b21da(builder) {
    return new $ba7fa9d46dea301e$export$71117d144d3091c9(builder);
}
function $ba7fa9d46dea301e$var$catchValidationError(fn) {
    try {
        return fn();
    } catch (err) {
        if ($ba7fa9d46dea301e$export$2191b9da168c6cf0.isError(err)) return Promise.reject(err);
        throw err;
    }
}
class $ba7fa9d46dea301e$export$71117d144d3091c9 {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$ba7fa9d46dea301e$export$213e2a3e7c4f326e(schema)) throw new TypeError('lazy() functions must return a valid schema');
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $ba7fa9d46dea301e$export$71117d144d3091c9(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return $ba7fa9d46dea301e$var$catchValidationError(()=>this._resolve(value, options).validate(value, options));
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return $ba7fa9d46dea301e$var$catchValidationError(()=>this._resolve(value, options).validateAt(path, value, options));
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        try {
            return this._resolve(value, options).isValid(value, options);
        } catch (err) {
            if ($ba7fa9d46dea301e$export$2191b9da168c6cf0.isError(err)) return Promise.resolve(false);
            throw err;
        }
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: 'lazy',
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    get ['~standard']() {
        const schema = this;
        const standard = {
            version: 1,
            vendor: 'yup',
            async validate (value) {
                try {
                    const result = await schema.validate(value, {
                        abortEarly: false
                    });
                    return {
                        value: result
                    };
                } catch (err) {
                    if ($ba7fa9d46dea301e$export$2191b9da168c6cf0.isError(err)) return {
                        issues: $ba7fa9d46dea301e$var$issuesFromValidationError(err)
                    };
                    throw err;
                }
            }
        };
        return standard;
    }
}
function $ba7fa9d46dea301e$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $ba7fa9d46dea301e$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $ba7fa9d46dea301e$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$ba7fa9d46dea301e$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}



var $dPnrE = parcelRequire("dPnrE");
const $ebc7b5cdb6c7d902$var$SignupSchema = $ba7fa9d46dea301e$export$be5493f9613cbbe().shape({
    firstName: $ba7fa9d46dea301e$export$22b082955e083ec3().min(2, "Too Short!").max(50, "Too Long!"),
    // .required("First Name Required")
    lastName: $ba7fa9d46dea301e$export$22b082955e083ec3().min(2, "Too Short!").max(50, "Too Long!"),
    // .required("Last Name Required")
    email: $ba7fa9d46dea301e$export$22b082955e083ec3().email("Invalid email").required("Email Required"),
    password: $ba7fa9d46dea301e$export$22b082955e083ec3().min(3, "Too Short!").max(50, "Too Long!").required("Password Required")
});
const $ebc7b5cdb6c7d902$export$21a94553ffa41578 = ()=>{
    const navigate = (0, $9e8d2fd6513e67b8$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
        className: "login-page m-auto flex flex-col h-screen justify-center items-center space-y-4 md:space-y-8",
        children: [
            /*#__PURE__*/ (0, $1KfxD.jsx)("h1", {
                className: "signin-heading text-3xl uppercase font-semibold text-violet-500 text-center",
                children: "Sign In to view restaurants"
            }),
            /*#__PURE__*/ (0, $1KfxD.jsx)((0, $3IfSZ.Formik), {
                className: "formik",
                initialValues: {
                    firstName: "",
                    lastName: "",
                    email: "",
                    password: ""
                },
                validationSchema: $ebc7b5cdb6c7d902$var$SignupSchema,
                onSubmit: (values)=>{
                    // same shape as initial values
                    console.log(values);
                    if (values.email === "a@b.co" && values.password === "12345678") {
                        localStorage.setItem("isAuth", "true");
                        // Combine and save the name
                        const fullName = `${values.firstName} ${values.lastName}`.trim();
                        localStorage.setItem("userName", fullName);
                        navigate("/");
                    } else alert("Invalid Credentials");
                },
                children: ({ errors: errors, touched: touched })=>/*#__PURE__*/ (0, $1KfxD.jsxs)((0, $3IfSZ.Form), {
                        className: "formik-form borde border-amber-500 rounded-md flex flex-col p-4 w-full max-w-xs md:max-w-96 shadow-lg hover:shadow-2xl shadow-amber-500 space-y-4 mx-auto",
                        children: [
                            /*#__PURE__*/ (0, $1KfxD.jsxs)("label", {
                                htmlFor: "firstName",
                                className: "text-lg text-black font-semibold flex flex-col w-full",
                                children: [
                                    "First Name",
                                    /*#__PURE__*/ (0, $1KfxD.jsx)((0, $3IfSZ.Field), {
                                        name: "firstName",
                                        id: "firstName",
                                        placeholder: "First Name",
                                        type: "text",
                                        autoComplete: "current-first-name",
                                        className: "outline-0 shadow p-1.5 text-orange-500 placeholder:font-normal"
                                    }),
                                    errors.firstName && touched.firstName ? /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
                                        className: "form-error-tag text-red-500",
                                        children: errors.firstName
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $1KfxD.jsxs)("label", {
                                htmlFor: "lastName",
                                className: "text-lg text-black font-semibold flex flex-col",
                                children: [
                                    "Last Name",
                                    /*#__PURE__*/ (0, $1KfxD.jsx)((0, $3IfSZ.Field), {
                                        name: "lastName",
                                        id: "lastName",
                                        placeholder: "Last Name",
                                        type: "text",
                                        autoComplete: "current-last-name",
                                        className: "outline-0 shadow p-1.5 text-orange-500 placeholder:font-normal"
                                    }),
                                    errors.lastName && touched.lastName ? /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
                                        className: "form-error-tag text-red-500",
                                        children: errors.lastName
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $1KfxD.jsxs)("label", {
                                htmlFor: "email",
                                className: "text-lg text-black font-semibold flex flex-col",
                                children: [
                                    "Email*",
                                    /*#__PURE__*/ (0, $1KfxD.jsx)((0, $3IfSZ.Field), {
                                        id: "email",
                                        name: "email",
                                        placeholder: "a@b.co",
                                        type: "email",
                                        autoComplete: "current-email",
                                        className: "outline-0 shadow p-1.5 text-orange-500 placeholder:font-normal"
                                    }),
                                    errors.email && touched.email ? /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
                                        className: "form-error-tag text-red-500",
                                        children: errors.email
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $1KfxD.jsxs)("label", {
                                htmlFor: "password",
                                className: "text-lg text-black font-semibold flex flex-col",
                                children: [
                                    "Password*",
                                    /*#__PURE__*/ (0, $1KfxD.jsx)((0, $3IfSZ.Field), {
                                        id: "password",
                                        name: "password",
                                        placeholder: "12345678",
                                        type: "password",
                                        autoComplete: "current-password",
                                        className: "outline-0 shadow p-1.5 text-orange-500 placeholder:font-normal"
                                    }),
                                    errors.password && touched.password ? /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
                                        className: "form-error-tag text-red-500",
                                        children: errors.password
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $1KfxD.jsx)((0, $dPnrE.default), {
                                type: "submit",
                                label: "Submit",
                                className: "mx-auto"
                            })
                        ]
                    })
            })
        ]
    });
};
var $ebc7b5cdb6c7d902$export$2e2bcd8739ae039 = $ebc7b5cdb6c7d902$export$21a94553ffa41578;



var $drrpd = parcelRequire("drrpd");

var $1KfxD = parcelRequire("1KfxD");

const $3b7f34af376a7a71$var$AuthLayout = ({ children: children })=>{
    const isAuth = localStorage.getItem("isAuth");
    const location = (0, $9e8d2fd6513e67b8$export$45d76561a5302f2b)();
    if (!isAuth && location.pathname !== "/auth/login") return /*#__PURE__*/ (0, $1KfxD.jsx)((0, $9e8d2fd6513e67b8$export$444b3ab0cb9aec40), {
        to: "/auth/login",
        replace: true
    });
    return children;
};
var $3b7f34af376a7a71$export$2e2bcd8739ae039 = $3b7f34af376a7a71$var$AuthLayout;



var $dSwpL = parcelRequire("dSwpL");





const $e863208c7e200f2a$var$store = (0, $ead9048c02d75bca$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $fd2d666be553f7be$export$2e2bcd8739ae039)
    }
});
var $e863208c7e200f2a$export$2e2bcd8739ae039 = $e863208c7e200f2a$var$store;


const $cc5a2e91394e7448$var$App = ()=>{
    const [isLoggedIn, setIsLoggedIn] = (0, $dSwpL.useState)(false);
    const [isConnecting, setIsConnecting] = (0, $dSwpL.useState)(false);
    const [userName, setUserName] = (0, $dSwpL.useState)("");
    const isOnline = (0, $40b1dd295cb29d97$export$2e2bcd8739ae039)();
    const { loggedInUser: loggedInUser } = (0, $dSwpL.useContext)((0, $drrpd.default));
    const prevOnlineRef = (0, $dSwpL.useRef)(isOnline);
    const navigate = (0, $9e8d2fd6513e67b8$export$9770f232ac06a008)();
    const location = (0, $9e8d2fd6513e67b8$export$45d76561a5302f2b)();
    // const hideLayout = location.pathname === "/auth/login";
    (0, $dSwpL.useEffect)(()=>{
        const data = {
            name: "Yogesh"
        };
        const storedName = localStorage.getItem("userName");
        if (storedName) setUserName(storedName);
        else setUserName(data.name);
    }, []);
    (0, $dSwpL.useEffect)(()=>{
        if (window.location.pathname === "/index.html") window.history.replaceState(null, "", "/");
    }, []);
    (0, $dSwpL.useEffect)(()=>{
        const isAuth = localStorage.getItem("isAuth");
        if (!isAuth) navigate("/auth/login");
    }, []);
    (0, $dSwpL.useEffect)(()=>{
        if (!prevOnlineRef.current && isOnline) {
            setIsConnecting(true);
            const timer = setTimeout(()=>{
                setIsConnecting(false);
            }, 2000);
            return ()=>clearTimeout(timer);
        }
        prevOnlineRef.current = isOnline;
    }, [
        isOnline
    ]);
    if (!isOnline) return /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
        className: "flex items-center text-center w-full justify-center font-bold text-2xl space-x-2 text-red-500 min-h-screen m-auto",
        children: /*#__PURE__*/ (0, $1KfxD.jsx)("h1", {
            className: "w-full text-center mx-auto",
            children: "\uD83D\uDD34Offline! Check internet connection!!"
        })
    });
    if (isConnecting) return /*#__PURE__*/ (0, $1KfxD.jsxs)("div", {
        className: "flex items-center justify-center font-bold text-2xl space-x-2 text-green-500 min-h-screen mx-auto",
        children: [
            /*#__PURE__*/ (0, $1KfxD.jsx)("img", {
                src: "https://png.pngtree.com/png-vector/20230926/ourmid/pngtree-green-wifi-symbol-network-png-image_10115831.png",
                className: "w-10 h-8 flex "
            }),
            /*#__PURE__*/ (0, $1KfxD.jsx)("h1", {
                children: "Connected to internet..."
            })
        ]
    });
    return /*#__PURE__*/ (0, $1KfxD.jsx)((0, $d70dbdb49916e071$export$2881499e37b75b9a), {
        store: (0, $e863208c7e200f2a$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $1KfxD.jsx)((0, $drrpd.default).Provider, {
            value: {
                loggedInUser: userName,
                setUserName: setUserName
            },
            children: /*#__PURE__*/ (0, $1KfxD.jsx)("div", {
                className: "App relative box-border pt-20 md:pt-24 w-full min-h-dvh h-full mx-auto flex flex-col justify-between overflow-auto",
                children: /*#__PURE__*/ (0, $1KfxD.jsxs)((0, $3b7f34af376a7a71$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $1KfxD.jsx)((0, $e871d5d4e0264d30$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $1KfxD.jsx)((0, $9e8d2fd6513e67b8$export$910ae8079b2c2852), {})
                    ]
                })
            })
        })
    });
};
const $cc5a2e91394e7448$export$9b5cb5a1fbefff82 = (0, $9e8d2fd6513e67b8$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $1KfxD.jsx)($cc5a2e91394e7448$var$App, {}),
        errorElement: /*#__PURE__*/ (0, $1KfxD.jsx)((0, $09f1789730a6f99e$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $1KfxD.jsx)((0, $1b20b4191a6fe390$export$2e2bcd8739ae039), {})
            },
            {
                path: "about",
                element: /*#__PURE__*/ (0, $1KfxD.jsx)((0, $97b68e048b5cf722$export$2e2bcd8739ae039), {})
            },
            {
                path: "contact",
                element: /*#__PURE__*/ (0, $1KfxD.jsx)((0, $79198b9808b69df1$export$2e2bcd8739ae039), {})
            },
            {
                path: "cart",
                element: /*#__PURE__*/ (0, $1KfxD.jsx)((0, $1d8aa4d68b04108d$export$2e2bcd8739ae039), {})
            },
            {
                path: "restaurant-details/:restaurantId",
                element: /*#__PURE__*/ (0, $1KfxD.jsx)((0, $3a9c1fdb0ffbaad9$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        path: "auth/login",
        element: /*#__PURE__*/ (0, $1KfxD.jsx)((0, $ebc7b5cdb6c7d902$export$2e2bcd8739ae039), {})
    }
]);
var $cc5a2e91394e7448$export$2e2bcd8739ae039 = $cc5a2e91394e7448$var$App;


const $4d77409ab1d8ecae$export$e8e78c978b129247 = (0, (/*@__PURE__*/$parcel$interopDefault($dda887183a0ed747$exports))).createRoot(document.getElementById("root"));
$4d77409ab1d8ecae$export$e8e78c978b129247.render(/*#__PURE__*/ (0, $1KfxD.jsx)((0, $9e8d2fd6513e67b8$export$323e4fc2fa4753fb), {
    router: (0, $cc5a2e91394e7448$export$9b5cb5a1fbefff82)
}));


//# sourceMappingURL=public.08f5b4b0.js.map
